import {
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString30pk9tzaqopn as toString,
  hashCodeq5arwsb9dgti as hashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  toList3jhuyej2anx2q as toList,
  VOID3gxj6tk5isa35 as VOID,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString_0,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  createThis2j2avj17cvnv2 as createThis,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  ArrayList3it5z8td81qkl as ArrayList,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  isInterface3d6p8outrmvmk as isInterface,
  constructCallableReference23y65rf941mch as constructCallableReference,
  lazy2hsh8ze7j6ikd as lazy,
  KProperty1ca4yb4wlo496 as KProperty1,
  isIntArrayeijsubfngq38 as isIntArray,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  fill2542d4m9l93pn as fill,
  toByte4i43936u611k as toByte,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  RuntimeException1r3t0zl97011n as RuntimeException,
  StringBuildermazzzhj6kkai as StringBuilder,
  iterator3f5i676wpaa3g as iterator,
  Iterable1y3qizuf89iou as Iterable,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  abs1kdzbjes1idip as abs,
  coerceAtMost322komnqp70ag as coerceAtMost,
  round2mrvepag8eey0 as round,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  isFloatArrayjjscnqphw92j as isFloatArray,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  to2cs3ny02qtbcb as to,
  mapOf1xd03cq9cnmy8 as mapOf,
  removePrefix279df90bhrqqg as removePrefix,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  split2bvyvnrlcifjv as split,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  startsWith26w8qjqapeeq6 as startsWith,
  setOf45ia9pnfhe90 as setOf,
  toInt5qdj874w69jh as toInt,
  printStackTrace18lnx7a39cni as printStackTrace,
  roundToInt1ue8x8yshtznx as roundToInt,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  compareTo3ankvs086tmwq as compareTo,
  Comparable198qfk8pnblz0 as Comparable,
  contains3u8qpdzrl9an as contains,
  Collection1k04j3hzsbod0 as Collection,
  indexOff2hgzjbxdcp4 as indexOf,
  KtList3hktaavzmj137 as KtList,
  numberToDouble210hrknaofnhf as numberToDouble,
  protoOf180f3jzyo7rfj as protoOf,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  HashMap1a0ld5kgwhmhv as HashMap,
  startsWith1bgirhbedtv2y as startsWith_0,
  firstOrNullf6vlo6vdgu1e as firstOrNull,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  first28gmhyvs4kf06 as first,
  toMap1vec9topfei08 as toMap,
  lines3g90sq0zeq43v as lines,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split_0,
  listOf1jh22dvmctj1r as listOf,
  plus310ted5e4i90h as plus,
  numberToChar93r9buh19yek as numberToChar,
  toString336ienavfnzn0 as toString_1,
  toInt2q8uldh7sc951 as toInt_0,
  toDouble1kn912gjoizjp as toDouble,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  Char__rangeTo_impl_tkncvp39f1k6qse2e6h as Char__rangeTo_impl_tkncvp,
  joinToString1cxrrlmo0chqs as joinToString,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd,
  toIntArray2d4xwvtjb01mq as toIntArray,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  Monotonic_instance2att21stfwfpk as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs593ou6p5l5hu as ValueTimeMark__elapsedNow_impl_eonqvs,
  TimedValuew9j01dao9jci as TimedValue,
  listOfvhqybd2zx248 as listOf_0,
  println2shhhgwwt4c61 as println,
  emptyList1g2z5xcrvp2zy as emptyList,
  until1jbpn0z3f8lbg as until,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  first58ocm7j58k3q as first_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  firstOrNull1982767dljvdy as firstOrNull_0,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  toList2z3tifmtru5ra as toList_0,
  emptyMapr06gerzljqtm as emptyMap,
  last1vo29oleiqj36 as last,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  getProgressionLastElement2w30kdy2w5nkt as getProgressionLastElement,
  isNumberiramasdbon0i as isNumber,
  toShort36kaw0zjdq3ex as toShort,
  Char__plus_impl_qi7pgj1h8009bm3fa2t as Char__plus_impl_qi7pgj,
  Default_getInstance3u7accvuecmtb as Default_getInstance,
  step18s9qzr5xwxat as step,
  charCodeAt1yspne1d8erbm as charCodeAt,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toList383f556t1dixk as toList_1,
  boxApply1qmzdb3dh90hg as boxApply,
  throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException,
  Long2qws0ah9gnpki as Long,
  multiply18i3gv3wlmcjg as multiply,
  copyOfRange1v9olvyjr7c0r as copyOfRange_0,
  repeat2w4c6j8zoq09o as repeat,
  getOrNull1d60i0672n7ns as getOrNull,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  toIntArray27j90pvfixv10 as toIntArray_0,
  first34dru09vyikub as first_1,
  getOrNullef5jbxih7r4f as getOrNull_0,
  lastOrNullxgbdyo3mdsps as lastOrNull,
  convertToIntofdoxh9bstof as convertToInt,
  fromInt1lka3ktyu79a4 as fromInt,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  addAll1k27qatfgp3k5 as addAll,
  distinct10qe1scfdvu5k as distinct,
  sortedWith2csnbbb21k0lg as sortedWith,
  first1vi3grnpj1175 as first_2,
  toSet2orjxp16sotqu as toSet,
  Exceptiondt2hlxn7j7vw as Exception,
  minus27abgkurcn6u0 as minus,
  CancellationException3b36o9qz53rgr as CancellationException,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  setOf1u3mizs95ngxo as setOf_0,
  plus1nh85pok677ot as plus_0,
  DurationUnit_SECONDS_getInstancehu17fry790z2 as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b1rke7yypzm7mk as Duration__toString_impl_8d916b,
  toMapcf6xfku344cz as toMap_0,
  getOrNull1go7ef9ldk0df as getOrNull_1,
  fill34ox8qmmmh3u3 as fill_0,
  coerceIn10f36k81le1mm as coerceIn,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  KProperty02ce7r476m8633 as KProperty0,
  ValueTimeMark__minus_impl_f87sko1ujubq06wu01s as ValueTimeMark__minus_impl_f87sko,
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancesewns20u1dyn as DurationUnit_MILLISECONDS_getInstance,
  Duration__compareTo_impl_pchp0f1g201z2whmah8 as Duration__compareTo_impl_pchp0f,
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  intercepted2ogpsikxxj4u0 as intercepted,
  copyToArray2j022khrow2yi as copyToArray,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_instance13goiojaq0ush as Companion_instance_0,
  RectSlicec5msorw5q4el as RectSlice,
  ImageDoNotFitException2gm4q4wt4lh58 as ImageDoNotFitException,
  _SliceOrientation___get_flipX__impl__lgb7bxpfrfmahmr1fq as _SliceOrientation___get_flipX__impl__lgb7bx,
  _SliceOrientation___get_rotation__impl__m65r0op3ryfmm1yyj as _SliceOrientation___get_rotation__impl__m65r0o,
  Companion_getInstance3seqq6212ijwe as Companion_getInstance_0,
  _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq34f1oadsx2p0 as _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  applyTransform1vhqlmleb4dce as applyTransform,
  getCurves2yjahbp68cxj3 as getCurves,
  toBezier1cphbqwqpx0d3 as toBezier,
  plus1r33v70e4ipd7 as plus_1,
  get_immutablepxpdoj6e54ll as get_immutable,
  arc$default2ya7cpeqzuelq as arc$default,
  VectorBuilder2g8a28qau4ty9 as VectorBuilder,
  SliceOrientation5szkqzxt7oev as SliceOrientation,
  Winding_EVEN_ODD_getInstance1rr1chty3mia4 as Winding_EVEN_ODD_getInstance,
  StrokeToFill127v8ehrppf9e as StrokeToFill,
  strokeToFill2j5wye7yyxd99 as strokeToFill,
  Companion_getInstance1wsp92tul7oln as Companion_getInstance_1,
  LineScaleMode_NORMAL_getInstance9o852ij0ybpr as LineScaleMode_NORMAL_getInstance,
  LineCap_BUTT_getInstance1x8jd0g8nody4 as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstancenxlz621uxkch as LineJoin_MITER_getInstance,
  Winding_NON_ZERO_getInstance1fdn4b7o3qufp as Winding_NON_ZERO_getInstance,
  line3u2mk0n2uhnlh as line,
  arcTo1g4ivunekrrtg as arcTo,
  isEmpty3b7xkdp0by4c8 as isEmpty,
  rect1tyihxx4629c2 as rect,
  rect31bppuugx2wch as rect_0,
  rect3nqbmqh4a4l2a as rect_1,
  roundRect2sqmspzw5002d as roundRect,
  arc1vjl2w7wqv39k as arc,
  circle1t8rrxfrm1ku9 as circle,
  rMoveTo38ittbd8h3wn5 as rMoveTo,
  rLineTo1671hm1vy9pme as rLineTo,
  transformed2t6vo3srmaaf9 as transformed,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  ProjectedPoint37gr1oedqap6n as ProjectedPoint,
  Companion_getInstance3dt5vnr8lhijd as Companion_getInstance_2,
  write11msa0gyjblqp as write,
  get_isConvex3nm4n5empqw0n as get_isConvex,
  strokeToFill34bvxzbc34djp as strokeToFill_0,
  get_mutableqzgwrema46rx as get_mutable,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
  RastScale3rcmuinujik1d as RastScale,
  PolygonScanline1ccjpk6mqxyxd as PolygonScanline,
  IntSegmentSet3br6yjcm9q2bd as IntSegmentSet,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  MarginInt3jiec8xsxkfd as MarginInt,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  SizeInte6w85oa6mz6v as SizeInt,
  Companion_instance29i2v8geu7jl9 as Companion_instance_1,
  Companion_getInstance3cokvjrertd3u as Companion_getInstance_3,
  Companion_getInstancepzu5ca8urjqj as Companion_getInstance_4,
  Vector2D378fe5rov8fgw as Vector2D,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance45f4wj6tp63r as Companion_getInstance_5,
  Line2D2pf35pcx71ncp as Line2D,
  Companion_getInstance1mhteccb9s8gp as Companion_getInstance_6,
  Companion_getInstance11dw08y48m2m0 as Companion_getInstance_7,
  Rectangle3q03woyn9k8x1 as Rectangle,
  BoundsBuilder__plus_impl_cz7f7x16kulpov94zla as BoundsBuilder__plus_impl_cz7f7x,
  _BoundsBuilder___get_bounds__impl__s1l1gxzjc7xpskx0n0 as _BoundsBuilder___get_bounds__impl__s1l1gx,
  BoundsBuilder__plus_impl_cz7f7x3p03svh4wzys8 as BoundsBuilder__plus_impl_cz7f7x_0,
  Scale2cm697xlulcp5 as Scale,
  toFloat3b315y36g90cd as toFloat,
  Matrix1p940sdz227jj as Matrix,
  Companion_getInstance1a9vx2vzoy0c2 as Companion_getInstance_8,
  Angle_between72970e1vlen9 as Angle_between,
  Angle__unaryMinus_impl_7901fr16exly0rraiwq as Angle__unaryMinus_impl_7901fr,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__div_impl_ut2btdaackrnjj1mz1 as Angle__div_impl_ut2btd,
  Angle2itorpob18n08 as Angle,
  Angle__hashCode_impl_szcndt1h2czn61kf53d as Angle__hashCode_impl_szcndt,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  get_radians391vbqqjsolq6 as get_radians,
  _Angle___get_degrees__impl__qg56vw3rdspcu2c88ii as _Angle___get_degrees__impl__qg56vw,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  _Angle___init__impl__g23q1m2b2a3p1lcfecp as _Angle___init__impl__g23q1m,
  _Angle___get_ratio__impl__ap3on4xjct7npipfzx as _Angle___get_ratio__impl__ap3on4,
  BoundsBuilder__xminOr_impl_k3l1m2rcdokyluvpsy as BoundsBuilder__xminOr_impl_k3l1m2,
  BoundsBuilder__toString_impl_fmvxh715k068517pw6p as BoundsBuilder__toString_impl_fmvxh7,
  BoundsBuilder__hashCode_impl_649zbo1qjjrsvk8mf98 as BoundsBuilder__hashCode_impl_649zbo,
  BoundsBuilder__plus_impl_cz7f7xgidk87zsybva as BoundsBuilder__plus_impl_cz7f7x_1,
  BoundsBuilder__boundsOrNull_impl_se9lyg1e0yj2dj19xak as BoundsBuilder__boundsOrNull_impl_se9lyg,
  scaled2eehd42i2trq9 as scaled,
  MatrixType_IDENTITY_getInstancew67nqjh3bh8t as MatrixType_IDENTITY_getInstance,
  _Angle___get_radians__impl__n00yt5vm4zpqngpunw as _Angle___get_radians__impl__n00yt5,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  setExtra314k0z6q35eku as setExtra,
  hasExtra1969mplo13qgb as hasExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  Property1m5vulkepgwzd as Property,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  toIntFloor3t307m2tavlm8 as toIntFloor,
  toIntCeiltm5lvaa6k4k9 as toIntCeil,
  toRatiolga1a9coidva as toRatio,
  clamp31lhm66c28ic8 as clamp,
  ilog23dbvpk38jf7rc as ilog2,
  extract2vhru1ihy4ogl as extract,
  insertm9bp9ll4cml3 as insert,
  clamp011ml7wx1d2b7sp as clamp01,
  min2wcdwdef93gdl as min,
  maxfuu7ju0dv4mx as max,
  convertRange378kqy75r4gq5 as convertRange,
  clampdicp8njiht45 as clamp_0,
  toIntFloor2i5mxseifeud5 as toIntFloor_0,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  divCeil2r4o5lbvnv4lh as divCeil,
  Ratio__toFloat_impl_1ftup51oeiehdv33vam as Ratio__toFloat_impl_1ftup5,
  clampUByte16elok6pzd6c5 as clampUByte,
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  interpolatexm8yaf0iv9q9 as interpolate,
  clamp012a0sd8pj80ati as clamp01_0,
  toIntCeil3h286vm49zgwd as toIntCeil_0,
  Companion_getInstancevp821koktwyg as Companion_getInstance_9,
  niceStr1mw27wr6fq0ek as niceStr,
  get_niceStr3crhxydmlnaoj as get_niceStr_0,
  extractSignedx6cuhlj55jv4 as extractSigned,
  insert163hf9bvod0wg0m as insert16,
  toIntRound1mv0y8x9hh1p4 as toIntRound_0,
  _Ratio___init__impl__9mwvn229jit2qvwiss1 as _Ratio___init__impl__9mwvn2,
  clamp1qclpmpfxm7xb as clamp_1,
  toRatio1hooqit5gulhr as toRatio_0,
  interpolate35pbs3ac913y4 as interpolate_0,
  Ratio__times_impl_ucdh7y3ofskh6zksge6 as Ratio__times_impl_ucdh7y,
  Ratio__toDouble_impl_o7epzewvz4wcchi2m as Ratio__toDouble_impl_o7epze,
  _Ratio___init__impl__9mwvn23v7lk04jh8pl2 as _Ratio___init__impl__9mwvn2_0,
  umodgae5ifx362au as umod,
  insert8f3zk23r8x9da as insert8,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  IntArray23680o40e0fgt8 as IntArray2,
  Companion_instanceanmlix73471t as Companion_instance_2,
  Companion_instance3l6feosw3otmo as Companion_instance_3,
  FloatArray2beehiaucxmzd as FloatArray2,
  GenericSubList2rec7qqyf06nw as GenericSubList,
  GenericListIterator397gjg9p2xwl5 as GenericListIterator,
  toIntMapp1jij98esrcm as toIntMap,
  associateByInt3vmv30txx5avl as associateByInt,
  IntMap2d9g6f5pyaoc2 as IntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  reverse22fe0u1pwl2c6 as reverse,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  IntIntMap3mvg5iqgd5t3z as IntIntMap,
  getCyclic28wvgqye98jqx as getCyclic,
  toIntArrayList3jlt4o6tyleu as toIntArrayList,
  doubleArrayListOfkj3z9zq4pobs as doubleArrayListOf,
  DoubleVectorArrayListq54dfthnqi2t as DoubleVectorArrayList,
  intArrayListOf18h0hna7wb0zr as intArrayListOf,
  _TGenStack___init__impl__yynjgt1a2ntdq1fkc7u as _TGenStack___init__impl__yynjgt,
  TGenStack__push_impl_9yh33t1oehqh3y1sfje as TGenStack__push_impl_9yh33t,
  TGenStack__pop_impl_qisxa01fn0eg90t1fqa as TGenStack__pop_impl_qisxa0,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  invalidOp1stebxh2m3n07 as invalidOp,
  NativeImageRefqizti6jm75 as NativeImageRef,
  reserved38luap2kxmc9d as reserved,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  get_reserved2d9gxjta2y60d as get_reserved,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  Endian_BIG_ENDIAN_getInstance3o2xiv864s15m as Endian_BIG_ENDIAN_getInstance,
  Endian_LITTLE_ENDIAN_getInstance43td1z4hn3ua as Endian_LITTLE_ENDIAN_getInstance,
  FileNotFoundException2tz8ve019qipn as FileNotFoundException,
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  Companion_getInstance1ju3fwn4mt9wh as Companion_getInstance_10,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  arraycopy14jict0dth60o as arraycopy,
  UByteArrayInt__get_impl_px6q8a35txexjj6o4n0 as UByteArrayInt__get_impl_px6q8a,
  UByteArrayInt__set_impl_gn453221vabkkeeuf12 as UByteArrayInt__set_impl_gn4532,
  arraycopy3czrd9re36wzt as arraycopy_0,
  _UByteArrayInt___init__impl__xif7bu20fs1loq9z3ij as _UByteArrayInt___init__impl__xif7bu,
  getU83agrw8yj0shar as getU8,
  _UShortArrayInt___init__impl__kdofb815k0nr37fhkly as _UShortArrayInt___init__impl__kdofb8,
  UShortArrayInt__set_impl_38wgvc1v2d04p43ifye as UShortArrayInt__set_impl_38wgvc,
  UShortArrayInt__get_impl_ciz20k2vat303djh1bv as UShortArrayInt__get_impl_ciz20k,
  getU16LE2cizldw8qp53x as getU16LE,
  getU16BE2rszf3doox5o as getU16BE,
  getU24LEi3x1z5ajbdbv as getU24LE,
  getU24BE36pml41y2814b as getU24BE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getS32BE5aphh7sm8f2q as getS32BE,
  getU1616fejrhhqwfv2 as getU16,
  getS3225c4j90s7n16a as getS32,
  _UByteArrayInt___init__impl__xif7bu22xrgtz1pdtsf as _UByteArrayInt___init__impl__xif7bu_0,
  asByteArray1mw554k0vpuh5 as asByteArray,
  UByteArrayInt__getOrElse_impl_f0pf72aegw9voo79ft as UByteArrayInt__getOrElse_impl_f0pf72,
  _UByteArrayInt___get_size__impl__bcjnte1ffm0g6so1ivs as _UByteArrayInt___get_size__impl__bcjnte,
  UByteArrayInt247ue4nx0pkns as UByteArrayInt,
  asInt32Arrayf0ml2lp92o3m as asInt32Array,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  substr2jonrcqd8qwvx as substr,
  substr1q77u5lo4evr6 as substr_0,
  unquote1kjyk5vajgaow as unquote,
  get_UTF82geyfhi1l22xl as get_UTF8,
  get_UTF16_BE3rxrt7v8707y4 as get_UTF16_BE,
  Companion_getInstance2omq1gulueyfd as Companion_getInstance_11,
  Charsets_instance36f67kdzeu1kr as Charsets_instance,
  ASCII_getInstance1ki74j81tlqzy as ASCII_getInstance,
  toString2x583ovdqfjci as toString_2,
  WStringReader2bukzqxb5clbi as WStringReader,
  _WChar___get_codePoint__impl__c8brwusjw60nkqwcvk as _WChar___get_codePoint__impl__c8brwu,
  WStringambx64bqrrmq as WString,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  appendHexByte1xtb46j7ij290 as appendHexByte,
  fromBase6434uveajlhn2ar as fromBase64,
  get_hex32p4ssq0y1xxx as get_hex,
  get_hex3lw8e6gsph9rg as get_hex_0,
} from './korlibs-encoding-root-korlibs-encoding.mjs';
import {
  Xmlepssdknidwxh as Xml,
  get12f8xnsftqcwn as get,
  Companion_getInstanceupvgqfr8b1ba as Companion_getInstance_12,
} from './korlibs-serialization-root-korlibs-serialization.mjs';
import {
  get_dynw5edstkdie96 as get_dyn,
  Dyn__get_impl_6l2p8025myyq9ua90y3 as Dyn__get_impl_6l2p80,
  Dyn__toDoubleDefault_impl_fspogf39agzsgy5m7pq as Dyn__toDoubleDefault_impl_fspogf,
  Dyn__toStringOrNull_impl_7e6cgy11smf33nxtna1 as Dyn__toStringOrNull_impl_7e6cgy,
  Dyn__toList_impl_pxssgrc6zfqu4ojyxp as Dyn__toList_impl_pxssgr,
  Dyn__toString_impl_9l0v3s2684pl1rylulf as Dyn__toString_impl_9l0v3s,
  _Dyn___get_int__impl__sh8lhmb37gw1mgcz3a as _Dyn___get_int__impl__sh8lhm,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import {
  Companion_getInstancee7wpm1ix3t3y as Companion_getInstance_13,
  uncompress3ofkd276wd0zn as uncompress,
} from './korlibs-compression-root-korlibs-compression.mjs';
import {
  openFastStream2r4uuohoj0wpo as openFastStream,
  toSyncStream3g0dpktigjx33 as toSyncStream,
  FastByteArrayInputStream1jjm4ufd0tkh5 as FastByteArrayInputStream,
  sliceHere46mgk3n9huns as sliceHere,
  readString2gn2js5u0onhc as readString,
  readU163iaqmopzplujm as readU16,
  readS32mmpqk5mai7ic as readS32,
  readBytesExact9lk5ofbmnwn5 as readBytesExact,
  sliceStartd2tqagpdmlnp as sliceStart,
  readStringz1nu1lc3nd8jc7 as readStringz,
  skipToAlignusebk6ndjvs1 as skipToAlign,
  openSync2m3qn99fqytu0 as openSync,
  sliceStart237tx6t7cytus as sliceStart_0,
  readString3106ot9qwcir2 as readString_0,
  readBytes3l26albs0coyl as readBytes,
  readAll1k0zte4qdypit as readAll,
  readS32BE1vkzsiuy9pof1 as readS32BE,
  get_eofaukbsoaf5jcj as get_eof,
  readAll3m5rixujsbctr as readAll_0,
  openAsync37anb1e84urmo as openAsync,
  readStringz3jxaogr49n5ys as readStringz_0,
  readStream3s64ivrsklqly as readStream,
  readU82o15i0epsnmc5 as readU8,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  Level_DEBUG_getInstance1gtvuokzl9cp4 as Level_DEBUG_getInstance,
  Companion_getInstance3f9e8v90vvgdj as Companion_getInstance_14,
  Level_INFO_getInstance2u0wredwjoo6m as Level_INFO_getInstance,
  Level_ERROR_getInstance1195cgr5fzwj1 as Level_ERROR_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  get_baseName2yf63efofm8te as get_baseName,
  readAsSyncStream39593nw0zd799 as readAsSyncStream,
  getUnderlyingUnscapedFilenlplw797lms5 as getUnderlyingUnscapedFile,
  UrlVfs292f1sja450ff as UrlVfs,
  LocalVfs18bzski76hhpp as LocalVfs,
} from './korlibs-io-vfs-root-korlibs-io-vfs.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from './kotlinx-atomicfu.mjs';
import {
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  runBlockingNoSuspensions25hsuevf2mle as runBlockingNoSuspensions,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  toDuration15w5sljvx2ut2 as toDuration_0,
  get_fast37cu8s8qwnuyi as get_fast,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Companion_instance2ulklky4u6bad as Companion_instance_4,
  decodeBytes2ku4evbjm0a21 as decodeBytes,
} from './korlibs-image-core-root-korlibs-image-core.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from './kotlinx-coroutines-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
var log2 = Math.log2;
//endregion
//region block: pre-declaration
class GrowMethod extends Enum {}
class Entry {
  constructor(slice, data) {
    this.ic0_1 = slice;
    this.jc0_1 = data;
  }
  toString() {
    return 'Entry(slice=' + this.ic0_1.toString() + ', data=' + toString(this.jc0_1) + ')';
  }
  hashCode() {
    var result = this.ic0_1.hashCode();
    result = imul(result, 31) + (this.jc0_1 == null ? 0 : hashCode(this.jc0_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!this.ic0_1.equals(tmp0_other_with_cast.ic0_1))
      return false;
    if (!equals(this.jc0_1, tmp0_other_with_cast.jc0_1))
      return false;
    return true;
  }
}
class MutableAtlas {
  constructor(binPacker, border, premultiplied, allowToGrow, growMethod) {
    return new.target.nc1(binPacker, border, premultiplied, allowToGrow, growMethod);
  }
  static nc1(binPacker, border, premultiplied, allowToGrow, growMethod) {
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    var $this = createThis(this);
    $this.kc0_1 = binPacker;
    $this.lc0_1 = border;
    $this.mc0_1 = premultiplied;
    $this.nc0_1 = allowToGrow;
    $this.oc0_1 = growMethod;
    $this.pc0_1 = MarginInt.t9k($this.lc0_1);
    $this.qc0_1 = Bitmap32.lc1($this.w9z(), $this.x9z(), VOID, $this.mc0_1);
    $this.rc0_1 = arrayListOf([$this.qc0_1]);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.sc0_1 = ArrayList.p2();
    $this.tc0_1 = LinkedHashMap.m7();
    $this.uc0_1 = null;
    return $this;
  }
  static oc1(width, height, border, premultiplied, allowToGrow, growMethod) {
    width = width === VOID ? 2048 : width;
    height = height === VOID ? width : height;
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    return this.nc1(Companion_instance_0.aai(width, height), border, premultiplied, allowToGrow, growMethod);
  }
  w9z() {
    return numberToInt(this.kc0_1.w9z());
  }
  x9z() {
    return numberToInt(this.kc0_1.x9z());
  }
  s2() {
    return this.sc0_1.s2();
  }
  pc1(bmp, data, name) {
    return this.mc1(slice(bmp, VOID, name), data, name);
  }
  qc1(bmp, data, name, $super) {
    name = name === VOID ? 'Slice' + this.s2() : name;
    return $super === VOID ? this.pc1(bmp, data, name) : $super.pc1.call(this, bmp, data, name);
  }
  mc1(bmp, data, name) {
    var tmp = get_bmp(bmp);
    if (!(tmp instanceof Bitmap32)) {
      return this.pc1(extract_0(bmp).ec2(), data, name);
    }
    if (!(bmp instanceof RectSlice))
      THROW_CCE();
    try {
      var rname = name == null ? 'Slice' + this.s2() : name;
      var isEmpty = isFullyTransparent(bmp);
      var entry = null;
      if (isEmpty && !(this.uc0_1 == null)) {
        var bigEmptySlice = ensureNotNull(this.uc0_1).ic0_1;
        if (bigEmptySlice.qaj_1 >= bmp.qaj_1 && bigEmptySlice.raj_1 >= bmp.raj_1) {
          entry = new Entry(bigEmptySlice.aal(RectangleInt.s9q(0, 0, bmp.qaj_1, bmp.raj_1)), data);
        }
      }
      if (entry == null) {
        var rect = this.kc0_1.taa(bmp.qaj_1 + imul(this.lc0_1, 2), bmp.raj_1 + imul(this.lc0_1, 2));
        var slice = sliceWithSize(this.qc0_1, numberToInt(rect.v9h() + this.lc0_1), numberToInt(rect.x9h() + this.lc0_1), bmp.qaj_1, bmp.raj_1, rname);
        var dstX = slice.v9h();
        var dstY = slice.x9h();
        var boundsWithBorder = get_bounds_0(slice).t9q(this.pc0_1);
        // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
        var this_0 = this.qc0_1;
        if (true) {
          this_0.fc2();
        }
        var result;
        try {
          this.qc0_1.gc2(bmp, dstX, dstY);
          expandBorder(this.qc0_1, slice.iaj_1, this.lc0_1);
        }finally {
          result = true ? this_0.hc2(boundsWithBorder) : 0;
        }
        entry = new Entry(slice, data);
        if (this.uc0_1 == null || bmp.g9r() > ensureNotNull(this.uc0_1).ic0_1.g9r()) {
          this.uc0_1 = entry;
        }
      }
      var tmp0 = this.sc0_1;
      // Inline function 'kotlin.collections.plusAssign' call
      var element = entry;
      tmp0.d2(element);
      var tmp0_0 = this.tc0_1;
      // Inline function 'kotlin.collections.set' call
      var value = entry;
      tmp0_0.b5(rname, value);
      return entry;
    } catch ($p) {
      if ($p instanceof ImageDoNotFitException) {
        var e = $p;
        if (!this.nc0_1)
          throw e;
        growAtlas(this, bmp);
        return this.mc1(bmp, data, name);
      } else {
        throw $p;
      }
    }
  }
  ic2(bmp, data, name, $super) {
    name = name === VOID ? bmp.laj_1 : name;
    return $super === VOID ? this.mc1(bmp, data, name) : $super.mc1.call(this, bmp, data, name);
  }
}
class Bitmap {
  static kc2(width, height, bpp, premultiplied, backingArray) {
    var $this = createThis(this);
    $this.rc1_1 = new Mixin();
    $this.sc1_1 = width;
    $this.tc1_1 = height;
    $this.uc1_1 = bpp;
    $this.vc1_1 = backingArray;
    $this.wc1_1 = RectangleInt.s9q(0, 0, $this.sc1_1, $this.tc1_1);
    $this.xc1_1 = null;
    $this.yc1_1 = premultiplied;
    $this.zc1_1 = false;
    var tmp = $this;
    tmp.ac2_1 = lazy(Bitmap$tempInts$delegate$lambda($this));
    $this.bc2_1 = 0;
    $this.cc2_1 = null;
    $this.dc2_1 = false;
    return $this;
  }
  o9u(_set____db54di) {
    this.rc1_1.o9u(_set____db54di);
  }
  p9u() {
    return this.rc1_1.p9u();
  }
  s2() {
    return SizeInt.q9s(this.sc1_1, this.tc1_1);
  }
  jc2() {
    var tmp0 = this.ac2_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('tempInts', 1, tmp, Bitmap$_get_tempInts_$ref_piyo2f(), null);
    return tmp0.k3();
  }
  lc2() {
    return _RgbaArray___init__impl__oib4y4(this.jc2());
  }
  mc2() {
    return imul(this.sc1_1, this.uc1_1) / 8 | 0;
  }
  g9r() {
    return imul(this.sc1_1, this.tc1_1);
  }
  nc2(x, y) {
    return imul(y, this.sc1_1) + x | 0;
  }
  oc2() {
    if (!(this.cc2_1 == null)) {
      this.cc2_1 = null;
    }
  }
  fc2() {
    return Unit_instance;
  }
  hc2(rect) {
    if (this.cc2_1 == null)
      this.cc2_1 = rect;
    else
      this.cc2_1 = Companion_instance_1.z9q(ensureNotNull(this.cc2_1), rect);
    this.bc2_1 = this.bc2_1 + 1 | 0;
    return this.bc2_1;
  }
  pc2(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            out[_unary__edvuaz] = _RGBA___get_value__impl__hhco8v(this.qc2(x0 + x | 0, y0 + y | 0));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  rc2(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = x0 + x | 0;
            var tmp_0 = y0 + y | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            this.sc2(tmp, tmp_0, _RGBA___init__impl__lqpay5(out[_unary__edvuaz]));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  tc2(x, y, width, height, out, offset, $super) {
    offset = offset === VOID ? 0 : offset;
    var tmp;
    if ($super === VOID) {
      this.rc2(x, y, width, height, out, offset);
      tmp = Unit_instance;
    } else {
      tmp = $super.rc2.call(this, x, y, width, height, out, offset);
    }
    return tmp;
  }
  uc2(x, y, v) {
    if (this.yc1_1) {
      this.sc2(x, y, asNonPremultiplied(_RGBA___get_premultiplied__impl__3bulqc(v)));
    } else {
      this.sc2(x, y, v);
    }
  }
  vc2(x, y) {
    var tmp;
    if (this.yc1_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = asPremultiplied(this.qc2(x, y));
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = this.qc2(x, y);
    }
    return tmp;
  }
  wc2(x, y, color) {
    this.sc2(x, y, _RGBA___init__impl__lqpay5(color));
  }
  xc2(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.qc2(x, y));
  }
  yc2(x, y) {
    var x0 = toIntFloor(x);
    var y0 = toIntFloor(y);
    if (x0 < 0 || y0 < 0 || x0 >= this.sc1_1 || y0 >= this.tc1_1)
      return Colors_getInstance().ec3_1;
    var x1 = toIntCeil(x);
    var y1 = toIntCeil(y);
    var x1Inside = x1 < (this.sc1_1 - 1 | 0);
    var y1Inside = y1 < (this.tc1_1 - 1 | 0);
    // Inline function 'korlibs.math.fract' call
    var xratio = x - toIntFloor(x);
    // Inline function 'korlibs.math.fract' call
    var yratio = y - toIntFloor(y);
    var c00 = this.qc2(x0, y0);
    var c10 = x1Inside ? this.qc2(x1, y0) : c00;
    var c01 = y1Inside ? this.qc2(x0, y1) : c00;
    var c11 = x1Inside && y1Inside ? this.qc2(x1, y1) : c01;
    return Companion_getInstance_21().wc8(c00, c10, c01, c11, toRatio(xratio), toRatio(yratio));
  }
  xc8(srcX, srcY, dst, dstX, dstY, width, height) {
    var src = this;
    var srcX0 = src.yc8(srcX);
    var srcX1 = src.yc8(srcX + width | 0);
    var srcY0 = src.zc8(srcY);
    var srcY1 = src.zc8(srcY + height | 0);
    var dstX0 = dst.yc8(dstX);
    var dstX1 = dst.yc8(dstX + width | 0);
    var dstY0 = dst.zc8(dstY);
    var dstY1 = dst.zc8(dstY + height | 0);
    var srcX_0 = srcX0;
    var srcY_0 = srcY0;
    var dstX_0 = dstX0;
    var dstY_0 = dstY0;
    var tmp0 = srcX1 - srcX0 | 0;
    // Inline function 'kotlin.math.min' call
    var b = dstX1 - dstX0 | 0;
    var width_0 = Math.min(tmp0, b);
    var tmp0_0 = srcY1 - srcY0 | 0;
    // Inline function 'kotlin.math.min' call
    var b_0 = dstY1 - dstY0 | 0;
    var height_0 = Math.min(tmp0_0, b_0);
    this.ac9(srcX_0, srcY_0, dst, dstX_0, dstY_0, width_0, height_0);
  }
  ac9(srcX, srcY, dst, dstX, dstY, width, height) {
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.pc2(srcX, srcY + y | 0, width, 1, this.jc2(), 0);
        dst.rc2(dstX, dstY + y | 0, width, 1, this.jc2(), 0);
      }
       while (inductionVariable < height);
  }
  bc9(x) {
    return x >= 0 && x < this.sc1_1;
  }
  cc9(y) {
    return y >= 0 && y < this.tc1_1;
  }
  dc9(x, y) {
    return this.bc9(x) && this.cc9(y);
  }
  ec9(x) {
    return clamp(x, 0, this.sc1_1 - 1 | 0);
  }
  fc9(y) {
    return clamp(y, 0, this.tc1_1 - 1 | 0);
  }
  yc8(x) {
    return clamp(x, 0, this.sc1_1);
  }
  zc8(y) {
    return clamp(y, 0, this.tc1_1);
  }
  gc9() {
    var inductionVariable = 0;
    var last = this.tc1_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.hc9(y, (this.tc1_1 - y | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  ic9() {
    var inductionVariable = 0;
    var last = this.sc1_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.jc9(x, (this.sc1_1 - x | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  kc9(rotation) {
    var tmp;
    switch (rotation.w1_1) {
      case 0:
        tmp = this.g9m();
        break;
      case 1:
        tmp = this.lc9().ic9();
        break;
      case 2:
        tmp = this.lc9().ic9().lc9().ic9();
        break;
      case 3:
        tmp = this.lc9().gc9();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  mc9(orientation) {
    var out = this.g9m();
    if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
      out.ic9();
    }
    return out.kc9(_SliceOrientation___get_rotation__impl__m65r0o(orientation));
  }
  lc9() {
    var temp = new IntArray2(this.sc1_1, this.tc1_1, readPixelsUnsafe(this, 0, 0, this.sc1_1, this.tc1_1));
    var tmp2 = this.tc1_1;
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var height = this.sc1_1;
    var tmp = 0;
    var tmp_0 = imul(tmp2, height);
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 0;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var out = new IntArray2(tmp2, height, isIntArray(tmp_2) ? tmp_2 : THROW_CCE());
    var inductionVariable = 0;
    var last = this.tc1_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.sc1_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.ca0(y, x, temp.p9j(x, y));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = this.nc9(this.tc1_1, this.sc1_1);
    this_0.tc2(0, 0, this.tc1_1, this.sc1_1, out.v9z_1);
    return this_0;
  }
  hc9(y0, y1) {
    var inductionVariable = 0;
    var last = this.sc1_1;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.xc2(x, y0);
        var c1 = this.xc2(x, y1);
        this.wc2(x, y0, c1);
        this.wc2(x, y1, c0);
      }
       while (inductionVariable < last);
  }
  jc9(x0, x1) {
    var inductionVariable = 0;
    var last = this.tc1_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.xc2(x0, y);
        var c1 = this.xc2(x1, y);
        this.wc2(x0, y, c1);
        this.wc2(x1, y, c0);
      }
       while (inductionVariable < last);
  }
  oc9(antialiasing) {
    throw UnsupportedOperationException.a1('Not implemented context2d on Bitmap, please use NativeImage or Bitmap32 instead');
  }
  nc9(width, height) {
    invalidOp('Unsupported createWithThisFormat (' + toString_0(this) + ')');
  }
  ec2() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.lc1(this.sc1_1, this.tc1_1, VOID, this.yc1_1);
    this.pc2(0, 0, this.sc1_1, this.tc1_1, this_0.ic1_1, 0);
    return this_0;
  }
  pc9() {
    var tmp;
    if (this instanceof Bitmap32) {
      tmp = this;
    } else {
      tmp = this.ec2();
    }
    return tmp;
  }
  g9m() {
    var out = this.nc9(this.sc1_1, this.tc1_1);
    this.ac9(0, 0, out, 0, 0, this.sc1_1, this.tc1_1);
    return out;
  }
}
class Companion {
  constructor() {
    Companion_instance_5 = this;
    this.xc9_1 = Bitmap32.lc1(0, 0, VOID, true);
  }
  yc9(width, height, value) {
    // Inline function 'kotlin.apply' call
    var this_0 = Bitmap32.lc1(width, height, VOID, true);
    fill(this_0.ic1_1, _RGBAPremultiplied___get_value__impl__bqfhud(value));
    return this_0;
  }
  zc9(width, height, premultiplied) {
    return Bitmap32.lc1(width, height, new Int32Array(imul(width, height)), premultiplied);
  }
  aca(src, srcChannel, dst, dstChannel) {
    var srcShift = srcChannel.eca_1;
    var dstShift = dstChannel.eca_1;
    var dstClear = dstChannel.gca_1;
    var dstData = dst.ic1_1;
    var srcData = src.ic1_1;
    var inductionVariable = 0;
    var last = dst.g9r();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = (srcData[n] >>> srcShift | 0) & 255;
        dstData[n] = dstData[n] & dstClear | c << dstShift;
      }
       while (inductionVariable < last);
  }
  hca(src, dst, dstChannel) {
    var destShift = imul(dstChannel.dca_1, 8);
    var destClear = ~(255 << destShift);
    var inductionVariable = 0;
    var last = dst.g9r();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = src.x8s()[n] & 255;
        dst.ic1_1[n] = dst.ic1_1[n] & destClear | c << destShift;
      }
       while (inductionVariable < last);
  }
  ccb(src, srcChannel, dst) {
    var shift = srcChannel.eca_1;
    var inductionVariable = 0;
    var last = src.g9r();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        dst.x8s()[n] = toByte((src.ic1_1[n] >>> shift | 0) & 255);
      }
       while (inductionVariable < last);
  }
}
class Bitmap32 extends Bitmap {
  constructor(width, height, ints, premultiplied) {
    return new.target.lc1(width, height, ints, premultiplied);
  }
  static lc1(width, height, ints, premultiplied) {
    Companion_getInstance_15();
    ints = ints === VOID ? new Int32Array(imul(width, height)) : ints;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    var $this = this.kc2(width, height, 32, premultiplied, ints);
    $this.ic1_1 = ints;
    if ($this.ic1_1.length < imul(width, height))
      throw RuntimeException.xb('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.ic1_1.length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.jc1_1 = new Int32Array(tmp$ret$0);
    $this.kc1_1 = RectangleInt.s9q(0, 0, width, height);
    return $this;
  }
  static ecb(width, height, value) {
    Companion_getInstance_15();
    var $this = this.lc1(width, height, VOID, false);
    fill($this.ic1_1, _RGBA___get_value__impl__hhco8v(value));
    return $this;
  }
  static fcb(width, height, value) {
    Companion_getInstance_15();
    return this.lc1(width, height, _RgbaArray___get_ints__impl__u2kps1(value), false);
  }
  nc9(width, height) {
    return Bitmap32.lc1(width, height, VOID, this.yc1_1);
  }
  ac9(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap32))
      return super.ac9(srcX, srcY, dst, dstX, dstY, width, height);
    var src = this;
    var srcArray = src.ic1_1;
    var dstArray = dst.ic1_1;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        arraycopy(srcArray, src.nc2(srcX, srcY + y | 0), dstArray, dst.nc2(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  gcb(x, y, color) {
    this.uc2(x, y, color);
  }
  hcb(x, y) {
    return this.vc2(x, y);
  }
  wc2(x, y, color) {
    this.ic1_1[this.nc2(x, y)] = color;
  }
  xc2(x, y) {
    return this.ic1_1[this.nc2(x, y)];
  }
  qc2(x, y) {
    return _RGBA___init__impl__lqpay5(this.xc2(x, y));
  }
  sc2(x, y, v) {
    return this.wc2(x, y, _RGBA___get_value__impl__hhco8v(v));
  }
  icb(n, color) {
    this.ic1_1[n] = this.yc1_1 ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(color)) : _RGBA___get_value__impl__hhco8v(color);
  }
  jcb(n, color) {
    var tmp;
    if (this.yc1_1) {
      tmp = _RGBAPremultiplied___get_value__impl__bqfhud(color);
    } else {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(color);
      tmp = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
    }
    this.ic1_1[n] = tmp;
  }
  dcb(n) {
    var tmp;
    if (this.yc1_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.ic1_1[n]);
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = _RGBA___init__impl__lqpay5(this.ic1_1[n]);
    }
    return tmp;
  }
  kcb(n) {
    return this.yc1_1 ? _RGBAPremultiplied___init__impl__uos02x(this.ic1_1[n]) : _RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.ic1_1[n]));
  }
  lcb(src, dx, dy, sleft, stop, sright, sbottom, mix_0) {
    var dst = this;
    var width = sright - sleft | 0;
    var height = sbottom - stop | 0;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dstOffset = dst.nc2(dx, dy + y | 0);
        var srcOffset = src.nc2(sleft, stop + y | 0);
        if (mix_0) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < width)
            do {
              var x = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              dst.jcb(dstOffset + x | 0, mix(dst.kcb(dstOffset + x | 0), src.kcb(srcOffset + x | 0)));
            }
             while (inductionVariable_0 < width);
        } else {
          if (dst.yc1_1 === src.yc1_1) {
            arraycopy(src.ic1_1, srcOffset, dst.ic1_1, dstOffset, width);
          } else if (!dst.yc1_1) {
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                dst.icb(dstOffset + x_0 | 0, src.dcb(srcOffset + x_0 | 0));
              }
               while (inductionVariable_1 < width);
          } else {
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < width)
              do {
                var x_1 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                dst.jcb(dstOffset + x_1 | 0, src.kcb(srcOffset + x_1 | 0));
              }
               while (inductionVariable_2 < width);
          }
        }
      }
       while (inductionVariable < height);
  }
  mcb(src, dx, dy, sleft, stop, sright, sbottom, mix) {
    var sleft_0 = sleft;
    var stop_0 = stop;
    var dx_0 = dx;
    var dy_0 = dy;
    if (dx_0 < 0) {
      sleft_0 = sleft_0 - dx_0 | 0;
      dx_0 = 0;
    }
    if (dy_0 < 0) {
      stop_0 = stop_0 - dy_0 | 0;
      dy_0 = 0;
    }
    var availableWidth = this.sc1_1 - dx_0 | 0;
    var availableHeight = this.tc1_1 - dy_0 | 0;
    // Inline function 'kotlin.math.min' call
    var b = sright - sleft_0 | 0;
    var awidth = Math.min(availableWidth, b);
    // Inline function 'kotlin.math.min' call
    var b_0 = sbottom - stop_0 | 0;
    var aheight = Math.min(availableHeight, b_0);
    this.lcb(src, dx_0, dy_0, sleft_0, stop_0, sleft_0 + awidth | 0, stop_0 + aheight | 0, mix);
  }
  ncb(mix, other, _dx, _dy) {
    this.mcb(other, _dx, _dy, 0, 0, other.sc1_1, other.tc1_1, mix);
  }
  ocb(color, x, y, width, height) {
    var x1 = this.ec9(x);
    var x2 = this.ec9((x + width | 0) - 1 | 0);
    var y1 = this.fc9(y);
    var y2 = this.fc9((y + height | 0) - 1 | 0);
    var colorInt = RGBA__premultipliedValue_impl_oja55q(color, this.yc1_1);
    var inductionVariable = y1;
    if (inductionVariable <= y2)
      do {
        var cy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        fill(this.ic1_1, colorInt, this.nc2(x1, cy), this.nc2(x2, cy) + 1 | 0);
      }
       while (!(cy === y2));
  }
  pcb(color, x, y, width, height, $super) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? this.sc1_1 - x | 0 : width;
    height = height === VOID ? this.tc1_1 - y | 0 : height;
    var tmp;
    if ($super === VOID) {
      this.ocb(color, x, y, width, height);
      tmp = Unit_instance;
    } else {
      tmp = $super.ocb.call(this, new RGBA(color), x, y, width, height);
    }
    return tmp;
  }
  qcb(src, dx, dy, mix) {
    var b = get_bounds_0(src);
    this.mcb(get_bmp(src), dx, dy, b.v9h(), b.x9h(), b.w9h(), b.y9h(), mix);
  }
  rcb(src, dx, dy) {
    return this.ncb(false, src, dx, dy);
  }
  scb(src, dx, dy) {
    return this.ncb(true, src, dx, dy);
  }
  gc2(src, dx, dy) {
    return this.qcb(src, dx, dy, true);
  }
  tcb(destination, input, source) {
    return Companion_getInstance_15().aca(input, source, this, destination);
  }
  ucb(destination, input) {
    return Companion_getInstance_15().hca(input, this, destination);
  }
  vcb(channel, out) {
    // Inline function 'kotlin.also' call
    Companion_getInstance_15().ccb(this, channel, out);
    return out;
  }
  wcb(channel, out, $super) {
    out = out === VOID ? Bitmap8.rcc(this.sc1_1, this.tc1_1) : out;
    return $super === VOID ? this.vcb(channel, out) : $super.vcb.call(this, channel, out);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    this_0.m1('Bitmap32(');
    this_0.kh(this.sc1_1);
    this_0.m1(', ');
    this_0.kh(this.tc1_1);
    if (!(this.xc1_1 == null)) {
      this_0.m1(', name=');
      this_0.m1(this.xc1_1);
    }
    this_0.m1(')');
    return this_0.toString();
  }
  hc9(y0, y1) {
    var s0 = this.nc2(0, y0);
    var s1 = this.nc2(0, y1);
    arraycopy(this.ic1_1, s0, this.jc1_1, 0, this.sc1_1);
    arraycopy(this.ic1_1, s1, this.ic1_1, s0, this.sc1_1);
    arraycopy(this.jc1_1, 0, this.ic1_1, s1, this.sc1_1);
  }
  g9m() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = this.ic1_1.slice();
    return Bitmap32.lc1(this.sc1_1, this.tc1_1, tmp$ret$0, this.yc1_1);
  }
  oc9(antialiasing) {
    return new Context2d(new Bitmap32Context2d(this, antialiasing));
  }
  scc() {
    return this.yc1_1 ? this : this.copyPremultiplied();
  }
  tcc() {
    return !this.yc1_1 ? this : this.ucc();
  }
  copyPremultiplied() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.g9m();
    this_0.vcc();
    return this_0;
  }
  ucc() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.g9m();
    this_0.wcc();
    return this_0;
  }
  vcc() {
    if (this.yc1_1)
      return Unit_instance;
    this.yc1_1 = true;
    var inductionVariable = 0;
    var last = this.g9r();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.ic1_1[n] = _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.ic1_1[n])));
      }
       while (inductionVariable < last);
  }
  wcc() {
    if (!this.yc1_1)
      return Unit_instance;
    this.yc1_1 = false;
    var inductionVariable = 0;
    var last = this.g9r();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.ic1_1[n]);
        var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
        this.ic1_1[n] = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
      }
       while (inductionVariable < last);
  }
  p1() {
    return iterator(Bitmap32$iterator$slambda(this));
  }
  xcc(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy(_RgbaArray___get_ints__impl__u2kps1(data), 0, this.ic1_1, this.nc2(x, y), width);
    } else {
      var m = this.nc2(x, y);
      var inductionVariable = 0;
      if (inductionVariable < width)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.ic1_1[m] = _RgbaArray___get_ints__impl__u2kps1(data)[n];
          m = m + increment | 0;
        }
         while (inductionVariable < width);
    }
  }
  ec2() {
    return this;
  }
}
class Companion_0 {
  ycc(src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.xc8(srcX, srcY, dst, dstX, dstY, width, height);
  }
}
class BitmapIndexed extends Bitmap {
  static acd(bpp, width, height, bytes, palette) {
    bytes = bytes === VOID ? new Int8Array(imul(width, height) / (8 / bpp | 0) | 0) : bytes;
    palette = palette === VOID ? Companion_instance_14.zcc(1 << bpp) : palette;
    var $this = this.kc2(width, height, bpp, false, bytes);
    $this.vca_1 = bytes;
    $this.wca_1 = palette;
    if ($this.vca_1.length < (imul(width, height) / (8 / bpp | 0) | 0))
      throw RuntimeException.xb('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.x8s().length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.xca_1 = new Int8Array(tmp$ret$0);
    $this.yca_1 = _UByteArrayInt___init__impl__xif7bu($this.x8s());
    $this.zca_1 = 8 / bpp | 0;
    $this.acb_1 = ilog2($this.zca_1);
    $this.bcb_1 = $this.zca_1 - 1 | 0;
    return $this;
  }
  x8s() {
    return this.vca_1;
  }
  toString() {
    return 'BitmapIndexed(bpp=' + this.uc1_1 + ', width=' + this.sc1_1 + ', height=' + this.tc1_1 + ', clut=' + _RgbaArray___get_size__impl__imxef8(this.wca_1) + ')';
  }
  xc2(x, y) {
    return this.ccd(this.nc2(x, y));
  }
  wc2(x, y, color) {
    return this.bcd(this.nc2(x, y), color);
  }
  ccd(n) {
    var iD = this.ecd(n);
    var iM = this.fcd(n);
    return extract(UByteArrayInt__get_impl_px6q8a(this.yca_1, iD), imul(this.uc1_1, iM), this.uc1_1);
  }
  bcd(n, color) {
    var iD = this.ecd(n);
    var iM = this.fcd(n);
    UByteArrayInt__set_impl_gn4532(this.yca_1, iD, insert(UByteArrayInt__get_impl_px6q8a(this.yca_1, iD), color, imul(this.uc1_1, iM), this.uc1_1));
  }
  qc2(x, y) {
    var tmp = this.wca_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.xc2(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  sc2(x, y, v) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Not yet implemented';
    throw NotImplementedError.le('An operation is not implemented: ' + reason);
  }
  dcd(x, y) {
    return this.ecd(this.nc2(x, y));
  }
  ecd(n) {
    return n >>> this.acb_1 | 0;
  }
  fcd(n) {
    return n & this.bcb_1;
  }
  hc9(y0, y1) {
    var s0 = this.dcd(0, y0);
    var s1 = this.dcd(0, y1);
    arraycopy_0(this.x8s(), s0, this.xca_1, 0, this.mc2());
    arraycopy_0(this.x8s(), s1, this.x8s(), s0, this.mc2());
    arraycopy_0(this.xca_1, 0, this.x8s(), s1, this.mc2());
  }
  gcd(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy_0(data, 0, this.x8s(), this.nc2(x, y), width / this.zca_1 | 0);
    } else {
      var m = this.nc2(x, y);
      var inductionVariable = 0;
      var last = width / this.zca_1 | 0;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.x8s()[m] = data[n];
          m = m + increment | 0;
        }
         while (inductionVariable < last);
    }
  }
  ec2() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.lc1(this.sc1_1, this.tc1_1, VOID, this.yc1_1);
    var out = this_0.ic1_1;
    var pal = _RgbaArray___get_ints__impl__u2kps1(this.wca_1);
    var inductionVariable = 0;
    var last = this.g9r();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out[n] = pal[this.ccd(n)];
      }
       while (inductionVariable < last);
    return this_0;
  }
}
class Bitmap8 extends BitmapIndexed {
  constructor(width, height, data, palette) {
    return new.target.rcc(width, height, data, palette);
  }
  static rcc(width, height, data, palette) {
    data = data === VOID ? new Int8Array(imul(width, height)) : data;
    palette = palette === VOID ? Companion_instance_14.zcc(256) : palette;
    return this.acd(8, width, height, data, palette);
  }
  nc9(width, height) {
    return Bitmap8.rcc(width, height, VOID, this.wca_1);
  }
  wc2(x, y, color) {
    return this.bcd(this.nc2(x, y), color);
  }
  xc2(x, y) {
    return UByteArrayInt__get_impl_px6q8a(this.yca_1, this.nc2(x, y));
  }
  qc2(x, y) {
    var tmp = this.wca_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.xc2(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  ccd(n) {
    return UByteArrayInt__get_impl_px6q8a(this.yca_1, n);
  }
  bcd(n, color) {
    UByteArrayInt__set_impl_gn4532(this.yca_1, n, color);
  }
  ac9(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap8))
      return super.ac9(srcX, srcY, dst, dstX, dstY, width, height);
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.x8s();
        var tmp_0 = this.nc2(srcX, srcY + y | 0);
        arraycopy_0(tmp, tmp_0, (dst instanceof Bitmap8 ? dst : THROW_CCE()).x8s(), dst.nc2(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  g9m() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this.x8s().slice();
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = _RgbaArray___get_ints__impl__u2kps1(this.wca_1).slice();
    return Bitmap8.rcc(this.sc1_1, this.tc1_1, tmp, _RgbaArray___init__impl__oib4y4(tmp$ret$2));
  }
  toString() {
    return 'Bitmap8(' + this.sc1_1 + ', ' + this.tc1_1 + ', palette=' + _RgbaArray___get_size__impl__imxef8(this.wca_1) + ')';
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_7 = this;
    this.hcd_1 = values();
  }
  u2(index) {
    return this.hcd_1[index];
  }
}
class BitmapChannel extends Enum {
  constructor(name, ordinal, index) {
    super(name, ordinal);
    this.dca_1 = index;
    this.eca_1 = imul(this.dca_1, 8);
    this.fca_1 = 255 << this.eca_1;
    this.gca_1 = ~this.fca_1;
  }
}
class Bitmaps {}
class Companion_2 {
  constructor() {
    this.icd_1 = 1.0;
    this.jcd_1 = 1.4142135;
  }
}
class DistanceBitmap {
  constructor(width, height, d, px, py) {
    d = d === VOID ? new Float32Array(imul(width, height)) : d;
    px = px === VOID ? new Int32Array(imul(width, height)) : px;
    py = py === VOID ? new Int32Array(imul(width, height)) : py;
    this.kcd_1 = width;
    this.lcd_1 = height;
    this.mcd_1 = d;
    this.ncd_1 = px;
    this.ocd_1 = py;
    this.pcd_1 = imul(this.kcd_1, this.lcd_1);
    // Inline function 'kotlin.check' call
    if (!(this.mcd_1.length >= this.pcd_1)) {
      throw IllegalStateException.o('Check failed.');
    }
    // Inline function 'kotlin.check' call
    if (!(this.ncd_1.length >= this.pcd_1)) {
      throw IllegalStateException.o('Check failed.');
    }
    // Inline function 'kotlin.check' call
    if (!(this.ocd_1.length >= this.pcd_1)) {
      throw IllegalStateException.o('Check failed.');
    }
  }
  bc9(x) {
    return x >= 0 && x < this.kcd_1;
  }
  cc9(y) {
    return y >= 0 && y < this.lcd_1;
  }
  dc9(x, y) {
    return this.bc9(x) && this.cc9(y);
  }
  nc2(x, y) {
    return imul(y, this.kcd_1) + x | 0;
  }
  ucd(x, y) {
    return this.dc9(x, y) ? this.mcd_1[this.nc2(x, y)] : Infinity;
  }
  rcd(x, y) {
    return this.dc9(x, y) ? this.ncd_1[this.nc2(x, y)] : -1;
  }
  scd(x, y) {
    return this.dc9(x, y) ? this.ocd_1[this.nc2(x, y)] : -1;
  }
  tcd(x, y, d) {
    if (!this.dc9(x, y))
      return Unit_instance;
    this.mcd_1[this.nc2(x, y)] = d;
  }
  vcd(x, y, px, py) {
    if (!this.dc9(x, y))
      return Unit_instance;
    var index = this.nc2(x, y);
    this.ncd_1[index] = px;
    this.ocd_1[index] = py;
  }
  qcd(x, y, px, py) {
    return this.vcd(x, y, this.rcd(px, py), this.scd(px, py));
  }
  wcd(bmp, thresold) {
    // Inline function 'kotlin.check' call
    if (!(this.kcd_1 === bmp.sc1_1)) {
      throw IllegalStateException.o('Check failed.');
    }
    // Inline function 'kotlin.check' call
    if (!(this.lcd_1 === bmp.tc1_1)) {
      throw IllegalStateException.o('Check failed.');
    }
    var thresoldInt = numberToInt(clamp01(thresold) * 255);
    var inductionVariable = 0;
    var last = this.lcd_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.kcd_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.tcd(x, y, Infinity);
            this.vcd(x, y, -1, -1);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    var inductionVariable_1 = 0;
    var last_1 = this.lcd_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = this.kcd_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var cur = setFromBitmap$getAlpha(bmp, x_0, y_0, thresoldInt);
            var left = setFromBitmap$getAlpha(bmp, x_0 - 1 | 0, y_0, thresoldInt);
            var right = setFromBitmap$getAlpha(bmp, x_0 + 1 | 0, y_0, thresoldInt);
            var up = setFromBitmap$getAlpha(bmp, x_0, y_0 - 1 | 0, thresoldInt);
            var down = setFromBitmap$getAlpha(bmp, x_0, y_0 + 1 | 0, thresoldInt);
            if (!(left === cur) || !(right === cur) || !(up === cur) || !(down === cur)) {
              this.tcd(x_0, y_0, 0.0);
              this.vcd(x_0, y_0, x_0, y_0);
            }
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    var inductionVariable_3 = 0;
    var last_3 = this.lcd_1;
    if (inductionVariable_3 < last_3)
      do {
        var y_1 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var inductionVariable_4 = 0;
        var last_4 = this.kcd_1;
        if (inductionVariable_4 < last_4)
          do {
            var x_1 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            setFromBitmap$pass(this, x_1, y_1, -1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, 0, -1, 1.0);
            setFromBitmap$pass(this, x_1, y_1, 1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, -1, 0, 1.0);
          }
           while (inductionVariable_4 < last_4);
      }
       while (inductionVariable_3 < last_3);
    var inductionVariable_5 = this.lcd_1 - 1 | 0;
    if (0 <= inductionVariable_5)
      do {
        var y_2 = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + -1 | 0;
        var inductionVariable_6 = this.kcd_1 - 1 | 0;
        if (0 <= inductionVariable_6)
          do {
            var x_2 = inductionVariable_6;
            inductionVariable_6 = inductionVariable_6 + -1 | 0;
            setFromBitmap$pass(this, x_2, y_2, 1, 0, 1.0);
            setFromBitmap$pass(this, x_2, y_2, -1, 1, 1.4142135);
            setFromBitmap$pass(this, x_2, y_2, 0, 1, 1.0);
            setFromBitmap$pass(this, x_2, y_2, 1, 1, 1.4142135);
          }
           while (0 <= inductionVariable_6);
      }
       while (0 <= inductionVariable_5);
    var inductionVariable_7 = this.lcd_1 - 1 | 0;
    if (0 <= inductionVariable_7)
      do {
        var y_3 = inductionVariable_7;
        inductionVariable_7 = inductionVariable_7 + -1 | 0;
        var inductionVariable_8 = this.kcd_1 - 1 | 0;
        if (0 <= inductionVariable_8)
          do {
            var x_3 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + -1 | 0;
            if (setFromBitmap$getAlpha(bmp, x_3, y_3, thresoldInt)) {
              this.tcd(x_3, y_3, -this.ucd(x_3, y_3));
            }
          }
           while (0 <= inductionVariable_8);
      }
       while (0 <= inductionVariable_7);
  }
}
class FloatBitmap32 extends Bitmap {
  constructor(width, height, data, premultiplied) {
    return new.target.lce(width, height, data, premultiplied);
  }
  static lce(width, height, data, premultiplied) {
    data = data === VOID ? new Float32Array(imul(imul(width, height), 4)) : data;
    premultiplied = premultiplied === VOID ? false : premultiplied;
    var $this = this.kc2(width, height, 32, premultiplied, data);
    $this.kce_1 = data;
    return $this;
  }
  sc2(x, y, v) {
    var rindex = index4(this, x, y);
    this.kce_1[rindex + 0 | 0] = _RGBA___get_rf__impl__kvz75k(v);
    this.kce_1[rindex + 1 | 0] = _RGBA___get_gf__impl__5gcu1f(v);
    this.kce_1[rindex + 2 | 0] = _RGBA___get_bf__impl__1xz5yg(v);
    this.kce_1[rindex + 3 | 0] = _RGBA___get_af__impl__vu36qv(v);
  }
  qc2(x, y) {
    var rindex = index4(this, x, y);
    return Companion_getInstance_21().mce(this.kce_1[rindex + 0 | 0], this.kce_1[rindex + 1 | 0], this.kce_1[rindex + 2 | 0], this.kce_1[rindex + 3 | 0]);
  }
  nce(x, y) {
    return this.kce_1[index4(this, x, y) + 0 | 0];
  }
  oce(x, y) {
    return this.kce_1[index4(this, x, y) + 1 | 0];
  }
  pce(x, y) {
    return this.kce_1[index4(this, x, y) + 2 | 0];
  }
  qce(x, y) {
    return this.kce_1[index4(this, x, y) + 3 | 0];
  }
  rce(x, y, r, g, b, a) {
    var rindex = index4(this, x, y);
    this.kce_1[rindex + 0 | 0] = r;
    this.kce_1[rindex + 1 | 0] = g;
    this.kce_1[rindex + 2 | 0] = b;
    this.kce_1[rindex + 3 | 0] = a;
  }
  sce(x, y, out) {
    var rindex = index4(this, x, y);
    _RGBAf___set_r__impl__pz5j5e(out, this.kce_1[rindex + 0 | 0]);
    _RGBAf___set_g__impl__c4jj21(out, this.kce_1[rindex + 1 | 0]);
    _RGBAf___set_b__impl__a2n9pa(out, this.kce_1[rindex + 2 | 0]);
    _RGBAf___set_a__impl__iqz7cx(out, this.kce_1[rindex + 3 | 0]);
    return out;
  }
  tce(out) {
    var min_0 = Infinity;
    var max_0 = -Infinity;
    var temp = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.sc1_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.tc1_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.nc2(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            n = n + 1 | 0;
            var c = this.sce(x, y, temp);
            min_0 = min(min_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
            max_0 = max(max_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    out[0] = min_0;
    out[1] = max_0;
    return out;
  }
  uce(out, $super) {
    out = out === VOID ? new Float32Array(2) : out;
    return $super === VOID ? this.tce(out) : $super.tce.call(this, out);
  }
  vce(minSrc, maxSrc, minDst, maxDst) {
    var out = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.sc1_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.tc1_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.nc2(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            n = n + 1 | 0;
            var rgbaf = this.sce(x, y, out);
            this.rce(x, y, convertRange(_RGBAf___get_r__impl__jfq8gq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_g__impl__dhoraz(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_b__impl__fjl0nq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_a__impl__qnwk97(rgbaf), minSrc, maxSrc, minDst, maxDst));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  wce(minSrc, maxSrc, minDst, maxDst, $super) {
    minDst = minDst === VOID ? 0.0 : minDst;
    maxDst = maxDst === VOID ? 1.0 : maxDst;
    var tmp;
    if ($super === VOID) {
      this.vce(minSrc, maxSrc, minDst, maxDst);
      tmp = Unit_instance;
    } else {
      tmp = $super.vce.call(this, minSrc, maxSrc, minDst, maxDst);
    }
    return tmp;
  }
  xce() {
    var _destruct__k2r9zo = this.uce();
    // Inline function 'kotlin.collections.component1' call
    var min = _destruct__k2r9zo[0];
    // Inline function 'kotlin.collections.component2' call
    var max = _destruct__k2r9zo[1];
    // Inline function 'kotlin.math.absoluteValue' call
    var tmp0 = Math.abs(min);
    // Inline function 'kotlin.math.absoluteValue' call
    // Inline function 'kotlin.math.max' call
    var b = Math.abs(max);
    var range = Math.max(tmp0, b);
    this.wce(-range, +range);
  }
  yce(scale) {
    return this.zce(scale, scale, scale, scale);
  }
  zce(scaleRed, scaleGreen, scaleBlue, scaleAlpha) {
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.sc1_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.tc1_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.nc2(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            n = n + 1 | 0;
            this.rce(x, y, this.nce(x, y) * scaleRed, this.oce(x, y) * scaleGreen, this.pce(x, y) * scaleBlue, this.qce(x, y) * scaleAlpha);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  acf(min, max) {
    // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.sc1_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.tc1_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.nc2(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            n = n + 1 | 0;
            var value = this.nce(x, y);
            var tmp = clamp_0(value, min, max);
            var value_0 = this.oce(x, y);
            var tmp_0 = clamp_0(value_0, min, max);
            var value_1 = this.pce(x, y);
            var tmp_1 = clamp_0(value_1, min, max);
            var value_2 = this.qce(x, y);
            var tmp$ret$6 = clamp_0(value_2, min, max);
            this.rce(x, y, tmp, tmp_0, tmp_1, tmp$ret$6);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
}
class MultiBitmap extends Bitmap {}
class NativeImage extends Bitmap {
  static pcf(width, height, data, premultiplied) {
    var $this = this.kc2(width, height, 32, premultiplied, null);
    $this.ocf_1 = data;
    return $this;
  }
  ec2() {
    // Inline function 'kotlin.also' call
    var this_0 = Companion_getInstance_15().zc9(this.sc1_1, this.tc1_1, this.yc1_1);
    this.pc2(0, 0, this.sc1_1, this.tc1_1, this_0.ic1_1, 0);
    return this_0;
  }
  sc2(x, y, v) {
    RgbaArray__set_impl_epw2wg(this.lc2(), 0, v);
    this.rc2(x, y, 1, 1, this.jc2(), 0);
  }
  qc2(x, y) {
    this.pc2(x, y, 1, 1, this.jc2(), 0);
    return RgbaArray__get_impl_nzyo1o(this.lc2(), 0);
  }
  wc2(x, y, color) {
    return this.sc2(x, y, _RGBA___init__impl__lqpay5(color));
  }
  xc2(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.qc2(x, y));
  }
  gc9() {
    var tmp = this.ec2().gc9();
    this.tc2(0, 0, this.sc1_1, this.tc1_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).ic1_1);
    return this;
  }
  ic9() {
    var tmp = this.ec2().ic9();
    this.tc2(0, 0, this.sc1_1, this.tc1_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).ic1_1);
    return this;
  }
  hc9(y0, y1) {
    this.pc2(0, y0, this.sc1_1, 1, this.jc2(), 0);
    this.pc2(0, y1, this.sc1_1, 1, this.jc2(), this.sc1_1);
    this.rc2(0, y1, this.sc1_1, 1, this.jc2(), 0);
    this.rc2(0, y0, this.sc1_1, 1, this.jc2(), this.sc1_1);
  }
  jc9(x0, x1) {
    this.pc2(x0, 0, 1, this.tc1_1, this.jc2(), 0);
    this.pc2(x1, 0, 1, this.tc1_1, this.jc2(), this.sc1_1);
    this.rc2(x1, 0, 1, this.tc1_1, this.jc2(), 0);
    this.rc2(x0, 0, 1, this.tc1_1, this.jc2(), this.sc1_1);
  }
  nc9(width, height) {
    return NativeImage_0(width, height);
  }
  toString() {
    return this.h1() + '(' + this.sc1_1 + ', ' + this.tc1_1 + ')';
  }
}
class ForcedTexId {}
function get_forcedTexTarget() {
  return 3553;
}
class NullBitmap extends Bitmap {
  constructor(width, height, premultiplied) {
    return new.target.ucg(width, height, premultiplied);
  }
  static ucg(width, height, premultiplied) {
    Companion_getInstance_19();
    premultiplied = premultiplied === VOID ? true : premultiplied;
    return this.kc2(width, height, 32, premultiplied, null);
  }
  sc2(x, y, v) {
    return Unit_instance;
  }
  qc2(x, y) {
    return _RGBA___init__impl__lqpay5(0);
  }
}
class Companion_3 extends NullBitmap {
  constructor() {
    return new.target.gcg();
  }
  static gcg() {
    Companion_instance_9 = null;
    var $this = this.ucg(1, 1);
    Companion_instance_9 = $this;
    return $this;
  }
}
class Palette {
  constructor(colors, names, changeStart, changeEnd) {
    names = names === VOID ? null : names;
    changeStart = changeStart === VOID ? 0 : changeStart;
    changeEnd = changeEnd === VOID ? 0 : changeEnd;
    this.vcg_1 = colors;
    this.wcg_1 = names;
    this.xcg_1 = changeStart;
    this.ycg_1 = changeEnd;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    this_0.m1('Palette(');
    var inductionVariable = 0;
    var last = _RgbaArray___get_size__impl__imxef8(this.vcg_1);
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var color = RgbaArray__get_impl_nzyo1o(this.vcg_1, n);
        var tmp22_safe_receiver = this.wcg_1;
        var name = tmp22_safe_receiver == null ? null : tmp22_safe_receiver[n];
        if (n > 0) {
          this_0.m1(', ');
        }
        if (!(name == null)) {
          this_0.m1(name);
          this_0.m1(': ');
        }
        this_0.m1(RGBA__toString_impl_4lw6dp(color));
      }
       while (inductionVariable < last);
    this_0.m1(')');
    return this_0.toString();
  }
}
class BitmapEffect {
  constructor(blurRadius, dropShadowX, dropShadowY, dropShadowRadius, dropShadowColor, borderSize, borderColor) {
    blurRadius = blurRadius === VOID ? 0 : blurRadius;
    dropShadowX = dropShadowX === VOID ? 0 : dropShadowX;
    dropShadowY = dropShadowY === VOID ? 0 : dropShadowY;
    dropShadowRadius = dropShadowRadius === VOID ? 0 : dropShadowRadius;
    dropShadowColor = dropShadowColor === VOID ? Colors_getInstance().ac3_1 : dropShadowColor;
    borderSize = borderSize === VOID ? 0 : borderSize;
    borderColor = borderColor === VOID ? Colors_getInstance().ac3_1 : borderColor;
    this.zcg_1 = blurRadius;
    this.ach_1 = dropShadowX;
    this.bch_1 = dropShadowY;
    this.cch_1 = dropShadowRadius;
    this.dch_1 = dropShadowColor;
    this.ech_1 = borderSize;
    this.fch_1 = borderColor;
  }
  gch() {
    var tmp0 = this.zcg_1;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = this.ach_1;
    // Inline function 'kotlin.math.max' call
    var b = abs(this_0);
    var tmp0_0 = Math.max(tmp0, b);
    // Inline function 'kotlin.math.absoluteValue' call
    var this_1 = this.bch_1;
    // Inline function 'kotlin.math.max' call
    var b_0 = abs(this_1);
    var tmp0_1 = Math.max(tmp0_0, b_0);
    // Inline function 'kotlin.math.max' call
    var b_1 = this.ech_1;
    return Math.max(tmp0_1, b_1);
  }
  toString() {
    return 'BitmapEffect(blurRadius=' + this.zcg_1 + ', dropShadowX=' + this.ach_1 + ', dropShadowY=' + this.bch_1 + ', dropShadowRadius=' + this.cch_1 + ', dropShadowColor=' + RGBA__toString_impl_4lw6dp(this.dch_1) + ', borderSize=' + this.ech_1 + ', borderColor=' + RGBA__toString_impl_4lw6dp(this.fch_1) + ')';
  }
  hashCode() {
    var result = this.zcg_1;
    result = imul(result, 31) + this.ach_1 | 0;
    result = imul(result, 31) + this.bch_1 | 0;
    result = imul(result, 31) + this.cch_1 | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.dch_1) | 0;
    result = imul(result, 31) + this.ech_1 | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.fch_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapEffect))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapEffect ? other : THROW_CCE();
    if (!(this.zcg_1 === tmp0_other_with_cast.zcg_1))
      return false;
    if (!(this.ach_1 === tmp0_other_with_cast.ach_1))
      return false;
    if (!(this.bch_1 === tmp0_other_with_cast.bch_1))
      return false;
    if (!(this.cch_1 === tmp0_other_with_cast.cch_1))
      return false;
    if (!(this.dch_1 === tmp0_other_with_cast.dch_1))
      return false;
    if (!(this.ech_1 === tmp0_other_with_cast.ech_1))
      return false;
    if (!(this.fch_1 === tmp0_other_with_cast.fch_1))
      return false;
    return true;
  }
}
class Result {
  constructor(bmp, buffer, radius, cutoff) {
    this.jch_1 = bmp;
    this.kch_1 = buffer;
    this.lch_1 = radius;
    this.mch_1 = cutoff;
  }
  toString() {
    return 'Result(bmp=' + this.jch_1.toString() + ', buffer=' + this.kch_1 + ', radius=' + this.lch_1 + ', cutoff=' + this.mch_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.jch_1);
    result = imul(result, 31) + this.kch_1 | 0;
    result = imul(result, 31) + this.lch_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.mch_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.jch_1, tmp0_other_with_cast.jch_1))
      return false;
    if (!(this.kch_1 === tmp0_other_with_cast.kch_1))
      return false;
    if (!(this.lch_1 === tmp0_other_with_cast.lch_1))
      return false;
    if (!equals(this.mch_1, tmp0_other_with_cast.mch_1))
      return false;
    return true;
  }
}
class NewSDF {
  constructor() {
    this.nch_1 = 1.0E10;
  }
  och(bmp, maxSide, buffer, radius, cutoff) {
    var size = maxSide + imul(buffer, 4) | 0;
    var out = Bitmap32.lc1(bmp.sc1_1 + imul(buffer, 2) | 0, bmp.tc1_1 + imul(buffer, 2) | 0);
    var tmp2 = out.sc1_1;
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var height = out.tc1_1;
    var tmp = 0;
    var tmp_0 = imul(tmp2, height);
    var tmp_1 = new Float32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 1.0E10;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var gridOuter = new FloatArray2(tmp2, height, isFloatArray(tmp_2) ? tmp_2 : THROW_CCE());
    var tmp2_0 = out.sc1_1;
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var height_0 = out.tc1_1;
    var tmp_3 = 0;
    var tmp_4 = imul(tmp2_0, height_0);
    var tmp_5 = new Float32Array(tmp_4);
    while (tmp_3 < tmp_4) {
      tmp_5[tmp_3] = 0.0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    var tmp_6 = tmp_5;
    var gridInner = new FloatArray2(tmp2_0, height_0, isFloatArray(tmp_6) ? tmp_6 : THROW_CCE());
    var f = new Float32Array(size);
    var z = new Float32Array(size + 1 | 0);
    var v = _UShortArrayInt___init__impl__kdofb8(size);
    var inductionVariable = 0;
    var last = bmp.tc1_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = bmp.sc1_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a = _RGBA___get_af__impl__vu36qv(bmp.hcb(x, y));
            var x0 = x + buffer | 0;
            var y0 = y + buffer | 0;
            switch (a) {
              case 0.0:
                gridOuter.ja0(x0, y0, 1.0E10);
                gridInner.ja0(x0, y0, 0.0);
                break;
              case 1.0:
                gridOuter.ja0(x0, y0, 0.0);
                gridInner.ja0(x0, y0, 1.0E10);
                break;
              default:
                var d = 0.5 - a;
                gridOuter.ja0(x0, y0, d > 0.0 ? d * d : 0.0);
                gridInner.ja0(x0, y0, d < 0.0 ? d * d : 0.0);
                break;
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    this.pch(gridOuter.ha0_1, 0, 0, out.sc1_1, out.tc1_1, gridOuter.w9z(), f, v, z);
    this.pch(gridInner.ha0_1, buffer, buffer, bmp.sc1_1, bmp.tc1_1, gridInner.w9z(), f, v, z);
    var inductionVariable_1 = 0;
    var last_1 = out.tc1_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = out.sc1_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var gout = gridOuter.p9j(x_0, y_0);
            var gin = gridInner.p9j(x_0, y_0);
            // Inline function 'kotlin.math.sqrt' call
            var tmp_7 = Math.sqrt(gout);
            // Inline function 'kotlin.math.sqrt' call
            var d_0 = tmp_7 - Math.sqrt(gin);
            var a_0 = toIntRound(255 - 255 * (d_0 / radius + cutoff));
            out.gcb(x_0, y_0, Companion_getInstance_21().ich(255, 255, 255, clamp(a_0, 0, 255)));
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    return new Result(out, buffer, radius, cutoff);
  }
  qch(bmp, maxSide, buffer, radius, cutoff, $super) {
    var tmp;
    if (maxSide === VOID) {
      var tmp0 = bmp.sc1_1;
      // Inline function 'kotlin.math.max' call
      var b = bmp.tc1_1;
      tmp = Math.max(tmp0, b);
    } else {
      tmp = maxSide;
    }
    maxSide = tmp;
    buffer = buffer === VOID ? divCeil(maxSide, 8) : buffer;
    radius = radius === VOID ? divCeil(maxSide, 3) : radius;
    cutoff = cutoff === VOID ? 0.5 : cutoff;
    return $super === VOID ? this.och(bmp, maxSide, buffer, radius, cutoff) : $super.och.call(this, bmp, maxSide, buffer, radius, cutoff);
  }
  pch(data, x0, y0, width, height, gridSize, f, v, z) {
    var inductionVariable = x0;
    var last = x0 + width | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.rch(data, imul(y0, gridSize) + x | 0, gridSize, height, f, v, z);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = y0;
    var last_0 = y0 + height | 0;
    if (inductionVariable_0 < last_0)
      do {
        var y = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.rch(data, imul(y, gridSize) + x0 | 0, 1, width, f, v, z);
      }
       while (inductionVariable_0 < last_0);
  }
  rch(grid, offset, stride, length, f, v, z) {
    UShortArrayInt__set_impl_38wgvc(v, 0, 0);
    z[0] = -1.0E10;
    z[1] = 1.0E10;
    f[0] = grid[offset];
    var k = 0;
    var s = 0.0;
    var inductionVariable = 1;
    if (inductionVariable < length)
      do {
        var q = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        f[q] = grid[offset + imul(q, stride) | 0];
        var q2 = imul(q, q);
        $l$1: do {
          $l$0: do {
            var r = UShortArrayInt__get_impl_ciz20k(v, k);
            s = (f[q] - f[r] + q2 - imul(r, r)) / (q - r | 0) / 2.0;
          }
           while (false);
          var tmp;
          if (s <= z[k]) {
            k = k - 1 | 0;
            tmp = k > -1;
          } else {
            tmp = false;
          }
        }
         while (tmp);
        k = k + 1 | 0;
        UShortArrayInt__set_impl_38wgvc(v, k, q);
        z[k] = s;
        z[k + 1 | 0] = 1.0E10;
      }
       while (inductionVariable < length);
    k = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < length)
      do {
        var q_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        while (z[k + 1 | 0] < q_0) {
          k = k + 1 | 0;
        }
        var r_0 = UShortArrayInt__get_impl_ciz20k(v, k);
        var qr = q_0 - r_0 | 0;
        grid[offset + imul(q_0, stride) | 0] = f[r_0] + imul(qr, qr);
      }
       while (inductionVariable_0 < length);
  }
}
class ColorFormat32 {
  constructor() {
    this.xch_1 = 32;
  }
  sch() {
    return this.xch_1;
  }
}
class ColorFormat24 {
  constructor() {
    this.ych_1 = 24;
  }
  sch() {
    return this.ych_1;
  }
}
class ColorTransformMul {
  constructor(_r, _g, _b, _a) {
    _r = _r === VOID ? 1.0 : _r;
    _g = _g === VOID ? 1.0 : _g;
    _b = _b === VOID ? 1.0 : _b;
    _a = _a === VOID ? 1.0 : _a;
    this.zch_1 = _r;
    this.aci_1 = _g;
    this.bci_1 = _b;
    this.cci_1 = _a;
    this.dci_1 = true;
    this.eci_1 = Colors_getInstance().zc2_1;
  }
  fci() {
    return this.zch_1;
  }
  gci() {
    return this.aci_1;
  }
  hci() {
    return this.bci_1;
  }
  ici(value) {
    this.cci_1 = value;
    this.dci_1 = true;
  }
  jci() {
    return this.cci_1;
  }
  kci(v) {
    this.lci(_RGBA___get_rf__impl__kvz75k(v), _RGBA___get_gf__impl__5gcu1f(v), _RGBA___get_bf__impl__1xz5yg(v), _RGBA___get_af__impl__vu36qv(v));
    this.eci_1 = v;
    this.dci_1 = false;
  }
  mci() {
    if (this.dci_1) {
      this.dci_1 = false;
      this.eci_1 = Companion_getInstance_21().mce(this.zch_1, this.aci_1, this.bci_1, this.cci_1);
    }
    return this.eci_1;
  }
  lci(r, g, b, a) {
    this.zch_1 = r;
    this.aci_1 = g;
    this.bci_1 = b;
    this.cci_1 = a;
    this.dci_1 = true;
  }
  nci(other) {
    return this.lci(other.zch_1, other.aci_1, other.bci_1, other.cci_1);
  }
  oci(a, b) {
    return this.lci(a.fci() * b.fci(), a.gci() * b.gci(), a.hci() * b.hci(), a.jci() * b.jci());
  }
  toString() {
    return 'ColorTransformMul(_r=' + this.zch_1 + ', _g=' + this.aci_1 + ', _b=' + this.bci_1 + ', _a=' + this.cci_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.zch_1);
    result = imul(result, 31) + getNumberHashCode(this.aci_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.bci_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.cci_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransformMul))
      return false;
    var tmp0_other_with_cast = other instanceof ColorTransformMul ? other : THROW_CCE();
    if (!equals(this.zch_1, tmp0_other_with_cast.zch_1))
      return false;
    if (!equals(this.aci_1, tmp0_other_with_cast.aci_1))
      return false;
    if (!equals(this.bci_1, tmp0_other_with_cast.bci_1))
      return false;
    if (!equals(this.cci_1, tmp0_other_with_cast.cci_1))
      return false;
    return true;
  }
}
class Colors {
  constructor() {
    Colors_instance = this;
    this.zc2_1 = Companion_getInstance_21().ich(255, 255, 255, 255);
    this.ac3_1 = Companion_getInstance_21().ich(0, 0, 0, 255);
    this.bc3_1 = Companion_getInstance_21().ich(255, 0, 0, 255);
    this.cc3_1 = Companion_getInstance_21().ich(0, 255, 0, 255);
    this.dc3_1 = Companion_getInstance_21().ich(0, 0, 255, 255);
    this.ec3_1 = Companion_getInstance_21().ich(0, 0, 0, 0);
    this.fc3_1 = Companion_getInstance_21().ich(255, 255, 255, 0);
    this.gc3_1 = Companion_getInstance_21().pci(240, 248, 255);
    this.hc3_1 = Companion_getInstance_21().pci(250, 235, 215);
    this.ic3_1 = Companion_getInstance_21().pci(0, 255, 255);
    this.jc3_1 = Companion_getInstance_21().pci(127, 255, 212);
    this.kc3_1 = Companion_getInstance_21().pci(240, 255, 255);
    this.lc3_1 = Companion_getInstance_21().pci(245, 245, 220);
    this.mc3_1 = Companion_getInstance_21().pci(255, 228, 196);
    this.nc3_1 = Companion_getInstance_21().pci(255, 235, 205);
    this.oc3_1 = Companion_getInstance_21().pci(138, 43, 226);
    this.pc3_1 = Companion_getInstance_21().pci(165, 42, 42);
    this.qc3_1 = Companion_getInstance_21().pci(222, 184, 135);
    this.rc3_1 = Companion_getInstance_21().pci(95, 158, 160);
    this.sc3_1 = Companion_getInstance_21().pci(127, 255, 0);
    this.tc3_1 = Companion_getInstance_21().pci(210, 105, 30);
    this.uc3_1 = Companion_getInstance_21().pci(255, 127, 80);
    this.vc3_1 = Companion_getInstance_21().pci(100, 149, 237);
    this.wc3_1 = Companion_getInstance_21().pci(255, 248, 220);
    this.xc3_1 = Companion_getInstance_21().pci(220, 20, 60);
    this.yc3_1 = Companion_getInstance_21().pci(0, 0, 139);
    this.zc3_1 = Companion_getInstance_21().pci(0, 255, 255);
    this.ac4_1 = Companion_getInstance_21().pci(0, 139, 139);
    this.bc4_1 = Companion_getInstance_21().pci(184, 134, 11);
    this.cc4_1 = Companion_getInstance_21().pci(169, 169, 169);
    this.dc4_1 = Companion_getInstance_21().pci(0, 100, 0);
    this.ec4_1 = Companion_getInstance_21().pci(169, 169, 169);
    this.fc4_1 = Companion_getInstance_21().pci(189, 183, 107);
    this.gc4_1 = Companion_getInstance_21().pci(255, 0, 255);
    this.hc4_1 = Companion_getInstance_21().pci(139, 0, 139);
    this.ic4_1 = Companion_getInstance_21().pci(85, 107, 47);
    this.jc4_1 = Companion_getInstance_21().pci(255, 140, 0);
    this.kc4_1 = Companion_getInstance_21().pci(153, 50, 204);
    this.lc4_1 = Companion_getInstance_21().pci(139, 0, 0);
    this.mc4_1 = Companion_getInstance_21().pci(233, 150, 122);
    this.nc4_1 = Companion_getInstance_21().pci(143, 188, 143);
    this.oc4_1 = Companion_getInstance_21().pci(72, 61, 139);
    this.pc4_1 = Companion_getInstance_21().pci(47, 79, 79);
    this.qc4_1 = Companion_getInstance_21().pci(47, 79, 79);
    this.rc4_1 = Companion_getInstance_21().pci(0, 206, 209);
    this.sc4_1 = Companion_getInstance_21().pci(148, 0, 211);
    this.tc4_1 = Companion_getInstance_21().pci(255, 20, 147);
    this.uc4_1 = Companion_getInstance_21().pci(0, 191, 255);
    this.vc4_1 = Companion_getInstance_21().pci(105, 105, 105);
    this.wc4_1 = Companion_getInstance_21().pci(105, 105, 105);
    this.xc4_1 = Companion_getInstance_21().pci(30, 144, 255);
    this.yc4_1 = Companion_getInstance_21().pci(178, 34, 34);
    this.zc4_1 = Companion_getInstance_21().pci(255, 250, 240);
    this.ac5_1 = Companion_getInstance_21().pci(34, 139, 34);
    this.bc5_1 = Companion_getInstance_21().pci(255, 0, 255);
    this.cc5_1 = Companion_getInstance_21().pci(220, 220, 220);
    this.dc5_1 = Companion_getInstance_21().pci(248, 248, 255);
    this.ec5_1 = Companion_getInstance_21().pci(255, 215, 0);
    this.fc5_1 = Companion_getInstance_21().pci(218, 165, 32);
    this.gc5_1 = Companion_getInstance_21().pci(173, 255, 47);
    this.hc5_1 = Companion_getInstance_21().pci(240, 255, 240);
    this.ic5_1 = Companion_getInstance_21().pci(255, 105, 180);
    this.jc5_1 = Companion_getInstance_21().pci(205, 92, 92);
    this.kc5_1 = Companion_getInstance_21().pci(75, 0, 130);
    this.lc5_1 = Companion_getInstance_21().pci(255, 255, 240);
    this.mc5_1 = Companion_getInstance_21().pci(240, 230, 140);
    this.nc5_1 = Companion_getInstance_21().pci(230, 230, 250);
    this.oc5_1 = Companion_getInstance_21().pci(255, 240, 245);
    this.pc5_1 = Companion_getInstance_21().pci(124, 252, 0);
    this.qc5_1 = Companion_getInstance_21().pci(255, 250, 205);
    this.rc5_1 = Companion_getInstance_21().pci(173, 216, 230);
    this.sc5_1 = Companion_getInstance_21().pci(240, 128, 128);
    this.tc5_1 = Companion_getInstance_21().pci(224, 255, 255);
    this.uc5_1 = Companion_getInstance_21().pci(250, 250, 210);
    this.vc5_1 = Companion_getInstance_21().pci(211, 211, 211);
    this.wc5_1 = Companion_getInstance_21().pci(144, 238, 144);
    this.xc5_1 = Companion_getInstance_21().pci(211, 211, 211);
    this.yc5_1 = Companion_getInstance_21().pci(255, 182, 193);
    this.zc5_1 = Companion_getInstance_21().pci(255, 160, 122);
    this.ac6_1 = Companion_getInstance_21().pci(32, 178, 170);
    this.bc6_1 = Companion_getInstance_21().pci(135, 206, 250);
    this.cc6_1 = Companion_getInstance_21().pci(119, 136, 153);
    this.dc6_1 = Companion_getInstance_21().pci(119, 136, 153);
    this.ec6_1 = Companion_getInstance_21().pci(176, 196, 222);
    this.fc6_1 = Companion_getInstance_21().pci(255, 255, 224);
    this.gc6_1 = Companion_getInstance_21().pci(0, 255, 0);
    this.hc6_1 = Companion_getInstance_21().pci(50, 205, 50);
    this.ic6_1 = Companion_getInstance_21().pci(250, 240, 230);
    this.jc6_1 = Companion_getInstance_21().pci(128, 0, 0);
    this.kc6_1 = Companion_getInstance_21().pci(102, 205, 170);
    this.lc6_1 = Companion_getInstance_21().pci(0, 0, 205);
    this.mc6_1 = Companion_getInstance_21().pci(186, 85, 211);
    this.nc6_1 = Companion_getInstance_21().pci(147, 112, 219);
    this.oc6_1 = Companion_getInstance_21().pci(60, 179, 113);
    this.pc6_1 = Companion_getInstance_21().pci(123, 104, 238);
    this.qc6_1 = Companion_getInstance_21().pci(0, 250, 154);
    this.rc6_1 = Companion_getInstance_21().pci(72, 209, 204);
    this.sc6_1 = Companion_getInstance_21().pci(199, 21, 133);
    this.tc6_1 = Companion_getInstance_21().pci(25, 25, 112);
    this.uc6_1 = Companion_getInstance_21().pci(245, 255, 250);
    this.vc6_1 = Companion_getInstance_21().pci(255, 228, 225);
    this.wc6_1 = Companion_getInstance_21().pci(255, 228, 181);
    this.xc6_1 = Companion_getInstance_21().pci(255, 222, 173);
    this.yc6_1 = Companion_getInstance_21().pci(0, 0, 128);
    this.zc6_1 = Companion_getInstance_21().pci(253, 245, 230);
    this.ac7_1 = Companion_getInstance_21().pci(128, 128, 0);
    this.bc7_1 = Companion_getInstance_21().pci(107, 142, 35);
    this.cc7_1 = Companion_getInstance_21().pci(255, 165, 0);
    this.dc7_1 = Companion_getInstance_21().pci(255, 69, 0);
    this.ec7_1 = Companion_getInstance_21().pci(218, 112, 214);
    this.fc7_1 = Companion_getInstance_21().pci(238, 232, 170);
    this.gc7_1 = Companion_getInstance_21().pci(152, 251, 152);
    this.hc7_1 = Companion_getInstance_21().pci(175, 238, 238);
    this.ic7_1 = Companion_getInstance_21().pci(219, 112, 147);
    this.jc7_1 = Companion_getInstance_21().pci(255, 239, 213);
    this.kc7_1 = Companion_getInstance_21().pci(255, 218, 185);
    this.lc7_1 = Companion_getInstance_21().pci(205, 133, 63);
    this.mc7_1 = Companion_getInstance_21().pci(255, 192, 203);
    this.nc7_1 = Companion_getInstance_21().pci(221, 160, 221);
    this.oc7_1 = Companion_getInstance_21().pci(176, 224, 230);
    this.pc7_1 = Companion_getInstance_21().pci(128, 0, 128);
    this.qc7_1 = Companion_getInstance_21().pci(188, 143, 143);
    this.rc7_1 = Companion_getInstance_21().pci(65, 105, 225);
    this.sc7_1 = Companion_getInstance_21().pci(139, 69, 19);
    this.tc7_1 = Companion_getInstance_21().pci(250, 128, 114);
    this.uc7_1 = Companion_getInstance_21().pci(244, 164, 96);
    this.vc7_1 = Companion_getInstance_21().pci(46, 139, 87);
    this.wc7_1 = Companion_getInstance_21().pci(255, 245, 238);
    this.xc7_1 = Companion_getInstance_21().pci(160, 82, 45);
    this.yc7_1 = Companion_getInstance_21().pci(192, 192, 192);
    this.zc7_1 = Companion_getInstance_21().pci(135, 206, 235);
    this.ac8_1 = Companion_getInstance_21().pci(106, 90, 205);
    this.bc8_1 = Companion_getInstance_21().pci(112, 128, 144);
    this.cc8_1 = Companion_getInstance_21().pci(112, 128, 144);
    this.dc8_1 = Companion_getInstance_21().pci(255, 250, 250);
    this.ec8_1 = Companion_getInstance_21().pci(0, 255, 127);
    this.fc8_1 = Companion_getInstance_21().pci(70, 130, 180);
    this.gc8_1 = Companion_getInstance_21().pci(210, 180, 140);
    this.hc8_1 = Companion_getInstance_21().pci(0, 128, 128);
    this.ic8_1 = Companion_getInstance_21().pci(216, 191, 216);
    this.jc8_1 = Companion_getInstance_21().pci(255, 99, 71);
    this.kc8_1 = Companion_getInstance_21().pci(64, 224, 208);
    this.lc8_1 = Companion_getInstance_21().pci(238, 130, 238);
    this.mc8_1 = Companion_getInstance_21().pci(245, 222, 179);
    this.nc8_1 = Companion_getInstance_21().pci(245, 245, 245);
    this.oc8_1 = Companion_getInstance_21().pci(154, 205, 50);
    this.pc8_1 = Companion_getInstance_21().pci(255, 255, 0);
    this.qc8_1 = mapOf([to('black', new RGBA(this.ac3_1)), to('white', new RGBA(this.zc2_1)), to('red', new RGBA(this.bc3_1)), to('green', new RGBA(this.cc3_1)), to('blue', new RGBA(this.dc3_1)), to('aliceblue', new RGBA(this.gc3_1)), to('antiquewhite', new RGBA(this.hc3_1)), to('aqua', new RGBA(this.ic3_1)), to('aquamarine', new RGBA(this.jc3_1)), to('azure', new RGBA(this.kc3_1)), to('beige', new RGBA(this.lc3_1)), to('bisque', new RGBA(this.mc3_1)), to('blanchedalmond', new RGBA(this.nc3_1)), to('blueviolet', new RGBA(this.oc3_1)), to('brown', new RGBA(this.pc3_1)), to('burlywood', new RGBA(this.qc3_1)), to('cadetblue', new RGBA(this.rc3_1)), to('chartreuse', new RGBA(this.sc3_1)), to('chocolate', new RGBA(this.tc3_1)), to('coral', new RGBA(this.uc3_1)), to('cornflowerblue', new RGBA(this.vc3_1)), to('cornsilk', new RGBA(this.wc3_1)), to('crimson', new RGBA(this.xc3_1)), to('cyan', new RGBA(this.zc3_1)), to('darkblue', new RGBA(this.yc3_1)), to('darkcyan', new RGBA(this.ac4_1)), to('darkgoldenrod', new RGBA(this.bc4_1)), to('darkgray', new RGBA(this.cc4_1)), to('darkgreen', new RGBA(this.dc4_1)), to('darkgrey', new RGBA(this.ec4_1)), to('darkkhaki', new RGBA(this.fc4_1)), to('darkmagenta', new RGBA(this.hc4_1)), to('darkolivegreen', new RGBA(this.ic4_1)), to('darkorange', new RGBA(this.jc4_1)), to('darkorchid', new RGBA(this.kc4_1)), to('darkred', new RGBA(this.lc4_1)), to('darksalmon', new RGBA(this.mc4_1)), to('darkseagreen', new RGBA(this.nc4_1)), to('darkslateblue', new RGBA(this.oc4_1)), to('darkslategray', new RGBA(this.pc4_1)), to('darkslategrey', new RGBA(this.qc4_1)), to('darkturquoise', new RGBA(this.rc4_1)), to('darkviolet', new RGBA(this.sc4_1)), to('deeppink', new RGBA(this.tc4_1)), to('deepskyblue', new RGBA(this.uc4_1)), to('dimgray', new RGBA(this.vc4_1)), to('dimgrey', new RGBA(this.wc4_1)), to('dodgerblue', new RGBA(this.xc4_1)), to('firebrick', new RGBA(this.yc4_1)), to('floralwhite', new RGBA(this.zc4_1)), to('forestgreen', new RGBA(this.ac5_1)), to('fuchsia', new RGBA(this.bc5_1)), to('gainsboro', new RGBA(this.cc5_1)), to('ghostwhite', new RGBA(this.dc5_1)), to('gold', new RGBA(this.ec5_1)), to('goldenrod', new RGBA(this.fc5_1)), to('greenyellow', new RGBA(this.gc5_1)), to('honeydew', new RGBA(this.hc5_1)), to('hotpink', new RGBA(this.ic5_1)), to('indianred', new RGBA(this.jc5_1)), to('indigo', new RGBA(this.kc5_1)), to('ivory', new RGBA(this.lc5_1)), to('khaki', new RGBA(this.mc5_1)), to('lavender', new RGBA(this.nc5_1)), to('lavenderblush', new RGBA(this.oc5_1)), to('lawngreen', new RGBA(this.pc5_1)), to('lemonchiffon', new RGBA(this.qc5_1)), to('lightblue', new RGBA(this.rc5_1)), to('lightcoral', new RGBA(this.sc5_1)), to('lightcyan', new RGBA(this.tc5_1)), to('lightgoldenrodyellow', new RGBA(this.uc5_1)), to('lightgray', new RGBA(this.vc5_1)), to('lightgreen', new RGBA(this.wc5_1)), to('lightgrey', new RGBA(this.xc5_1)), to('lightpink', new RGBA(this.yc5_1)), to('lightsalmon', new RGBA(this.zc5_1)), to('lightseagreen', new RGBA(this.ac6_1)), to('lightskyblue', new RGBA(this.bc6_1)), to('lightslategray', new RGBA(this.cc6_1)), to('lightslategrey', new RGBA(this.dc6_1)), to('lightsteelblue', new RGBA(this.ec6_1)), to('lightyellow', new RGBA(this.fc6_1)), to('lime', new RGBA(this.gc6_1)), to('limegreen', new RGBA(this.hc6_1)), to('linen', new RGBA(this.ic6_1)), to('magenta', new RGBA(this.gc4_1)), to('maroon', new RGBA(this.jc6_1)), to('mediumaquamarine', new RGBA(this.kc6_1)), to('mediumblue', new RGBA(this.lc6_1)), to('mediumorchid', new RGBA(this.mc6_1)), to('mediumpurple', new RGBA(this.nc6_1)), to('mediumseagreen', new RGBA(this.oc6_1)), to('mediumslateblue', new RGBA(this.pc6_1)), to('mediumspringgreen', new RGBA(this.qc6_1)), to('mediumturquoise', new RGBA(this.rc6_1)), to('mediumvioletred', new RGBA(this.sc6_1)), to('midnightblue', new RGBA(this.tc6_1)), to('mintcream', new RGBA(this.uc6_1)), to('mistyrose', new RGBA(this.vc6_1)), to('moccasin', new RGBA(this.wc6_1)), to('navajowhite', new RGBA(this.xc6_1)), to('navy', new RGBA(this.yc6_1)), to('oldlace', new RGBA(this.zc6_1)), to('olive', new RGBA(this.ac7_1)), to('olivedrab', new RGBA(this.bc7_1)), to('orange', new RGBA(this.cc7_1)), to('orangered', new RGBA(this.dc7_1)), to('orchid', new RGBA(this.ec7_1)), to('palegoldenrod', new RGBA(this.fc7_1)), to('palegreen', new RGBA(this.gc7_1)), to('paleturquoise', new RGBA(this.hc7_1)), to('palevioletred', new RGBA(this.ic7_1)), to('papayawhip', new RGBA(this.jc7_1)), to('peachpuff', new RGBA(this.kc7_1)), to('peru', new RGBA(this.lc7_1)), to('pink', new RGBA(this.mc7_1)), to('plum', new RGBA(this.nc7_1)), to('powderblue', new RGBA(this.oc7_1)), to('purple', new RGBA(this.pc7_1)), to('rosybrown', new RGBA(this.qc7_1)), to('royalblue', new RGBA(this.rc7_1)), to('saddlebrown', new RGBA(this.sc7_1)), to('salmon', new RGBA(this.tc7_1)), to('sandybrown', new RGBA(this.uc7_1)), to('seagreen', new RGBA(this.vc7_1)), to('seashell', new RGBA(this.wc7_1)), to('sienna', new RGBA(this.xc7_1)), to('silver', new RGBA(this.yc7_1)), to('skyblue', new RGBA(this.zc7_1)), to('slateblue', new RGBA(this.ac8_1)), to('slategray', new RGBA(this.bc8_1)), to('slategrey', new RGBA(this.cc8_1)), to('snow', new RGBA(this.dc8_1)), to('springgreen', new RGBA(this.ec8_1)), to('steelblue', new RGBA(this.fc8_1)), to('tan', new RGBA(this.gc8_1)), to('teal', new RGBA(this.hc8_1)), to('thistle', new RGBA(this.ic8_1)), to('tomato', new RGBA(this.jc8_1)), to('turquoise', new RGBA(this.kc8_1)), to('violet', new RGBA(this.lc8_1)), to('wheat', new RGBA(this.mc8_1)), to('whitesmoke', new RGBA(this.nc8_1)), to('yellowgreen', new RGBA(this.oc8_1)), to('yellow', new RGBA(this.pc8_1))]);
  }
  qci(str) {
    return this.rci(str, this.ec3_1, true);
  }
  rci(str, default_0, errorOnDefault) {
    try {
      if (startsWith(str, '#')) {
        var hex = substr(str, 1);
        if (!setOf([3, 4, 6, 8]).w2(hex.length))
          return this.ac3_1;
        var chars = hex.length < 6 ? 1 : 2;
        var scale = hex.length < 6 ? 255.0 / 15.0 : 1.0;
        var hasAlpha = (hex.length / chars | 0) >= 4;
        var r = numberToInt(toInt(substr_0(hex, imul(0, chars), chars), 16) * scale);
        var g = numberToInt(toInt(substr_0(hex, imul(1, chars), chars), 16) * scale);
        var b = numberToInt(toInt(substr_0(hex, imul(2, chars), chars), 16) * scale);
        var a = hasAlpha ? numberToInt(toInt(substr_0(hex, imul(3, chars), chars), 16) * scale) : 255;
        return Companion_getInstance_21().ich(r, g, b, a);
      } else if (startsWith(str, 'RGBA(', true)) {
        // Inline function 'kotlin.text.toUpperCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = str.toUpperCase();
        var parts = split(removeSuffix(removePrefix(tmp$ret$0, 'RGBA('), ')'), [',']);
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp;
        if (0 <= 0 ? 0 < parts.s2() : false) {
          tmp = parts.u2(0);
        } else {
          tmp = '0';
        }
        var tmp$ret$2 = tmp;
        var tmp0_elvis_lhs = toIntOrNull(tmp$ret$2);
        var r_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp_0;
        if (0 <= 1 ? 1 < parts.s2() : false) {
          tmp_0 = parts.u2(1);
        } else {
          tmp_0 = '0';
        }
        var tmp$ret$4 = tmp_0;
        var tmp1_elvis_lhs = toIntOrNull(tmp$ret$4);
        var g_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp_1;
        if (0 <= 2 ? 2 < parts.s2() : false) {
          tmp_1 = parts.u2(2);
        } else {
          tmp_1 = '0';
        }
        var tmp$ret$6 = tmp_1;
        var tmp2_elvis_lhs = toIntOrNull(tmp$ret$6);
        var b_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp_2;
        if (0 <= 3 ? 3 < parts.s2() : false) {
          tmp_2 = parts.u2(3);
        } else {
          tmp_2 = '1.0';
        }
        var tmp$ret$8 = tmp_2;
        var tmp3_elvis_lhs = toDoubleOrNull(tmp$ret$8);
        var af = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
        return Companion_getInstance_21().ich(r_0, g_0, b_0, numberToInt(af * 255));
      } else {
        // Inline function 'kotlin.text.toLowerCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$10 = str.toLowerCase();
        var tmp_3 = this.qc8_1.w4(tmp$ret$10);
        var col = tmp_3 == null ? null : tmp_3.sci_1;
        var tmp_4;
        var tmp_5 = col;
        if ((tmp_5 == null ? null : new RGBA(tmp_5)) == null) {
          tmp_4 = errorOnDefault;
        } else {
          tmp_4 = false;
        }
        if (tmp_4)
          return this.tci('#' + str, default_0);
        var tmp_6;
        var tmp_7 = col;
        if ((tmp_7 == null ? null : new RGBA(tmp_7)) == null) {
          tmp_6 = default_0;
        } else {
          tmp_6 = col;
        }
        return tmp_6;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        return Colors_getInstance().bc3_1;
      } else {
        throw $p;
      }
    }
  }
  tci(str, default_0, errorOnDefault, $super) {
    errorOnDefault = errorOnDefault === VOID ? false : errorOnDefault;
    return $super === VOID ? this.rci(str, default_0, errorOnDefault) : $super.rci.call(this, str, new RGBA(default_0), errorOnDefault).sci_1;
  }
}
class RGB extends ColorFormat24 {
  constructor(rOffset, gOffset, bOffset) {
    Companion_getInstance_20();
    super();
    this.vci_1 = rOffset;
    this.wci_1 = gOffset;
    this.xci_1 = bOffset;
  }
  tch(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.vci_1 | 0) & 255;
  }
  uch(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.wci_1 | 0) & 255;
  }
  vch(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.xci_1 | 0) & 255;
  }
  wch(v) {
    return 255;
  }
}
class Companion_4 extends RGB {
  constructor() {
    Companion_instance_10 = null;
    super(0, 8, 16);
    Companion_instance_10 = this;
  }
}
class Companion_5 extends ColorFormat32 {
  constructor() {
    Companion_instance_11 = null;
    super();
    Companion_instance_11 = this;
    this.sc8_1 = 0;
    this.tc8_1 = 8;
    this.uc8_1 = 16;
    this.vc8_1 = 24;
  }
  mce(r, g, b, a) {
    return this.zci(f2i(r), f2i(g), f2i(b), f2i(a));
  }
  zci(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntUnchecked(r, g, b, a));
  }
  ich(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, a));
  }
  pci(r, g, b) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, 255));
  }
  acj(rgb, a) {
    return _RGBA___init__impl__lqpay5(rgb & 16777215 | a << 24);
  }
  tch(v) {
    return _RGBA___get_r__impl__duz7mo(_RGBA___init__impl__lqpay5(v));
  }
  uch(v) {
    return _RGBA___get_g__impl__o8pukr(_RGBA___init__impl__lqpay5(v));
  }
  vch(v) {
    return _RGBA___get_b__impl__m6tl80(_RGBA___init__impl__lqpay5(v));
  }
  wch(v) {
    return _RGBA___get_a__impl__6msvu7(_RGBA___init__impl__lqpay5(v));
  }
  bcj(c1, c2, factor256) {
    return _RGBA___init__impl__lqpay5(this.ccj(_RGBA___get_value__impl__hhco8v(c1), _RGBA___get_value__impl__hhco8v(c2), factor256));
  }
  ccj(c1, c2, factor256) {
    var ifactor256 = 256 - factor256 | 0;
    return ((imul(c1 & 16711935, ifactor256) + imul(c2 & 16711935, factor256) | 0) & -16711936 | (imul(c1 & 65280, ifactor256) + imul(c2 & 65280, factor256) | 0) & 16711680) >>> 8 | 0;
  }
  dcj(c1, c2, factor) {
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = Ratio__toFloat_impl_1ftup5(factor) * 256;
    var tmp$ret$0 = roundToInt(this_0);
    return this.bcj(c1, c2, tmp$ret$0);
  }
  ecj(c1, c2, factor) {
    return Companion_getInstance_21().acj(_RGBA___get_rgb__impl__tijaqt(this.dcj(c1, c2, factor)), blendComponent(this, _RGBA___get_a__impl__6msvu7(c1), _RGBA___get_a__impl__6msvu7(c2), factor));
  }
  wc8(c00, c10, c01, c11, factorX, factorY) {
    var c1 = this.ecj(c00, c10, factorX);
    var c2 = this.ecj(c01, c11, factorX);
    return this.ecj(c1, c2, factorY);
  }
  hch(dst, src) {
    var srcA = _RGBA___get_a__impl__6msvu7(src);
    var iSrcA = 255 - srcA | 0;
    switch (srcA) {
      case 0:
        return dst;
      case 255:
        return src;
      default:
        return Companion_getInstance_21().acj(_RGBA___get_rgb__impl__tijaqt(this.bcj(dst, src, srcA + 1 | 0)), clampUByte(srcA + (imul(_RGBA___get_a__impl__6msvu7(dst), iSrcA) / 255 | 0) | 0));
    }
  }
  yci(src, dst, ratio) {
    return Companion_getInstance_21().ich(interpolate(ratio, _RGBA___get_r__impl__duz7mo(src), _RGBA___get_r__impl__duz7mo(dst)), interpolate(ratio, _RGBA___get_g__impl__o8pukr(src), _RGBA___get_g__impl__o8pukr(dst)), interpolate(ratio, _RGBA___get_b__impl__m6tl80(src), _RGBA___get_b__impl__m6tl80(dst)), interpolate(ratio, _RGBA___get_a__impl__6msvu7(src), _RGBA___get_a__impl__6msvu7(dst)));
  }
}
class RGBA {
  constructor(value) {
    Companion_getInstance_21();
    this.sci_1 = value;
  }
  g9m() {
    return RGBA__clone_impl_w007z0(this.sci_1);
  }
  toString() {
    return RGBA__toString_impl_4lw6dp(this.sci_1);
  }
  fcj(other) {
    return RGBA__compareTo_impl_lrfjc1(this.sci_1, other);
  }
  d(other) {
    return RGBA__compareTo_impl_lrfjc1_0(this, other);
  }
  gcj(ratio, other) {
    return RGBA__interpolateWith_impl_mw7p5y(this.sci_1, ratio, other);
  }
  u9f(ratio, other) {
    return RGBA__interpolateWith_impl_mw7p5y_0(this, ratio, other);
  }
  hashCode() {
    return RGBA__hashCode_impl_h59qf6(this.sci_1);
  }
  equals(other) {
    return RGBA__equals_impl_4vjmca(this.sci_1, other);
  }
}
class Companion_6 {
  constructor() {
    this.hcj_1 = 16711935;
    this.icj_1 = -16711936;
  }
  jcj(dst, src) {
    return _RGBAPremultiplied___init__impl__uos02x(sumPacked4MulR(_RGBAPremultiplied___get_value__impl__bqfhud(src), _RGBAPremultiplied___get_value__impl__bqfhud(dst), 256 - _RGBAPremultiplied___get_a__impl__f0hnd1(src) | 0));
  }
}
class Companion_7 {
  kcj(size) {
    return _RgbaPremultipliedArray___init__impl__lx83hy(new Int32Array(size));
  }
}
class RgbaPremultipliedArray {
  constructor(ints) {
    this.lcj_1 = ints;
  }
  toString() {
    return RgbaPremultipliedArray__toString_impl_seal6e(this.lcj_1);
  }
  hashCode() {
    return RgbaPremultipliedArray__hashCode_impl_kvnjzv(this.lcj_1);
  }
  equals(other) {
    return RgbaPremultipliedArray__equals_impl_vav5d5(this.lcj_1, other);
  }
}
class Companion_8 {
  zcc(size) {
    return _RgbaArray___init__impl__oib4y4(new Int32Array(size));
  }
}
class RgbaArray {
  constructor(ints) {
    this.mcj_1 = ints;
  }
  t4(fromIndex, toIndex) {
    return RgbaArray__subList_impl_rbyi98(this.mcj_1, fromIndex, toIndex);
  }
  ncj(element) {
    return RgbaArray__contains_impl_ofn00n(this.mcj_1, element);
  }
  w2(element) {
    return RgbaArray__contains_impl_ofn00n_0(this, element);
  }
  ocj(elements) {
    return RgbaArray__containsAll_impl_l6gz5c(this.mcj_1, elements);
  }
  r4(elements) {
    return RgbaArray__containsAll_impl_l6gz5c_0(this, elements);
  }
  pcj(element) {
    return RgbaArray__indexOf_impl_d6b5pl(this.mcj_1, element);
  }
  y2(element) {
    return RgbaArray__indexOf_impl_d6b5pl_0(this, element);
  }
  n1() {
    return RgbaArray__isEmpty_impl_nch3ip(this.mcj_1);
  }
  p1() {
    return RgbaArray__iterator_impl_5wfwsm(this.mcj_1);
  }
  s4() {
    return RgbaArray__listIterator_impl_m4kjt0(this.mcj_1);
  }
  x2(index) {
    return RgbaArray__listIterator_impl_m4kjt0_0(this.mcj_1, index);
  }
  s2() {
    return _RgbaArray___get_size__impl__imxef8(this.mcj_1);
  }
  qcj(index) {
    return RgbaArray__get_impl_nzyo1o(this.mcj_1, index);
  }
  u2(index) {
    return RgbaArray__get_impl_nzyo1o_0(this, index);
  }
  toString() {
    return RgbaArray__toString_impl_vgvk04(this.mcj_1);
  }
  hashCode() {
    return RgbaArray__hashCode_impl_ht2l65(this.mcj_1);
  }
  equals(other) {
    return RgbaArray__equals_impl_6qvuf(this.mcj_1, other);
  }
}
class Companion_9 {
  rcj(f, s) {
    return insert(insert(0, f, 0, 16), s, 16, 16);
  }
}
class Companion_10 {}
class Kerning {
  constructor(first, second, amount) {
    this.bck_1 = first;
    this.cck_1 = second;
    this.dck_1 = amount;
  }
}
class Glyph {
  constructor(fontSize, id, texture, xoffset, yoffset, xadvance) {
    this.scj_1 = fontSize;
    this.tcj_1 = id;
    this.ucj_1 = texture;
    this.vcj_1 = xoffset;
    this.wcj_1 = yoffset;
    this.xcj_1 = xadvance;
    var tmp = this;
    tmp.ycj_1 = lazy(BitmapFont$Glyph$bmp$delegate$lambda(this));
    this.zcj_1 = new GlyphMetrics(this.scj_1, true, -1, Companion_getInstance_4().r9p(this.vcj_1, this.wcj_1, this.ucj_1.qaj_1, this.ucj_1.raj_1), this.xcj_1);
  }
  ack() {
    var tmp0 = this.ycj_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('bmp', 1, tmp, BitmapFont$Glyph$_get_bmp_$ref_4xexcz(), null);
    return tmp0.k3();
  }
  toString() {
    return 'Glyph(fontSize=' + this.scj_1 + ', id=' + this.tcj_1 + ', texture=' + this.ucj_1.toString() + ', xoffset=' + this.vcj_1 + ', yoffset=' + this.wcj_1 + ', xadvance=' + this.xcj_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.scj_1);
    result = imul(result, 31) + this.tcj_1 | 0;
    result = imul(result, 31) + this.ucj_1.hashCode() | 0;
    result = imul(result, 31) + this.vcj_1 | 0;
    result = imul(result, 31) + this.wcj_1 | 0;
    result = imul(result, 31) + this.xcj_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Glyph))
      return false;
    var tmp0_other_with_cast = other instanceof Glyph ? other : THROW_CCE();
    if (!equals(this.scj_1, tmp0_other_with_cast.scj_1))
      return false;
    if (!(this.tcj_1 === tmp0_other_with_cast.tcj_1))
      return false;
    if (!this.ucj_1.equals(tmp0_other_with_cast.ucj_1))
      return false;
    if (!(this.vcj_1 === tmp0_other_with_cast.vcj_1))
      return false;
    if (!(this.wcj_1 === tmp0_other_with_cast.wcj_1))
      return false;
    if (!(this.xcj_1 === tmp0_other_with_cast.xcj_1))
      return false;
    return true;
  }
}
class Font {}
function getOrNull_2() {
  return this;
}
function getFontMetrics$default(size, metrics, $super) {
  metrics = metrics === VOID ? new FontMetrics() : metrics;
  return $super === VOID ? this.nck(size, metrics) : $super.nck.call(this, size, metrics);
}
function getGlyphMetrics$default(size, codePoint, metrics, reader, $super) {
  metrics = metrics === VOID ? new GlyphMetrics() : metrics;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.zck(size, codePoint, metrics, reader) : $super.zck.call(this, size, codePoint, metrics, reader);
}
function renderGlyph$default(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw, $super) {
  reader = reader === VOID ? null : reader;
  beforeDraw = beforeDraw === VOID ? null : beforeDraw;
  return $super === VOID ? this.jcl(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) : $super.jcl.call(this, ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw);
}
class BitmapFont {}
function get_baseBmp() {
  return get_bmp(this.kck().ucj_1);
}
function getFontMetrics(size, metrics) {
  return metrics.xck(this.lck(), size);
}
function getGlyphMetrics(size, codePoint, metrics, reader) {
  var tmp38_safe_receiver = this.sa4(codePoint);
  var tmp0_elvis_lhs = tmp38_safe_receiver == null ? null : tmp38_safe_receiver.zcj_1;
  return metrics.fcl(tmp0_elvis_lhs == null ? this.mck() : tmp0_elvis_lhs, size, codePoint);
}
function getTextScale(size) {
  return size / this.eck();
}
function get_0(charCode) {
  var tmp0_elvis_lhs = this.sa4(charCode);
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.sa4(32) : tmp0_elvis_lhs;
  return tmp1_elvis_lhs == null ? this.kck() : tmp1_elvis_lhs;
}
function renderGlyph(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  var scale = this.icl(size);
  var tmp0_elvis_lhs = this.hck().u2(codePoint);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var g = tmp;
  // Inline function 'kotlin.takeIf' call
  var this_0 = this.zck(size, codePoint, metrics, reader);
  var tmp_0;
  if (this_0.bcl_1) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  if (tmp_0 == null)
    return false;
  if (metrics.w9z() === 0.0 && metrics.x9z() === 0.0)
    return false;
  var texX = pos.r9g_1 + metrics.v9h();
  var texY = pos.s9g_1 + metrics.x9h();
  var swidth = metrics.w9z();
  var sheight = metrics.x9z();
  var tmp_1;
  if (equals(ctx.gcm(), new RGBA(get_DefaultPaint()))) {
    tmp_1 = g.ack();
  } else {
    // Inline function 'korlibs.image.bitmap.context2d' call
    var this_1 = Bitmap32.lc1(g.ack().sc1_1, g.ack().tc1_1, VOID, true);
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_1.wc1_1;
    if (true) {
      this_1.fc2();
    }
    var result;
    try {
      var ctx_0 = this_1.oc9(true);
      try {
        // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
        var t = ctx_0.tc9_1.kcl_1;
        try {
          ctx_0.fcm(1.0 / scale);
          ctx_0.hcm(ctx.gcm());
          var tmp6 = ctx_0.w9z() * scale;
          // Inline function 'korlibs.image.vector.Context2d.fillRect' call
          var height = ctx_0.x9z() * scale;
          ctx_0.icm(numberToDouble(0), numberToDouble(0), numberToDouble(tmp6), numberToDouble(height));
        }finally {
          ctx_0.tc9_1.kcl_1 = t;
        }
      }finally {
        ctx_0.u1o();
      }
    }finally {
      result = true ? this_1.hc2(rect) : 0;
    }
    var bmpFill = this_1;
    bmpFill.tcb(BitmapChannel_ALPHA_getInstance(), g.ack(), BitmapChannel_ALPHA_getInstance());
    tmp_1 = bmpFill;
  }
  var bmp = tmp_1;
  if (beforeDraw == null)
    null;
  else
    beforeDraw();
  ctx.jcm(bmp, Vector2D.t9g(texX, texY - metrics.y9h()), Size2D.y9p(swidth, sheight));
  return true;
}
function getKerning(size, leftCodePoint, rightCodePoint) {
  var tmp = this.icl(size);
  var tmp40_safe_receiver = this.hcl(leftCodePoint, rightCodePoint);
  var tmp41_safe_receiver = tmp40_safe_receiver == null ? null : tmp40_safe_receiver.dck_1;
  var tmp0_elvis_lhs = tmp41_safe_receiver == null ? null : tmp41_safe_receiver;
  return tmp * (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
}
class BitmapFontImpl {
  constructor(fontSize, lineHeight, base, glyphs, kernings, name, distanceField) {
    name = name === VOID ? 'BitmapFont' : name;
    distanceField = distanceField === VOID ? null : distanceField;
    this.mcm_1 = new Mixin();
    this.ncm_1 = fontSize;
    this.ocm_1 = lineHeight;
    this.pcm_1 = base;
    this.qcm_1 = glyphs;
    this.rcm_1 = kernings;
    this.scm_1 = name;
    this.tcm_1 = distanceField;
    this.ucm_1 = this.ocm_1 - this.pcm_1;
    var tmp = this;
    tmp.vcm_1 = lazy(BitmapFontImpl$naturalFontMetrics$delegate$lambda(this));
    this.wcm_1 = new GlyphMetrics(this.ncm_1, false, 0, Companion_getInstance_4().y9k(), 0.0);
    var tmp_0 = this;
    tmp_0.xcm_1 = lazy(BitmapFontImpl$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.ycm_1 = lazy(BitmapFontImpl$invalidGlyph$delegate$lambda(this));
  }
  o9u(_set____db54di) {
    this.mcm_1.o9u(_set____db54di);
  }
  p9u() {
    return this.mcm_1.p9u();
  }
  eck() {
    return this.ncm_1;
  }
  fck() {
    return this.ocm_1;
  }
  qak() {
    return this.pcm_1;
  }
  hck() {
    return this.qcm_1;
  }
  ick() {
    return this.rcm_1;
  }
  h1() {
    return this.scm_1;
  }
  gck() {
    return this.tcm_1;
  }
  q9v() {
    return this;
  }
  lck() {
    var tmp0 = this.vcm_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('naturalFontMetrics', 1, tmp, BitmapFontImpl$_get_naturalFontMetrics_$ref_dn6csr(), null);
    return tmp0.k3();
  }
  mck() {
    return this.wcm_1;
  }
  hcl(first, second) {
    return this.rcm_1.u2(Companion_instance_15.rcj(first, second));
  }
  sa4(codePoint) {
    return this.qcm_1.u2(codePoint);
  }
  kck() {
    var tmp0 = this.xcm_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('anyGlyph', 1, tmp, BitmapFontImpl$_get_anyGlyph_$ref_qec2o0(), null);
    return tmp0.k3();
  }
  zcm() {
    var tmp0 = this.ycm_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('invalidGlyph', 1, tmp, BitmapFontImpl$_get_invalidGlyph_$ref_bkheff(), null);
    return tmp0.k3();
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_17 = this;
    this.dcn_1 = CharacterSet.mcn(' ');
    this.ecn_1 = CharacterSet.mcn(joinToString(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90)), ''));
    this.fcn_1 = CharacterSet.mcn(joinToString(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)), ''));
    this.gcn_1 = CharacterSet.mcn(joinToString(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57)), ''));
    this.hcn_1 = CharacterSet.mcn('!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}');
    this.icn_1 = CharacterSet.mcn('\xE7\xC7 \xF1\xD1 \xE5\xC5 \xE6\xC6 \xFF \xA2\xA3\xA5P\xAA\xB0\xBF\xAC\xBD\xBC\xA1\xAB\xBB\xDF\xB5\xF8\xB1\xF7\xB0\xB7.\xB2 \xE1\xE9\xED\xF3\xFA\xE4\xEB\xEF\xF6\xFC\xE0\xE8\xEC\xF2\xF9\xE2\xEA\xEE\xF4\xFB \xC1\xC9\xCD\xD3\xDA\xC4\xCB\xCF\xD6\xDC\xC0\xC8\xCC\xD2\xD9\xC2\xCA\xCE\xD4\xDB');
    this.jcn_1 = CharacterSet.mcn('\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F');
    this.kcn_1 = this.dcn_1.ncn(this.ecn_1).ncn(this.fcn_1).ncn(this.gcn_1).ncn(this.hcn_1).ncn(this.icn_1);
  }
}
class CharacterSet {
  constructor(codePoints) {
    return new.target.ocn(codePoints);
  }
  static ocn(codePoints) {
    Companion_getInstance_27();
    var $this = createThis(this);
    $this.lcn_1 = codePoints;
    return $this;
  }
  static mcn(chars) {
    Companion_getInstance_27();
    // Inline function 'kotlin.text.map' call
    // Inline function 'kotlin.text.mapTo' call
    var destination = ArrayList.n2(charSequenceLength(chars));
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(chars)) {
      var item = charSequenceGet(chars, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$2 = Char__toInt_impl_vasixd(item);
      destination.d2(tmp$ret$2);
    }
    return this.ocn(toIntArray(destination));
  }
  ncn(other) {
    var tmp0 = this.lcn_1;
    // Inline function 'kotlin.collections.plus' call
    var elements = other.lcn_1;
    var tmp$ret$0 = primitiveArrayConcat([tmp0, elements]);
    return CharacterSet.ocn(tmp$ret$0);
  }
}
class TextToBitmapResult {
  constructor(bmp, fmetrics, metrics, glyphs, glyphsPerLine, shape) {
    shape = shape === VOID ? null : shape;
    this.bcq_1 = bmp;
    this.ccq_1 = fmetrics;
    this.dcq_1 = metrics;
    this.ecq_1 = glyphs;
    this.fcq_1 = glyphsPerLine;
    this.gcq_1 = shape;
  }
  toString() {
    return 'TextToBitmapResult(bmp=' + toString_0(this.bcq_1) + ', fmetrics=' + this.ccq_1.toString() + ', metrics=' + this.dcq_1.toString() + ', glyphs=' + toString_0(this.ecq_1) + ', glyphsPerLine=' + toString_0(this.fcq_1) + ', shape=' + toString(this.gcq_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.bcq_1);
    result = imul(result, 31) + this.ccq_1.hashCode() | 0;
    result = imul(result, 31) + this.dcq_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.ecq_1) | 0;
    result = imul(result, 31) + hashCode(this.fcq_1) | 0;
    result = imul(result, 31) + (this.gcq_1 == null ? 0 : hashCode(this.gcq_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextToBitmapResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextToBitmapResult ? other : THROW_CCE();
    if (!equals(this.bcq_1, tmp0_other_with_cast.bcq_1))
      return false;
    if (!this.ccq_1.equals(tmp0_other_with_cast.ccq_1))
      return false;
    if (!this.dcq_1.equals(tmp0_other_with_cast.dcq_1))
      return false;
    if (!equals(this.ecq_1, tmp0_other_with_cast.ecq_1))
      return false;
    if (!equals(this.fcq_1, tmp0_other_with_cast.fcq_1))
      return false;
    if (!equals(this.gcq_1, tmp0_other_with_cast.gcq_1))
      return false;
    return true;
  }
}
class PlacedGlyphMetrics {
  constructor(codePoint, pos, metrics, fontMetrics, transform, index, nline) {
    this.scq_1 = codePoint;
    this.tcq_1 = pos;
    this.ucq_1 = metrics;
    this.vcq_1 = fontMetrics;
    this.wcq_1 = transform;
    this.xcq_1 = index;
    this.ycq_1 = nline;
    var tmp = this;
    tmp.zcq_1 = lazy(PlacedGlyphMetrics$boundsPath$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.acr_1 = lazy(PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.bcr_1 = lazy(PlacedGlyphMetrics$caretStart$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.ccr_1 = lazy(PlacedGlyphMetrics$caretEnd$delegate$lambda(this));
  }
  dcr() {
    var tmp0 = this.zcq_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('boundsPath', 1, tmp, PlacedGlyphMetrics$_get_boundsPath_$ref_h88zv4(), null);
    return tmp0.k3();
  }
  ecr() {
    var tmp0 = this.acr_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('boundsPathCurves', 1, tmp, PlacedGlyphMetrics$_get_boundsPathCurves_$ref_1r7ydw(), null);
    return tmp0.k3();
  }
  fcr() {
    var tmp0 = this.bcr_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('caretStart', 1, tmp, PlacedGlyphMetrics$_get_caretStart_$ref_1l9c45(), null);
    return tmp0.k3();
  }
  gcr() {
    var tmp0 = this.ccr_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('caretEnd', 1, tmp, PlacedGlyphMetrics$_get_caretEnd_$ref_fj1a4y(), null);
    return tmp0.k3();
  }
  hcr(x, y, startEnd) {
    if (this.dcr().fat(x, y))
      return 0.0;
    var tmp;
    switch (startEnd) {
      case true:
        tmp = this.fcr().gae(Companion_getInstance_9().y9f_1);
        break;
      case false:
        tmp = this.gcr().gae(Companion_getInstance_9().y9f_1);
        break;
      case null:
        Companion_getInstance_6();
        var tmp2 = this.fcr().gae(Companion_getInstance_9().y9f_1);
        // Inline function 'korlibs.math.geom.Companion.middle' call

        // Inline function 'korlibs.math.geom.Vector2D.plus' call

        var that = this.gcr().gae(Companion_getInstance_9().y9f_1);
        // Inline function 'korlibs.math.geom.Vector2D.times' call

        var this_0 = Vector2D.t9g(tmp2.r9g_1 + that.r9g_1, tmp2.s9g_1 + that.s9g_1);
        tmp = Vector2D.t9g(this_0.r9g_1 * 0.5, this_0.s9g_1 * 0.5);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var middle = tmp;
    return Companion_getInstance_6().y9q(middle.r9g_1, middle.s9g_1, x, y);
  }
  icr(p, startEnd) {
    return this.hcr(p.r9g_1, p.s9g_1, startEnd);
  }
  jcr(p, startEnd, $super) {
    startEnd = startEnd === VOID ? null : startEnd;
    return $super === VOID ? this.icr(p, startEnd) : $super.icr.call(this, p, startEnd);
  }
  toString() {
    return 'PlacedGlyphMetrics(codePoint=' + this.scq_1 + ', pos=' + this.tcq_1.toString() + ', metrics=' + this.ucq_1.toString() + ', fontMetrics=' + this.vcq_1.toString() + ', transform=' + this.wcq_1.toString() + ', index=' + this.xcq_1 + ', nline=' + this.ycq_1 + ')';
  }
  hashCode() {
    var result = this.scq_1;
    result = imul(result, 31) + this.tcq_1.hashCode() | 0;
    result = imul(result, 31) + this.ucq_1.hashCode() | 0;
    result = imul(result, 31) + this.vcq_1.hashCode() | 0;
    result = imul(result, 31) + this.wcq_1.hashCode() | 0;
    result = imul(result, 31) + this.xcq_1 | 0;
    result = imul(result, 31) + this.ycq_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacedGlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof PlacedGlyphMetrics ? other : THROW_CCE();
    if (!(this.scq_1 === tmp0_other_with_cast.scq_1))
      return false;
    if (!this.tcq_1.equals(tmp0_other_with_cast.tcq_1))
      return false;
    if (!this.ucq_1.equals(tmp0_other_with_cast.ucq_1))
      return false;
    if (!this.vcq_1.equals(tmp0_other_with_cast.vcq_1))
      return false;
    if (!this.wcq_1.equals(tmp0_other_with_cast.wcq_1))
      return false;
    if (!(this.xcq_1 === tmp0_other_with_cast.xcq_1))
      return false;
    if (!(this.ycq_1 === tmp0_other_with_cast.ycq_1))
      return false;
    return true;
  }
}
class TextMetricsResult {
  constructor(fmetrics, metrics, glyphs, glyphsPerLine) {
    fmetrics = fmetrics === VOID ? new FontMetrics() : fmetrics;
    metrics = metrics === VOID ? new TextMetrics() : metrics;
    glyphs = glyphs === VOID ? emptyList() : glyphs;
    glyphsPerLine = glyphsPerLine === VOID ? emptyList() : glyphsPerLine;
    this.kcr_1 = fmetrics;
    this.lcr_1 = metrics;
    this.mcr_1 = glyphs;
    this.ncr_1 = glyphsPerLine;
  }
  toString() {
    return 'TextMetricsResult(fmetrics=' + this.kcr_1.toString() + ', metrics=' + this.lcr_1.toString() + ', glyphs=' + toString_0(this.mcr_1) + ', glyphsPerLine=' + toString_0(this.ncr_1) + ')';
  }
  hashCode() {
    var result = this.kcr_1.hashCode();
    result = imul(result, 31) + this.lcr_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.mcr_1) | 0;
    result = imul(result, 31) + hashCode(this.ncr_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetricsResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetricsResult ? other : THROW_CCE();
    if (!this.kcr_1.equals(tmp0_other_with_cast.kcr_1))
      return false;
    if (!this.lcr_1.equals(tmp0_other_with_cast.lcr_1))
      return false;
    if (!equals(this.mcr_1, tmp0_other_with_cast.mcr_1))
      return false;
    if (!equals(this.ncr_1, tmp0_other_with_cast.ncr_1))
      return false;
    return true;
  }
}
class MultiplePlacedGlyphMetrics {
  constructor() {
    this.sct_1 = FastArrayList.f9v();
    this.tct_1 = FastArrayList.f9v();
  }
  s2() {
    return this.sct_1.s2();
  }
  vct(glyph) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.sct_1.d2(glyph);
    while (this.tct_1.s2() <= glyph.ycq_1) {
      this.tct_1.d2(FastArrayList.f9v());
    }
    this.tct_1.u2(glyph.ycq_1).d2(glyph);
  }
}
class ITextRendererActions {}
function reset() {
  this.fcw(Companion_getInstance_6().g9h_1);
}
function advance(x) {
  var tmp0 = this.wb5();
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var that = Vector2D.t9g(x, 0.0);
  var tmp$ret$0 = Vector2D.t9g(tmp0.r9g_1 + that.r9g_1, tmp0.s9g_1 + that.s9g_1);
  this.fcw(tmp$ret$0);
}
function newLine(y, end) {
  this.fcw(Vector2D.t9g(0.0, this.wb5().s9g_1 + y));
  var _unary__edvuaz = this.xcv();
  this.dcw(_unary__edvuaz + 1 | 0);
}
class TextRendererActions {
  constructor($box) {
    boxApply(this, $box);
    this.ncv_1 = new GlyphPath();
    this.ocv_1 = new GlyphMetrics();
    this.pcv_1 = new FontMetrics();
    this.qcv_1 = 0;
    this.scv_1 = 0.0;
    this.tcv_1 = Companion_getInstance_6().g9h_1;
    this.ucv_1 = Companion_getInstance_5().v9k_1;
    this.vcv_1 = null;
    this.wcv_1 = Colors_getInstance().zc2_1;
  }
  fck() {
    return this.pcv_1.fck();
  }
  dcw(_set____db54di) {
    this.qcv_1 = _set____db54di;
  }
  xcv() {
    return this.qcv_1;
  }
  ccw() {
    var tmp = this.rcv_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('font');
    }
  }
  ecw(font, size) {
    this.rcv_1 = font;
    this.scv_1 = size;
    font.nck(size, this.pcv_1);
  }
  fcw(_set____db54di) {
    this.tcv_1 = _set____db54di;
  }
  wb5() {
    return this.tcv_1;
  }
  gcw(reader, codePoint) {
    return this.ccw().zck(this.scv_1, codePoint, this.ocv_1, reader);
  }
  hcw(_set____db54di) {
    this.ucv_1 = _set____db54di;
  }
  acw() {
    return this.ucv_1;
  }
  hcl(leftCodePoint, rightCodePoint) {
    return this.ccw().lcm(this.scv_1, leftCodePoint, rightCodePoint);
  }
}
class drawText$actions$1 extends TextRendererActions {
  constructor($renderer, $text, $size, $fnt, $align, $pos, $ctx, $paint, $textRangeStart, $textRangeEnd, $doRender, $glyphs, $placed, $box) {
    if ($box === VOID)
      $box = {};
    $box.ccv_1 = $size;
    $box.dcv_1 = $align;
    $box.ecv_1 = $pos;
    $box.fcv_1 = $ctx;
    $box.gcv_1 = $paint;
    $box.hcv_1 = $textRangeStart;
    $box.icv_1 = $textRangeEnd;
    $box.jcv_1 = $doRender;
    $box.kcv_1 = $glyphs;
    $box.lcv_1 = $placed;
    super($box);
    this.acv_1 = measure($renderer, $text, $size, $fnt);
    this.bcv_1 = 0;
  }
  mcv(reader, codePoint) {
    var nline = this.xcv();
    var dx = this.acv_1.ycv(this.dcv_1.ict_1, nline);
    var dy = this.acv_1.lct(this.dcv_1.jct_1, this.pcv_1);
    var px = this.wb5().r9g_1 + this.ecv_1.r9g_1 - dx;
    var py = this.wb5().s9g_1 + this.ecv_1.s9g_1 + dy;
    var tmp71_safe_receiver = this.fcv_1;
    if (tmp71_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
      var t = tmp71_safe_receiver.tc9_1.kcl_1;
      try {
        this.fcv_1.zcv(px, py);
        this.fcv_1.bcw(get_immutable(this.acw()));
        var tmp0_elvis_lhs = this.vcv_1;
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.gcv_1 : tmp0_elvis_lhs;
        this.fcv_1.hcm(tmp1_elvis_lhs == null ? NonePaint_instance : tmp1_elvis_lhs);
        var containsLower = this.hcv_1;
        var containsUpper = this.icv_1;
        var containsArg = this.bcv_1;
        if (containsLower <= containsArg ? containsArg < containsUpper : false) {
          this.ccw().jcl(this.fcv_1, this.ccv_1, codePoint, Companion_getInstance_6().g9h_1, null, this.ocv_1, reader, this.jcv_1);
        }
        this.bcv_1 = this.bcv_1 + 1 | 0;
      }finally {
        tmp71_safe_receiver.tc9_1.kcl_1 = t;
      }
    }
    if (!(this.kcv_1 == null)) {
      var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.t9g(px, py), this.ocv_1.g9m(), this.pcv_1.g9m(), this.acw(), this.kcv_1.s2(), nline);
      this.kcv_1.vct(glyph);
    }
    var tmp72_safe_receiver = this.lcv_1;
    if (tmp72_safe_receiver == null)
      null;
    else
      tmp72_safe_receiver(this, codePoint, Vector2D.t9g(px, py), this.ccv_1, this.ocv_1, this.pcv_1, this.acw());
    return this.ocv_1;
  }
}
class GlyphPath {
  constructor(path, colorShape, bitmap, bitmapOffset, bitmapScale, transform, scale) {
    path = path === VOID ? new VectorPath() : path;
    colorShape = colorShape === VOID ? null : colorShape;
    bitmap = bitmap === VOID ? null : bitmap;
    bitmapOffset = bitmapOffset === VOID ? Vector2D.a9k(0, 0) : bitmapOffset;
    bitmapScale = bitmapScale === VOID ? Scale.q9r(1, 1) : bitmapScale;
    transform = transform === VOID ? Companion_getInstance_5().y9k() : transform;
    scale = scale === VOID ? 1.0 : scale;
    this.kcw_1 = path;
    this.lcw_1 = colorShape;
    this.mcw_1 = bitmap;
    this.ncw_1 = bitmapOffset;
    this.ocw_1 = bitmapScale;
    this.pcw_1 = transform;
    this.qcw_1 = scale;
  }
  rcw() {
    return this.mcw_1 == null && this.lcw_1 == null;
  }
  scw(c) {
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = c.tc9_1.kcl_1;
    try {
      c.bcw(this.pcw_1);
      if (!(this.mcw_1 == null)) {
        c.jcm(ensureNotNull(this.mcw_1), this.ncw_1, toFloat(ensureNotNull(this.mcw_1).s2()).g9s(this.ocw_1));
      } else if (!(this.lcw_1 == null)) {
        c.tcw(ensureNotNull(this.lcw_1));
        c.rct();
      } else {
        draw_1(c, this.kcw_1);
      }
    }finally {
      c.tc9_1.kcl_1 = t;
    }
  }
  toString() {
    return 'GlyphPath(path=' + this.kcw_1.toString() + ', colorShape=' + toString(this.lcw_1) + ', bitmap=' + toString(this.mcw_1) + ', bitmapOffset=' + this.ncw_1.toString() + ', bitmapScale=' + this.ocw_1.toString() + ', transform=' + this.pcw_1.toString() + ', scale=' + this.qcw_1 + ')';
  }
  hashCode() {
    var result = this.kcw_1.hashCode();
    result = imul(result, 31) + (this.lcw_1 == null ? 0 : hashCode(this.lcw_1)) | 0;
    result = imul(result, 31) + (this.mcw_1 == null ? 0 : hashCode(this.mcw_1)) | 0;
    result = imul(result, 31) + this.ncw_1.hashCode() | 0;
    result = imul(result, 31) + this.ocw_1.hashCode() | 0;
    result = imul(result, 31) + this.pcw_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.qcw_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath ? other : THROW_CCE();
    if (!this.kcw_1.equals(tmp0_other_with_cast.kcw_1))
      return false;
    if (!equals(this.lcw_1, tmp0_other_with_cast.lcw_1))
      return false;
    if (!equals(this.mcw_1, tmp0_other_with_cast.mcw_1))
      return false;
    if (!this.ncw_1.equals(tmp0_other_with_cast.ncw_1))
      return false;
    if (!this.ocw_1.equals(tmp0_other_with_cast.ocw_1))
      return false;
    if (!this.pcw_1.equals(tmp0_other_with_cast.pcw_1))
      return false;
    if (!equals(this.qcw_1, tmp0_other_with_cast.qcw_1))
      return false;
    return true;
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_18 = this;
    var tmp = this;
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    // Inline function 'kotlin.intArrayOf' call
    tmp.ucw_1 = new Int32Array([tmp$ret$0]);
  }
}
class LazyBitmapFont {
  constructor(font, fontSize, distanceField) {
    Companion_getInstance_28();
    distanceField = distanceField === VOID ? null : distanceField;
    this.vcw_1 = new Mixin();
    this.wcw_1 = font;
    this.xcw_1 = fontSize;
    this.ycw_1 = distanceField;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = MutableAtlas.oc1(1024, 1024, 2);
    if (!(this.ycw_1 == null))
      this_0.qc0_1;
    else
      mipmaps(this_0.qc0_1);
    tmp.zcw_1 = this_0;
    this.acx_1 = this.wcw_1.yck(this.xcw_1);
    this.bcx_1 = this.acx_1.fck();
    this.ccx_1 = this.acx_1.rck_1;
    this.dcx_1 = IntMap.fa7();
    this.ecx_1 = IntMap.fa7();
    var tmp_0 = this;
    tmp_0.fcx_1 = lazy(LazyBitmapFont$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.gcx_1 = lazy(LazyBitmapFont$invalidGlyph$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.hcx_1 = lazy(LazyBitmapFont$naturalFontMetrics$delegate$lambda(this));
    this.icx_1 = new GlyphMetrics(this.xcw_1, false, 0, Companion_getInstance_4().y9k(), 0.0);
  }
  o9u(_set____db54di) {
    this.vcw_1.o9u(_set____db54di);
  }
  p9u() {
    return this.vcw_1.p9u();
  }
  eck() {
    return this.xcw_1;
  }
  gck() {
    return this.ycw_1;
  }
  fck() {
    return this.bcx_1;
  }
  qak() {
    return this.ccx_1;
  }
  hck() {
    return this.dcx_1;
  }
  ick() {
    return this.ecx_1;
  }
  kck() {
    var tmp0 = this.fcx_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('anyGlyph', 1, tmp, LazyBitmapFont$_get_anyGlyph_$ref_5keg5w(), null);
    return tmp0.k3();
  }
  zcm() {
    var tmp0 = this.gcx_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('invalidGlyph', 1, tmp, LazyBitmapFont$_get_invalidGlyph_$ref_m7c1op(), null);
    return tmp0.k3();
  }
  h1() {
    return this.wcw_1.h1();
  }
  lck() {
    var tmp0 = this.hcx_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('naturalFontMetrics', 1, tmp, LazyBitmapFont$_get_naturalFontMetrics_$ref_dzk74v(), null);
    return tmp0.k3();
  }
  mck() {
    return this.icx_1;
  }
  hcl(first, second) {
    var kerning = this.wcw_1.lcm(this.xcw_1, first, second);
    var tmp;
    if (kerning === 0.0) {
      tmp = null;
    } else {
      var tmp0 = this.ecx_1;
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var key = Companion_instance_15.rcj(first, second);
      var res = tmp0.u2(key);
      if (res == null) {
        var tmp$ret$1 = new Kerning(first, second, numberToInt(kerning));
        tmp0.za6(key, tmp$ret$1);
      }
      tmp = ensureNotNull(tmp0.u2(key));
    }
    return tmp;
  }
  sa4(codePoint) {
    if (this.dcx_1.u2(codePoint) == null) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(97);
      var tmp = Char__toInt_impl_vasixd(this_0);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(122);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      this.jcx(codePoint, numberRangeToNumber(tmp, tmp$ret$1));
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      var tmp_0 = Char__toInt_impl_vasixd(this_2);
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(90);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_3);
      this.jcx(codePoint, numberRangeToNumber(tmp_0, tmp$ret$3));
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(48);
      var tmp_1 = Char__toInt_impl_vasixd(this_4);
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(57);
      var tmp$ret$5 = Char__toInt_impl_vasixd(this_5);
      this.jcx(codePoint, numberRangeToNumber(tmp_1, tmp$ret$5));
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$6 = new Int32Array([codePoint]);
      this.kcx(tmp$ret$6);
    }
    return this.dcx_1.u2(codePoint);
  }
  jcx(codePoint, range) {
    var containsLower = range.n3_1;
    if (codePoint <= range.o3_1 ? containsLower <= codePoint : false) {
      // Inline function 'korlibs.datastructure.toIntList' call
      // Inline function 'kotlin.also' call
      var this_0 = IntArrayList.za1(coerceAtLeast(range.r3() - range.s3() | 0, 0));
      var inductionVariable = range.s3();
      var last = range.r3();
      if (inductionVariable <= last)
        do {
          var v = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.ga2(v);
        }
         while (!(v === last));
      this.kcx(this_0.sa2());
    }
  }
  kcx(codePoints) {
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var this_0 = this.zcw_1.qc0_1;
    var rect = this_0.wc1_1;
    if (true) {
      this_0.fc2();
    }
    var result;
    try {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < codePoints.length) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var codePoint = codePoints[_unary__edvuaz];
        // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
        var this_1 = this.dcx_1;
        var res = this_1.u2(codePoint);
        if (res == null) {
          var tmp;
          if (!(this.ycw_1 == null)) {
            // Inline function 'kotlin.math.max' call
            var b = toIntCeil_0(this.xcw_1 / 8.0);
            tmp = Math.max(4, b);
          } else {
            tmp = 1;
          }
          var border = tmp;
          var tmp83_$receiver = this.wcw_1;
          var tmp84_size = this.xcw_1;
          var tmp85_paint = Colors_getInstance().zc2_1;
          var result_0 = renderGlyphToBitmap(tmp83_$receiver, tmp84_size, codePoint, new RGBA(tmp85_paint), true, null, border);
          var bmp = result_0.bcq_1.ec2();
          var rbmp;
          switch (this.ycw_1) {
            case 'msdf':
              rbmp = msdfBmp(ensureNotNull(result_0.gcq_1).lcx(), bmp.sc1_1, bmp.tc1_1);
              break;
            case 'sdf':
              rbmp = sdfBmp(ensureNotNull(result_0.gcq_1).lcx(), bmp.sc1_1, bmp.tc1_1);
              break;
            default:
              rbmp = bmp;
              break;
          }
          var entry = this.zcw_1.qc1(rbmp, Unit_instance);
          var slice = entry.ic0_1.wak(border, border, entry.ic0_1.qaj_1 - border | 0, entry.ic0_1.raj_1 - border | 0);
          var g = first_0(result_0.ecq_1);
          var m = g.ucq_1;
          var xadvance = m.ecl_1;
          var tmp$ret$5 = new Glyph(this.xcw_1, codePoint, slice, -toIntRound(g.tcq_1.r9g_1) | 0, -toIntRound(g.tcq_1.s9g_1) | 0, toIntRound(xadvance));
          this_1.za6(codePoint, tmp$ret$5);
        }
        ensureNotNull(this_1.u2(codePoint));
      }
    }finally {
      result = true ? this_0.hc2(rect) : 0;
    }
  }
}
class FontMetrics {
  constructor(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    size = size === VOID ? 0.0 : size;
    top = top === VOID ? 0.0 : top;
    ascent = ascent === VOID ? 0.0 : ascent;
    baseline = baseline === VOID ? 0.0 : baseline;
    descent = descent === VOID ? 0.0 : descent;
    bottom = bottom === VOID ? 0.0 : bottom;
    lineGap = lineGap === VOID ? 0.0 : lineGap;
    maxWidth = maxWidth === VOID ? 0.0 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? 0.0 : unitsPerEm;
    this.ock_1 = size;
    this.pck_1 = top;
    this.qck_1 = ascent;
    this.rck_1 = baseline;
    this.sck_1 = descent;
    this.tck_1 = bottom;
    this.uck_1 = lineGap;
    this.vck_1 = maxWidth;
    this.wck_1 = unitsPerEm;
  }
  mcx() {
    var tmp0 = this.qck_1;
    // Inline function 'kotlin.math.max' call
    var b = this.pck_1;
    return Math.max(tmp0, b);
  }
  ncx() {
    var tmp0 = this.sck_1;
    // Inline function 'kotlin.math.min' call
    var b = this.tck_1;
    return Math.min(tmp0, b);
  }
  ocx() {
    return this.mcx() - this.ncx();
  }
  fck() {
    return this.ocx() + this.uck_1;
  }
  uct(other) {
    return this.pcx(other, 1.0);
  }
  xck(other, size) {
    return this.pcx(other, size / other.ock_1);
  }
  pcx(other, scale) {
    this.ock_1 = other.ock_1 * scale;
    this.pck_1 = other.pck_1 * scale;
    this.qck_1 = other.qck_1 * scale;
    this.rck_1 = other.rck_1 * scale;
    this.sck_1 = other.sck_1 * scale;
    this.tck_1 = other.tck_1 * scale;
    this.uck_1 = other.uck_1 * scale;
    this.wck_1 = other.wck_1 * scale;
    this.vck_1 = other.vck_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    this_0.m1('FontMetrics(');
    this_0.m1('size=' + niceStr(this.ock_1, 1) + ', ');
    this_0.m1('top=' + niceStr(this.pck_1, 1) + ', ');
    this_0.m1('ascent=' + niceStr(this.qck_1, 1) + ', ');
    this_0.m1('baseline=' + niceStr(this.rck_1, 1) + ', ');
    this_0.m1('descent=' + niceStr(this.sck_1, 1) + ', ');
    this_0.m1('bottom=' + niceStr(this.tck_1, 1) + ', ');
    this_0.m1('lineGap=' + niceStr(this.uck_1, 1) + ', ');
    this_0.m1('unitsPerEm=' + niceStr(this.wck_1, 1) + ', ');
    this_0.m1('maxWidth=' + niceStr(this.vck_1, 1) + ', ');
    this_0.m1('lineHeight=' + niceStr(this.fck(), 1));
    this_0.m1(')');
    return this_0.toString();
  }
  g9m() {
    return this.qcx();
  }
  rcx(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    return new FontMetrics(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  qcx(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm, $super) {
    size = size === VOID ? this.ock_1 : size;
    top = top === VOID ? this.pck_1 : top;
    ascent = ascent === VOID ? this.qck_1 : ascent;
    baseline = baseline === VOID ? this.rck_1 : baseline;
    descent = descent === VOID ? this.sck_1 : descent;
    bottom = bottom === VOID ? this.tck_1 : bottom;
    lineGap = lineGap === VOID ? this.uck_1 : lineGap;
    maxWidth = maxWidth === VOID ? this.vck_1 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? this.wck_1 : unitsPerEm;
    return $super === VOID ? this.rcx(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) : $super.rcx.call(this, size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  hashCode() {
    var result = getNumberHashCode(this.ock_1);
    result = imul(result, 31) + getNumberHashCode(this.pck_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.qck_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.rck_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.sck_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.tck_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.uck_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.vck_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.wck_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FontMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof FontMetrics ? other : THROW_CCE();
    if (!equals(this.ock_1, tmp0_other_with_cast.ock_1))
      return false;
    if (!equals(this.pck_1, tmp0_other_with_cast.pck_1))
      return false;
    if (!equals(this.qck_1, tmp0_other_with_cast.qck_1))
      return false;
    if (!equals(this.rck_1, tmp0_other_with_cast.rck_1))
      return false;
    if (!equals(this.sck_1, tmp0_other_with_cast.sck_1))
      return false;
    if (!equals(this.tck_1, tmp0_other_with_cast.tck_1))
      return false;
    if (!equals(this.uck_1, tmp0_other_with_cast.uck_1))
      return false;
    if (!equals(this.vck_1, tmp0_other_with_cast.vck_1))
      return false;
    if (!equals(this.wck_1, tmp0_other_with_cast.wck_1))
      return false;
    return true;
  }
}
class GlyphMetrics {
  constructor(size, existing, codePoint, bounds, xadvance) {
    size = size === VOID ? 0.0 : size;
    existing = existing === VOID ? false : existing;
    codePoint = codePoint === VOID ? 0 : codePoint;
    bounds = bounds === VOID ? Companion_getInstance_4().y9k() : bounds;
    xadvance = xadvance === VOID ? 0.0 : xadvance;
    this.acl_1 = size;
    this.bcl_1 = existing;
    this.ccl_1 = codePoint;
    this.dcl_1 = bounds;
    this.ecl_1 = xadvance;
  }
  y9h() {
    return this.dcl_1.y9h();
  }
  v9h() {
    return this.dcl_1.v9h();
  }
  x9h() {
    return this.dcl_1.x9h();
  }
  w9z() {
    return this.dcl_1.q9h_1;
  }
  x9z() {
    return this.dcl_1.r9h_1;
  }
  g9m() {
    return this.scx(VOID, VOID, VOID, this.dcl_1.g9m());
  }
  fcl(other, size, codePoint) {
    return this.tcx(other, size / other.acl_1, codePoint);
  }
  tcx(other, scale, codePoint) {
    this.acl_1 = other.acl_1;
    this.bcl_1 = other.bcl_1;
    this.ccl_1 = codePoint;
    this.dcl_1 = other.dcl_1.b9q(scale);
    this.ecl_1 = other.ecl_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    this_0.m1('GlyphMetrics(');
    this_0.m1('codePoint=' + this.ccl_1 + " ('" + toString_1(numberToChar(this.ccl_1)) + "'), ");
    this_0.m1('existing=' + this.bcl_1 + ', ');
    this_0.m1('xadvance=' + roundToInt(this.ecl_1) + ', ');
    this_0.m1('bounds=' + this.dcl_1.n9q().toString());
    this_0.m1(')');
    return this_0.toString();
  }
  ucx(size, existing, codePoint, bounds, xadvance) {
    return new GlyphMetrics(size, existing, codePoint, bounds, xadvance);
  }
  scx(size, existing, codePoint, bounds, xadvance, $super) {
    size = size === VOID ? this.acl_1 : size;
    existing = existing === VOID ? this.bcl_1 : existing;
    codePoint = codePoint === VOID ? this.ccl_1 : codePoint;
    bounds = bounds === VOID ? this.dcl_1 : bounds;
    xadvance = xadvance === VOID ? this.ecl_1 : xadvance;
    return $super === VOID ? this.ucx(size, existing, codePoint, bounds, xadvance) : $super.ucx.call(this, size, existing, codePoint, bounds, xadvance);
  }
  hashCode() {
    var result = getNumberHashCode(this.acl_1);
    result = imul(result, 31) + getBooleanHashCode(this.bcl_1) | 0;
    result = imul(result, 31) + this.ccl_1 | 0;
    result = imul(result, 31) + this.dcl_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.ecl_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphMetrics ? other : THROW_CCE();
    if (!equals(this.acl_1, tmp0_other_with_cast.acl_1))
      return false;
    if (!(this.bcl_1 === tmp0_other_with_cast.bcl_1))
      return false;
    if (!(this.ccl_1 === tmp0_other_with_cast.ccl_1))
      return false;
    if (!this.dcl_1.equals(tmp0_other_with_cast.dcl_1))
      return false;
    if (!equals(this.ecl_1, tmp0_other_with_cast.ecl_1))
      return false;
    return true;
  }
}
class TextMetrics {
  constructor(bounds, lineBounds, fontMetrics, nlines) {
    bounds = bounds === VOID ? Companion_getInstance_4().y9k() : bounds;
    lineBounds = lineBounds === VOID ? emptyList() : lineBounds;
    fontMetrics = fontMetrics === VOID ? new FontMetrics() : fontMetrics;
    nlines = nlines === VOID ? 0 : nlines;
    this.ocs_1 = bounds;
    this.pcs_1 = lineBounds;
    this.qcs_1 = fontMetrics;
    this.rcs_1 = nlines;
  }
  vcx() {
    var tmp0_elvis_lhs = firstOrNull_0(this.pcs_1);
    return tmp0_elvis_lhs == null ? Companion_getInstance_4().a9i_1 : tmp0_elvis_lhs;
  }
  v9h() {
    return this.ocs_1.v9h();
  }
  x9h() {
    return this.ocs_1.x9h();
  }
  w9z() {
    return this.ocs_1.q9h_1;
  }
  x9z() {
    return this.ocs_1.r9h_1;
  }
  wcx() {
    return -this.v9h();
  }
  xcx() {
    return this.vcx().r9h_1 + this.vcx().x9h();
  }
  qct() {
    return this.qcs_1.qck_1;
  }
  toString() {
    return 'TextMetrics[' + get_niceStr_0(this.v9h()) + ', ' + get_niceStr_0(this.x9h()) + ', ' + get_niceStr_0(this.w9z()) + ', ' + get_niceStr_0(this.x9z()) + '][' + get_niceStr_0(this.wcx()) + ', ' + get_niceStr_0(this.xcx()) + ']';
  }
  hashCode() {
    var result = this.ocs_1.hashCode();
    result = imul(result, 31) + hashCode(this.pcs_1) | 0;
    result = imul(result, 31) + this.qcs_1.hashCode() | 0;
    result = imul(result, 31) + this.rcs_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetrics ? other : THROW_CCE();
    if (!this.ocs_1.equals(tmp0_other_with_cast.ocs_1))
      return false;
    if (!equals(this.pcs_1, tmp0_other_with_cast.pcs_1))
      return false;
    if (!this.qcs_1.equals(tmp0_other_with_cast.qcs_1))
      return false;
    if (!(this.rcs_1 === tmp0_other_with_cast.rcs_1))
      return false;
    return true;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_19 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_0();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cd(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$2 = element.acy_1;
      destination.b5(tmp$ret$2, element);
    }
    tmp.bcy_1 = toIntMap(destination);
  }
  u2(id) {
    return this.bcy_1.u2(id);
  }
}
class GlyphPath_0 {
  constructor(path, advanceWidth) {
    this.ccy_1 = path;
    this.dcy_1 = advanceWidth;
  }
  toString() {
    return 'GlyphPath(path=' + this.ccy_1.toString() + ', advanceWidth=' + this.dcy_1 + ')';
  }
  hashCode() {
    var result = this.ccy_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.dcy_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath_0))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath_0 ? other : THROW_CCE();
    if (!this.ccy_1.equals(tmp0_other_with_cast.ccy_1))
      return false;
    if (!equals(this.dcy_1, tmp0_other_with_cast.dcy_1))
      return false;
    return true;
  }
}
class CFFResult {
  constructor(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict) {
    this.ecy_1 = charstringsIndex;
    this.fcy_1 = globalSubrIndex;
    this.gcy_1 = localSubrsIndex;
    this.hcy_1 = privateDict;
    var tmp = this;
    var tmp90_safe_receiver = this.hcy_1.w4(Op_defaultWidthX_getInstance());
    var tmp91_safe_receiver = tmp90_safe_receiver == null ? null : firstOrNull_0(tmp90_safe_receiver);
    var tmp0_elvis_lhs = tmp91_safe_receiver == null ? null : numberToDouble(tmp91_safe_receiver);
    tmp.icy_1 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp92_safe_receiver = this.hcy_1.w4(Op_nominalWidthX_getInstance());
    var tmp93_safe_receiver = tmp92_safe_receiver == null ? null : firstOrNull_0(tmp92_safe_receiver);
    var tmp0_elvis_lhs_0 = tmp93_safe_receiver == null ? null : numberToDouble(tmp93_safe_receiver);
    tmp_0.jcy_1 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
  }
  kcy(index, flipY) {
    var evalCtx = new EvalContext(this.fcy_1, this.gcy_1, this.icy_1, this.jcy_1, index);
    var vp = new VectorPath();
    var bytes = this.ecy_1.u2(index);
    CharStringType2_instance.ncy(vp, openFastStream(bytes), evalCtx);
    if (flipY) {
      vp.sat(1.0, -1.0);
    }
    return new GlyphPath_0(vp, evalCtx.xcy_1);
  }
  zcy(index, flipY, $super) {
    flipY = flipY === VOID ? true : flipY;
    return $super === VOID ? this.kcy(index, flipY) : $super.kcy.call(this, index, flipY);
  }
}
class DataIndex {
  constructor(offsets, bytes) {
    return new.target.acz(offsets, bytes);
  }
  static acz(offsets, bytes) {
    var $this = createThis(this);
    $this.lcy_1 = offsets;
    $this.mcy_1 = bytes;
    return $this;
  }
  static bcz() {
    // Inline function 'kotlin.intArrayOf' call
    var tmp = new Int32Array([0]);
    // Inline function 'kotlin.byteArrayOf' call
    var tmp$ret$1 = new Int8Array([]);
    return this.acz(tmp, tmp$ret$1);
  }
  s2() {
    return this.lcy_1.length - 1 | 0;
  }
  ccz(index) {
    return this.lcy_1[index + 1 | 0] - this.lcy_1[index] | 0;
  }
  u2(index) {
    return copyOfRange(this.mcy_1, this.lcy_1[index], this.lcy_1[index + 1 | 0]);
  }
  dcz() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.s2());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.n3_1;
    var last = this_0.o3_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = item;
        var tmp$ret$2 = this.u2(it);
        destination.d2(tmp$ret$2);
      }
       while (!(item === last));
    return destination;
  }
  p1() {
    return this.dcz().p1();
  }
  toString() {
    var tmp = this.s2();
    var tmp_0 = toString_0(toList_0(this.lcy_1));
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.s2());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.n3_1;
    var last = this_0.o3_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = item;
        var tmp$ret$2 = this.ccz(it);
        destination.d2(tmp$ret$2);
      }
       while (!(item === last));
    return 'DataIndex[' + tmp + '](' + tmp_0 + ')(' + toString_0(destination) + ')';
  }
}
class Op extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.acy_1 = id;
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_20 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_1();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cd(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$2 = element.gcz_1;
      destination.b5(tmp$ret$2, element);
    }
    tmp.hcz_1 = toIntMap(destination);
  }
  u2(id) {
    var tmp0_elvis_lhs = this.hcz_1.u2(id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Unknown CFF CS2 operator ' + id;
      throw IllegalStateException.o(toString_0(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
class EvalContext {
  constructor(globalSubrIndex, localSubrsIndex, defaultWidthX, nominalWidthX, index, heap) {
    globalSubrIndex = globalSubrIndex === VOID ? DataIndex.bcz() : globalSubrIndex;
    localSubrsIndex = localSubrsIndex === VOID ? DataIndex.bcz() : localSubrsIndex;
    defaultWidthX = defaultWidthX === VOID ? 0.0 : defaultWidthX;
    nominalWidthX = nominalWidthX === VOID ? 0.0 : nominalWidthX;
    index = index === VOID ? -1 : index;
    heap = heap === VOID ? new Float64Array(32) : heap;
    this.ocy_1 = globalSubrIndex;
    this.pcy_1 = localSubrsIndex;
    this.qcy_1 = defaultWidthX;
    this.rcy_1 = nominalWidthX;
    this.scy_1 = index;
    this.tcy_1 = heap;
    this.ucy_1 = computeSubrBias(CharStringType2_instance, this.ocy_1.s2());
    this.vcy_1 = computeSubrBias(CharStringType2_instance, this.pcy_1.s2());
    this.wcy_1 = 0;
    this.xcy_1 = this.qcy_1;
    this.ycy_1 = false;
  }
}
class Op_0 extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.gcz_1 = id;
  }
}
class CFF {
  icz(_this__u8e3s4) {
    this.jcz(_this__u8e3s4);
    var nameIndex = this.kcz(_this__u8e3s4);
    var topDictIndex = this.kcz(_this__u8e3s4);
    var topDictByte = topDictIndex.u2(0)[1];
    var topDict = this.lcz(openFastStream(topDictIndex.u2(0)));
    var stringIndex = this.kcz(_this__u8e3s4);
    var globalSubrIndex = this.kcz(_this__u8e3s4);
    var privateSizeOffset = topDict.w4(Op_Private_getInstance());
    var localSubrsIndex = DataIndex.bcz();
    var privateDict = emptyMap();
    if (!(privateSizeOffset == null)) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.n2(collectionSizeOrDefault(privateSizeOffset, 10));
      var _iterator__ex2g4s = privateSizeOffset.p1();
      while (_iterator__ex2g4s.q1()) {
        var item = _iterator__ex2g4s.r1();
        var tmp$ret$2 = numberToInt(item);
        destination.d2(tmp$ret$2);
      }
      // Inline function 'kotlin.collections.component1' call
      var privateSize = destination.u2(0);
      // Inline function 'kotlin.collections.component2' call
      var privateOffset = destination.u2(1);
      privateDict = this.lcz(_this__u8e3s4.zb6(privateOffset, privateSize));
      var localSubrs = privateDict.w4(Op_Subrs_getInstance());
      if (!(localSubrs == null)) {
        var subrsOffset = privateOffset + numberToInt(last(localSubrs)) | 0;
        localSubrsIndex = this.kcz(_this__u8e3s4.ab7(subrsOffset));
      }
    }
    var charstringsOffsets = topDict.w4(Op_CharStrings_getInstance());
    var charstringsOffset = numberToInt(first_0(ensureNotNull(charstringsOffsets)));
    var charstringsIndex = this.kcz(_this__u8e3s4.ab7(charstringsOffset));
    return new CFFResult(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict);
  }
  jcz(_this__u8e3s4) {
    var versionMajor = _this__u8e3s4.fb7();
    var versionMinor = _this__u8e3s4.fb7();
    var headerSize = _this__u8e3s4.fb7();
    var offsetSize = _this__u8e3s4.fb7();
    if (versionMajor > 1) {
      // Inline function 'kotlin.error' call
      var message = 'Only supported CFF version 1';
      throw IllegalStateException.o(toString_0(message));
    }
    // Inline function 'korlibs.logger.Logger.debug' call
    var tmp0 = TtfCIDFont_getInstance().mcz_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_DEBUG_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$3 = 'CFF.versionMajor/Minor: ' + versionMajor + '.' + versionMinor + ' : headerSize=' + headerSize + ', offsetSize=' + offsetSize;
      tmp0.pbj(level, tmp$ret$3);
    }
  }
  ncz(_this__u8e3s4) {
    return _this__u8e3s4.fb7();
  }
  ocz(_this__u8e3s4, offSize) {
    var roffSize = offSize < 0 ? this.ncz(_this__u8e3s4) : offSize;
    var tmp;
    switch (roffSize) {
      case 1:
        tmp = _this__u8e3s4.fb7();
        break;
      case 2:
        tmp = _this__u8e3s4.hb7();
        break;
      case 3:
        tmp = _this__u8e3s4.ib7();
        break;
      case 4:
        tmp = _this__u8e3s4.jb7();
        break;
      default:
        reserved('' + roffSize);
        break;
    }
    return tmp;
  }
  kcz(_this__u8e3s4) {
    var count = _this__u8e3s4.hb7();
    if (count === 0)
      return DataIndex.bcz();
    var offSize = this.ncz(_this__u8e3s4);
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = until(0, count + 1 | 0);
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.za1((coerceAtLeast(this_0.r3() - this_0.s3() | 0, 0) / this_0.p3_1 | 0) + 1 | 0);
    var nestedFirst = this_0.s3();
    var nestedLast = this_0.r3();
    var stepArg = this_0.p3_1;
    if (stepArg <= 0)
      THROW_IAE('Step must be positive, was: ' + stepArg + '.');
    var inductionVariable = nestedFirst;
    var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
    if (inductionVariable <= last)
      do {
        var v = inductionVariable;
        inductionVariable = inductionVariable + stepArg | 0;
        var tmp$ret$3 = CFF_instance.ocz(_this__u8e3s4, offSize) - 1 | 0;
        this_1.ga2(tmp$ret$3);
      }
       while (!(v === last));
    var offsets = this_1;
    var bytes = _this__u8e3s4.db7(offsets.oa2());
    return DataIndex.acz(offsets.sa2(), bytes);
  }
  lcz(_this__u8e3s4) {
    var map = LinkedHashMap.m7();
    // Inline function 'kotlin.collections.arrayListOf' call
    var values = ArrayList.p2();
    while (_this__u8e3s4.b6y()) {
      var item = this.pcz(_this__u8e3s4);
      if (item instanceof Op) {
        // Inline function 'kotlin.collections.set' call
        var value = toList(values);
        map.b5(item, value);
        values.a5();
      } else {
        if (isNumber(item)) {
          values.d2(item);
        }
      }
    }
    return map;
  }
  pcz(_this__u8e3s4) {
    var b0 = _this__u8e3s4.fb7();
    var tmp;
    if (0 <= b0 ? b0 <= 21 : false) {
      var tmp_0 = Companion_getInstance_29();
      tmp = tmp_0.u2(b0 === 12 ? b0 << 8 | _this__u8e3s4.fb7() : b0);
    } else if (22 <= b0 ? b0 <= 27 : false) {
      get_reserved();
    } else if (b0 === 28) {
      tmp = toShort(_this__u8e3s4.fb7() << 8 | _this__u8e3s4.fb7());
    } else if (b0 === 29) {
      tmp = _this__u8e3s4.fb7() << 24 | _this__u8e3s4.fb7() << 16 | _this__u8e3s4.fb7() << 8 | _this__u8e3s4.fb7();
    } else if (b0 === 30) {
      tmp = this.qcz(_this__u8e3s4, false);
    } else if (b0 === 31) {
      get_reserved();
    } else if (32 <= b0 ? b0 <= 246 : false) {
      tmp = b0 - 139 | 0;
    } else if (247 <= b0 ? b0 <= 250 : false) {
      tmp = (imul(b0 - 247 | 0, 256) + _this__u8e3s4.fb7() | 0) + 108 | 0;
    } else if (251 <= b0 ? b0 <= 254 : false) {
      tmp = ((-imul(b0 - 251 | 0, 256) | 0) - _this__u8e3s4.fb7() | 0) - 108 | 0;
    } else if (b0 === 255) {
      get_reserved();
    } else {
      get_unreachable();
    }
    return tmp;
  }
  rcz(_this__u8e3s4, readHeader) {
    if (readHeader) {
      // Inline function 'kotlin.check' call
      if (!(_this__u8e3s4.fb7() === 30)) {
        throw IllegalStateException.o('Check failed.');
      }
    }
    var str = StringBuilder.l1();
    end: while (true) {
      var byte = _this__u8e3s4.fb7();
      var inductionVariable = 0;
      if (inductionVariable <= 1)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var nibble = (byte >>> imul(1 - n | 0, 4) | 0) & 15;
          if (nibble === 15)
            break end;
          switch (nibble) {
            case 15:
              break end;
            case 12:
              str.m1('E-');
              break;
            default:
              str.o1((0 <= nibble ? nibble <= 9 : false) ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), nibble) : nibble === 10 ? _Char___init__impl__6a9atx(46) : nibble === 11 ? _Char___init__impl__6a9atx(69) : nibble === 14 ? _Char___init__impl__6a9atx(45) : _Char___init__impl__6a9atx(48));
              break;
          }
        }
         while (inductionVariable <= 1);
    }
    return str.toString();
  }
  qcz(_this__u8e3s4, readHeader) {
    return toDouble(this.rcz(_this__u8e3s4, readHeader));
  }
}
class CharStringType2 {
  scz(_this__u8e3s4, value) {
    _this__u8e3s4.ta3(_this__u8e3s4.s2() - 1 | 0, value);
  }
  tcz(_this__u8e3s4) {
    return _this__u8e3s4.u2(_this__u8e3s4.s2() - 1 | 0);
  }
  ucz(_this__u8e3s4) {
    return _this__u8e3s4.g5(_this__u8e3s4.s2() - 1 | 0);
  }
  vcz(_this__u8e3s4, value) {
    _this__u8e3s4.la3(value);
  }
  wcz(_this__u8e3s4, value) {
    _this__u8e3s4.la3(value);
  }
  xcz(_this__u8e3s4) {
    var lastPoint = _this__u8e3s4.hah();
    _this__u8e3s4.f7();
    _this__u8e3s4.gah(lastPoint);
  }
  ycz(_this__u8e3s4, x, y) {
    _this__u8e3s4.yas(Vector2D.t9g(x, y));
  }
  zcz(_this__u8e3s4, x, y) {
    _this__u8e3s4.zas(Vector2D.t9g(x, y));
  }
  ad0(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay) {
    _this__u8e3s4.lah(Vector2D.t9g(fcx1, fcy1), Vector2D.t9g(fcx2, fcy2), Vector2D.t9g(fax, fay));
  }
  bd0(_this__u8e3s4, cx1, cy1, cx2, cy2, ax, ay) {
    var fcx1 = _this__u8e3s4.hah().r9g_1 + cx1;
    var fcy1 = _this__u8e3s4.hah().s9g_1 + cy1;
    var fcx2 = fcx1 + cx2;
    var fcy2 = fcy1 + cy2;
    var fax = fcx2 + ax;
    var fay = fcy2 + ay;
    this.ad0(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay);
  }
  cd0(_this__u8e3s4, v, horizontal) {
    return this.ycz(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  dd0(_this__u8e3s4, v, horizontal) {
    return this.zcz(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  ed0(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    return _this__u8e3s4.fb7();
  }
  fd0(ctx, s, evalCtx, stack, stackLevel) {
    while (s.b6y()) {
      var v0 = this.ed0(s);
      if ((0 <= v0 ? v0 <= 27 : false) || (29 <= v0 ? v0 <= 31 : false)) {
        var tmp = Companion_getInstance_30();
        var op = tmp.u2(v0 === 12 ? v0 << 8 | this.ed0(s) : v0);
        switch (op.w1_1) {
          case 13:
            return Unit_instance;
          case 16:
            var tmp_0;
            // Inline function 'kotlin.collections.isNotEmpty' call

            if (!stack.n1()) {
              tmp_0 = !evalCtx.ycy_1;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              evalCtx.xcy_1 = stack.u2(0) + evalCtx.rcy_1;
              evalCtx.ycy_1 = true;
            }

            if (!(ctx.pas() === 0)) {
              this.xcz(ctx);
            }

            return Unit_instance;
          case 11:
          case 40:
            var global = op.equals(Op_callgsubr_getInstance());
            var funcOffset = numberToInt(this.ucz(stack));
            var bytes = global ? evalCtx.ocy_1.u2(evalCtx.ucy_1 + funcOffset | 0) : evalCtx.pcy_1.u2(evalCtx.vcy_1 + funcOffset | 0);
            this.fd0(ctx, openFastStream(bytes), evalCtx, stack, stackLevel + 1 | 0);
            break;
          case 22:
            this.ucz(stack);
            break;
          case 38:
            // Inline function 'kotlin.also' call

            var this_0 = this.ucz(stack);
            stack.ma3(this_0, this_0);
            break;
          case 39:
            stack.qa2(stack.s2() - 2 | 0, stack.s2() - 1 | 0);
            break;
          case 43:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.le();
          case 41:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.le();
          case 25:
            var index = this.ucz(stack);
            var value = this.ucz(stack);
            evalCtx.tcy_1[numberToInt(index)] = value;
            break;
          case 27:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            var it = this.tcz(stack);
            var tmp$ret$7 = evalCtx.tcy_1[numberToInt(it)];
            this.scz(stack, tmp$ret$7);
            break;
          case 2:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r = this.ucz(stack);
            var l = this.ucz(stack);
            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$9 = !(l === 0.0) && !(r === 0.0) ? 1 : 0;
            this.vcz(stack, tmp$ret$9);
            break;
          case 4:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_0 = this.ucz(stack);
            var l_0 = this.ucz(stack);
            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$12 = !(l_0 === 0.0) || !(r_0 === 0.0) ? 1 : 0;
            this.vcz(stack, tmp$ret$12);
            break;
          case 6:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$15 = this.tcz(stack) === 0.0 ? 1 : 0;
            this.scz(stack, tmp$ret$15);
            break;
          case 19:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_1 = this.ucz(stack);
            var l_1 = this.ucz(stack);
            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$18 = l_1 === r_1 ? 1 : 0;
            this.vcz(stack, tmp$ret$18);
            break;
          case 29:
            var v2 = this.ucz(stack);
            var v1 = this.ucz(stack);
            var s2 = this.ucz(stack);
            var s1 = this.ucz(stack);
            this.vcz(stack, v1 <= v2 ? s1 : s2);
            break;
          case 31:
            stack.la3(Default_getInstance().nr());
            break;
          case 36:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'kotlin.math.sqrt' call

            var x = this.tcz(stack);
            var tmp$ret$21 = Math.sqrt(x);
            this.scz(stack, tmp$ret$21);
            break;
          case 10:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'kotlin.math.abs' call

            var x_0 = this.tcz(stack);
            var tmp$ret$24 = Math.abs(x_0);
            this.scz(stack, tmp$ret$24);
            break;
          case 17:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            var tmp$ret$27 = -this.tcz(stack);
            this.scz(stack, tmp$ret$27);
            break;
          case 12:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_2 = this.ucz(stack);
            var l_2 = this.ucz(stack);
            var tmp$ret$29 = l_2 + r_2;
            this.vcz(stack, tmp$ret$29);
            break;
          case 14:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_3 = this.ucz(stack);
            var l_3 = this.ucz(stack);
            var tmp$ret$31 = l_3 - r_3;
            this.vcz(stack, tmp$ret$31);
            break;
          case 15:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_4 = this.ucz(stack);
            var l_4 = this.ucz(stack);
            var tmp$ret$33 = l_4 / r_4;
            this.vcz(stack, tmp$ret$33);
            break;
          case 33:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_5 = this.ucz(stack);
            var l_5 = this.ucz(stack);
            var tmp$ret$35 = l_5 * r_5;
            this.vcz(stack, tmp$ret$35);
            break;
          case 26:
            if (stack.s2() > 2) {
              evalCtx.xcy_1 = stack.u2(0) + evalCtx.rcy_1;
              evalCtx.ycy_1 = true;
            }

            if (!(ctx.pas() === 0)) {
              this.xcz(ctx);
            }

            this.ycz(ctx, stack.u2(stack.s2() - 2 | 0), stack.u2(stack.s2() - 1 | 0));
            stack.a5();
            break;
          case 3:
          case 28:
            if (stack.s2() > 1) {
              evalCtx.xcy_1 = stack.u2(0) + evalCtx.rcy_1;
              evalCtx.ycy_1 = true;
            }

            this.cd0(ctx, this.ucz(stack), op.equals(Op_hmoveto_getInstance()));
            stack.a5();
            break;
          case 5:
            var progression = step(until(0, stack.s2()), 2);
            var inductionVariable = progression.n3_1;
            var last = progression.o3_1;
            var step_0 = progression.p3_1;
            if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
              do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + step_0 | 0;
                this.zcz(ctx, stack.u2(n), stack.u2(n + 1 | 0));
              }
               while (!(n === last));
            stack.a5();
            break;
          case 7:
          case 8:
            var toggle = op.equals(Op_hlineto_getInstance());
            var inductionVariable_0 = 0;
            var last_0 = stack.s2();
            if (inductionVariable_0 < last_0)
              do {
                var n_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                this.dd0(ctx, stack.u2(n_0), toggle);
                toggle = !toggle;
              }
               while (inductionVariable_0 < last_0);
            stack.a5();
            break;
          case 9:
          case 32:
          case 34:
            var n_1 = 0;
            if (op.equals(Op_rlinecurve_getInstance())) {
              while ((stack.s2() - n_1 | 0) < 6) {
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var tmp_1 = stack.u2(_unary__edvuaz);
                var _unary__edvuaz_0 = n_1;
                n_1 = _unary__edvuaz_0 + 1 | 0;
                this.zcz(ctx, tmp_1, stack.u2(_unary__edvuaz_0));
              }
            }

            while ((stack.s2() - n_1 | 0) >= 6) {
              var _unary__edvuaz_1 = n_1;
              n_1 = _unary__edvuaz_1 + 1 | 0;
              var tmp_2 = stack.u2(_unary__edvuaz_1);
              var _unary__edvuaz_2 = n_1;
              n_1 = _unary__edvuaz_2 + 1 | 0;
              var tmp_3 = stack.u2(_unary__edvuaz_2);
              var _unary__edvuaz_3 = n_1;
              n_1 = _unary__edvuaz_3 + 1 | 0;
              var tmp_4 = stack.u2(_unary__edvuaz_3);
              var _unary__edvuaz_4 = n_1;
              n_1 = _unary__edvuaz_4 + 1 | 0;
              var tmp_5 = stack.u2(_unary__edvuaz_4);
              var _unary__edvuaz_5 = n_1;
              n_1 = _unary__edvuaz_5 + 1 | 0;
              var tmp_6 = stack.u2(_unary__edvuaz_5);
              var _unary__edvuaz_6 = n_1;
              n_1 = _unary__edvuaz_6 + 1 | 0;
              this.bd0(ctx, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, stack.u2(_unary__edvuaz_6));
            }

            if (op.equals(Op_rcurveline_getInstance())) {
              while (n_1 < stack.s2()) {
                var _unary__edvuaz_7 = n_1;
                n_1 = _unary__edvuaz_7 + 1 | 0;
                var tmp_7 = stack.u2(_unary__edvuaz_7);
                var _unary__edvuaz_8 = n_1;
                n_1 = _unary__edvuaz_8 + 1 | 0;
                this.zcz(ctx, tmp_7, stack.u2(_unary__edvuaz_8));
              }
            }

            stack.a5();
            break;
          case 35:
          case 37:
            var horizontal = op.equals(Op_hhcurveto_getInstance());
            var n_2 = 0;
            var tmp_8;
            if ((stack.s2() % 2 | 0) === 1) {
              var _unary__edvuaz_9 = n_2;
              n_2 = _unary__edvuaz_9 + 1 | 0;
              tmp_8 = stack.u2(_unary__edvuaz_9);
            } else {
              tmp_8 = 0.0;
            }

            var v = tmp_8;
            var initialY = horizontal ? v : 0.0;
            var initialX = horizontal ? 0.0 : v;
            if (!(((stack.s2() - n_2 | 0) % 4 | 0) === 0)) {
              // Inline function 'kotlin.error' call
              var message = 'Invalid number of operands';
              throw IllegalStateException.o(toString_0(message));
            }

            while (n_2 < stack.s2()) {
              var _unary__edvuaz_10 = n_2;
              n_2 = _unary__edvuaz_10 + 1 | 0;
              var vv = stack.u2(_unary__edvuaz_10);
              var x1 = initialX + (horizontal ? vv : 0.0);
              var y1 = initialY + (horizontal ? 0.0 : vv);
              var _unary__edvuaz_11 = n_2;
              n_2 = _unary__edvuaz_11 + 1 | 0;
              var x2 = stack.u2(_unary__edvuaz_11);
              var _unary__edvuaz_12 = n_2;
              n_2 = _unary__edvuaz_12 + 1 | 0;
              var y2 = stack.u2(_unary__edvuaz_12);
              var _unary__edvuaz_13 = n_2;
              n_2 = _unary__edvuaz_13 + 1 | 0;
              var v1_0 = stack.u2(_unary__edvuaz_13);
              var lastX = horizontal ? v1_0 : 0.0;
              var lastY = horizontal ? 0.0 : v1_0;
              this.bd0(ctx, x1, y1, x2, y2, lastX, lastY);
              initialX = 0.0;
              initialY = 0.0;
            }

            stack.a5();
            break;
          case 42:
          case 44:
            reverse(stack);
            var toggle_0 = op.equals(Op_hvcurveto_getInstance());
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!stack.n1()) {
                break $l$loop;
              }
              var vv_0 = this.ucz(stack);
              var x1_0 = toggle_0 ? vv_0 : 0.0;
              var y1_0 = toggle_0 ? 0.0 : vv_0;
              var x2_0 = this.ucz(stack);
              var y2_0 = this.ucz(stack);
              var v1_1 = this.ucz(stack);
              var v2_0 = stack.s2() === 1 ? this.ucz(stack) : 0.0;
              var ax = toggle_0 ? v2_0 : v1_1;
              var ay = toggle_0 ? v1_1 : v2_0;
              this.bd0(ctx, x1_0, y1_0, x2_0, y2_0, ax, ay);
              toggle_0 = !toggle_0;
            }

            stack.a5();
            break;
          case 45:
          case 46:
          case 47:
          case 48:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.le();
          case 0:
          case 1:
          case 21:
          case 30:
          case 23:
          case 24:
            if (!((stack.s2() % 2 | 0) === 0) && !evalCtx.ycy_1) {
              var value_0 = stack.u2(0);
              evalCtx.xcy_1 = value_0 + evalCtx.rcy_1;
            }

            evalCtx.wcy_1 = evalCtx.wcy_1 + (stack.s2() >>> 1 | 0) | 0;
            evalCtx.ycy_1 = true;
            stack.a5();
            if (op.equals(Op_hintmask_getInstance()) || op.equals(Op_cntrmask_getInstance())) {
              var skipCount = (evalCtx.wcy_1 + 7 | 0) >>> 3 | 0;
              s.kb5(skipCount);
            }

            break;
          case 18:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.le();
          case 20:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.le();
          default:
            noWhenBranchMatchedException();
            break;
        }
      } else if (v0 === 255) {
        var integerPart = this.ed0(s) << 8 | this.ed0(s);
        var fractionPart = this.ed0(s) << 8 | this.ed0(s);
        var value_1 = integerPart + fractionPart / 65536.0;
        this.vcz(stack, value_1);
      } else {
        var tmp_9;
        if (v0 === 28) {
          tmp_9 = toShort(this.ed0(s) << 8 | this.ed0(s));
        } else if (32 <= v0 ? v0 <= 246 : false) {
          tmp_9 = v0 - 139 | 0;
        } else if (247 <= v0 ? v0 <= 250 : false) {
          tmp_9 = (imul(v0 - 247 | 0, 256) + this.ed0(s) | 0) + 108 | 0;
        } else if (251 <= v0 ? v0 <= 254 : false) {
          tmp_9 = ((-imul(v0 - 251 | 0, 256) | 0) - this.ed0(s) | 0) - 108 | 0;
        } else {
          get_unreachable();
        }
        var value_2 = tmp_9;
        this.wcz(stack, value_2);
      }
    }
  }
  ncy(ctx, s, evalCtx, stack, stackLevel, $super) {
    stack = stack === VOID ? DoubleArrayList.ga3(32) : stack;
    stackLevel = stackLevel === VOID ? 0 : stackLevel;
    var tmp;
    if ($super === VOID) {
      this.fd0(ctx, s, evalCtx, stack, stackLevel);
      tmp = Unit_instance;
    } else {
      tmp = $super.fd0.call(this, ctx, s, evalCtx, stack, stackLevel);
    }
    return tmp;
  }
}
class TtfCIDFont {
  constructor() {
    TtfCIDFont_instance = this;
    this.mcz_1 = Companion_getInstance_14().pb5('TtfCIDFont');
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_21 = this;
    this.gd0_1 = Companion_getInstance_14().pb5('TTF');
  }
}
class VectorFont {}
function getGlyphPath$default(size, codePoint, path, reader, $super) {
  path = path === VOID ? new GlyphPath() : path;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.wd2(size, codePoint, path, reader) : $super.wd2.call(this, size, codePoint, path, reader);
}
function renderGlyph_0(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  $l$block: {
    // Inline function 'korlibs.io.lang.keep' call
    var tmp0_elvis_lhs = reader == null ? null : reader.zb4_1;
    var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    try {
      this.zck(size, codePoint, metrics, reader);
      break $l$block;
    }finally {
      if (reader == null)
        null;
      else {
        reader.zb4_1 = old;
      }
    }
  }
  var g = this.xd2(size, codePoint, VOID, reader);
  if (!(g == null)) {
    if (!(fill == null)) {
      ctx.rct();
    }
    if (!g.rcw()) {
      if (beforeDraw == null)
        null;
      else
        beforeDraw();
    }
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = ctx.tc9_1.kcl_1;
    try {
      // Inline function 'korlibs.image.vector.Context2d.translate' call
      ctx.zcv(pos.r9g_1, pos.s9g_1);
      g.scw(ctx);
    }finally {
      ctx.tc9_1.kcl_1 = t;
    }
    switch (fill) {
      case true:
        ctx.xct();
        break;
      case false:
        ctx.wct();
        break;
      case null:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return !g.rcw();
  }
  return false;
}
class BaseTtfFont {
  static sdc(s, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = createThis(this);
    $this.hd0_1 = new Mixin();
    $this.id0_1 = s;
    $this.jd0_1 = extName;
    $this.kd0_1 = onlyReadMetadata;
    $this.ld0_1 = enableLigatures;
    $this.md0_1 = new NamesInfo();
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(3);
    while (tmp_0 < 3) {
      tmp_1[tmp_0] = new Contour();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.nd0_1 = tmp_1;
    $this.od0_1 = 0;
    $this.pd0_1 = 0;
    $this.qd0_1 = 0;
    $this.rd0_1 = 0;
    $this.sd0_1 = 0;
    $this.td0_1 = 0;
    $this.ud0_1 = 0;
    $this.vd0_1 = 0;
    $this.wd0_1 = 0;
    $this.xd0_1 = 0;
    $this.yd0_1 = 0;
    $this.zd0_1 = 0;
    $this.ad1_1 = 0;
    $this.bd1_1 = 0;
    $this.cd1_1 = Companion_instance_25.tdc(0, 0);
    $this.dd1_1 = 0;
    $this.ed1_1 = 0;
    $this.fd1_1 = 0;
    $this.gd1_1 = 0;
    $this.hd1_1 = 0;
    $this.id1_1 = 0;
    $this.jd1_1 = 0;
    $this.kd1_1 = 0;
    $this.ld1_1 = 0;
    $this.md1_1 = 0;
    $this.nd1_1 = 0;
    $this.od1_1 = 0;
    $this.pd1_1 = new Int32Array(0);
    $this.qd1_1 = Companion_instance_25.tdc(0, 0);
    $this.rd1_1 = 128;
    $this.sd1_1 = 0;
    $this.td1_1 = 0;
    $this.ud1_1 = 0;
    $this.vd1_1 = 0;
    $this.wd1_1 = 0;
    $this.xd1_1 = 0;
    $this.yd1_1 = 0;
    $this.zd1_1 = 0;
    $this.ad2_1 = 0;
    var tmp_2 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_2.bd2_1 = emptyList();
    $this.cd2_1 = LinkedHashMap.m7();
    $this.dd2_1 = LinkedHashMap.m7();
    $this.ed2_1 = IntMap.fa7(512);
    $this.fd2_1 = LinkedHashMap.m7();
    var tmp_3 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_3.gd2_1 = [];
    $this.hd2_1 = IntMap.fa7();
    var tmp_4 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_4.id2_1 = emptyList();
    $this.jd2_1 = new COLRv1();
    $this.kd2_1 = false;
    $this.ld2_1 = IntIntMap.xa7();
    $this.md2_1 = IntMap.fa7();
    $this.od2_1 = new GlyphMetrics(1.0, false, 0, Companion_getInstance_4().y9k(), 0.0);
    $this.pd2_1 = false;
    $this.qd2_1 = null;
    return $this;
  }
  o9u(_set____db54di) {
    this.hd0_1.o9u(_set____db54di);
  }
  p9u() {
    return this.hd0_1.p9u();
  }
  static rd2(d, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    return this.sdc(openFastStream(d), extName, onlyReadMetadata, enableLigatures);
  }
  nck(size, metrics) {
    return metrics.xck(this.bd3(), size);
  }
  zck(size, codePoint, metrics, reader) {
    var tmp104_safe_receiver = this.md4(reader, codePoint);
    var tmp0_elvis_lhs = tmp104_safe_receiver == null ? null : tmp104_safe_receiver.yd9_1;
    return metrics.fcl(tmp0_elvis_lhs == null ? this.od2_1 : tmp0_elvis_lhs, size, codePoint);
  }
  lcm(size, leftCodePoint, rightCodePoint) {
    return 0.0;
  }
  wd2(size, codePoint, path, reader) {
    var spos = reader == null ? null : reader.zb4_1;
    var codePointPeek = reader == null ? null : reader.gb5(0);
    var tmp0_elvis_lhs = this.ld4(reader, codePoint, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var g = tmp;
    var scale = this.icl(size);
    path.kcw_1 = g.obf().bda_1;
    var tmp_0 = path;
    var tmp107_safe_receiver = g.lda();
    tmp_0.lcw_1 = tmp107_safe_receiver == null ? null : tmp107_safe_receiver.dda();
    var bitmapEntry = g.nda();
    var bitmap = bitmapEntry == null ? null : bitmapEntry.nd7();
    path.mcw_1 = bitmap;
    if (!(bitmapEntry == null)) {
      var scaleX = this.rd1_1 / bitmapEntry.wd6_1.cd6_1;
      var scaleY = this.rd1_1 / bitmapEntry.wd6_1.dd6_1;
      path.ncw_1 = Vector2D.t9g(0.0, ((-bitmapEntry.xd6_1 | 0) - bitmapEntry.hd7() | 0) * scaleY);
      path.ocw_1 = Scale.e9p(scaleX, scaleY);
    }
    path.pcw_1 = Companion_getInstance_5().v9k_1.u9l(scale, scale);
    path.qcw_1 = scale;
    return path;
  }
  icl(size) {
    return size / this.rd1_1;
  }
  yd2(key) {
    return this.cd2_1.w4(key);
  }
  zd2(codePoint, glyphID) {
    // Inline function 'kotlin.collections.set' call
    this.cd2_1.b5(codePoint, glyphID);
    // Inline function 'kotlin.collections.set' call
    this.dd2_1.b5(glyphID, codePoint);
  }
  ad3(codePoint, glyphID) {
  }
  bd3() {
    var tmp = this.nd2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontMetrics1px');
    }
  }
  cd3() {
    return this.md0_1.cd3();
  }
  h1() {
    var tmp0_elvis_lhs = this.jd0_1;
    return tmp0_elvis_lhs == null ? this.cd3() : tmp0_elvis_lhs;
  }
  sd2() {
    this.td2();
    this.id3();
    this.jd3();
    this.kd3();
    this.gd3();
    if (!this.kd0_1) {
      if (!(this.vd2('CFF ') == null) && this.vd2('glyf') == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
        var tmp111_safe_receiver = this.fd3('CFF ');
        if (tmp111_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.apply' call
          this.qd2_1 = CFF_instance.icz(tmp111_safe_receiver);
        }
      }
      this.hd3();
      this.id4();
      this.ld3();
      this.md3();
      this.hd4();
      this.gd4();
      this.od3();
      this.pd3();
      this.qd3();
    }
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new FontMetrics();
    var scale = this.icl(1.0);
    this_0.ock_1 = 1.0;
    this_0.pck_1 = this.vd1_1 * scale;
    this_0.qck_1 = this.dd1_1 * scale;
    this_0.rck_1 = 0.0 * scale;
    this_0.sck_1 = this.ed1_1 * scale;
    this_0.tck_1 = this.td1_1 * scale;
    this_0.uck_1 = this.fd1_1 * scale;
    this_0.vck_1 = this.gd1_1 * scale;
    this_0.wck_1 = this.rd1_1 * scale;
    tmp.nd2_1 = this_0;
  }
  toString() {
    return 'TtfFont(name=' + this.h1() + ')';
  }
  dd3(_this__u8e3s4) {
    return _FWord___init__impl__2rjyqf(_this__u8e3s4.hb7());
  }
  ed3(_this__u8e3s4) {
    return Companion_instance_25.tdc(_this__u8e3s4.gb7(), _this__u8e3s4.gb7());
  }
  fd3(name) {
    var tmp109_safe_receiver = this.vd2(name);
    return tmp109_safe_receiver == null ? null : tmp109_safe_receiver.qd5();
  }
  gd3() {
    // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
    var tmp111_safe_receiver = this.fd3('name');
    if (tmp111_safe_receiver == null)
      null;
    else {
      Companion_instance_24.td5(tmp111_safe_receiver, this.md0_1);
    }
    return Unit_instance;
  }
  hd3() {
    // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
    var tmp111_safe_receiver = this.fd3('loca');
    if (tmp111_safe_receiver == null)
      null;
    else {
      var tmp;
      switch (this.zd1_1) {
        case 0:
          tmp = 2;
          break;
        case 1:
          tmp = 4;
          break;
        default:
          get_invalidOp();
          break;
      }
      var bytesPerEntry = tmp;
      var data = tmp111_safe_receiver.db7(imul(bytesPerEntry, this.od0_1 + 1 | 0));
      var tmp_0 = this;
      // Inline function 'kotlin.run' call
      var $this$run = new FastByteArrayInputStream(data);
      var tmp_1;
      switch (this.zd1_1) {
        case 0:
          // Inline function 'korlibs.datastructure.mapInt' call

          var this_0 = $this$run.nb7(this.od0_1 + 1 | 0);
          // Inline function 'kotlin.also' call

          var this_1 = new Int32Array(this_0.length);
          var inductionVariable = 0;
          var last = this_0.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'kotlin.code' call
              var this_2 = this_0[n];
              var tmp$ret$8 = Char__toInt_impl_vasixd(this_2);
              this_1[n] = imul(tmp$ret$8, 2);
            }
             while (inductionVariable < last);
          tmp_1 = this_1;
          break;
        case 1:
          tmp_1 = $this$run.pb7(this.od0_1 + 1 | 0);
          break;
        default:
          get_invalidOp();
          break;
      }
      tmp_0.pd1_1 = tmp_1;
    }
    return Unit_instance;
  }
  id3() {
    // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
    var tmp111_safe_receiver = this.fd3('head');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.apply' call
      if (!(tmp111_safe_receiver.hb7() === 1)) {
        invalidOp('Invalid TTF');
      }
      // Inline function 'kotlin.apply' call
      if (!(tmp111_safe_receiver.hb7() === 0)) {
        invalidOp('Invalid TTF');
      }
      this.qd1_1 = this.ed3(tmp111_safe_receiver);
      var checkSumAdjustment = tmp111_safe_receiver.jb7();
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.jb7();
      if (!(this_0 === 1594834165)) {
        invalidOp('Invalid magic ' + get_hex(this_0));
      }
      var flags = tmp111_safe_receiver.hb7();
      this.rd1_1 = tmp111_safe_receiver.hb7();
      var created = multiply(tmp111_safe_receiver.kb7(), new Long(1000, 0));
      var modified = multiply(tmp111_safe_receiver.kb7(), new Long(1000, 0));
      this.sd1_1 = tmp111_safe_receiver.gb7();
      this.td1_1 = tmp111_safe_receiver.gb7();
      this.ud1_1 = tmp111_safe_receiver.gb7();
      this.vd1_1 = tmp111_safe_receiver.gb7();
      this.wd1_1 = tmp111_safe_receiver.hb7();
      this.xd1_1 = tmp111_safe_receiver.hb7();
      this.yd1_1 = tmp111_safe_receiver.gb7();
      this.zd1_1 = tmp111_safe_receiver.gb7();
      this.ad2_1 = tmp111_safe_receiver.gb7();
    }
    return Unit_instance;
  }
  jd3() {
    // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
    var tmp111_safe_receiver = this.fd3('maxp');
    if (tmp111_safe_receiver == null)
      null;
    else {
      var version = this.ed3(tmp111_safe_receiver);
      this.od0_1 = tmp111_safe_receiver.hb7();
      this.pd0_1 = tmp111_safe_receiver.hb7();
      this.qd0_1 = tmp111_safe_receiver.hb7();
      this.rd0_1 = tmp111_safe_receiver.hb7();
      this.sd0_1 = tmp111_safe_receiver.hb7();
      this.td0_1 = tmp111_safe_receiver.hb7();
      this.ud0_1 = tmp111_safe_receiver.hb7();
      this.vd0_1 = tmp111_safe_receiver.hb7();
      this.wd0_1 = tmp111_safe_receiver.hb7();
      this.xd0_1 = tmp111_safe_receiver.hb7();
      this.yd0_1 = tmp111_safe_receiver.hb7();
      this.zd0_1 = tmp111_safe_receiver.hb7();
      this.ad1_1 = tmp111_safe_receiver.hb7();
      this.bd1_1 = tmp111_safe_receiver.hb7();
    }
    return Unit_instance;
  }
  kd3() {
    // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
    var tmp111_safe_receiver = this.fd3('hhea');
    if (tmp111_safe_receiver == null)
      null;
    else {
      this.cd1_1 = this.ed3(tmp111_safe_receiver);
      this.dd1_1 = tmp111_safe_receiver.gb7();
      this.ed1_1 = tmp111_safe_receiver.gb7();
      this.fd1_1 = tmp111_safe_receiver.gb7();
      this.gd1_1 = tmp111_safe_receiver.hb7();
      this.hd1_1 = tmp111_safe_receiver.gb7();
      this.id1_1 = tmp111_safe_receiver.gb7();
      this.jd1_1 = tmp111_safe_receiver.gb7();
      this.kd1_1 = tmp111_safe_receiver.gb7();
      this.ld1_1 = tmp111_safe_receiver.gb7();
      this.md1_1 = tmp111_safe_receiver.gb7();
      tmp111_safe_receiver.gb7();
      tmp111_safe_receiver.gb7();
      tmp111_safe_receiver.gb7();
      tmp111_safe_receiver.gb7();
      this.nd1_1 = tmp111_safe_receiver.gb7();
      this.od1_1 = tmp111_safe_receiver.hb7();
    }
    return Unit_instance;
  }
  ld3() {
    // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
    var tmp111_safe_receiver = this.fd3('hmtx');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, this.od1_1);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.n3_1;
      var last_0 = this_0.o3_1;
      if (inductionVariable <= last_0)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$4 = new HorMetric(tmp111_safe_receiver.hb7(), tmp111_safe_receiver.gb7());
          destination.d2(tmp$ret$4);
        }
         while (!(item === last_0));
      var firstMetrics = destination;
      var lastAdvanceWidth = last(firstMetrics).rd5_1;
      // Inline function 'kotlin.collections.map' call
      var this_1 = until(0, this.od0_1 - this.od1_1 | 0);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.n2(collectionSizeOrDefault(this_1, 10));
      var inductionVariable_0 = this_1.n3_1;
      var last_1 = this_1.o3_1;
      if (inductionVariable_0 <= last_1)
        do {
          var item_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tmp$ret$7 = new HorMetric(lastAdvanceWidth, tmp111_safe_receiver.gb7());
          destination_0.d2(tmp$ret$7);
        }
         while (!(item_0 === last_1));
      var compressedMetrics = destination_0;
      this.bd2_1 = plus(firstMetrics, compressedMetrics);
    }
    return Unit_instance;
  }
  md3() {
    // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
    var tmp111_safe_receiver = this.fd3('CPAL');
    if (tmp111_safe_receiver == null)
      null;
    else {
      var version = tmp111_safe_receiver.hb7();
      switch (version) {
        case 0:
        case 1:
          var numPaletteEntries = tmp111_safe_receiver.hb7();
          var numPalettes = tmp111_safe_receiver.hb7();
          var numColorRecords = tmp111_safe_receiver.hb7();
          var colorRecordsArrayOffset = tmp111_safe_receiver.jb7();
          var colorRecordIndices = tmp111_safe_receiver.mb7(numPalettes);
          var paletteTypesArrayOffset = version === 1 ? tmp111_safe_receiver.jb7() : -1;
          var paletteLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.jb7() : -1;
          var paletteEntryLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.jb7() : -1;
          tmp111_safe_receiver.vb6(colorRecordsArrayOffset);
          var colorInts = tmp111_safe_receiver.ob7(numColorRecords);
          var inductionVariable = 0;
          var last = colorInts.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var c = _RGBA___init__impl__lqpay5(colorInts[n]);
              colorInts[n] = _RGBA___get_value__impl__hhco8v(Companion_getInstance_21().ich(_RGBA___get_b__impl__m6tl80(c), _RGBA___get_g__impl__o8pukr(c), _RGBA___get_r__impl__duz7mo(c), _RGBA___get_a__impl__6msvu7(c)));
            }
             while (inductionVariable < last);
          var tmp = this;
          // Inline function 'kotlin.collections.map' call

          // Inline function 'kotlin.collections.mapTo' call

          var destination = ArrayList.n2(colorRecordIndices.length);
          var inductionVariable_0 = 0;
          var last_0 = colorRecordIndices.length;
          while (inductionVariable_0 < last_0) {
            var item = colorRecordIndices[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp$ret$4 = new Palette(_RgbaArray___init__impl__oib4y4(copyOfRange_0(colorInts, item, item + numPaletteEntries | 0)));
            destination.d2(tmp$ret$4);
          }

          tmp.id2_1 = destination;
          break;
        default:
          println('TTF WARNING CPAL version != 0,1');
          break;
      }
    }
    return Unit_instance;
  }
  nd3(_this__u8e3s4) {
    return new SbitLineMetrics(_this__u8e3s4.eb7(), _this__u8e3s4.eb7(), _this__u8e3s4.fb7(), _this__u8e3s4.eb7(), _this__u8e3s4.eb7(), _this__u8e3s4.eb7(), _this__u8e3s4.eb7(), _this__u8e3s4.eb7(), _this__u8e3s4.eb7(), _this__u8e3s4.eb7(), _this__u8e3s4.eb7(), _this__u8e3s4.eb7());
  }
  od3() {
    // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
    var tmp111_safe_receiver = this.fd3('CBLC');
    if (tmp111_safe_receiver == null)
      null;
    else {
      var majorVersion = tmp111_safe_receiver.hb7();
      var minorVersion = tmp111_safe_receiver.hb7();
      if (majorVersion === 3) {
        var numSizes = tmp111_safe_receiver.jb7();
        var tmp = 0;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_0 = Array(numSizes);
        while (tmp < numSizes) {
          tmp_0[tmp] = new ColorBitmapInfo(tmp111_safe_receiver.jb7(), tmp111_safe_receiver.jb7(), tmp111_safe_receiver.jb7(), tmp111_safe_receiver.jb7(), this.nd3(tmp111_safe_receiver), this.nd3(tmp111_safe_receiver), tmp111_safe_receiver.hb7(), tmp111_safe_receiver.hb7(), tmp111_safe_receiver.fb7(), tmp111_safe_receiver.fb7(), tmp111_safe_receiver.fb7(), tmp111_safe_receiver.eb7());
          tmp = tmp + 1 | 0;
        }
        var colorBitmapInfos = toList_1(tmp_0);
        var _iterator__ex2g4s = colorBitmapInfos.p1();
        while (_iterator__ex2g4s.q1()) {
          var cbi = _iterator__ex2g4s.r1();
          var glyphCount = cbi.bd6_1 - cbi.ad6_1 | 0;
          tmp111_safe_receiver.vb6(cbi.ud5_1);
          var tmp_1 = 0;
          var tmp_2 = cbi.wd5_1;
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_3 = Array(tmp_2);
          while (tmp_1 < tmp_2) {
            tmp_3[tmp_1] = new BaseTtfFont$readCblc$Subtable(tmp111_safe_receiver.hb7(), tmp111_safe_receiver.hb7(), tmp111_safe_receiver.jb7());
            tmp_1 = tmp_1 + 1 | 0;
          }
          var subtables = tmp_3;
          var inductionVariable = 0;
          var last = subtables.length;
          while (inductionVariable < last) {
            var subtable = subtables[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            tmp111_safe_receiver.vb6(cbi.ud5_1 + subtable.fdc_1 | 0);
            var indexFormat = tmp111_safe_receiver.hb7();
            var imageFormat = tmp111_safe_receiver.hb7();
            var imageDataOffset = tmp111_safe_receiver.jb7();
            var tmp_4;
            if (indexFormat === 1) {
              var tmp_5 = 0;
              var tmp_6 = subtable.gdc() + 1 | 0;
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_7 = Array(tmp_6);
              while (tmp_5 < tmp_6) {
                tmp_7[tmp_5] = imageDataOffset + tmp111_safe_receiver.jb7() | 0;
                tmp_5 = tmp_5 + 1 | 0;
              }
              tmp_4 = tmp_7;
            } else {
              // Inline function 'kotlin.emptyArray' call
              tmp_4 = [];
            }
            var offsets = tmp_4;
            var inductionVariable_0 = 0;
            var last_0 = offsets.length - 1 | 0;
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var offset = offsets[n];
                var size = offsets[n + 1 | 0] - offset | 0;
                var glyphID = (subtable.ddc_1 + n | 0) - 1 | 0;
                var tmp0 = this.fd2_1;
                // Inline function 'kotlin.collections.set' call
                var value = new BitmapGlyphInfo(glyphID, imageFormat, offset, size, cbi);
                tmp0.b5(glyphID, value);
              }
               while (inductionVariable_0 < last_0);
          }
        }
      } else {
        println('Unsupported CBLC ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  pd3() {
    // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
    var tmp111_safe_receiver = this.fd3('CBDT');
    if (tmp111_safe_receiver == null)
      null;
    else {
      var majorVersion = tmp111_safe_receiver.hb7();
      var minorVersion = tmp111_safe_receiver.hb7();
      if (majorVersion === 3) {
        var _iterator__ex2g4s = this.fd2_1.y4().p1();
        while (_iterator__ex2g4s.q1()) {
          var i = _iterator__ex2g4s.r1();
          var format = i.td6_1;
          if (format === 17 || format === 18) {
            i.xd6_1 = tmp111_safe_receiver.fb7();
            i.yd6_1 = tmp111_safe_receiver.fb7();
            i.zd6_1 = tmp111_safe_receiver.eb7();
            i.ad7_1 = tmp111_safe_receiver.eb7();
            i.bd7_1 = tmp111_safe_receiver.fb7();
            i.cd7_1 = format === 18 ? tmp111_safe_receiver.eb7() : i.zd6_1;
            i.dd7_1 = format === 18 ? tmp111_safe_receiver.eb7() : i.ad7_1;
            i.ed7_1 = format === 18 ? tmp111_safe_receiver.eb7() : i.bd7_1;
          }
          var dataLen = tmp111_safe_receiver.jb7();
          i.fd7_1 = tmp111_safe_receiver.yb6(dataLen);
        }
      } else {
        println('Unsupported CBDT ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  qd3() {
    // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
    var tmp111_safe_receiver = this.fd3('sbix');
    if (tmp111_safe_receiver == null)
      null;
    else {
      var version = tmp111_safe_receiver.hb7();
      var flags = tmp111_safe_receiver.hb7();
      var numStrikes = tmp111_safe_receiver.jb7();
      var strikeOffsets = tmp111_safe_receiver.pb7(numStrikes);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.n2(strikeOffsets.length);
      var inductionVariable = 0;
      var last = strikeOffsets.length;
      while (inductionVariable < last) {
        var item = strikeOffsets[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        tmp111_safe_receiver.vb6(item);
        var tmp$ret$4 = new BaseTtfFont$readSbix$StrikeInfo(tmp111_safe_receiver.hb7(), tmp111_safe_receiver.hb7(), item, toIntArrayList(tmp111_safe_receiver.pb7(this.od0_1 + 1 | 0)));
        destination.d2(tmp$ret$4);
      }
      var strikes = destination;
      var tmp$ret$5;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxByOrNull' call
        var iterator = strikes.p1();
        if (!iterator.q1()) {
          tmp$ret$5 = null;
          break $l$block_0;
        }
        var maxElem = iterator.r1();
        if (!iterator.q1()) {
          tmp$ret$5 = maxElem;
          break $l$block_0;
        }
        var maxValue = maxElem.hdc_1;
        do {
          var e = iterator.r1();
          var v = e.hdc_1;
          if (compareTo(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (iterator.q1());
        tmp$ret$5 = maxElem;
      }
      var strike = ensureNotNull(tmp$ret$5);
      var inductionVariable_0 = 0;
      var last_0 = this.od0_1;
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var glyphID = n;
          var offset = strike.kdc_1.u2(n);
          var len = strike.kdc_1.u2(n + 1 | 0) - offset | 0;
          var start = strike.jdc_1 + offset | 0;
          var end = start + len | 0;
          tmp111_safe_receiver.vb6(start);
          var originOffsetX = tmp111_safe_receiver.gb7();
          var originOffsetY = tmp111_safe_receiver.gb7();
          var graphicType = tmp111_safe_receiver.sb7(4);
          var bytes = tmp111_safe_receiver.yb6(len - 8 | 0);
          var tmp0 = this.fd2_1;
          // Inline function 'kotlin.also' call
          var this_0 = new BitmapGlyphInfo(glyphID, VOID, VOID, VOID, new ColorBitmapInfo(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, strike.hdc_1, strike.hdc_1));
          this_0.fd7_1 = bytes;
          // Inline function 'kotlin.collections.set' call
          tmp0.b5(glyphID, this_0);
        }
         while (inductionVariable_0 < last_0);
    }
    return Unit_instance;
  }
  rd3(_this__u8e3s4) {
    return _this__u8e3s4.jb7();
  }
  sd3(_this__u8e3s4) {
    return _this__u8e3s4.hb7();
  }
  td3(_this__u8e3s4) {
    return _this__u8e3s4.gb7();
  }
  ud3(_this__u8e3s4) {
    return _this__u8e3s4.hb7();
  }
  vd3(_this__u8e3s4) {
    return _this__u8e3s4.ib7();
  }
  wd3(_this__u8e3s4) {
    return _this__u8e3s4.jb7();
  }
  xd3(_this__u8e3s4, isVar) {
    var xx = this.sd4(_this__u8e3s4);
    var yx = this.sd4(_this__u8e3s4);
    var xy = this.sd4(_this__u8e3s4);
    var yy = this.sd4(_this__u8e3s4);
    var dx = this.sd4(_this__u8e3s4);
    var dy = this.sd4(_this__u8e3s4);
    return new Matrix(xx, yx, xy, yy, dx, -dy);
  }
  yd3(_this__u8e3s4, out) {
    out.rd7_1 = this.rd4(_this__u8e3s4);
    out.sd7_1 = _this__u8e3s4.hb7();
    out.td7_1 = this.rd4(_this__u8e3s4);
    return out;
  }
  zd3(_this__u8e3s4, out, $super) {
    out = out === VOID ? new ColorStop(0.0, 0, 0.0) : out;
    return $super === VOID ? this.yd3(_this__u8e3s4, out) : $super.yd3.call(this, _this__u8e3s4, out);
  }
  ad4(_this__u8e3s4, doVar) {
    var format = _this__u8e3s4.fb7();
    var xMin = this.td3(_this__u8e3s4);
    var yMin = this.td3(_this__u8e3s4);
    var xMax = this.td3(_this__u8e3s4);
    var yMax = this.td3(_this__u8e3s4);
    if (format === 2) {
      var varIndexBase = this.rd3(_this__u8e3s4);
    }
    return Companion_getInstance_4().v9p(xMin, yMin, xMax, yMax);
  }
  bd4(_this__u8e3s4, doVar, $super) {
    doVar = doVar === VOID ? false : doVar;
    return $super === VOID ? this.ad4(_this__u8e3s4, doVar) : $super.ad4.call(this, _this__u8e3s4, doVar);
  }
  cd4(_this__u8e3s4) {
    var cycle;
    switch (_this__u8e3s4.fb7()) {
      case 0:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
      case 1:
        cycle = CycleMethod_REPEAT_getInstance();
        break;
      case 2:
        cycle = CycleMethod_REFLECT_getInstance();
        break;
      default:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
    }
    // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf16' call
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.hb7();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = this.zd3(_this__u8e3s4);
      tmp = tmp + 1 | 0;
    }
    return new ColorLine(cycle, toList_1(tmp_1));
  }
  dd4(glyphID, s, c, pal, level) {
    var nodeFormat = s.fb7();
    var isVar = (nodeFormat % 2 | 0) === 1;
    var indent = repeat('  ', level);
    var debug = false;
    var debugShape = false;
    if (debug) {
      println(indent + 'interpretColrv1[glyphID=' + glyphID + ']: ' + nodeFormat + ' - ' + toString(getOrNull(Companion_getInstance_33().cd5_1, nodeFormat)));
    }
    switch (nodeFormat) {
      case 1:
        var numLayers = s.fb7();
        var firstLayerIndex = s.jb7();
        var inductionVariable = 0;
        if (inductionVariable < numLayers)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var paint = this.jd2_1.wd8_1[firstLayerIndex + n | 0];
            this.dd4(glyphID, this.jd2_1.zd8_1.ab7(paint), c, pal, level + 1 | 0);
          }
           while (inductionVariable < numLayers);
        break;
      case 2:
      case 3:
        var paletteIndex = s.hb7();
        var alpha = this.rd4(s);
        if (isVar) {
          var varIndexBase = this.rd3(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.le();
        }

        var color = RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(this.id2_1.u2(pal).vcg_1, paletteIndex), alpha);
        if (debugShape) {
          println("ctx.fillStyle = '" + _RGBA___get_htmlStringSimple__impl__l4nu0u(color) + "';");
          println('ctx.fill();');
        }

        if (debug) {
          println(indent + RGBA__toString_impl_4lw6dp(color));
        }

        c.acu(new RGBA(color));
        break;
      case 4:
      case 5:
        var colorLineOffset = this.vd3(s);
        var x0 = this.td3(s);
        var y0 = this.td3(s);
        var x1 = this.td3(s);
        var y1 = this.td3(s);
        var x2 = this.td3(s);
        var y2 = this.td3(s);
        var colorLine = this.cd4(s.ab7(colorLineOffset));
        if (isVar) {
          var varIndexBase_0 = this.rd3(s);
        }

        var tmp2 = -y0;
        var tmp6 = -y1;
        // Inline function 'korlibs.image.paint.LinearGradientPaint' call

        var cycle = colorLine.od7_1;
        var transform = Companion_getInstance_5().v9k_1;
        // Inline function 'kotlin.also' call

        var paint_0 = new GradientPaint(GradientKind_LINEAR_getInstance(), numberToDouble(x0), numberToDouble(tmp2), 0.0, numberToDouble(x1), numberToDouble(tmp6), 0.0, VOID, VOID, cycle, transform);
        colorLine.qd7(paint_0, this.id2_1.u2(pal));
        if (debug) {
          println(indent + paint_0.toString());
        }

        c.acu(paint_0);
        break;
      case 6:
      case 7:
        var colorLineOffset_0 = this.vd3(s);
        var x0_0 = this.td3(s);
        var y0_0 = this.td3(s);
        var radius0 = this.sd3(s);
        var x1_0 = this.td3(s);
        var y1_0 = this.td3(s);
        var radius1 = this.sd3(s);
        var colorLine_0 = this.cd4(s.ab7(colorLineOffset_0));
        if (isVar) {
          var varIndexBase_1 = this.rd3(s);
        }

        if (debugShape) {
          println('ctx.fillStyle = ctx.createRadialGradient(' + x0_0 + ', -' + y0_0 + ', ' + radius0 + ', ' + x1_0 + ', -' + y1_0 + ', ' + radius1 + ');');
          println('ctx.fill();');
        }

        var tmp2_0 = -y0_0;
        var tmp8 = -y1_0;
        // Inline function 'korlibs.image.paint.RadialGradientPaint' call

        var cycle_0 = colorLine_0.od7_1;
        var transform_0 = Companion_getInstance_5().v9k_1;
        // Inline function 'kotlin.also' call

        var paint_1 = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(x0_0), numberToDouble(tmp2_0), numberToDouble(radius0), numberToDouble(x1_0), numberToDouble(tmp8), numberToDouble(radius1), VOID, VOID, cycle_0, transform_0);
        colorLine_0.qd7(paint_1, this.id2_1.u2(pal));
        if (debug) {
          println(indent + paint_1.toString());
        }

        c.acu(paint_1);
        break;
      case 8:
      case 9:
        var colorLine_1 = this.vd3(s);
        var centerX = this.td3(s);
        var centerY = this.td3(s);
        var startAngle = this.rd4(s);
        var endAngle = this.rd4(s);
        if (isVar) {
          var varIndexBase_2 = this.rd3(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.le();
      case 10:
        var paint_2 = this.vd3(s);
        var glyphID_0 = s.hb7();
        var colr = this.hd2_1.u2(glyphID_0);
        var glyph = this.qd4(glyphID_0);
        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.hcu();
        try {
          if (!(glyph == null)) {
            if (debugShape) {
              println(joinToString(toContext2dCommands(glyph.obf().bda_1), '\n'));
            }
            c.udc(glyph.obf().bda_1);
            this.dd4(glyphID_0, s.ab7(paint_2), c, pal, level + 1 | 0);
          }
        }finally {
          c.pcu();
        }

        break;
      case 11:
        var glyphID_1 = s.hb7();
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.le();
      case 12:
      case 13:
        var paint_3 = this.vd3(s);
        var transform_1 = this.vd3(s);
        var affine = this.xd3(s.ab7(transform_1), isVar);
        if (debug) {
          println(indent + 'affine=' + affine.toString());
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.hcu();
        try {
          c.bcw(affine);
          this.dd4(glyphID, s.ab7(paint_3), c, pal, level + 1 | 0);
        }finally {
          c.pcu();
        }

        break;
      case 14:
      case 15:
        var paint_4 = this.vd3(s);
        var dx = FWord__toDouble_impl_53j5qp(this.dd3(s));
        var dy = FWord__toDouble_impl_53j5qp(this.dd3(s));
        if (isVar) {
          var varIndexBase_3 = this.rd3(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.hcu();
        try {
          if (debug) {
            println('translate: ' + dx + ', ' + dy);
          }
          c.zcv(dx, -dy);
          this.dd4(glyphID, s.ab7(paint_4), c, pal, level + 1 | 0);
        }finally {
          c.pcu();
        }

        break;
      case 16:
      case 17:
      case 18:
      case 19:
        var paint_5 = this.vd3(s);
        var scaleX = this.rd4(s);
        var scaleY = this.rd4(s);
        var aroundCenter = nodeFormat >= 18;
        if (aroundCenter) {
          var centerX_0 = this.td3(s);
          var centerY_0 = this.td3(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.le();
        }

        if (isVar) {
          var varIndexBase_4 = this.rd3(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.hcu();
        try {
          // Inline function 'korlibs.image.vector.Context2d.scale' call
          c.vdc(numberToDouble(scaleX), numberToDouble(scaleY));
          this.dd4(glyphID, s.ab7(paint_5), c, pal, level + 1 | 0);
        }finally {
          c.pcu();
        }

        break;
      case 20:
      case 21:
      case 22:
      case 23:
        var paint_6 = this.vd3(s);
        var scale = this.rd4(s);
        if (nodeFormat >= 22) {
          var centerX_1 = this.td3(s);
          var centerY_1 = this.td3(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_5 = this.rd3(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.le();
      case 24:
      case 25:
      case 26:
      case 27:
        var paint_7 = this.vd3(s);
        var angle = this.rd4(s);
        if (nodeFormat >= 26) {
          var centerX_2 = this.td3(s);
          var centerY_2 = this.td3(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_6 = this.rd3(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.le();
      case 28:
      case 29:
      case 30:
      case 31:
        var paint_8 = this.vd3(s);
        var xSkewAngle = this.rd4(s);
        var ySkewAngle = this.rd4(s);
        if (nodeFormat >= 30) {
          var centerX_3 = this.td3(s);
          var centerY_3 = this.td3(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_7 = this.rd3(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.le();
      case 32:
        var sourcePaint = this.vd3(s);
        var compositeMode = s.fb7();
        var backdropPaint = this.vd3(s);
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.le();
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Unknown colorv1 format=' + nodeFormat;
        throw NotImplementedError.le('An operation is not implemented: ' + reason);
    }
  }
  ed4(_this__u8e3s4, hintedCount) {
    var coverageFormat = _this__u8e3s4.hb7();
    switch (coverageFormat) {
      case 1:
        var glyphCount = _this__u8e3s4.hb7();
        // Inline function 'korlibs.datastructure.mapInt' call

        var this_0 = _this__u8e3s4.nb7(glyphCount);
        // Inline function 'kotlin.also' call

        var this_1 = new Int32Array(this_0.length);
        var inductionVariable = 0;
        var last = this_0.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.code' call
            var this_2 = this_0[n];
            this_1[n] = Char__toInt_impl_vasixd(this_2);
          }
           while (inductionVariable < last);
        return this_1;
      case 2:
        var rangeCount = _this__u8e3s4.hb7();
        // Inline function 'kotlin.collections.map' call

        var this_3 = until(0, rangeCount);
        // Inline function 'kotlin.collections.mapTo' call

        var destination = ArrayList.n2(collectionSizeOrDefault(this_3, 10));
        var inductionVariable_0 = this_3.n3_1;
        var last_0 = this_3.o3_1;
        if (inductionVariable_0 <= last_0)
          do {
            var item = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp$ret$7 = new BaseTtfFont$readCoverage$RangeInfo(_this__u8e3s4.hb7(), _this__u8e3s4.hb7(), _this__u8e3s4.hb7());
            destination.d2(tmp$ret$7);
          }
           while (!(item === last_0));
        var ranges = destination;
        // Inline function 'kotlin.collections.maxOf' call

        var iterator = ranges.p1();
        if (!iterator.q1())
          throw NoSuchElementException.w7();
        var it = iterator.r1();
        var maxValue = it.ndc_1 + it.odc_1 | 0;
        while (iterator.q1()) {
          var it_0 = iterator.r1();
          var v = it_0.ndc_1 + it_0.odc_1 | 0;
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }

        var glyphCount_0 = maxValue;
        var glyphArray = new Int32Array(glyphCount_0);
        var _iterator__ex2g4s = ranges.p1();
        while (_iterator__ex2g4s.q1()) {
          var range = _iterator__ex2g4s.r1();
          var inductionVariable_1 = range.ldc_1;
          var last_1 = range.mdc_1;
          if (inductionVariable_1 <= last_1)
            do {
              var glyphID = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var offset = glyphID - range.ldc_1 | 0;
              glyphArray[range.ndc_1 + offset | 0] = glyphID;
            }
             while (!(glyphID === last_1));
        }

        return glyphArray;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'coverageFormat=' + coverageFormat;
        throw NotImplementedError.le('An operation is not implemented: ' + reason);
    }
  }
  fd4(_this__u8e3s4, hintedCount, $super) {
    hintedCount = hintedCount === VOID ? -1 : hintedCount;
    return $super === VOID ? this.ed4(_this__u8e3s4, hintedCount) : $super.ed4.call(this, _this__u8e3s4, hintedCount);
  }
  gd4() {
    // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
    var tmp111_safe_receiver = this.fd3('GSUB');
    if (tmp111_safe_receiver == null)
      null;
    else {
      var totalLength = tmp111_safe_receiver.a();
      var majorVersion = tmp111_safe_receiver.hb7();
      var minorVersion = tmp111_safe_receiver.hb7();
      if (!(majorVersion === 1)) {
        // Inline function 'kotlin.error' call
        var message = 'Unknown GSUB majorVerrsion=' + majorVersion;
        throw IllegalStateException.o(toString_0(message));
      }
      var scriptListOffset = this.ud3(tmp111_safe_receiver);
      var featureListOffset = this.ud3(tmp111_safe_receiver);
      var lookupListOffset = this.ud3(tmp111_safe_receiver);
      if (minorVersion >= 1) {
        var featureVariationsOffset = this.wd3(tmp111_safe_receiver);
      }
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.ab7(scriptListOffset);
      var scriptCount = this_0.hb7();
      var inductionVariable = 0;
      if (inductionVariable < scriptCount)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var scriptTag = this_0.sb7(4);
          var scriptOffset = this.ud3(this_0);
        }
         while (inductionVariable < scriptCount);
      // Inline function 'kotlin.apply' call
      var this_1 = tmp111_safe_receiver.ab7(featureListOffset);
      var featureCount = this_1.hb7();
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < featureCount)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var featureTag = this_1.sb7(4);
          var featureOffset = this.ud3(this_1);
        }
         while (inductionVariable_0 < featureCount);
      // Inline function 'kotlin.apply' call
      var this_2 = tmp111_safe_receiver.ab7(lookupListOffset);
      var lookupCount = this_2.hb7();
      // Inline function 'korlibs.datastructure.mapInt' call
      var this_3 = until(0, lookupCount);
      // Inline function 'kotlin.also' call
      var this_4 = IntArrayList.za1((coerceAtLeast(this_3.r3() - this_3.s3() | 0, 0) / this_3.p3_1 | 0) + 1 | 0);
      var nestedFirst = this_3.s3();
      var nestedLast = this_3.r3();
      var stepArg = this_3.p3_1;
      if (stepArg <= 0)
        THROW_IAE('Step must be positive, was: ' + stepArg + '.');
      var inductionVariable_1 = nestedFirst;
      var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
      if (inductionVariable_1 <= last)
        do {
          var v = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + stepArg | 0;
          var tmp$ret$12 = this.ud3(this_2);
          this_4.ga2(tmp$ret$12);
        }
         while (!(v === last));
      var lookups = this_4;
      var _iterator__ex2g4s = lookups.p1();
      while (_iterator__ex2g4s.q1()) {
        var lookupOffset = _iterator__ex2g4s.r1();
        // Inline function 'kotlin.apply' call
        var this_5 = this_2.ab7(lookupOffset);
        var lookupType = this_5.hb7();
        var lookupFlag = this_5.hb7();
        var subTableCount = this_5.hb7();
        // Inline function 'korlibs.datastructure.mapInt' call
        var this_6 = this_5.mb7(subTableCount);
        // Inline function 'kotlin.also' call
        var this_7 = new Int32Array(this_6.length);
        var inductionVariable_2 = 0;
        var last_0 = this_6.length;
        if (inductionVariable_2 < last_0)
          do {
            var n_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            this_7[n_1] = this_6[n_1] & 65535;
          }
           while (inductionVariable_2 < last_0);
        var subtableOffsets = this_7;
        var markFilteringSet = this_5.hb7();
        var inductionVariable_3 = 0;
        var last_1 = subtableOffsets.length;
        while (inductionVariable_3 < last_1) {
          var offset = subtableOffsets[inductionVariable_3];
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_8 = this_5.ab7(offset);
          var subsTable = this_8;
          switch (lookupType) {
            case 1:
              var substFormat = this_8.hb7();
              var coverageOffset = this.ud3(this_8);
              switch (substFormat) {
                case 1:
                  var deltaGlyphID = this_8.gb7();
                  var coverageTable = this.fd4(this_8.ab7(coverageOffset));
                  var inductionVariable_4 = 0;
                  var last_2 = coverageTable.length;
                  while (inductionVariable_4 < last_2) {
                    var glyphID = coverageTable[inductionVariable_4];
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    this.ld2_1.wa7(glyphID, glyphID + deltaGlyphID | 0);
                  }

                  break;
                case 2:
                  var glyphCount = this_8.hb7();
                  var coverageTable_0 = this.fd4(this_8.ab7(coverageOffset));
                  // Inline function 'korlibs.datastructure.mapInt' call

                  var this_9 = this_8.nb7(glyphCount);
                  // Inline function 'kotlin.also' call

                  var this_10 = new Int32Array(this_9.length);
                  var inductionVariable_5 = 0;
                  var last_3 = this_9.length;
                  if (inductionVariable_5 < last_3)
                    do {
                      var n_2 = inductionVariable_5;
                      inductionVariable_5 = inductionVariable_5 + 1 | 0;
                      // Inline function 'kotlin.code' call
                      var this_11 = this_9[n_2];
                      this_10[n_2] = Char__toInt_impl_vasixd(this_11);
                    }
                     while (inductionVariable_5 < last_3);
                  var substituteGlyphIDs = this_10;
                  // Inline function 'kotlin.repeat' call

                  var inductionVariable_6 = 0;
                  if (inductionVariable_6 < glyphCount)
                    do {
                      var index = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      this.ld2_1.wa7(coverageTable_0[index], substituteGlyphIDs[index]);
                    }
                     while (inductionVariable_6 < glyphCount);
                  break;
                default:
                  // Inline function 'kotlin.error' call

                  var message_0 = 'Unsupported lookupType=1, substFormat=' + substFormat;
                  throw IllegalStateException.o(toString_0(message_0));
              }

              break;
            case 4:
              var substFormat_0 = this_8.hb7();
              if (!(substFormat_0 === 1)) {
                // Inline function 'kotlin.error' call
                var message_1 = 'For lookType=4 only substFormat=1 is supported';
                throw IllegalStateException.o(toString_0(message_1));
              }

              var coverageOffset_0 = this.ud3(this_8);
              var ligatureSetCount = this_8.hb7();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_12 = this_8.nb7(ligatureSetCount);
              // Inline function 'kotlin.also' call

              var this_13 = new Int32Array(this_12.length);
              var inductionVariable_7 = 0;
              var last_4 = this_12.length;
              if (inductionVariable_7 < last_4)
                do {
                  var n_3 = inductionVariable_7;
                  inductionVariable_7 = inductionVariable_7 + 1 | 0;
                  // Inline function 'kotlin.code' call
                  var this_14 = this_12[n_3];
                  this_13[n_3] = Char__toInt_impl_vasixd(this_14);
                }
                 while (inductionVariable_7 < last_4);
              var ligatureSetOffsets = this_13;
              var glyphArray = this.ed4(this_8.ab7(coverageOffset_0), ligatureSetCount);
              var inductionVariable_8 = 0;
              var last_5 = ligatureSetOffsets.length - 1 | 0;
              if (inductionVariable_8 <= last_5)
                do {
                  var n_4 = inductionVariable_8;
                  inductionVariable_8 = inductionVariable_8 + 1 | 0;
                  var glyphID_0 = glyphArray[n_4];
                  var asetoffset = ligatureSetOffsets[n_4];
                  var map = LinkedHashMap.m7();
                  var codePoint = this.kd4(glyphID_0);
                  // Inline function 'kotlin.intArrayOf' call
                  var codePointIntArray = new Int32Array([codePoint]);
                  var maxComponentCount = 1;
                  // Inline function 'kotlin.apply' call
                  var this_15 = subsTable.ab7(asetoffset);
                  var ligatureCount = this_15.hb7();
                  // Inline function 'korlibs.datastructure.mapInt' call
                  var this_16 = this_15.nb7(ligatureCount);
                  // Inline function 'kotlin.also' call
                  var this_17 = new Int32Array(this_16.length);
                  var inductionVariable_9 = 0;
                  var last_6 = this_16.length;
                  if (inductionVariable_9 < last_6)
                    do {
                      var n_5 = inductionVariable_9;
                      inductionVariable_9 = inductionVariable_9 + 1 | 0;
                      // Inline function 'kotlin.code' call
                      var this_18 = this_16[n_5];
                      this_17[n_5] = Char__toInt_impl_vasixd(this_18);
                    }
                     while (inductionVariable_9 < last_6);
                  var ligatureOffsets = this_17;
                  var inductionVariable_10 = 0;
                  var last_7 = ligatureOffsets.length;
                  while (inductionVariable_10 < last_7) {
                    var offset_0 = ligatureOffsets[inductionVariable_10];
                    inductionVariable_10 = inductionVariable_10 + 1 | 0;
                    // Inline function 'kotlin.apply' call
                    var this_19 = this_15.ab7(offset_0);
                    var ligatureGlyph = this_19.hb7();
                    var componentCount = this_19.hb7();
                    var tmp0 = maxComponentCount;
                    // Inline function 'kotlin.math.max' call
                    var b = componentCount + 1 | 0;
                    maxComponentCount = Math.max(tmp0, b);
                    // Inline function 'korlibs.datastructure.mapInt' call
                    var this_20 = this_19.nb7(componentCount - 1 | 0);
                    // Inline function 'kotlin.also' call
                    var this_21 = new Int32Array(this_20.length);
                    var inductionVariable_11 = 0;
                    var last_8 = this_20.length;
                    if (inductionVariable_11 < last_8)
                      do {
                        var n_6 = inductionVariable_11;
                        inductionVariable_11 = inductionVariable_11 + 1 | 0;
                        // Inline function 'kotlin.code' call
                        var this_22 = this_20[n_6];
                        var tmp$ret$50 = Char__toInt_impl_vasixd(this_22);
                        this_21[n_6] = this.kd4(tmp$ret$50);
                      }
                       while (inductionVariable_11 < last_8);
                    var componentCodePoints = this_21;
                    var tmp = Companion_getInstance_11();
                    // Inline function 'kotlin.collections.plus' call
                    var tmp$ret$51 = primitiveArrayConcat([codePointIntArray, componentCodePoints]);
                    var ligature = tmp.nb5(tmp$ret$51);
                    // Inline function 'kotlin.intArrayOf' call
                    // Inline function 'kotlin.collections.set' call
                    var value = new Int32Array([ligatureGlyph]);
                    map.b5(ligature, value);
                  }
                  this.md2_1.za6(codePoint, new SubstitutionInfo(maxComponentCount, map));
                }
                 while (inductionVariable_8 <= last_5);
              break;
            default:
              // Inline function 'korlibs.logger.Logger.info' call

              var tmp0_0 = Companion_getInstance_31().gd0_1;
              // Inline function 'korlibs.logger.Logger.log' call

              var level = Level_INFO_getInstance();
              if (tmp0_0.obj(level)) {
                var tmp$ret$56 = 'TTF.GSUB: Unsupported lookupType=' + lookupType;
                tmp0_0.pbj(level, tmp$ret$56);
              }

              break;
          }
        }
      }
    }
    return Unit_instance;
  }
  hd4() {
    // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
    var tmp111_safe_receiver = this.fd3('COLR');
    if (tmp111_safe_receiver == null)
      null;
    else {
      var version = tmp111_safe_receiver.hb7();
      switch (version) {
        case 0:
        case 1:
          var numBaseGlyphRecords = tmp111_safe_receiver.hb7();
          var baseGlyphRecordsOffset = tmp111_safe_receiver.jb7();
          var layerRecordsOffset = tmp111_safe_receiver.jb7();
          var numLayerRecords = tmp111_safe_receiver.hb7();
          // Inline function 'kotlin.apply' call

          var this_0 = tmp111_safe_receiver.ab7(layerRecordsOffset);
          var tmp = this;
          var tmp_0 = 0;
          // Inline function 'kotlin.arrayOfNulls' call

          var tmp_1 = Array(numLayerRecords);
          while (tmp_0 < numLayerRecords) {
            tmp_1[tmp_0] = new ColrLayerInfo(this, this_0.hb7(), this_0.hb7());
            tmp_0 = tmp_0 + 1 | 0;
          }

          tmp.gd2_1 = tmp_1;
          // Inline function 'kotlin.apply' call

          var this_1 = tmp111_safe_receiver.ab7(baseGlyphRecordsOffset);
          var inductionVariable = 0;
          if (inductionVariable < numBaseGlyphRecords)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var info = new ColrGlyphInfoV0(this, this_1.hb7(), this_1.hb7(), this_1.hb7());
              this.hd2_1.za6(info.hda_1, info);
            }
             while (inductionVariable < numBaseGlyphRecords);
          if (version === 1) {
            var baseGlyphListOffset = this.wd3(tmp111_safe_receiver);
            var layerListOffset = this.wd3(tmp111_safe_receiver);
            var clipListOffset = this.wd3(tmp111_safe_receiver);
            var varIdxMapOffset = this.wd3(tmp111_safe_receiver);
            var varStoreOffset = this.wd3(tmp111_safe_receiver);
            this.jd2_1.bd9_1.a5();
            var tmp_2 = this;
            var tmp126_s = tmp111_safe_receiver.ab7(0);
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_2 = tmp111_safe_receiver.ab7(layerListOffset);
            var tmp_3 = 0;
            var tmp_4 = this_2.jb7();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_5 = Array(tmp_4);
            while (tmp_3 < tmp_4) {
              tmp_5[tmp_3] = this.wd3(this_2);
              tmp_3 = tmp_3 + 1 | 0;
            }
            var tmp127_layerList = toIntArray_0(tmp_5);
            var tmp128_sBaseOffset = tmp111_safe_receiver.ab7(baseGlyphListOffset);
            var tmp129_sLayerOffset = tmp111_safe_receiver.ab7(layerListOffset);
            // Inline function 'kotlin.takeIf' call
            var tmp_6;
            if (!(clipListOffset === 0)) {
              tmp_6 = clipListOffset;
            } else {
              tmp_6 = null;
            }
            var tmp125_safe_receiver = tmp_6;
            var tmp_7;
            if (tmp125_safe_receiver == null) {
              tmp_7 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_7 = tmp111_safe_receiver.ab7(tmp125_safe_receiver);
            }
            var tmp130_sClipOffset = tmp_7;
            tmp_2.jd2_1 = new COLRv1(tmp127_layerList, tmp126_s, tmp128_sBaseOffset, tmp129_sLayerOffset, tmp130_sClipOffset);
            // Inline function 'kotlin.takeIf' call
            var tmp_8;
            if (!(clipListOffset === 0)) {
              tmp_8 = clipListOffset;
            } else {
              tmp_8 = null;
            }
            if (tmp_8 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              var s = tmp111_safe_receiver.ab7(clipListOffset);
              var format = s.fb7();
              // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
              var tmp_9 = 0;
              var tmp_10 = s.jb7();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_11 = Array(tmp_10);
              while (tmp_9 < tmp_10) {
                var tmp_12 = tmp_9;
                var startGlyphID = s.hb7();
                var endGlyphID = s.hb7();
                var clipBoxOffset = this.vd3(s);
                var inductionVariable_0 = startGlyphID;
                if (inductionVariable_0 <= endGlyphID)
                  do {
                    var glyphID = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    this.jd2_1.bd9_1.wa7(glyphID, clipBoxOffset);
                  }
                   while (!(glyphID === endGlyphID));
                tmp_11[tmp_12] = Unit_instance;
                tmp_9 = tmp_9 + 1 | 0;
              }
            }
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_3 = tmp111_safe_receiver.ab7(baseGlyphListOffset);
            var tmp_13 = 0;
            var tmp_14 = this_3.jb7();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_15 = Array(tmp_14);
            while (tmp_13 < tmp_14) {
              var tmp_16 = tmp_13;
              var glyphID_0 = this_3.hb7();
              var paint = this.wd3(this_3);
              this.hd2_1.za6(glyphID_0, new ColrGlyphInfoV1(this, glyphID_0, paint));
              tmp_15[tmp_16] = Unit_instance;
              tmp_13 = tmp_13 + 1 | 0;
            }
          }

          break;
        default:
          println('TTF WARNING CCOLv' + version + ' not supported');
          break;
      }
    }
    return Unit_instance;
  }
  id4() {
    // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
    var tmp111_safe_receiver = this.fd3('cmap');
    if (tmp111_safe_receiver == null)
      null;
    else {
      var version = tmp111_safe_receiver.hb7();
      var numTables = tmp111_safe_receiver.hb7();
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, numTables);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.n3_1;
      var last = this_0.o3_1;
      if (inductionVariable <= last)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$4 = new BaseTtfFont$readCmap$EncodingRecord(tmp111_safe_receiver.hb7(), tmp111_safe_receiver.hb7(), tmp111_safe_receiver.jb7());
          destination.d2(tmp$ret$4);
        }
         while (!(item === last));
      var tables = destination;
      var index = 0;
      var _iterator__ex2g4s = tables.p1();
      while (_iterator__ex2g4s.q1()) {
        var table = _iterator__ex2g4s.r1();
        // Inline function 'kotlin.run' call
        var $this$run = tmp111_safe_receiver.ab7(table.rdc_1);
        var format = $this$run.hb7();
        try {
          switch (format) {
            case 0:
              var length = $this$run.hb7();
              var language = $this$run.hb7();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_1 = $this$run.db7(256);
              // Inline function 'kotlin.also' call

              var this_2 = new Int32Array(this_1.length);
              var inductionVariable_0 = 0;
              var last_0 = this_1.length;
              if (inductionVariable_0 < last_0)
                do {
                  var n = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  this_2[n] = this_1[n] & 255;
                }
                 while (inductionVariable_0 < last_0);
              var glyphIdArray = this_2;
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < 256)
                do {
                  var n_0 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  this.ad3(n_0, glyphIdArray[n_0]);
                }
                 while (inductionVariable_1 < 256);
              break;
            case 2:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 4:
              var length_0 = $this$run.hb7();
              var language_0 = $this$run.hb7();
              var segCount = $this$run.hb7() / 2 | 0;
              var searchRangeS = $this$run.hb7();
              var entrySelector = $this$run.hb7();
              var rangeShift = $this$run.hb7();
              var endCount = $this$run.nb7(segCount);
              $this$run.hb7();
              var startCount = $this$run.nb7(segCount);
              var idDelta = $this$run.mb7(segCount);
              var rangeOffsetPos = $this$run.wb6();
              var idRangeOffset = $this$run.nb7(segCount);
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < segCount)
                do {
                  var n_1 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  var ec = Char__toInt_impl_vasixd(endCount[n_1]);
                  var sc = Char__toInt_impl_vasixd(startCount[n_1]);
                  var delta = idDelta[n_1];
                  var iro = Char__toInt_impl_vasixd(idRangeOffset[n_1]);
                  var inductionVariable_3 = sc;
                  if (inductionVariable_3 <= ec)
                    do {
                      var c = inductionVariable_3;
                      inductionVariable_3 = inductionVariable_3 + 1 | 0;
                      if (!(iro === 0)) {
                        var glyphIndexOffset = rangeOffsetPos + imul(n_1, 2) | 0;
                        glyphIndexOffset = glyphIndexOffset + iro | 0;
                        glyphIndexOffset = glyphIndexOffset + imul(c - sc | 0, 2) | 0;
                        index = $this$run.ab7(glyphIndexOffset).hb7();
                        if (!(index === 0)) {
                          index = index + delta | 0;
                        }
                      } else {
                        index = c + delta | 0;
                      }
                      this.zd2(c, index & 65535);
                    }
                     while (!(c === ec));
                }
                 while (inductionVariable_2 < segCount);
              break;
            case 6:
              var length_1 = $this$run.hb7();
              var language_1 = $this$run.hb7();
              var firstCode = $this$run.hb7();
              var entryCount = $this$run.hb7();
              var inductionVariable_4 = 0;
              if (inductionVariable_4 < entryCount)
                do {
                  var n_2 = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  var codePoint = firstCode + n_2 | 0;
                  this.zd2(codePoint, $this$run.hb7());
                }
                 while (inductionVariable_4 < entryCount);
              break;
            case 8:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 10:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 12:
              $this$run.hb7();
              var length_2 = $this$run.jb7();
              var language_2 = $this$run.jb7();
              var numGroups = $this$run.jb7();
              var inductionVariable_5 = 0;
              if (inductionVariable_5 < numGroups)
                do {
                  var n_3 = inductionVariable_5;
                  inductionVariable_5 = inductionVariable_5 + 1 | 0;
                  var startCharCode = $this$run.jb7();
                  var endCharCode = $this$run.jb7();
                  var startGlyphId = $this$run.jb7();
                  var inductionVariable_6 = startCharCode;
                  if (inductionVariable_6 <= endCharCode)
                    do {
                      var c_0 = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      var m = c_0 - startCharCode | 0;
                      this.zd2(c_0, startGlyphId + m | 0);
                    }
                     while (!(c_0 === endCharCode));
                }
                 while (inductionVariable_5 < numGroups);
              break;
            case 13:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            default:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
      }
    }
    return Unit_instance;
  }
  jd4(charIndex, default_0) {
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs = this.dd2_1.w4(charIndex);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = default_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  kd4(charIndex, default_0, $super) {
    default_0 = default_0 === VOID ? -1 : default_0;
    return $super === VOID ? this.jd4(charIndex, default_0) : $super.jd4.call(this, charIndex, default_0);
  }
  ld4(reader, codePoint, cache) {
    var g = this.od4(codePoint);
    var skipCount = 1;
    if (this.ld0_1 && !(g == null)) {
      var subs = this.md2_1.u2(codePoint);
      if (!(reader == null) && !(subs == null)) {
        var tmp0 = reader.ab5();
        // Inline function 'kotlin.math.min' call
        var b = subs.od5_1;
        var inductionVariable = Math.min(tmp0, b);
        if (2 <= inductionVariable)
          $l$loop_0: do {
            var count = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var sub = reader.lb5(0, count);
            var replacement = subs.pd5_1.w4(sub);
            if (!(replacement == null)) {
              skipCount = sub.a();
              var tmp0_elvis_lhs = this.qd4(first_1(replacement));
              var tmp;
              if (tmp0_elvis_lhs == null) {
                break $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              g = tmp;
              break $l$loop_0;
            }
          }
           while (2 <= inductionVariable);
      }
    }
    if (reader == null)
      null;
    else {
      reader.kb5(skipCount);
    }
    return g;
  }
  md4(reader, codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.ld4(reader, codePoint, cache) : $super.ld4.call(this, reader, codePoint, cache);
  }
  nd4(codePoint, cache) {
    var tmp134_safe_receiver = this.yd2(codePoint);
    var tmp;
    if (tmp134_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = this.pd4(tmp134_safe_receiver, cache, codePoint);
    }
    return tmp;
  }
  od4(codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.nd4(codePoint, cache) : $super.nd4.call(this, codePoint, cache);
  }
  pd4(index, cache, codePoint) {
    var cff = this.qd2_1;
    if (!(cff == null)) {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.ed2_1;
      var res = this_0.u2(index);
      if (res == null) {
        var gvector = cff.zcy(index);
        var tmp$ret$1 = new CFFGlyph(this, index, 0, 0, 0, 0, numberToInt(gvector.dcy_1), new GlyphGraphicsPath(index, gvector.ccy_1));
        this_0.za6(index, tmp$ret$1);
      }
      return ensureNotNull(this_0.u2(index));
    }
    var tmp0_elvis_lhs = getOrNull_0(this.pd1_1, index);
    var start = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = getOrNull_0(this.pd1_1, index + 1 | 0);
    var end = tmp1_elvis_lhs == null ? start : tmp1_elvis_lhs;
    var size = end - start | 0;
    var tmp;
    if (!(size === 0)) {
      var tmp2_elvis_lhs = this.ed2_1.u2(index);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.image.font.BaseTtfFont.runTable' call
          var tmp0_elvis_lhs_0 = this.vd2('glyf');
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            tmp$ret$2 = null;
            break $l$block;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var table = tmp_1;
          var $this$runTable = table.qd5();
          // Inline function 'kotlin.also' call
          tmp$ret$2 = this.ud4($this$runTable.ab7(start), index);
        }
        tmp_0 = tmp$ret$2;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      // Inline function 'kotlin.intArrayOf' call
      var tmp_2 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_3 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_4 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$9 = new Int32Array([]);
      // Inline function 'kotlin.also' call
      tmp = new SimpleGlyph(this, index, 0, 0, 0, 0, tmp_2, tmp_3, tmp_4, tmp$ret$9, this.bd2_1.u2(index).rd5_1, true);
    }
    var glyph = tmp;
    if (cache && !this.kd2_1) {
      this.ed2_1.za6(index, glyph);
    }
    return glyph;
  }
  qd4(index, cache, codePoint, $super) {
    cache = cache === VOID ? true : cache;
    codePoint = codePoint === VOID ? -1 : codePoint;
    return $super === VOID ? this.pd4(index, cache, codePoint) : $super.pd4.call(this, index, cache, codePoint);
  }
  rd4(_this__u8e3s4) {
    var v = _this__u8e3s4.gb7();
    var i = extractSigned(v, 14, 2);
    var f = extract(v, 0, 14);
    return i + f / 16384.0;
  }
  sd4(_this__u8e3s4) {
    var v = _this__u8e3s4.jb7();
    var i = extractSigned(v, 16, 16);
    var f = extract(v, 0, 16);
    return i + f / 65536.0;
  }
  td4(_this__u8e3s4, signed, word) {
    var tmp;
    if (!word && signed) {
      tmp = _this__u8e3s4.eb7();
    } else if (!word && !signed) {
      tmp = _this__u8e3s4.fb7();
    } else if (word && signed) {
      tmp = _this__u8e3s4.gb7();
    } else if (word && !signed) {
      tmp = _this__u8e3s4.hb7();
    } else {
      get_invalidOp();
    }
    return tmp;
  }
  ud4(_this__u8e3s4, index) {
    var ncontours = _this__u8e3s4.gb7();
    var xMin = _this__u8e3s4.gb7();
    var yMin = _this__u8e3s4.gb7();
    var xMax = _this__u8e3s4.gb7();
    var yMax = _this__u8e3s4.gb7();
    var advanceWidth = this.bd2_1.u2(index).rd5_1;
    var tmp;
    if (ncontours < 0) {
      var ARG_1_AND_2_ARE_WORDS = 1;
      var ARGS_ARE_XY_VALUES = 2;
      var ROUND_XY_TO_GRID = 4;
      var WE_HAVE_A_SCALE = 8;
      var MORE_COMPONENTS = 32;
      var WE_HAVE_AN_X_AND_Y_SCALE = 64;
      var WE_HAVE_A_TWO_BY_TWO = 128;
      var WE_HAVE_INSTRUCTIONS = 256;
      var USE_MY_METRICS = 512;
      var OVERLAP_COMPOUND = 1024;
      var SCALED_COMPONENT_OFFSET = 2048;
      var UNSCALED_COMPONENT_OFFSET = 4096;
      // Inline function 'kotlin.collections.arrayListOf' call
      var references = ArrayList.p2();
      do {
        var flags = _this__u8e3s4.hb7();
        var glyphIndex = _this__u8e3s4.hb7();
        var signed = !((flags & ARGS_ARE_XY_VALUES) === 0);
        var words = !((flags & ARG_1_AND_2_ARE_WORDS) === 0);
        var x = this.td4(_this__u8e3s4, signed, words);
        var y = this.td4(_this__u8e3s4, signed, words);
        var scaleX = 1.0;
        var scaleY = 1.0;
        var scale01 = 0.0;
        var scale10 = 0.0;
        if (!((flags & WE_HAVE_A_SCALE) === 0)) {
          scaleX = this.rd4(_this__u8e3s4);
          scaleY = scaleX;
        } else if (!((flags & WE_HAVE_AN_X_AND_Y_SCALE) === 0)) {
          scaleX = this.rd4(_this__u8e3s4);
          scaleY = this.rd4(_this__u8e3s4);
        } else if (!((flags & WE_HAVE_A_TWO_BY_TWO) === 0)) {
          scaleX = this.rd4(_this__u8e3s4);
          scale01 = this.rd4(_this__u8e3s4);
          scale10 = this.rd4(_this__u8e3s4);
          scaleY = this.rd4(_this__u8e3s4);
        }
        var ref = new GlyphReference(ensureNotNull(this.qd4(glyphIndex)), x, y, scaleX, scale01, scale10, scaleY);
        // Inline function 'kotlin.collections.plusAssign' call
        references.d2(ref);
      }
       while (!((flags & MORE_COMPONENTS) === 0));
      tmp = new CompositeGlyph(this, index, xMin, yMin, xMax, yMax, references, advanceWidth);
    } else {
      var contoursIndices = new Int32Array(ncontours + 1 | 0);
      contoursIndices[0] = -1;
      var inductionVariable = 1;
      if (inductionVariable <= ncontours)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          contoursIndices[n] = _this__u8e3s4.hb7();
        }
         while (!(n === ncontours));
      var instructionLength = _this__u8e3s4.hb7();
      var instructions = _this__u8e3s4.db7(instructionLength);
      var tmp139_safe_receiver = lastOrNull(contoursIndices);
      var tmp0_elvis_lhs = tmp139_safe_receiver == null ? null : tmp139_safe_receiver + 1 | 0;
      var numPoints = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      var flags_0 = IntArrayList.za1();
      var npos = 0;
      while (npos < numPoints) {
        var cf = _this__u8e3s4.fb7();
        flags_0.ga2(cf);
        if (!((cf & 8) === 0)) {
          var count = _this__u8e3s4.fb7();
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < count)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              flags_0.ga2(cf);
            }
             while (inductionVariable_0 < count);
          npos = npos + (count + 1 | 0) | 0;
        } else {
          npos = npos + 1 | 0;
        }
      }
      var xPos = new Int32Array(numPoints);
      var yPos = new Int32Array(numPoints);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= 1)
        do {
          var xy = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var pos = xy === 0 ? xPos : yPos;
          var p = 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < numPoints)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var flag = flags_0.j9u(n_1);
              var b1 = !(((flag >>> (1 + xy | 0) | 0) & 1) === 0);
              var b2 = !(((flag >>> (4 + xy | 0) | 0) & 1) === 0);
              if (b1) {
                var magnitude = _this__u8e3s4.fb7();
                if (b2)
                  p = p + magnitude | 0;
                else
                  p = p - magnitude | 0;
              } else if (!b2) {
                p = p + _this__u8e3s4.gb7() | 0;
              }
              pos[n_1] = p;
            }
             while (inductionVariable_2 < numPoints);
        }
         while (inductionVariable_1 <= 1);
      tmp = new SimpleGlyph(this, index, xMin, yMin, xMax, yMax, contoursIndices, flags_0.sa2(), xPos, yPos, advanceWidth);
    }
    // Inline function 'kotlin.also' call
    return tmp;
  }
}
class TtfFont extends BaseTtfFont {
  constructor(d, extName, onlyReadMetadata, enableLigatures) {
    return new.target.acq(d, extName, onlyReadMetadata, enableLigatures);
  }
  static acq(d, extName, onlyReadMetadata, enableLigatures) {
    Companion_getInstance_31();
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = this.rd2(d, extName, onlyReadMetadata, enableLigatures);
    $this.zcp_1 = LinkedHashMap.m7();
    $this.sd2();
    return $this;
  }
  td2() {
    this.zcp_1.d5(Companion_instance_24.ud2(this.id0_1.bb7()));
  }
  vd2(name) {
    return this.zcp_1.w4(name);
  }
}
class Companion_16 {
  constructor() {
    this.bd5_1 = 26;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_23 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp0 = Array(1);
    // Inline function 'kotlin.collections.plus' call
    var elements = values_3();
    // Inline function 'kotlin.js.asDynamic' call
    tmp.cd5_1 = tmp0.concat(elements);
  }
}
class NamesInfo {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.dd5_1 = Array(26);
    this.ed5_1 = new Int32Array(26);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(26);
    while (tmp_1 < 26) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.fd5_1 = tmp_2;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = Array(26);
    while (tmp_4 < 26) {
      tmp_5[tmp_4] = get_UTF8();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.gd5_1 = tmp_5;
    this.hd5_1 = null;
  }
  cd3() {
    var tmp0_elvis_lhs = this.id5(NameId_NAME_getInstance());
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.id5(NameId_COMPLETE_NAME_getInstance()) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? 'TtfFont' : tmp1_elvis_lhs;
  }
  jd5(nameId) {
    if (this.dd5_1[nameId] == null) {
      var nameLength = this.fd5_1[nameId];
      if (nameLength < 0)
        return null;
      var string = ensureNotNull(this.hd5_1).qb7(this.ed5_1[nameId], nameLength, this.gd5_1[nameId]);
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(string) === 0) {
        tmp = string;
      } else {
        if (charCodeAt(string, 0) === _Char___init__impl__6a9atx(0)) {
          // Inline function 'kotlin.text.filter' call
          // Inline function 'kotlin.text.filterTo' call
          var destination = StringBuilder.l1();
          var inductionVariable = 0;
          var last = charSequenceLength(string);
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element = charSequenceGet(string, index);
              if (!(element === _Char___init__impl__6a9atx(0))) {
                destination.o1(element);
              }
            }
             while (inductionVariable < last);
          tmp = destination.toString();
        } else {
          tmp = string;
        }
      }
      this.dd5_1[nameId] = tmp;
    }
    return this.dd5_1[nameId];
  }
  id5(nameId) {
    return this.jd5(nameId.md5_1);
  }
  nd5() {
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = values_2();
    var result = LinkedHashMap.cd(coerceAtLeast(mapCapacity(this_0.length), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$2 = this.id5(element);
      result.b5(element, tmp$ret$2);
    }
    return result;
  }
  toString() {
    return 'NamesInfo(' + toString_0(this.nd5()) + ')';
  }
}
class SubstitutionInfo {
  constructor(maxSequence, map) {
    this.od5_1 = maxSequence;
    this.pd5_1 = map;
  }
}
class Table {
  constructor(id, checksum, offset, length) {
    this.vd4_1 = id;
    this.wd4_1 = checksum;
    this.xd4_1 = offset;
    this.yd4_1 = length;
    this.zd4_1 = null;
    var tmp = this;
    tmp.ad5_1 = lazy(BaseTtfFont$Table$ss$delegate$lambda(this));
  }
  qd5() {
    return _get_ss__ndcawb(this).g9m();
  }
  toString() {
    return 'Table(id=' + this.vd4_1 + ', checksum=' + this.wd4_1 + ', offset=' + this.xd4_1 + ', length=' + this.yd4_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.vd4_1);
    result = imul(result, 31) + this.wd4_1 | 0;
    result = imul(result, 31) + this.xd4_1 | 0;
    result = imul(result, 31) + this.yd4_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Table))
      return false;
    var tmp0_other_with_cast = other instanceof Table ? other : THROW_CCE();
    if (!(this.vd4_1 === tmp0_other_with_cast.vd4_1))
      return false;
    if (!(this.wd4_1 === tmp0_other_with_cast.wd4_1))
      return false;
    if (!(this.xd4_1 === tmp0_other_with_cast.xd4_1))
      return false;
    if (!(this.yd4_1 === tmp0_other_with_cast.yd4_1))
      return false;
    return true;
  }
}
class HorMetric {
  constructor(advanceWidth, lsb) {
    this.rd5_1 = advanceWidth;
    this.sd5_1 = lsb;
  }
  toString() {
    return 'HorMetric(advanceWidth=' + this.rd5_1 + ', lsb=' + this.sd5_1 + ')';
  }
  hashCode() {
    var result = this.rd5_1;
    result = imul(result, 31) + this.sd5_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HorMetric))
      return false;
    var tmp0_other_with_cast = other instanceof HorMetric ? other : THROW_CCE();
    if (!(this.rd5_1 === tmp0_other_with_cast.rd5_1))
      return false;
    if (!(this.sd5_1 === tmp0_other_with_cast.sd5_1))
      return false;
    return true;
  }
}
class Companion_18 {
  td5(s, info) {
    // Inline function 'kotlin.run' call
    var format = s.hb7();
    var count = s.hb7();
    var stringOffset = s.hb7();
    var inductionVariable = 0;
    if (inductionVariable < count)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var platformId = s.hb7();
        var encodingId = s.hb7();
        var languageId = s.hb7();
        var nameId = s.hb7();
        var length = s.hb7();
        var offset = s.hb7();
        if (nameId < 0 || nameId >= 26)
          continue $l$loop;
        var charset;
        switch (encodingId) {
          case 0:
            charset = get_UTF8();
            break;
          case 1:
            charset = get_UTF16_BE();
            break;
          default:
            charset = get_UTF16_BE();
            break;
        }
        if (platformId === 0 && languageId === 0 || info.fd5_1[nameId] === -1) {
          info.ed5_1[nameId] = stringOffset + offset | 0;
          info.fd5_1[nameId] = length;
          info.gd5_1[nameId] = charset;
          info.hd5_1 = s;
        }
      }
       while (inductionVariable < count);
    return Unit_instance;
  }
  ud2(s) {
    // Inline function 'kotlin.run' call
    if (s.jb7() === 1953784678) {
      var majorVersion = s.hb7();
      var minorVersion = s.hb7();
      var numFonts = s.jb7();
      var tableDirectoryOffsets = s.pb7(numFonts);
      if (majorVersion >= 2) {
        var dsigTag = s.jb7();
        var dsigLength = s.jb7();
        var dsigOffset = s.jb7();
      }
      s.vb6(tableDirectoryOffsets[0]);
    } else {
      s.cb7(4);
    }
    // Inline function 'kotlin.apply' call
    var this_0 = s.hb7();
    if (!(this_0 === 1) && !(this_0 === 20308)) {
      invalidOp('Not a TTF/OTF file');
    }
    var majorVersion_0 = this_0;
    // Inline function 'kotlin.apply' call
    var this_1 = s.hb7();
    if (!(this_1 === 0) && !(this_1 === 21583)) {
      invalidOp('Not a TTF/OTF file');
    }
    var minorVersion_0 = this_1;
    var numTables = s.hb7();
    var searchRange = s.hb7();
    var entrySelector = s.hb7();
    var rangeShift = s.hb7();
    // Inline function 'kotlin.collections.map' call
    var this_2 = until(0, numTables);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_2, 10));
    var inductionVariable = this_2.n3_1;
    var last = this_2.o3_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$8 = new Table(s.sb7(4), s.jb7(), s.jb7(), s.jb7());
        destination.d2(tmp$ret$8);
      }
       while (!(item === last));
    var tables = destination;
    var tablesByName = LinkedHashMap.m7();
    var _iterator__ex2g4s = tables.p1();
    while (_iterator__ex2g4s.q1()) {
      var table = _iterator__ex2g4s.r1();
      var tmp = table;
      tmp.zd4_1 = BaseTtfFont$Companion$readHeaderTables$lambda(s, table);
      // Inline function 'kotlin.collections.set' call
      var key = table.vd4_1;
      tablesByName.b5(key, table);
    }
    return tablesByName;
  }
}
class NameId extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.md5_1 = id;
  }
}
class ColorBitmapInfo {
  constructor(indexSubTableArrayOffset, indexTablesSize, numberofIndexSubTables, colorRef, hori, vert, startGlyphIndex, endGlyphIndex, ppemX, ppemY, bitDepth, flags) {
    indexSubTableArrayOffset = indexSubTableArrayOffset === VOID ? 0 : indexSubTableArrayOffset;
    indexTablesSize = indexTablesSize === VOID ? 0 : indexTablesSize;
    numberofIndexSubTables = numberofIndexSubTables === VOID ? 0 : numberofIndexSubTables;
    colorRef = colorRef === VOID ? 0 : colorRef;
    hori = hori === VOID ? new SbitLineMetrics() : hori;
    vert = vert === VOID ? new SbitLineMetrics() : vert;
    startGlyphIndex = startGlyphIndex === VOID ? 0 : startGlyphIndex;
    endGlyphIndex = endGlyphIndex === VOID ? 0 : endGlyphIndex;
    ppemX = ppemX === VOID ? 0 : ppemX;
    ppemY = ppemY === VOID ? 0 : ppemY;
    bitDepth = bitDepth === VOID ? 0 : bitDepth;
    flags = flags === VOID ? 0 : flags;
    this.ud5_1 = indexSubTableArrayOffset;
    this.vd5_1 = indexTablesSize;
    this.wd5_1 = numberofIndexSubTables;
    this.xd5_1 = colorRef;
    this.yd5_1 = hori;
    this.zd5_1 = vert;
    this.ad6_1 = startGlyphIndex;
    this.bd6_1 = endGlyphIndex;
    this.cd6_1 = ppemX;
    this.dd6_1 = ppemY;
    this.ed6_1 = bitDepth;
    this.fd6_1 = flags;
  }
  toString() {
    return 'ColorBitmapInfo(indexSubTableArrayOffset=' + this.ud5_1 + ', indexTablesSize=' + this.vd5_1 + ', numberofIndexSubTables=' + this.wd5_1 + ', colorRef=' + this.xd5_1 + ', hori=' + this.yd5_1.toString() + ', vert=' + this.zd5_1.toString() + ', startGlyphIndex=' + this.ad6_1 + ', endGlyphIndex=' + this.bd6_1 + ', ppemX=' + this.cd6_1 + ', ppemY=' + this.dd6_1 + ', bitDepth=' + this.ed6_1 + ', flags=' + this.fd6_1 + ')';
  }
  hashCode() {
    var result = this.ud5_1;
    result = imul(result, 31) + this.vd5_1 | 0;
    result = imul(result, 31) + this.wd5_1 | 0;
    result = imul(result, 31) + this.xd5_1 | 0;
    result = imul(result, 31) + this.yd5_1.hashCode() | 0;
    result = imul(result, 31) + this.zd5_1.hashCode() | 0;
    result = imul(result, 31) + this.ad6_1 | 0;
    result = imul(result, 31) + this.bd6_1 | 0;
    result = imul(result, 31) + this.cd6_1 | 0;
    result = imul(result, 31) + this.dd6_1 | 0;
    result = imul(result, 31) + this.ed6_1 | 0;
    result = imul(result, 31) + this.fd6_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorBitmapInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ColorBitmapInfo ? other : THROW_CCE();
    if (!(this.ud5_1 === tmp0_other_with_cast.ud5_1))
      return false;
    if (!(this.vd5_1 === tmp0_other_with_cast.vd5_1))
      return false;
    if (!(this.wd5_1 === tmp0_other_with_cast.wd5_1))
      return false;
    if (!(this.xd5_1 === tmp0_other_with_cast.xd5_1))
      return false;
    if (!this.yd5_1.equals(tmp0_other_with_cast.yd5_1))
      return false;
    if (!this.zd5_1.equals(tmp0_other_with_cast.zd5_1))
      return false;
    if (!(this.ad6_1 === tmp0_other_with_cast.ad6_1))
      return false;
    if (!(this.bd6_1 === tmp0_other_with_cast.bd6_1))
      return false;
    if (!(this.cd6_1 === tmp0_other_with_cast.cd6_1))
      return false;
    if (!(this.dd6_1 === tmp0_other_with_cast.dd6_1))
      return false;
    if (!(this.ed6_1 === tmp0_other_with_cast.ed6_1))
      return false;
    if (!(this.fd6_1 === tmp0_other_with_cast.fd6_1))
      return false;
    return true;
  }
}
class SbitLineMetrics {
  constructor(ascender, descender, widthMax, caretSlopeNumerator, caretSlopeDenominator, caretOffset, minOriginSB, minAdvanceSB, maxBeforeBL, minAfterBL, pad1, pad2) {
    ascender = ascender === VOID ? 0 : ascender;
    descender = descender === VOID ? 0 : descender;
    widthMax = widthMax === VOID ? 0 : widthMax;
    caretSlopeNumerator = caretSlopeNumerator === VOID ? 0 : caretSlopeNumerator;
    caretSlopeDenominator = caretSlopeDenominator === VOID ? 0 : caretSlopeDenominator;
    caretOffset = caretOffset === VOID ? 0 : caretOffset;
    minOriginSB = minOriginSB === VOID ? 0 : minOriginSB;
    minAdvanceSB = minAdvanceSB === VOID ? 0 : minAdvanceSB;
    maxBeforeBL = maxBeforeBL === VOID ? 0 : maxBeforeBL;
    minAfterBL = minAfterBL === VOID ? 0 : minAfterBL;
    pad1 = pad1 === VOID ? 0 : pad1;
    pad2 = pad2 === VOID ? 0 : pad2;
    this.gd6_1 = ascender;
    this.hd6_1 = descender;
    this.id6_1 = widthMax;
    this.jd6_1 = caretSlopeNumerator;
    this.kd6_1 = caretSlopeDenominator;
    this.ld6_1 = caretOffset;
    this.md6_1 = minOriginSB;
    this.nd6_1 = minAdvanceSB;
    this.od6_1 = maxBeforeBL;
    this.pd6_1 = minAfterBL;
    this.qd6_1 = pad1;
    this.rd6_1 = pad2;
  }
  toString() {
    return 'SbitLineMetrics(ascender=' + this.gd6_1 + ', descender=' + this.hd6_1 + ', widthMax=' + this.id6_1 + ', caretSlopeNumerator=' + this.jd6_1 + ', caretSlopeDenominator=' + this.kd6_1 + ', caretOffset=' + this.ld6_1 + ', minOriginSB=' + this.md6_1 + ', minAdvanceSB=' + this.nd6_1 + ', maxBeforeBL=' + this.od6_1 + ', minAfterBL=' + this.pd6_1 + ', pad1=' + this.qd6_1 + ', pad2=' + this.rd6_1 + ')';
  }
  hashCode() {
    var result = this.gd6_1;
    result = imul(result, 31) + this.hd6_1 | 0;
    result = imul(result, 31) + this.id6_1 | 0;
    result = imul(result, 31) + this.jd6_1 | 0;
    result = imul(result, 31) + this.kd6_1 | 0;
    result = imul(result, 31) + this.ld6_1 | 0;
    result = imul(result, 31) + this.md6_1 | 0;
    result = imul(result, 31) + this.nd6_1 | 0;
    result = imul(result, 31) + this.od6_1 | 0;
    result = imul(result, 31) + this.pd6_1 | 0;
    result = imul(result, 31) + this.qd6_1 | 0;
    result = imul(result, 31) + this.rd6_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SbitLineMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof SbitLineMetrics ? other : THROW_CCE();
    if (!(this.gd6_1 === tmp0_other_with_cast.gd6_1))
      return false;
    if (!(this.hd6_1 === tmp0_other_with_cast.hd6_1))
      return false;
    if (!(this.id6_1 === tmp0_other_with_cast.id6_1))
      return false;
    if (!(this.jd6_1 === tmp0_other_with_cast.jd6_1))
      return false;
    if (!(this.kd6_1 === tmp0_other_with_cast.kd6_1))
      return false;
    if (!(this.ld6_1 === tmp0_other_with_cast.ld6_1))
      return false;
    if (!(this.md6_1 === tmp0_other_with_cast.md6_1))
      return false;
    if (!(this.nd6_1 === tmp0_other_with_cast.nd6_1))
      return false;
    if (!(this.od6_1 === tmp0_other_with_cast.od6_1))
      return false;
    if (!(this.pd6_1 === tmp0_other_with_cast.pd6_1))
      return false;
    if (!(this.qd6_1 === tmp0_other_with_cast.qd6_1))
      return false;
    if (!(this.rd6_1 === tmp0_other_with_cast.rd6_1))
      return false;
    return true;
  }
}
class BitmapGlyphInfo {
  constructor(glyphID, imageFormat, offset, size, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance) {
    imageFormat = imageFormat === VOID ? 0 : imageFormat;
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? 0 : size;
    height = height === VOID ? 0 : height;
    width = width === VOID ? 0 : width;
    horiBearingX = horiBearingX === VOID ? 0 : horiBearingX;
    horiBearingY = horiBearingY === VOID ? 0 : horiBearingY;
    horiAdvance = horiAdvance === VOID ? 0 : horiAdvance;
    vertBearingX = vertBearingX === VOID ? 0 : vertBearingX;
    vertBearingY = vertBearingY === VOID ? 0 : vertBearingY;
    vertAdvance = vertAdvance === VOID ? 0 : vertAdvance;
    this.sd6_1 = glyphID;
    this.td6_1 = imageFormat;
    this.ud6_1 = offset;
    this.vd6_1 = size;
    this.wd6_1 = info;
    this.xd6_1 = height;
    this.yd6_1 = width;
    this.zd6_1 = horiBearingX;
    this.ad7_1 = horiBearingY;
    this.bd7_1 = horiAdvance;
    this.cd7_1 = vertBearingX;
    this.dd7_1 = vertBearingY;
    this.ed7_1 = vertAdvance;
    this.fd7_1 = null;
    this.gd7_1 = null;
  }
  hd7() {
    return this.wd6_1.yd5_1.hd6_1;
  }
  id7(cache) {
    var tmp0_elvis_lhs = this.gd7_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      try {
        tmp_0 = PNG_getInstance().md7(toSyncStream(ensureNotNull(this.fd7_1)));
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          println('Error in TtfFont.BitmapGlyphInfo: ' + e.message);
          // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
          var tmp$ret$0 = get_Bitmaps_transparent();
          tmp_1 = get_bmp(tmp$ret$0);
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var bmp = tmp;
    if (cache)
      this.gd7_1 = bmp;
    return bmp;
  }
  nd7(cache, $super) {
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.id7(cache) : $super.id7.call(this, cache);
  }
  toString() {
    return 'BitmapGlyphInfo(glyphID=' + this.sd6_1 + ', imageFormat=' + this.td6_1 + ', offset=' + this.ud6_1 + ', size=' + this.vd6_1 + ', info=' + this.wd6_1.toString() + ', height=' + this.xd6_1 + ', width=' + this.yd6_1 + ', horiBearingX=' + this.zd6_1 + ', horiBearingY=' + this.ad7_1 + ', horiAdvance=' + this.bd7_1 + ', vertBearingX=' + this.cd7_1 + ', vertBearingY=' + this.dd7_1 + ', vertAdvance=' + this.ed7_1 + ')';
  }
  hashCode() {
    var result = this.sd6_1;
    result = imul(result, 31) + this.td6_1 | 0;
    result = imul(result, 31) + this.ud6_1 | 0;
    result = imul(result, 31) + this.vd6_1 | 0;
    result = imul(result, 31) + this.wd6_1.hashCode() | 0;
    result = imul(result, 31) + this.xd6_1 | 0;
    result = imul(result, 31) + this.yd6_1 | 0;
    result = imul(result, 31) + this.zd6_1 | 0;
    result = imul(result, 31) + this.ad7_1 | 0;
    result = imul(result, 31) + this.bd7_1 | 0;
    result = imul(result, 31) + this.cd7_1 | 0;
    result = imul(result, 31) + this.dd7_1 | 0;
    result = imul(result, 31) + this.ed7_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapGlyphInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapGlyphInfo ? other : THROW_CCE();
    if (!(this.sd6_1 === tmp0_other_with_cast.sd6_1))
      return false;
    if (!(this.td6_1 === tmp0_other_with_cast.td6_1))
      return false;
    if (!(this.ud6_1 === tmp0_other_with_cast.ud6_1))
      return false;
    if (!(this.vd6_1 === tmp0_other_with_cast.vd6_1))
      return false;
    if (!this.wd6_1.equals(tmp0_other_with_cast.wd6_1))
      return false;
    if (!(this.xd6_1 === tmp0_other_with_cast.xd6_1))
      return false;
    if (!(this.yd6_1 === tmp0_other_with_cast.yd6_1))
      return false;
    if (!(this.zd6_1 === tmp0_other_with_cast.zd6_1))
      return false;
    if (!(this.ad7_1 === tmp0_other_with_cast.ad7_1))
      return false;
    if (!(this.bd7_1 === tmp0_other_with_cast.bd7_1))
      return false;
    if (!(this.cd7_1 === tmp0_other_with_cast.cd7_1))
      return false;
    if (!(this.dd7_1 === tmp0_other_with_cast.dd7_1))
      return false;
    if (!(this.ed7_1 === tmp0_other_with_cast.ed7_1))
      return false;
    return true;
  }
}
class ColorLine {
  constructor(cycle, stops) {
    this.od7_1 = cycle;
    this.pd7_1 = stops;
  }
  qd7(paint, palette) {
    var _iterator__ex2g4s = this.pd7_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var stop = _iterator__ex2g4s.r1();
      paint.sd8(stop.rd7_1, RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(palette.vcg_1, stop.sd7_1), stop.td7_1));
    }
  }
  toString() {
    return 'ColorLine(cycle=' + this.od7_1.toString() + ', stops=' + toString_0(this.pd7_1) + ')';
  }
  hashCode() {
    var result = this.od7_1.hashCode();
    result = imul(result, 31) + hashCode(this.pd7_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorLine))
      return false;
    var tmp0_other_with_cast = other instanceof ColorLine ? other : THROW_CCE();
    if (!this.od7_1.equals(tmp0_other_with_cast.od7_1))
      return false;
    if (!equals(this.pd7_1, tmp0_other_with_cast.pd7_1))
      return false;
    return true;
  }
}
class ColorStop {
  constructor(stopOffset, paletteIndex, alpha) {
    this.rd7_1 = stopOffset;
    this.sd7_1 = paletteIndex;
    this.td7_1 = alpha;
  }
}
class Colrv1Paint extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.vd8_1 = this.w1_1 + 1 | 0;
  }
}
class COLRv1 {
  constructor(layerList, s, sBaseOffset, sLayerOffset, sClipOffset) {
    var tmp;
    if (layerList === VOID) {
      // Inline function 'kotlin.intArrayOf' call
      tmp = new Int32Array([]);
    } else {
      tmp = layerList;
    }
    layerList = tmp;
    var tmp_0;
    if (s === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0 = new Int8Array([]);
      tmp_0 = new FastByteArrayInputStream(tmp$ret$0);
    } else {
      tmp_0 = s;
    }
    s = tmp_0;
    var tmp_1;
    if (sBaseOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_0 = new Int8Array([]);
      tmp_1 = new FastByteArrayInputStream(tmp$ret$0_0);
    } else {
      tmp_1 = sBaseOffset;
    }
    sBaseOffset = tmp_1;
    var tmp_2;
    if (sLayerOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_1 = new Int8Array([]);
      tmp_2 = new FastByteArrayInputStream(tmp$ret$0_1);
    } else {
      tmp_2 = sLayerOffset;
    }
    sLayerOffset = tmp_2;
    sClipOffset = sClipOffset === VOID ? null : sClipOffset;
    this.wd8_1 = layerList;
    this.xd8_1 = s;
    this.yd8_1 = sBaseOffset;
    this.zd8_1 = sLayerOffset;
    this.ad9_1 = sClipOffset;
    this.bd9_1 = IntIntMap.xa7();
  }
}
class Contour {
  constructor(x, y, onCurve) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    onCurve = onCurve === VOID ? false : onCurve;
    this.cd9_1 = x;
    this.dd9_1 = y;
    this.ed9_1 = onCurve;
  }
  toString() {
    return 'Contour(x=' + this.cd9_1 + ', y=' + this.dd9_1 + ', onCurve=' + this.ed9_1 + ')';
  }
  hashCode() {
    var result = this.cd9_1;
    result = imul(result, 31) + this.dd9_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ed9_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Contour))
      return false;
    var tmp0_other_with_cast = other instanceof Contour ? other : THROW_CCE();
    if (!(this.cd9_1 === tmp0_other_with_cast.cd9_1))
      return false;
    if (!(this.dd9_1 === tmp0_other_with_cast.dd9_1))
      return false;
    if (!(this.ed9_1 === tmp0_other_with_cast.ed9_1))
      return false;
    return true;
  }
}
class GlyphReference {
  constructor(glyph, x, y, scaleX, scale01, scale10, scaleY) {
    this.fd9_1 = glyph;
    this.gd9_1 = x;
    this.hd9_1 = y;
    this.id9_1 = scaleX;
    this.jd9_1 = scale01;
    this.kd9_1 = scale10;
    this.ld9_1 = scaleY;
  }
  toString() {
    return 'GlyphReference(glyph=' + toString_0(this.fd9_1) + ', x=' + this.gd9_1 + ', y=' + this.hd9_1 + ', scaleX=' + this.id9_1 + ', scale01=' + this.jd9_1 + ', scale10=' + this.kd9_1 + ', scaleY=' + this.ld9_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.fd9_1);
    result = imul(result, 31) + this.gd9_1 | 0;
    result = imul(result, 31) + this.hd9_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.id9_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.jd9_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.kd9_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ld9_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphReference))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphReference ? other : THROW_CCE();
    if (!equals(this.fd9_1, tmp0_other_with_cast.fd9_1))
      return false;
    if (!(this.gd9_1 === tmp0_other_with_cast.gd9_1))
      return false;
    if (!(this.hd9_1 === tmp0_other_with_cast.hd9_1))
      return false;
    if (!equals(this.id9_1, tmp0_other_with_cast.id9_1))
      return false;
    if (!equals(this.jd9_1, tmp0_other_with_cast.jd9_1))
      return false;
    if (!equals(this.kd9_1, tmp0_other_with_cast.kd9_1))
      return false;
    if (!equals(this.ld9_1, tmp0_other_with_cast.ld9_1))
      return false;
    return true;
  }
}
class ColrLayerInfo {
  constructor($outer, glyphID, paletteIndex) {
    this.od9_1 = $outer;
    this.md9_1 = glyphID;
    this.nd9_1 = paletteIndex;
  }
  pd9(pal) {
    var tmp0 = new RgbaArray(getCyclic(this.od9_1.id2_1, pal).vcg_1);
    // Inline function 'kotlin.collections.getOrElse' call
    var index = this.nd9_1;
    var tmp;
    if (0 <= index ? index < tmp0.s2() : false) {
      tmp = tmp0.u2(index);
    } else {
      tmp = new RGBA(Colors_getInstance().bc5_1);
    }
    return tmp.sci_1;
  }
  qd9() {
    return this.pd9(0);
  }
  rd9(pal) {
    var tmp135_safe_receiver = this.od9_1.qd4(this.md9_1);
    var tmp136_safe_receiver = tmp135_safe_receiver == null ? null : tmp135_safe_receiver.obf();
    var tmp;
    if (tmp136_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new FillShape(tmp136_safe_receiver.bda_1, null, new RGBA(this.pd9(pal)));
    }
    return tmp;
  }
  toString() {
    return 'ColrLayerInfo(' + this.md9_1 + ', ' + this.nd9_1 + ', ' + RGBA__toString_impl_4lw6dp(this.qd9()) + ')';
  }
}
class ColrGlyphInfo {}
function getColorShape$default(pal, $super) {
  pal = pal === VOID ? 0 : pal;
  return $super === VOID ? this.cda(pal) : $super.cda.call(this, pal);
}
class ColrGlyphInfoV1 {
  constructor($outer, glyphID, paint) {
    this.gda_1 = $outer;
    this.eda_1 = glyphID;
    this.fda_1 = paint;
  }
  cda(pal) {
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    var this_0 = new ShapeBuilder(null, null);
    var paintS = this.gda_1.jd2_1.yd8_1.ab7(this.fda_1);
    try {
      this.gda_1.dd4(this.eda_1, paintS, this_0, pal, 0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    // Inline function 'kotlin.also' call
    return this_0.rcq();
  }
  toString() {
    return 'ColrGlyphInfoV1[' + this.eda_1 + '][' + this.fda_1 + ']';
  }
}
class ColrGlyphInfoV0 {
  constructor($outer, glyphID, firstLayerIndex, numLayers) {
    this.kda_1 = $outer;
    this.hda_1 = glyphID;
    this.ida_1 = firstLayerIndex;
    this.jda_1 = numLayers;
  }
  u2(index) {
    return this.kda_1.gd2_1[this.ida_1 + index | 0];
  }
  dcz() {
    var tmp = 0;
    var tmp_0 = this.jda_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this.u2(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return toList_1(tmp_1);
  }
  cda(pal) {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = this.dcz();
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList.p2();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp0_safe_receiver = element.rd9(pal);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.d2(tmp0_safe_receiver);
      }
    }
    return new CompoundShape(destination);
  }
  toString() {
    return 'ColrGlyphInfoV0[' + this.hda_1 + '][' + this.jda_1 + '](' + toString_0(this.dcz()) + ')';
  }
}
class GlyphGraphicsPath {
  constructor(glpyhIndex, path) {
    this.ada_1 = glpyhIndex;
    this.bda_1 = path;
  }
  gah(p) {
    this.bda_1.gah(p);
  }
  iah(p) {
    this.bda_1.iah(p);
  }
  jah(c, a) {
    this.bda_1.jah(c, a);
  }
  lah(c1, c2, a) {
    this.bda_1.lah(c1, c2, a);
  }
  f7() {
    this.bda_1.f7();
  }
  qas(p0, p1) {
    this.bda_1.qas(p0, p1);
  }
  ras(a, c, r) {
    this.bda_1.ras(a, c, r);
  }
  n1() {
    return this.bda_1.n1();
  }
  sas(rect) {
    this.bda_1.sas(rect);
  }
  tas(pos, size) {
    this.bda_1.tas(pos, size);
  }
  uas(x, y, width, height) {
    this.bda_1.uas(x, y, width, height);
  }
  vas(x, y, w, h, rtl, rtr, rbr, rbl) {
    this.bda_1.vas(x, y, w, h, rtl, rtr, rbr, rbl);
  }
  was(center, r, start, end, counterclockwise) {
    this.bda_1.was(center, r, start, end, counterclockwise);
  }
  oab(center, radius) {
    this.bda_1.oab(center, radius);
  }
  yas(delta) {
    this.bda_1.yas(delta);
  }
  zas(delta) {
    this.bda_1.zas(delta);
  }
  v9q(m) {
    return this.bda_1.v9q(m);
  }
  pas() {
    return this.bda_1.pas();
  }
  hah() {
    return this.bda_1.tah_1;
  }
  toString() {
    return 'GlyphGraphicsPath(glpyhIndex=' + this.ada_1 + ', "' + toSvgPathString(this.bda_1) + '")';
  }
  hashCode() {
    var result = this.ada_1;
    result = imul(result, 31) + this.bda_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphGraphicsPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphGraphicsPath ? other : THROW_CCE();
    if (!(this.ada_1 === tmp0_other_with_cast.ada_1))
      return false;
    if (!this.bda_1.equals(tmp0_other_with_cast.bda_1))
      return false;
    return true;
  }
}
class Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box) {
    boxApply(this, $box);
    this.zd9_1 = $outer;
    this.sd9_1 = index;
    this.td9_1 = xMin;
    this.ud9_1 = yMin;
    this.vd9_1 = xMax;
    this.wd9_1 = yMax;
    this.xd9_1 = advanceWidth;
    var tmp = this;
    // Inline function 'kotlin.run' call
    var xMin_0 = this.td9_1;
    var yMin_0 = this.ud9_1;
    var xMax_0 = this.vd9_1;
    var yMax_0 = this.wd9_1;
    if (xMin_0 === 0 && yMin_0 === 0 && xMax_0 === 0 && yMax_0 === 0) {
      var sClipOffset = this.zd9_1.jd2_1.ad9_1;
      var glyphIDToClipOffset = this.zd9_1.jd2_1.bd9_1;
      var tmp_0;
      if (!(sClipOffset == null) && glyphIDToClipOffset.as(this.sd9_1)) {
        var clipOffset = glyphIDToClipOffset.u2(this.sd9_1);
        tmp_0 = this.zd9_1.bd4(sClipOffset.ab7(clipOffset));
      } else {
        var tmp137_safe_receiver = this.lda();
        var tmp138_safe_receiver = tmp137_safe_receiver == null ? null : tmp137_safe_receiver.dda();
        tmp_0 = tmp138_safe_receiver == null ? null : tmp138_safe_receiver.mda();
      }
      var bounds = tmp_0;
      if (!(bounds == null)) {
        xMin_0 = numberToInt(bounds.v9h());
        xMax_0 = numberToInt(bounds.w9h());
        yMin_0 = numberToInt(bounds.x9h());
        yMax_0 = numberToInt(bounds.y9h());
      }
    }
    var size = this.zd9_1.rd1_1;
    var scale = this.zd9_1.icl(size);
    tmp.yd9_1 = new GlyphMetrics(size, true, -1, Companion_getInstance_4().u9p(xMin_0 * scale, yMin_0 * scale, xMax_0 * scale, yMax_0 * scale), this.xd9_1 * scale);
  }
  lda() {
    return this.zd9_1.hd2_1.u2(this.sd9_1);
  }
  nda() {
    return this.zd9_1.fd2_1.w4(this.sd9_1);
  }
}
class CompositeGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, refs, advanceWidth, $box) {
    if ($box === VOID)
      $box = {};
    $box.zda_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.wda_1 = refs;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.wda_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var gpath = item.fd9_1.obf().bda_1;
      // Inline function 'kotlin.also' call
      var this_1 = new GlyphGraphicsPath(item.fd9_1.sd9_1, new VectorPath(IntArrayList.za1(gpath.nah_1.s2()), DoubleArrayList.ga3(gpath.oah_1.s2())));
      var m = Companion_getInstance_5().y9k().t9l(item.id9_1, item.ld9_1).z9l(item.gd9_1, -item.hd9_1 | 0);
      this_1.bda_1.pat(item.fd9_1.obf().bda_1, m);
      destination.d2(this_1);
    }
    tmp.xda_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.run' call
    var commandsSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = this.xda_1;
    var n = 0;
    while (n < this_2.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gpath_0 = this_2.u2(_unary__edvuaz);
      commandsSize = commandsSize + gpath_0.bda_1.nah_1.s2() | 0;
      dataSize = dataSize + gpath_0.bda_1.oah_1.s2() | 0;
    }
    // Inline function 'kotlin.also' call
    var this_3 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.za1(commandsSize), DoubleArrayList.ga3(dataSize)));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_4 = this.xda_1;
    var n_0 = 0;
    while (n_0 < this_4.s2()) {
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var it = this_4.u2(_unary__edvuaz_0);
      this_3.bda_1.qat(it.bda_1);
    }
    tmp_0.yda_1 = this_3;
  }
  toString() {
    return 'CompositeGlyph[' + this.xd9_1 + '](' + toString_0(this.wda_1) + ')';
  }
  obf() {
    return this.yda_1;
  }
}
class CFFGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, path, $box) {
    if ($box === VOID)
      $box = {};
    $box.kdb_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.idb_1 = path;
    this.jdb_1 = listOf_0(this.idb_1);
  }
  obf() {
    return this.idb_1;
  }
}
class SimpleGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, contoursIndices, flags, xPos, yPos, advanceWidth, dummy, $box) {
    if ($box === VOID)
      $box = {};
    dummy = dummy === VOID ? false : dummy;
    $box.adc_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.tdb_1 = contoursIndices;
    this.udb_1 = flags;
    this.vdb_1 = xPos;
    this.wdb_1 = yPos;
    this.xdb_1 = dummy;
    var tmp = this;
    // Inline function 'kotlin.run' call
    var commandSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    var inductionVariable = 0;
    var last = this.tdb_1.length - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var cstart = this.tdb_1[n] + 1 | 0;
        var cend = this.tdb_1[n + 1 | 0];
        var csize = (cend - cstart | 0) + 1 | 0;
        commandSize = commandSize + (1 + imul(csize, 2) | 0) | 0;
        dataSize = dataSize + (2 + imul(csize, 8) | 0) | 0;
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.za1(commandSize), DoubleArrayList.ga3(dataSize)));
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    var inductionVariable_0 = 0;
    var last_0 = this.tdb_1.length - 1 | 0;
    if (inductionVariable_0 < last_0)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var cstart_0 = this.tdb_1[n_0] + 1 | 0;
        var cend_0 = this.tdb_1[n_0 + 1 | 0];
        var csize_0 = (cend_0 - cstart_0 | 0) + 1 | 0;
        var curr = this.bdc(cend_0, this.adc_1.nd0_1[0]);
        var next = this.bdc(cstart_0, this.adc_1.nd0_1[1]);
        if (curr.ed9_1) {
          this_0.gah(Vector2D.a9k(curr.cd9_1, -curr.dd9_1 | 0));
        } else if (next.ed9_1) {
          this_0.gah(Vector2D.a9k(next.cd9_1, -next.dd9_1 | 0));
        } else {
          this_0.gah(Vector2D.a9k(imul(curr.cd9_1 + next.cd9_1 | 0, numberToInt(0.5)), -numberToInt((curr.dd9_1 + next.dd9_1 | 0) * 0.5) | 0));
        }
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < csize_0)
          do {
            var cpos = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var prev = curr;
            curr = next;
            next = this.bdc(cstart_0 + ((cpos + 1 | 0) % csize_0 | 0) | 0, this.adc_1.nd0_1[(cpos + 2 | 0) % 3 | 0]);
            if (curr.ed9_1) {
              this_0.iah(Vector2D.a9k(curr.cd9_1, -curr.dd9_1 | 0));
            } else {
              var prev2X = prev.cd9_1;
              var prev2Y = prev.dd9_1;
              var next2X = next.cd9_1;
              var next2Y = next.dd9_1;
              if (!prev.ed9_1) {
                prev2X = numberToInt((curr.cd9_1 + prev.cd9_1 | 0) * 0.5);
                prev2Y = numberToInt((curr.dd9_1 + prev.dd9_1 | 0) * 0.5);
                this_0.iah(Vector2D.a9k(prev2X, -prev2Y | 0));
              }
              if (!next.ed9_1) {
                next2X = numberToInt((curr.cd9_1 + next.cd9_1 | 0) * 0.5);
                next2Y = numberToInt((curr.dd9_1 + next.dd9_1 | 0) * 0.5);
              }
              this_0.iah(Vector2D.a9k(prev2X, -prev2Y | 0));
              this_0.jah(Vector2D.a9k(curr.cd9_1, -curr.dd9_1 | 0), Vector2D.a9k(next2X, -next2Y | 0));
            }
          }
           while (inductionVariable_1 < csize_0);
        this_0.f7();
      }
       while (inductionVariable_0 < last_0);
    tmp.ydb_1 = this_0;
    this.zdb_1 = listOf_0(this.ydb_1);
  }
  toString() {
    return 'SimpleGlyph' + (this.xdb_1 ? 'Dummy' : '') + '[' + this.sd9_1 + '](advance=' + this.xd9_1 + ') : ' + this.ydb_1.toString();
  }
  cdc(n) {
    return !((this.udb_1[n] & 1) === 0);
  }
  bdc(n, out) {
    // Inline function 'kotlin.apply' call
    out.cd9_1 = this.vdb_1[n];
    out.dd9_1 = this.wdb_1[n];
    out.ed9_1 = this.cdc(n);
    return out;
  }
  obf() {
    return this.ydb_1;
  }
}
class BaseTtfFont$readCblc$Subtable {
  constructor(firstGlyphIndex, lastGlyphIndex, additionalOffsetToIndexSubtable) {
    this.ddc_1 = firstGlyphIndex;
    this.edc_1 = lastGlyphIndex;
    this.fdc_1 = additionalOffsetToIndexSubtable;
  }
  gdc() {
    return this.edc_1 - this.ddc_1 | 0;
  }
  toString() {
    return 'Subtable(firstGlyphIndex=' + this.ddc_1 + ', lastGlyphIndex=' + this.edc_1 + ', additionalOffsetToIndexSubtable=' + this.fdc_1 + ')';
  }
  hashCode() {
    var result = this.ddc_1;
    result = imul(result, 31) + this.edc_1 | 0;
    result = imul(result, 31) + this.fdc_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCblc$Subtable))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCblc$Subtable ? other : THROW_CCE();
    if (!(this.ddc_1 === tmp0_other_with_cast.ddc_1))
      return false;
    if (!(this.edc_1 === tmp0_other_with_cast.edc_1))
      return false;
    if (!(this.fdc_1 === tmp0_other_with_cast.fdc_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readSbix$StrikeInfo {
  constructor(ppem, ppi, strikeOffset, offsets) {
    this.hdc_1 = ppem;
    this.idc_1 = ppi;
    this.jdc_1 = strikeOffset;
    this.kdc_1 = offsets;
  }
  toString() {
    return 'StrikeInfo(ppem=' + this.hdc_1 + ', ppi=' + this.idc_1 + ', strikeOffset=' + this.jdc_1 + ', offsets=' + this.kdc_1.toString() + ')';
  }
  hashCode() {
    var result = this.hdc_1;
    result = imul(result, 31) + this.idc_1 | 0;
    result = imul(result, 31) + this.jdc_1 | 0;
    result = imul(result, 31) + this.kdc_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readSbix$StrikeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readSbix$StrikeInfo ? other : THROW_CCE();
    if (!(this.hdc_1 === tmp0_other_with_cast.hdc_1))
      return false;
    if (!(this.idc_1 === tmp0_other_with_cast.idc_1))
      return false;
    if (!(this.jdc_1 === tmp0_other_with_cast.jdc_1))
      return false;
    if (!this.kdc_1.equals(tmp0_other_with_cast.kdc_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCoverage$RangeInfo {
  constructor(start, endInclusive, index) {
    this.ldc_1 = start;
    this.mdc_1 = endInclusive;
    this.ndc_1 = index;
    this.odc_1 = (this.mdc_1 - this.ldc_1 | 0) + 1 | 0;
  }
  toString() {
    return 'RangeInfo(start=' + this.ldc_1 + ', endInclusive=' + this.mdc_1 + ', index=' + this.ndc_1 + ')';
  }
  hashCode() {
    var result = this.ldc_1;
    result = imul(result, 31) + this.mdc_1 | 0;
    result = imul(result, 31) + this.ndc_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCoverage$RangeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCoverage$RangeInfo ? other : THROW_CCE();
    if (!(this.ldc_1 === tmp0_other_with_cast.ldc_1))
      return false;
    if (!(this.mdc_1 === tmp0_other_with_cast.mdc_1))
      return false;
    if (!(this.ndc_1 === tmp0_other_with_cast.ndc_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCmap$EncodingRecord {
  constructor(platformId, encodingId, offset) {
    this.pdc_1 = platformId;
    this.qdc_1 = encodingId;
    this.rdc_1 = offset;
  }
  toString() {
    return 'EncodingRecord(platformId=' + this.pdc_1 + ', encodingId=' + this.qdc_1 + ', offset=' + this.rdc_1 + ')';
  }
  hashCode() {
    var result = this.pdc_1;
    result = imul(result, 31) + this.qdc_1 | 0;
    result = imul(result, 31) + this.rdc_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCmap$EncodingRecord))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCmap$EncodingRecord ? other : THROW_CCE();
    if (!(this.pdc_1 === tmp0_other_with_cast.pdc_1))
      return false;
    if (!(this.qdc_1 === tmp0_other_with_cast.qdc_1))
      return false;
    if (!(this.rdc_1 === tmp0_other_with_cast.rdc_1))
      return false;
    return true;
  }
}
class Companion_19 {
  tdc(num, den) {
    return insert16(insert16(0, num, 0), den, 16);
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_26 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_4();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cd(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$2 = element.ydc_1;
      destination.b5(tmp$ret$2, element);
    }
    tmp.add_1 = destination;
  }
  u2(index) {
    var tmp0_elvis_lhs = this.add_1.w4(index);
    return tmp0_elvis_lhs == null ? DataFormat_UNKNOWN_getInstance() : tmp0_elvis_lhs;
  }
}
class DataFormat extends Enum {
  constructor(name, ordinal, id, indexBytes) {
    super(name, ordinal);
    this.ydc_1 = id;
    this.zdc_1 = indexBytes;
  }
}
class EXIF {
  constructor() {
    EXIF_instance = this;
    this.bdd_1 = Companion_getInstance_14().pb5('EXIF');
  }
  *cdd(ss, info, debug, $completion) {
    var s = yield* sliceHere(ss, VOID, $completion);
    var start = yield* readString(s, 2, Charsets_instance.ub4(), $completion);
    var tmp;
    switch (start) {
      case 'MM':
        tmp = Endian_BIG_ENDIAN_getInstance();
        break;
      case 'II':
        tmp = Endian_LITTLE_ENDIAN_getInstance();
        break;
      default:
        // Inline function 'kotlin.error' call

        var message = "Not Exif data (not starting with MM or II but '" + start + "')";
        throw IllegalStateException.o(toString_0(message));
    }
    var endian = tmp;
    var tagMark = yield* readU16(s, endian, $completion);
    var offsetFirstIFD = yield* readS32(s, endian, $completion);
    var nDirEntry = yield* readU16(s, endian, $completion);
    if (debug) {
      // Inline function 'korlibs.logger.Logger.error' call
      var tmp0 = this.bdd_1;
      // Inline function 'korlibs.logger.Logger.log' call
      var level = Level_ERROR_getInstance();
      if (tmp0.obj(level)) {
        var tmp$ret$3 = 'nDirEntry=' + nDirEntry + ', tagMark=' + tagMark + ', offsetFirstFID=' + offsetFirstIFD;
        tmp0.pbj(level, tmp$ret$3);
      }
    }
    var inductionVariable = 0;
    if (inductionVariable < nDirEntry)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tagPos = convertToInt(s.yb8_1);
        var tagNumber = yield* readU16(s, endian, $completion);
        var dataFormat = Companion_getInstance_36().u2(yield* readU16(s, endian, $completion));
        var nComponent = yield* readS32(s, endian, $completion);
        if (debug) {
          // Inline function 'korlibs.logger.Logger.error' call
          var tmp0_0 = this.bdd_1;
          // Inline function 'korlibs.logger.Logger.log' call
          var level_0 = Level_ERROR_getInstance();
          if (tmp0_0.obj(level_0)) {
            var tmp$ret$6 = 'tagPos=' + get_hex(tagPos) + ', tagNumber=' + get_hex(tagNumber) + ', dataFormat=' + dataFormat.toString() + ', nComponent=' + nComponent + ', size=' + dataFormat.zdc_1(nComponent);
            tmp0_0.pbj(level_0, tmp$ret$6);
          }
        }
        var data = yield* readBytesExact(s, dataFormat.zdc_1(nComponent), $completion);
        if (debug) {
          if (dataFormat.equals(DataFormat_STRING_getInstance())) {
            // Inline function 'korlibs.logger.Logger.error' call
            var tmp0_1 = this.bdd_1;
            // Inline function 'korlibs.logger.Logger.log' call
            var level_1 = Level_ERROR_getInstance();
            if (tmp0_1.obj(level_1)) {
              var tmp$ret$9 = "  - '" + (yield* readStringz(yield* sliceStart(s, fromInt(readExifBase$readInt(data, endian, 0)), VOID, $completion), nComponent, VOID, $completion)) + "'";
              tmp0_1.pbj(level_1, tmp$ret$9);
            }
          }
        }
        if (tagNumber === 274) {
          var tmp_0;
          switch (readExifBase$readUShort(data, endian, 0)) {
            case 1:
              // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

              tmp_0 = Companion_getInstance_0().yai_1;
              break;
            case 2:
              // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_HORIZONTAL' call

              tmp_0 = Companion_getInstance_0().caj_1;
              break;
            case 3:
              tmp_0 = Companion_getInstance_0().aaj_1;
              break;
            case 4:
              // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_VERTICAL' call

              tmp_0 = Companion_getInstance_0().eaj_1;
              break;
            case 5:
              tmp_0 = Companion_getInstance_0().faj_1;
              break;
            case 6:
              tmp_0 = Companion_getInstance_0().zai_1;
              break;
            case 7:
              tmp_0 = Companion_getInstance_0().daj_1;
              break;
            case 8:
              tmp_0 = Companion_getInstance_0().baj_1;
              break;
            default:
              // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

              tmp_0 = Companion_getInstance_0().yai_1;
              break;
          }
          set_orientation(info, tmp_0);
        }
        skipToAlign(s, 4, 2);
      }
       while (inductionVariable < nDirEntry);
    return info;
  }
  ddd(ss, info, debug, $completion, $super) {
    info = info === VOID ? new ImageInfo() : info;
    debug = debug === VOID ? false : debug;
    return $super === VOID ? this.cdd(ss, info, debug, $completion) : $super.cdd.call(this, ss, info, debug, $completion);
  }
}
class Direction extends Enum {}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.edd_1 = function_0;
  }
  pj(a, b) {
    return this.edd_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.edd_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class ImageAnimation {
  constructor(frames, direction, name, layers) {
    var tmp;
    if (layers === VOID) {
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList.p2();
      var _iterator__ex2g4s = frames.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var list = element.ldd_1;
        addAll(destination, list);
      }
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.n2(collectionSizeOrDefault(destination, 10));
      var _iterator__ex2g4s_0 = destination.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var item = _iterator__ex2g4s_0.r1();
        var tmp$ret$5 = item.ndd_1;
        destination_0.d2(tmp$ret$5);
      }
      // Inline function 'kotlin.collections.sortedBy' call
      var this_0 = distinct(destination_0);
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = ImageAnimation$_init_$lambda_bxp50i;
      var tmp$ret$7 = new sam$kotlin_Comparator$0(tmp_0);
      tmp = sortedWith(this_0, tmp$ret$7);
    } else {
      tmp = layers;
    }
    layers = tmp;
    this.xdd_1 = frames;
    this.ydd_1 = direction;
    this.zdd_1 = name;
    this.ade_1 = layers;
    var tmp_1 = this;
    var tmp0_elvis_lhs = firstOrNull_0(this.xdd_1);
    tmp_1.bde_1 = tmp0_elvis_lhs == null ? ImageFrame.cde(0) : tmp0_elvis_lhs;
  }
}
class Companion_21 {
  dde(bitmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(bitmaps.length);
    var inductionVariable = 0;
    var last = bitmaps.length;
    while (inductionVariable < last) {
      var item = bitmaps[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$2 = Companion_instance_30.ede(item);
      destination.d2(tmp$ret$2);
    }
    return new ImageData(destination);
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.fde_1 = function_0;
  }
  pj(a, b) {
    return this.fde_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.fde_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class ImageData {
  constructor(frames, loopCount, width, height, layers, animations, name) {
    loopCount = loopCount === VOID ? 0 : loopCount;
    var tmp;
    if (width === VOID) {
      var tmp171_safe_receiver = firstOrNull_0(frames);
      var tmp0_elvis_lhs = tmp171_safe_receiver == null ? null : tmp171_safe_receiver.w9z();
      tmp = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    } else {
      tmp = width;
    }
    width = tmp;
    var tmp_0;
    if (height === VOID) {
      var tmp172_safe_receiver = firstOrNull_0(frames);
      var tmp1_elvis_lhs = tmp172_safe_receiver == null ? null : tmp172_safe_receiver.x9z();
      tmp_0 = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    } else {
      tmp_0 = height;
    }
    height = tmp_0;
    layers = layers === VOID ? fastArrayListOf([]) : layers;
    animations = animations === VOID ? fastArrayListOf([]) : animations;
    name = name === VOID ? null : name;
    this.ide_1 = new Mixin();
    this.jde_1 = frames;
    this.kde_1 = loopCount;
    this.lde_1 = width;
    this.mde_1 = height;
    this.nde_1 = layers;
    this.ode_1 = animations;
    this.pde_1 = name;
    this.qde_1 = new ImageAnimation(this.jde_1, Direction_FORWARD_getInstance(), 'default');
    var tmp_1 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.ode_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cd(capacity);
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp$ret$2 = element.zdd_1;
      destination.b5(tmp$ret$2, element);
    }
    tmp_1.rde_1 = destination;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = this.jde_1;
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.cd(capacity_0);
    var _iterator__ex2g4s_0 = this_1.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      var tmp$ret$5 = element_0.h1();
      destination_0.b5(tmp$ret$5, element_0);
    }
    tmp_2.sde_1 = destination_0;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_2 = this.jde_1;
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_4 = ImageData$framesSortedByPriority$lambda;
    var tmp$ret$7 = new sam$kotlin_Comparator$0_0(tmp_4);
    tmp_3.tde_1 = sortedWith(this_2, tmp$ret$7);
  }
  o9u(_set____db54di) {
    this.ide_1.o9u(_set____db54di);
  }
  p9u() {
    return this.ide_1.p9u();
  }
  ude() {
    var tmp173_safe_receiver = firstOrNull_0(this.tde_1);
    var tmp0_elvis_lhs = tmp173_safe_receiver == null ? null : tmp173_safe_receiver.gde();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.h2('No bitmap found');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'ImageData(' + toString_0(this.jde_1) + ')';
  }
}
class Companion_22 {
  vde(bitmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(bitmaps, 10));
    var _iterator__ex2g4s = bitmaps.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = Companion_instance_27.dde([item]);
      destination.d2(tmp$ret$2);
    }
    return new ImageDataContainer(destination);
  }
  dde(bitmaps) {
    return Companion_instance_28.vde(toList_1(bitmaps));
  }
}
class ImageDataContainer {
  constructor(imageDatas) {
    this.wde_1 = imageDatas;
    var tmp = this;
    tmp.xde_1 = lazy(ImageDataContainer$imageDatasByName$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.yde_1 = lazy(ImageDataContainer$default$delegate$lambda(this));
  }
  zde() {
    var tmp0 = this.xde_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('imageDatasByName', 1, tmp, ImageDataContainer$_get_imageDatasByName_$ref_lvn64y(), null);
    return tmp0.k3();
  }
  adf() {
    var tmp0 = this.yde_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('default', 1, tmp, ImageDataContainer$_get_default_$ref_ugc3m1(), null);
    return tmp0.k3();
  }
}
class ImageFormat {
  static cdf(exts, mimeType) {
    mimeType = mimeType === VOID ? 'image/' + first_2(exts) : mimeType;
    var $this = createThis(this);
    $this.jd7_1 = mimeType;
    var tmp = $this;
    tmp.kd7_1 = lazy(ImageFormat$decodingProps$delegate$lambda($this));
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.text.trim' call
      var this_0 = item.toLowerCase();
      var tmp$ret$2 = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.d2(tmp$ret$2);
    }
    tmp_0.ld7_1 = toSet(destination);
    return $this;
  }
  bdf() {
    var tmp0 = this.kd7_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('decodingProps', 1, tmp, ImageFormat$_get_decodingProps_$ref_aisyt3(), null);
    return tmp0.k3();
  }
  edf(s, props) {
    return this.ddf(s, props).adf();
  }
  fdf(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      var bmp = this.gdf(s, props);
      // Inline function 'kotlin.apply' call
      var this_0 = new ImageInfo();
      this_0.idf_1 = bmp.sc1_1;
      this_0.jdf_1 = bmp.tc1_1;
      this_0.kdf_1 = bmp.uc1_1;
      tmp = this_0;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  gdf(s, props) {
    return this.edf(s, props).ude();
  }
  ldf(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      tmp = !(this.fdf(s, props) == null);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  mdf(s, props) {
    return this.gdf(s, props);
  }
  md7(s, props, $super) {
    props = props === VOID ? Companion_getInstance_39().acn_1 : props;
    return $super === VOID ? this.mdf(s, props) : $super.mdf.call(this, s, props);
  }
  ndf(data, props) {
    return this.gdf(openSync(data), props);
  }
  *odf(data, props, $completion) {
    return this.ndf(data, props);
  }
  *pdf(file, props, $completion) {
    return this.gdf(yield* readAsSyncStream(file, $completion), props.cdg(file));
  }
  toString() {
    return 'ImageFormat(' + toString_0(this.ld7_1) + ')';
  }
}
class Companion_23 {
  constructor() {
    Companion_instance_29 = this;
    this.acn_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.bcn_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.ccn_1 = new ImageDecodingProps(VOID, VOID, VOID, false);
  }
}
class ImageDecodingProps {
  constructor(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    Companion_getInstance_39();
    filename = filename === VOID ? 'unknown' : filename;
    width = width === VOID ? null : width;
    height = height === VOID ? null : height;
    premultiplied = premultiplied === VOID ? null : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? false : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? null : requestedMaxSize;
    debug = debug === VOID ? false : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? false : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? true : tryNativeDecode;
    format = format === VOID ? get_RegisteredImageFormats() : format;
    out = out === VOID ? null : out;
    extra = extra === VOID ? null : extra;
    this.qdf_1 = filename;
    this.rdf_1 = width;
    this.sdf_1 = height;
    this.tdf_1 = premultiplied;
    this.udf_1 = asumePremultiplied;
    this.vdf_1 = requestedMaxSize;
    this.wdf_1 = debug;
    this.xdf_1 = preferKotlinDecoder;
    this.ydf_1 = tryNativeDecode;
    this.zdf_1 = format;
    this.adg_1 = out;
    this.bdg_1 = extra;
  }
  o9u(_set____db54di) {
    this.bdg_1 = _set____db54di;
  }
  p9u() {
    return this.bdg_1;
  }
  bdf() {
    return this;
  }
  ddg() {
    var tmp0_elvis_lhs = this.tdf_1;
    return tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs;
  }
  edg(filename) {
    return this.fdg(filename);
  }
  cdg(file) {
    return this.edg(get_baseName(file));
  }
  gdg(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    return new ImageDecodingProps(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  fdg(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra, $super) {
    filename = filename === VOID ? this.qdf_1 : filename;
    width = width === VOID ? this.rdf_1 : width;
    height = height === VOID ? this.sdf_1 : height;
    premultiplied = premultiplied === VOID ? this.tdf_1 : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? this.udf_1 : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? this.vdf_1 : requestedMaxSize;
    debug = debug === VOID ? this.wdf_1 : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? this.xdf_1 : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? this.ydf_1 : tryNativeDecode;
    format = format === VOID ? this.zdf_1 : format;
    out = out === VOID ? this.adg_1 : out;
    extra = extra === VOID ? this.bdg_1 : extra;
    return $super === VOID ? this.gdg(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) : $super.gdg.call(this, filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  toString() {
    return 'ImageDecodingProps(filename=' + this.qdf_1 + ', width=' + this.rdf_1 + ', height=' + this.sdf_1 + ', premultiplied=' + this.tdf_1 + ', asumePremultiplied=' + this.udf_1 + ', requestedMaxSize=' + this.vdf_1 + ', debug=' + this.wdf_1 + ', preferKotlinDecoder=' + this.xdf_1 + ', tryNativeDecode=' + this.ydf_1 + ', format=' + toString(this.zdf_1) + ', out=' + toString(this.adg_1) + ', extra=' + toString(this.bdg_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.qdf_1);
    result = imul(result, 31) + (this.rdf_1 == null ? 0 : this.rdf_1) | 0;
    result = imul(result, 31) + (this.sdf_1 == null ? 0 : this.sdf_1) | 0;
    result = imul(result, 31) + (this.tdf_1 == null ? 0 : getBooleanHashCode(this.tdf_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.udf_1) | 0;
    result = imul(result, 31) + (this.vdf_1 == null ? 0 : this.vdf_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.wdf_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.xdf_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ydf_1) | 0;
    result = imul(result, 31) + (this.zdf_1 == null ? 0 : hashCode(this.zdf_1)) | 0;
    result = imul(result, 31) + (this.adg_1 == null ? 0 : hashCode(this.adg_1)) | 0;
    result = imul(result, 31) + (this.bdg_1 == null ? 0 : hashCode(this.bdg_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof ImageDecodingProps ? other : THROW_CCE();
    if (!(this.qdf_1 === tmp0_other_with_cast.qdf_1))
      return false;
    if (!(this.rdf_1 == tmp0_other_with_cast.rdf_1))
      return false;
    if (!(this.sdf_1 == tmp0_other_with_cast.sdf_1))
      return false;
    if (!(this.tdf_1 == tmp0_other_with_cast.tdf_1))
      return false;
    if (!(this.udf_1 === tmp0_other_with_cast.udf_1))
      return false;
    if (!(this.vdf_1 == tmp0_other_with_cast.vdf_1))
      return false;
    if (!(this.wdf_1 === tmp0_other_with_cast.wdf_1))
      return false;
    if (!(this.xdf_1 === tmp0_other_with_cast.xdf_1))
      return false;
    if (!(this.ydf_1 === tmp0_other_with_cast.ydf_1))
      return false;
    if (!equals(this.zdf_1, tmp0_other_with_cast.zdf_1))
      return false;
    if (!equals(this.adg_1, tmp0_other_with_cast.adg_1))
      return false;
    if (!equals(this.bdg_1, tmp0_other_with_cast.bdg_1))
      return false;
    return true;
  }
}
class ImageDecoderNotFoundException extends Exception {}
class ImageFormats extends ImageFormat {
  static ndg(formats) {
    var $this = this.cdf(['']);
    $this.kdg_1 = atomic$ref$1(minus(listFormats(formats), $this));
    return $this;
  }
  static odg(formats) {
    return this.ndg(toList_1(formats));
  }
  mdg(_set____db54di) {
    var tmp0 = this.kdg_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ImageFormats$_get__formats_$ref_elynds();
    // Inline function 'kotlinx.atomicfu.AtomicRef.setValue' call
    getPropertyCallableRef('_formats', 1, tmp, tmp_0, ImageFormats$_set__formats_$ref_u5pdxw());
    tmp0.kotlinx$atomicfu$value = _set____db54di;
    return Unit_instance;
  }
  ldg() {
    var tmp0 = this.kdg_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ImageFormats$_get__formats_$ref_elynds();
    // Inline function 'kotlinx.atomicfu.AtomicRef.getValue' call
    getPropertyCallableRef('_formats', 1, tmp, tmp_0, ImageFormats$_set__formats_$ref_u5pdxw());
    return tmp0.kotlinx$atomicfu$value;
  }
  pdg() {
    return this.ldg();
  }
  toString() {
    return 'ImageFormats(' + this.pdg().s2() + ')' + toString_0(this.pdg());
  }
  fdf(s, props) {
    if (this.pdg().n1())
      return null;
    var _iterator__ex2g4s = this.pdg().p1();
    $l$loop_0: while (_iterator__ex2g4s.q1()) {
      var format = _iterator__ex2g4s.r1();
      var tmp;
      try {
        var tmp0_elvis_lhs = format.fdf(sliceStart_0(s), props);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          if (e instanceof CancellationException)
            throw e;
          continue $l$loop_0;
        } else {
          throw $p;
        }
      }
      return tmp;
    }
    return null;
  }
  ddf(s, props) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
      var _iterator__ex2g4s = this.pdg().p1();
      while (_iterator__ex2g4s.q1()) {
        var format = _iterator__ex2g4s.r1();
        if (format.ldf(sliceStart_0(s), props)) {
          var s_0 = sliceStart_0(s);
          tmp$ret$0 = format.ddf(sliceStart_0(s_0), props);
          break $l$block;
        }
      }
      throw UnsupportedOperationException.a1('No suitable image format : MAGIC:' + readString_0(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes(sliceStart_0(s), 4)) + ') (' + toString_2(readBytes(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
    }
    return tmp$ret$0;
  }
}
class ImageFormatsMutable extends ImageFormats {
  constructor() {
    return new.target.vdg();
  }
  static vdg() {
    var $this = this.odg([]);
    $this.udg_1 = new NonRecursiveLock();
    return $this;
  }
  static wdg(formats) {
    var $this = this.vdg();
    $this.xdg(formats.slice());
    return $this;
  }
  xdg(formats) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.udg_1.i9w_1;
    this.mdg(minus(plus_0(this.ldg(), formats), this));
    return this;
  }
}
class Companion_24 {
  ydg(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) {
    return ImageFrame.zdg(index, time, fastArrayListOf([new ImageFrameLayer(new ImageLayer(0, null, Type_NORMAL_getInstance()), slice(bitmap, VOID, name), targetX, targetY, main, includeInAtlas)]));
  }
  ede(bitmap, time, targetX, targetY, main, includeInAtlas, name, index, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    name = name === VOID ? null : name;
    index = index === VOID ? 0 : index;
    return $super === VOID ? this.ydg(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) : $super.ydg.call(this, bitmap, new Duration(time), targetX, targetY, main, includeInAtlas, name, index);
  }
}
class ImageFrame {
  constructor(index, fastTime, layerData) {
    return new.target.cde(index, fastTime, layerData);
  }
  static cde(index, fastTime, layerData) {
    fastTime = fastTime === VOID ? get_fastSeconds(0) : fastTime;
    layerData = layerData === VOID ? emptyList() : layerData;
    var $this = createThis(this);
    $this.idd_1 = new Mixin();
    $this.jdd_1 = index;
    $this.kdd_1 = fastTime;
    $this.ldd_1 = layerData;
    $this.mdd_1 = firstOrNull_0($this.ldd_1);
    return $this;
  }
  o9u(_set____db54di) {
    this.idd_1.o9u(_set____db54di);
  }
  p9u() {
    return this.idd_1.p9u();
  }
  adh() {
    return toDuration_0(this.kdd_1);
  }
  static zdg(index, time, layerData) {
    layerData = layerData === VOID ? emptyList() : layerData;
    return this.cde(index, get_fast(time), layerData);
  }
  bdh() {
    var tmp177_safe_receiver = this.mdd_1;
    var tmp0_elvis_lhs = tmp177_safe_receiver == null ? null : tmp177_safe_receiver.wdd_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  cdh() {
    var tmp178_safe_receiver = this.mdd_1;
    var tmp0_elvis_lhs = tmp178_safe_receiver == null ? null : tmp178_safe_receiver.odd_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  ddh() {
    var tmp179_safe_receiver = this.mdd_1;
    var tmp0_elvis_lhs = tmp179_safe_receiver == null ? null : tmp179_safe_receiver.pdd_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  hde() {
    var tmp180_safe_receiver = this.mdd_1;
    var tmp0_elvis_lhs = tmp180_safe_receiver == null ? null : tmp180_safe_receiver.qdd_1;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  w9z() {
    return this.bdh().qaj_1;
  }
  x9z() {
    return this.bdh().raj_1;
  }
  gde() {
    var tmp182_safe_receiver = this.mdd_1;
    var tmp0_elvis_lhs = tmp182_safe_receiver == null ? null : tmp182_safe_receiver.gde();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      tmp = get_bmp(tmp$ret$0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  h1() {
    return this.bdh().laj_1;
  }
  toString() {
    return 'ImageFrame(' + this.bdh().toString() + ', time=' + Duration__toString_impl_8d916b(this.adh()) + ', targetX=' + this.cdh() + ', targetY=' + this.ddh() + ', main=' + this.hde() + ')';
  }
}
class ImageFrameLayer {
  constructor(layer, slice, targetX, targetY, main, includeInAtlas, tilemap, ninePatchSlice) {
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    tilemap = tilemap === VOID ? null : tilemap;
    ninePatchSlice = ninePatchSlice === VOID ? null : ninePatchSlice;
    this.ndd_1 = layer;
    this.odd_1 = targetX;
    this.pdd_1 = targetY;
    this.qdd_1 = main;
    this.rdd_1 = includeInAtlas;
    this.sdd_1 = tilemap;
    this.tdd_1 = ninePatchSlice;
    this.udd_1 = null;
    this.vdd_1 = null;
    this.wdd_1 = slice;
  }
  w9z() {
    return this.wdd_1.qaj_1;
  }
  x9z() {
    return this.wdd_1.raj_1;
  }
  gde() {
    if (get_bmp(this.wdd_1).sc1_1 === this.w9z() && get_bmp(this.wdd_1).tc1_1 === this.x9z())
      return get_bmp(this.wdd_1);
    if (this.udd_1 == null)
      this.udd_1 = extract_0(this.wdd_1);
    return ensureNotNull(this.udd_1);
  }
}
class ImageInfo {
  constructor() {
    this.hdf_1 = new Mixin();
    this.idf_1 = 0;
    this.jdf_1 = 0;
    this.kdf_1 = 8;
  }
  o9u(_set____db54di) {
    this.hdf_1.o9u(_set____db54di);
  }
  p9u() {
    return this.hdf_1.p9u();
  }
  toString() {
    var tmp = this.idf_1;
    var tmp_0 = this.jdf_1;
    var tmp_1 = this.kdf_1;
    var tmp183_safe_receiver = this.p9u();
    return 'ImageInfo(width=' + tmp + ', height=' + tmp_0 + ', bpp=' + tmp_1 + ', extra=' + toString(tmp183_safe_receiver == null ? null : toMap_0(tmp183_safe_receiver)) + ')';
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_31 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.edh_1 = [Type_NORMAL_getInstance(), Type_GROUP_getInstance(), Type_TILEMAP_getInstance()];
  }
}
class Type extends Enum {}
class ImageLayer {
  constructor(index, name, type) {
    type = type === VOID ? Type_NORMAL_getInstance() : type;
    this.fdd_1 = index;
    this.gdd_1 = name;
    this.hdd_1 = type;
  }
}
class NativeImageFormatProvider {
  *fdh(data, props, $completion) {
    if (props.udf_1 || props.tdf_1 === false) {
      return this.gdh(get_RegisteredImageFormats().ndf(data, props), props);
    }
    var image = yield* decodeBytes(Companion_instance_4, data, $completion);
    return this.gdh(this.hdh(image, props), props);
  }
  hdh(_this__u8e3s4, props) {
    return this.idh(_this__u8e3s4, props);
  }
  idh(image, props) {
    return this.jdh(toBitmap(image.pbk()), props);
  }
  *kdh(vfs, path, props, $completion) {
    return yield* this.fdh(yield* vfs.cbg(path).rbh($completion), props, $completion);
  }
  *ldh(data, props, $completion) {
    return (yield* this.fdh(data, props, $completion)).mdh_1;
  }
  odf(data, props, $completion) {
    return this.ldh(data, props, $completion);
  }
  *pdh(file, props, $completion) {
    return (yield* this.kdh(file.ibf(), file.obf(), props, $completion)).mdh_1;
  }
  *pdf(file, props, $completion) {
    return yield* this.pdh(yield* getUnderlyingUnscapedFile(file, $completion), props, $completion);
  }
  qcf(width, height, premultiplied) {
    return BitmapNativeImage.gdi(Bitmap32.lc1(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  scf(bmp) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.qcf(bmp.sc1_1, bmp.tc1_1, bmp.yc1_1);
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_0.wc1_1;
    if (true) {
      this_0.fc2();
    }
    var result;
    try {
      var ctx = this_0.oc9(true);
      try {
        ctx.hdi(bmp, Companion_getInstance_6().g9h_1);
      }finally {
        ctx.u1o();
      }
    }finally {
      result = true ? this_0.hc2(rect) : 0;
    }
    return this_0;
  }
  idi(bmp) {
    return BitmapNativeImage.jdi(bmp);
  }
  jdh(_this__u8e3s4, props) {
    var tmp;
    var tmp_0;
    if (_this__u8e3s4 instanceof NativeImage) {
      tmp_0 = !props.udf_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = props.tdf_1 == null || props.tdf_1 === _this__u8e3s4.yc1_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      return _this__u8e3s4;
    }
    var out = _this__u8e3s4.pc9();
    if (props.udf_1) {
      asumePremultiplied(out);
    } else if (!_this__u8e3s4.yc1_1 && props.tdf_1 === false) {
      out.wcc();
    } else if (_this__u8e3s4.yc1_1 && props.tdf_1 === true) {
      out.vcc();
    }
    return this.idi(out);
  }
  gdh(_this__u8e3s4, props) {
    return new NativeImageResult(this.jdh(_this__u8e3s4, props));
  }
}
class NativeImageResult {
  constructor(image, originalWidth, originalHeight) {
    originalWidth = originalWidth === VOID ? image.sc1_1 : originalWidth;
    originalHeight = originalHeight === VOID ? image.tc1_1 : originalHeight;
    this.mdh_1 = image;
    this.ndh_1 = originalWidth;
    this.odh_1 = originalHeight;
  }
  toString() {
    return 'NativeImageResult(image=' + this.mdh_1.toString() + ', originalWidth=' + this.ndh_1 + ', originalHeight=' + this.odh_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.mdh_1);
    result = imul(result, 31) + this.ndh_1 | 0;
    result = imul(result, 31) + this.odh_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NativeImageResult))
      return false;
    var tmp0_other_with_cast = other instanceof NativeImageResult ? other : THROW_CCE();
    if (!equals(this.mdh_1, tmp0_other_with_cast.mdh_1))
      return false;
    if (!(this.ndh_1 === tmp0_other_with_cast.ndh_1))
      return false;
    if (!(this.odh_1 === tmp0_other_with_cast.odh_1))
      return false;
    return true;
  }
}
class BitmapNativeImage extends NativeImage {
  constructor(bitmap) {
    return new.target.gdi(bitmap);
  }
  static gdi(bitmap) {
    var $this = this.pcf(bitmap.sc1_1, bitmap.tc1_1, bitmap, bitmap.yc1_1);
    $this.edi_1 = bitmap;
    $this.fdi_1 = $this.edi_1.ic1_1;
    return $this;
  }
  h1() {
    return 'BitmapNativeImage';
  }
  static jdi(bitmap) {
    return this.gdi(bitmap.pc9());
  }
  oc9(antialiasing) {
    return this.edi_1.oc9(antialiasing);
  }
  ec2() {
    return this.edi_1;
  }
  pc2(x, y, width, height, out, offset) {
    return this.edi_1.pc2(x, y, width, height, out, offset);
  }
  rc2(x, y, width, height, out, offset) {
    return this.edi_1.rc2(x, y, width, height, out, offset);
  }
  sc2(x, y, v) {
    return this.edi_1.sc2(x, y, v);
  }
  qc2(x, y) {
    return this.edi_1.qc2(x, y);
  }
}
class BaseNativeImageFormatProvider extends NativeImageFormatProvider {
  *fdh(data, props, $completion) {
    if (props.udf_1 || props.tdf_1 === false) {
      return this.gdh(get_RegisteredImageFormats().ndf(data, props), props);
    }
    return this.kdi(toBitmap_0(yield* decodeBytes(Companion_instance_4, data, $completion)), props);
  }
  ldi(bmp) {
    return BitmapNativeImage.jdi(bmp);
  }
  kdi(bmp, props) {
    var bmp32 = bmp.pc9();
    return new NativeImageResult(this.ldi(props.udf_1 ? asumePremultiplied(bmp32) : props.ddg() ? bmp32.scc() : bmp32.tcc()));
  }
  qcf(width, height, premultiplied) {
    return this.ldi(Bitmap32.lc1(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  scf(bmp) {
    return this.ldi(bmp);
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_32 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_5();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cd(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$2 = element.odi_1;
      destination.b5(tmp$ret$2, element);
    }
    tmp.qdi_1 = destination;
  }
}
class InterlacedPass {
  constructor(startingRow, startingCol, rowIncrement, colIncrement, blockHeight, blockWidth) {
    this.rdi_1 = startingRow;
    this.sdi_1 = startingCol;
    this.tdi_1 = rowIncrement;
    this.udi_1 = colIncrement;
    this.vdi_1 = blockHeight;
    this.wdi_1 = blockWidth;
    var tmp = this;
    // Inline function 'kotlin.math.log2' call
    var x = this.udi_1;
    var tmp$ret$0 = log2(x);
    tmp.xdi_1 = numberToInt(tmp$ret$0);
  }
  toString() {
    return 'InterlacedPass(startingRow=' + this.rdi_1 + ', startingCol=' + this.sdi_1 + ', rowIncrement=' + this.tdi_1 + ', colIncrement=' + this.udi_1 + ', blockHeight=' + this.vdi_1 + ', blockWidth=' + this.wdi_1 + ')';
  }
  hashCode() {
    var result = this.rdi_1;
    result = imul(result, 31) + this.sdi_1 | 0;
    result = imul(result, 31) + this.tdi_1 | 0;
    result = imul(result, 31) + this.udi_1 | 0;
    result = imul(result, 31) + this.vdi_1 | 0;
    result = imul(result, 31) + this.wdi_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InterlacedPass))
      return false;
    var tmp0_other_with_cast = other instanceof InterlacedPass ? other : THROW_CCE();
    if (!(this.rdi_1 === tmp0_other_with_cast.rdi_1))
      return false;
    if (!(this.sdi_1 === tmp0_other_with_cast.sdi_1))
      return false;
    if (!(this.tdi_1 === tmp0_other_with_cast.tdi_1))
      return false;
    if (!(this.udi_1 === tmp0_other_with_cast.udi_1))
      return false;
    if (!(this.vdi_1 === tmp0_other_with_cast.vdi_1))
      return false;
    if (!(this.wdi_1 === tmp0_other_with_cast.wdi_1))
      return false;
    return true;
  }
}
class Colorspace extends Enum {
  constructor(name, ordinal, id, nchannels) {
    super(name, ordinal);
    this.odi_1 = id;
    this.pdi_1 = nchannels;
  }
}
class Header {
  constructor(width, height, bitsPerChannel, colorspace, compressionmethod, filtermethod, interlacemethod) {
    this.ydi_1 = width;
    this.zdi_1 = height;
    this.adj_1 = bitsPerChannel;
    this.bdj_1 = colorspace;
    this.cdj_1 = compressionmethod;
    this.ddj_1 = filtermethod;
    this.edj_1 = interlacemethod;
    var tmp = this;
    var tmp_0;
    switch (this.bdj_1.w1_1) {
      case 0:
        tmp_0 = 1;
        break;
      case 2:
        tmp_0 = 1;
        break;
      case 3:
        tmp_0 = 2;
        break;
      case 1:
        tmp_0 = 3;
        break;
      case 4:
        tmp_0 = 4;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.fdj_1 = tmp_0;
    this.gdj_1 = imul(imul(this.ydi_1, this.fdj_1), this.adj_1) / 8 | 0;
  }
}
class DecodingContext {
  constructor(header) {
    this.hdj_1 = header;
    this.idj_1 = _UByteArrayInt___init__impl__xif7bu_0(this.hdj_1.gdj_1);
    this.jdj_1 = _UByteArrayInt___init__impl__xif7bu_0(this.hdj_1.gdj_1);
    this.kdj_1 = Companion_instance_14.zcc(this.hdj_1.ydi_1);
  }
  udj() {
    var temp = this.jdj_1;
    this.jdj_1 = this.idj_1;
    this.idj_1 = temp;
  }
}
class PNG extends ImageFormat {
  constructor() {
    return new.target.vdj();
  }
  static vdj() {
    PNG_instance = null;
    var $this = this.cdf(['png']);
    PNG_instance = $this;
    $this.odj_1 = -1991225785;
    $this.pdj_1 = 218765834;
    $this.qdj_1 = listOf([new InterlacedPass(0, 0, 8, 8, 8, 8), new InterlacedPass(0, 4, 8, 8, 8, 4), new InterlacedPass(4, 0, 8, 4, 4, 4), new InterlacedPass(0, 2, 4, 4, 4, 2), new InterlacedPass(2, 0, 4, 2, 2, 2), new InterlacedPass(0, 1, 2, 2, 2, 1), new InterlacedPass(1, 0, 2, 1, 1, 1)]);
    $this.rdj_1 = listOf_0(new InterlacedPass(0, 0, 1, 1, 1, 1));
    return $this;
  }
  fdf(s, props) {
    var tmp;
    try {
      var info = new ImageInfo();
      var tmp_0 = readCommon(this, s, true, info);
      var header = tmp_0 instanceof Header ? tmp_0 : THROW_CCE();
      tmp = info;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var t = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  ddf(s, props) {
    var tmp = Companion_instance_28;
    var tmp_0 = readCommon(this, s, false);
    return tmp.dde([tmp_0 instanceof Bitmap ? tmp_0 : THROW_CCE()]);
  }
  wdj(a, b, c) {
    var p = (a + b | 0) - c | 0;
    var pa = abs(p - a | 0);
    var pb = abs(p - b | 0);
    var pc = abs(p - c | 0);
    return pa <= pb && pa <= pc ? a : pb <= pc ? b : c;
  }
  sdj(filter, p, c, bpp, size) {
    switch (filter) {
      case 0:
        break;
      case 1:
        var inductionVariable = bpp;
        if (inductionVariable < size)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n, UByteArrayInt__get_impl_px6q8a(c, n) + UByteArrayInt__get_impl_px6q8a(c, n - bpp | 0) | 0);
          }
           while (inductionVariable < size);
        break;
      case 2:
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < size)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_0, UByteArrayInt__get_impl_px6q8a(c, n_0) + UByteArrayInt__get_impl_px6q8a(p, n_0) | 0);
          }
           while (inductionVariable_0 < size);
        break;
      case 3:
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < bpp)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_1, UByteArrayInt__get_impl_px6q8a(c, n_1) + (UByteArrayInt__get_impl_px6q8a(p, n_1) / 2 | 0) | 0);
          }
           while (inductionVariable_1 < bpp);
        var inductionVariable_2 = bpp;
        if (inductionVariable_2 < size)
          do {
            var n_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_2, UByteArrayInt__get_impl_px6q8a(c, n_2) + ((UByteArrayInt__get_impl_px6q8a(c, n_2 - bpp | 0) + UByteArrayInt__get_impl_px6q8a(p, n_2) | 0) / 2 | 0) | 0);
          }
           while (inductionVariable_2 < size);
        break;
      case 4:
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < bpp)
          do {
            var n_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_3, UByteArrayInt__get_impl_px6q8a(c, n_3) + UByteArrayInt__get_impl_px6q8a(p, n_3) | 0);
          }
           while (inductionVariable_3 < bpp);
        var inductionVariable_4 = bpp;
        if (inductionVariable_4 < size)
          do {
            var n_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_4, UByteArrayInt__get_impl_px6q8a(c, n_4) + this.wdj(UByteArrayInt__get_impl_px6q8a(c, n_4 - bpp | 0), UByteArrayInt__get_impl_px6q8a(p, n_4), UByteArrayInt__get_impl_px6q8a(p, n_4 - bpp | 0)) | 0);
          }
           while (inductionVariable_4 < size);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Filter: ' + filter;
        throw NotImplementedError.le('An operation is not implemented: ' + reason);
    }
  }
  tdj(filter, p, c, bpp, size, $super) {
    size = size === VOID ? _UByteArrayInt___get_size__impl__bcjnte(c) : size;
    var tmp;
    if ($super === VOID) {
      this.sdj(filter, p, c, bpp, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.sdj.call(this, filter, new UByteArrayInt(p), new UByteArrayInt(c), bpp, size);
    }
    return tmp;
  }
}
class BaseFiller {
  adk(data, offset, x0, x1, y) {
    var yFloat = y;
    var inductionVariable = x0;
    if (inductionVariable <= x1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl_7fwbby(data, offset + n | 0, this.zdj(n, yFloat));
      }
       while (!(n === x1));
  }
  bdk(bmp, rect) {
    var cols = _RgbaPremultipliedArray___init__impl__lx83hy(bmp.ic1_1);
    var inductionVariable = rect.x9h();
    var last = rect.y9h();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var offset = imul(y, bmp.sc1_1);
        this.adk(cols, offset, rect.v9h(), rect.w9h() - 1 | 0, y);
      }
       while (inductionVariable < last);
  }
  cdk(bmp, rect, $super) {
    rect = rect === VOID ? bmp.kc1_1 : rect;
    var tmp;
    if ($super === VOID) {
      this.bdk(bmp, rect);
      tmp = Unit_instance;
    } else {
      tmp = $super.bdk.call(this, bmp, rect);
    }
    return tmp;
  }
}
class ColorFiller extends BaseFiller {
  constructor() {
    super();
    this.xdj_1 = _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().bc3_1);
  }
  ydj(fill, state) {
    // Inline function 'kotlin.apply' call
    this.xdj_1 = _RGBA___get_premultiplied__impl__3bulqc(_RGBA___get_color__impl__8x3sb3(fill));
    return this;
  }
  zdj(x, y) {
    return this.xdj_1;
  }
  adk(data, offset, x0, x1, y) {
    RgbaPremultipliedArray__fill_impl_sem38t(data, this.xdj_1, offset + x0 | 0, (offset + x1 | 0) + 1 | 0);
  }
}
class Companion_27 {
  constructor() {
    this.ddk_1 = 256;
  }
}
class GradientFiller extends BaseFiller {
  constructor() {
    super();
    this.edk_1 = Companion_instance_13.kcj(256);
  }
  gdk(fill, state) {
    fill.hdk(this.edk_1);
    this.fdk_1 = fill.idk(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_5().v9k_1.n9m(fill.ed8_1).n9m(state.kcl_1));
    return this;
  }
  jdk(x, y) {
    return _get_fill__d6ivc8(this).kdk(Vector2D.d9m(x, y));
  }
  zdj(x, y) {
    return color(this, this.jdk(x, y));
  }
}
class BitmapFiller extends BaseFiller {
  constructor() {
    super();
    this.ldk_1 = _CycleMethodPair___init__impl__y6jlco_0(CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_getInstance());
    this.mdk_1 = 0.0;
    this.ndk_1 = 0.0;
    this.odk_1 = 0.0;
    this.pdk_1 = 0.0;
    var tmp = this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    tmp.qdk_1 = get_bmp(tmp$ret$0);
    this.rdk_1 = Companion_getInstance_5().v9k_1;
    this.sdk_1 = true;
    this.tdk_1 = Companion_getInstance_5().v9k_1;
  }
  udk(fill, state) {
    // Inline function 'kotlin.apply' call
    this.ldk_1 = _CycleMethodPair___init__impl__y6jlco_0(fill.xdk_1, fill.ydk_1);
    _set_texture__qu271y(this, fill.bdl_1);
    this.rdk_1 = fill.wdk_1;
    this.sdk_1 = fill.zdk_1;
    this.tdk_1 = Companion_getInstance_5().v9k_1.f9m(state.kcl_1).f9m(fill.wdk_1).h9m();
    return this;
  }
  cdl(x, y) {
    return this.qdk_1.yc2(x, y);
  }
  ddl(x, y) {
    return this.qdk_1.hcb(numberToInt(x), numberToInt(y));
  }
  zdj(x, y) {
    var mat = this.tdk_1;
    var tmp2 = Vector2D.d9m(x, y);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      if (mat.t9h()) {
        tmp$ret$0 = tmp2;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.t9g(mat.m9l(tmp2.r9g_1, tmp2.s9g_1), mat.p9l(tmp2.r9g_1, tmp2.s9g_1));
    }
    var tmp0 = tmp$ret$0;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var that = Vector2D.d9m(this.odk_1, this.pdk_1);
    var p = Vector2D.t9g(tmp0.r9g_1 * that.r9g_1, tmp0.s9g_1 * that.s9g_1);
    var tmp0_0 = CycleMethodPair__apply_impl_g3sekg(this.ldk_1, p);
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var that_0 = Vector2D.d9m(this.mdk_1, this.ndk_1);
    var t = Vector2D.t9g(tmp0_0.r9g_1 * that_0.r9g_1, tmp0_0.s9g_1 * that_0.s9g_1);
    return this.sdk_1 ? _RGBA___get_premultiplied__impl__3bulqc(this.cdl(t.r9g_1, t.s9g_1)) : _RGBA___get_premultiplied__impl__3bulqc(this.ddl(t.r9g_1, t.s9g_1));
  }
}
class NoneFiller extends BaseFiller {
  constructor() {
    NoneFiller_instance = null;
    super();
    NoneFiller_instance = this;
  }
  zdj(x, y) {
    return _RGBAPremultiplied___init__impl__uos02x(0);
  }
  adk(data, offset, x0, x1, y) {
    return Unit_instance;
  }
}
class NonePaint {
  g9m() {
    return this;
  }
}
class TransformedPaint {}
class BitmapPaint {
  constructor(bitmap, transform, cycleX, cycleY, smooth, units) {
    transform = transform === VOID ? Companion_getInstance_5().v9k_1 : transform;
    cycleX = cycleX === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleX;
    cycleY = cycleY === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleY;
    smooth = smooth === VOID ? true : smooth;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    this.vdk_1 = bitmap;
    this.wdk_1 = transform;
    this.xdk_1 = cycleX;
    this.ydk_1 = cycleY;
    this.zdk_1 = smooth;
    this.adl_1 = units;
    this.bdl_1 = this.vdk_1.ec2();
  }
  acw() {
    return this.wdk_1;
  }
  edl() {
    return this.xdk_1.hdl();
  }
  idl() {
    return this.ydk_1.hdl();
  }
  g9m() {
    return this.jdl(VOID, this.wdk_1);
  }
  toString() {
    return 'BitmapPaint(' + toString_0(this.vdk_1) + ', cycle=(' + this.xdk_1.toString() + ', ' + this.ydk_1.toString() + '), smooth=' + this.zdk_1 + ', transform=' + this.wdk_1.toString() + ')';
  }
  kdl(bitmap, transform, cycleX, cycleY, smooth, units) {
    return new BitmapPaint(bitmap, transform, cycleX, cycleY, smooth, units);
  }
  jdl(bitmap, transform, cycleX, cycleY, smooth, units, $super) {
    bitmap = bitmap === VOID ? this.vdk_1 : bitmap;
    transform = transform === VOID ? this.wdk_1 : transform;
    cycleX = cycleX === VOID ? this.xdk_1 : cycleX;
    cycleY = cycleY === VOID ? this.ydk_1 : cycleY;
    smooth = smooth === VOID ? this.zdk_1 : smooth;
    units = units === VOID ? this.adl_1 : units;
    return $super === VOID ? this.kdl(bitmap, transform, cycleX, cycleY, smooth, units) : $super.kdl.call(this, bitmap, transform, cycleX, cycleY, smooth, units);
  }
  hashCode() {
    var result = hashCode(this.vdk_1);
    result = imul(result, 31) + this.wdk_1.hashCode() | 0;
    result = imul(result, 31) + this.xdk_1.hashCode() | 0;
    result = imul(result, 31) + this.ydk_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.zdk_1) | 0;
    result = imul(result, 31) + this.adl_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapPaint))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapPaint ? other : THROW_CCE();
    if (!equals(this.vdk_1, tmp0_other_with_cast.vdk_1))
      return false;
    if (!this.wdk_1.equals(tmp0_other_with_cast.wdk_1))
      return false;
    if (!this.xdk_1.equals(tmp0_other_with_cast.xdk_1))
      return false;
    if (!this.ydk_1.equals(tmp0_other_with_cast.ydk_1))
      return false;
    if (!(this.zdk_1 === tmp0_other_with_cast.zdk_1))
      return false;
    if (!this.adl_1.equals(tmp0_other_with_cast.adl_1))
      return false;
    return true;
  }
}
class Companion_28 {}
class GradientPaint {
  constructor(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    stops = stops === VOID ? DoubleArrayList.ga3() : stops;
    colors = colors === VOID ? IntArrayList.za1() : colors;
    cycle = cycle === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycle;
    transform = transform === VOID ? Companion_getInstance_5().v9k_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? GradientInterpolationMethod_NORMAL_getInstance() : interpolationMethod;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    startAngle = startAngle === VOID ? Companion_getInstance_8().x9g_1 : startAngle;
    this.ud7_1 = kind;
    this.vd7_1 = x0;
    this.wd7_1 = y0;
    this.xd7_1 = r0;
    this.yd7_1 = x1;
    this.zd7_1 = y1;
    this.ad8_1 = r1;
    this.bd8_1 = stops;
    this.cd8_1 = colors;
    this.dd8_1 = cycle;
    this.ed8_1 = transform;
    this.fd8_1 = interpolationMethod;
    this.gd8_1 = units;
    this.hd8_1 = startAngle;
    var tmp = this;
    var tmp_0 = Companion_getInstance_5().v9k_1.a9m(-this.vd7_1, -this.wd7_1).v9l(1.0 / clamp_1(Companion_getInstance_6().y9q(this.vd7_1, this.wd7_1, this.yd7_1, this.zd7_1), 1.0, 16000.0));
    Companion_getInstance_8();
    var tmp2 = this.vd7_1;
    var tmp4 = this.wd7_1;
    var tmp6 = this.yd7_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var y1_0 = this.zd7_1;
    var up = Companion_getInstance_6().k9h_1;
    var tmp$ret$0 = Angle_between(tmp2, tmp4, tmp6, y1_0, up);
    tmp.id8_1 = tmp_0.s9l(Angle__unaryMinus_impl_7901fr(tmp$ret$0));
    this.jd8_1 = this.ed8_1.h9m();
    this.kd8_1 = Companion_getInstance_5().v9k_1.f9m(this.id8_1).f9m(this.jd8_1);
    this.ld8_1 = 2 * this.xd7_1 * this.ad8_1;
    this.md8_1 = this.ldl(this.xd7_1);
    this.nd8_1 = this.ldl(this.ad8_1);
    this.od8_1 = this.wd7_1 - this.zd7_1;
    this.pd8_1 = this.xd7_1 - this.ad8_1;
    this.qd8_1 = this.vd7_1 - this.yd7_1;
    this.rd8_1 = 1.0 / (this.ldl(this.xd7_1 - this.ad8_1) - this.ldl(this.vd7_1 - this.yd7_1) - this.ldl(this.wd7_1 - this.zd7_1));
  }
  acw() {
    return this.ed8_1;
  }
  hdk(out) {
    return _fillColors(Companion_instance_34, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(out), this.bd8_1, this.cd8_1, true);
  }
  sd8(stop, color) {
    return this.mdl(stop, color);
  }
  mdl(stop, color) {
    this.bd8_1.pa3(stop);
    this.cd8_1.ja2(_RGBA___get_value__impl__hhco8v(color));
    return this;
  }
  kdk(p) {
    var tmp;
    switch (this.ud7_1.w1_1) {
      case 2:
        var tmp0 = this.jd8_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          if (tmp0.t9h()) {
            tmp$ret$0 = p;
            break $l$block;
          }
          tmp$ret$0 = Vector2D.t9g(tmp0.m9l(p.r9g_1, p.s9g_1), tmp0.p9l(p.r9g_1, p.s9g_1));
        }

        var p_0 = tmp$ret$0;
        tmp = Angle__div_impl_ut2btd(Companion_getInstance_6().t9s(Vector2D.t9g(this.vd7_1, this.wd7_1), p_0), get_degrees(360));
        break;
      case 1:
        var tmp0_0 = this.jd8_1;
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          if (tmp0_0.t9h()) {
            tmp$ret$1 = p;
            break $l$block_0;
          }
          tmp$ret$1 = Vector2D.t9g(tmp0_0.m9l(p.r9g_1, p.s9g_1), tmp0_0.p9l(p.r9g_1, p.s9g_1));
        }

        var _destruct__k2r9zo = tmp$ret$1;
        var x = _destruct__k2r9zo.jm();
        var y = _destruct__k2r9zo.km();
        var tmp_0 = -this.ad8_1 * this.pd8_1 + this.qd8_1 * (this.yd7_1 - x) + this.od8_1 * (this.zd7_1 - y);
        // Inline function 'kotlin.math.sqrt' call

        var x_0 = this.nd8_1 * (this.ldl(this.vd7_1 - x) + this.ldl(this.wd7_1 - y)) - this.ld8_1 * ((this.vd7_1 - x) * (this.yd7_1 - x) + (this.wd7_1 - y) * (this.zd7_1 - y)) + this.md8_1 * (this.ldl(this.yd7_1 - x) + this.ldl(this.zd7_1 - y)) - this.ldl(this.yd7_1 * this.wd7_1 - x * this.wd7_1 - this.vd7_1 * this.zd7_1 + x * this.zd7_1 + this.vd7_1 * y - this.yd7_1 * y);
        tmp = 1.0 - (tmp_0 - Math.sqrt(x_0)) * this.rd8_1;
        break;
      default:
        tmp = this.kd8_1.l9l(p);
        break;
    }
    return this.dd8_1.ndl(tmp);
  }
  ldl(_this__u8e3s4) {
    return _this__u8e3s4 * _this__u8e3s4;
  }
  g9m() {
    return this.idk(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.ed8_1);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    var tmp;
    switch (this.ud7_1.w1_1) {
      case 0:
        tmp = 'LinearGradient([' + this.vd7_1 + ', ' + this.wd7_1 + '], [' + this.yd7_1 + ', ' + this.zd7_1 + ']';
        break;
      case 1:
        tmp = 'RadialGradient([' + this.vd7_1 + ', ' + this.wd7_1 + ', ' + this.xd7_1 + '], [' + this.yd7_1 + ', ' + this.zd7_1 + ', ' + this.ad8_1 + ']';
        break;
      case 2:
        tmp = 'ConicGradient([' + this.vd7_1 + ', ' + this.wd7_1 + ']';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this_0.m1(tmp);
    this_0.m1(', stops=' + this.bd8_1.toString() + ', colors=' + colorsToString_0(this, this.cd8_1) + ', cycle=' + this.dd8_1.toString() + ', transform=' + this.ed8_1.toString() + ', interpolationMethod=' + this.fd8_1.toString() + ', units=' + this.gd8_1.toString() + ')');
    return this_0.toString();
  }
  odl(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    return new GradientPaint(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle);
  }
  idk(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle, $super) {
    kind = kind === VOID ? this.ud7_1 : kind;
    x0 = x0 === VOID ? this.vd7_1 : x0;
    y0 = y0 === VOID ? this.wd7_1 : y0;
    r0 = r0 === VOID ? this.xd7_1 : r0;
    x1 = x1 === VOID ? this.yd7_1 : x1;
    y1 = y1 === VOID ? this.zd7_1 : y1;
    r1 = r1 === VOID ? this.ad8_1 : r1;
    stops = stops === VOID ? this.bd8_1 : stops;
    colors = colors === VOID ? this.cd8_1 : colors;
    cycle = cycle === VOID ? this.dd8_1 : cycle;
    transform = transform === VOID ? this.ed8_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? this.fd8_1 : interpolationMethod;
    units = units === VOID ? this.gd8_1 : units;
    startAngle = startAngle === VOID ? this.hd8_1 : startAngle;
    return $super === VOID ? this.odl(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) : $super.odl.call(this, kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, new Angle(startAngle));
  }
  hashCode() {
    var result = this.ud7_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.vd7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.wd7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.xd7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.yd7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.zd7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ad8_1) | 0;
    result = imul(result, 31) + this.bd8_1.hashCode() | 0;
    result = imul(result, 31) + this.cd8_1.hashCode() | 0;
    result = imul(result, 31) + this.dd8_1.hashCode() | 0;
    result = imul(result, 31) + this.ed8_1.hashCode() | 0;
    result = imul(result, 31) + this.fd8_1.hashCode() | 0;
    result = imul(result, 31) + this.gd8_1.hashCode() | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.hd8_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GradientPaint))
      return false;
    var tmp0_other_with_cast = other instanceof GradientPaint ? other : THROW_CCE();
    if (!this.ud7_1.equals(tmp0_other_with_cast.ud7_1))
      return false;
    if (!equals(this.vd7_1, tmp0_other_with_cast.vd7_1))
      return false;
    if (!equals(this.wd7_1, tmp0_other_with_cast.wd7_1))
      return false;
    if (!equals(this.xd7_1, tmp0_other_with_cast.xd7_1))
      return false;
    if (!equals(this.yd7_1, tmp0_other_with_cast.yd7_1))
      return false;
    if (!equals(this.zd7_1, tmp0_other_with_cast.zd7_1))
      return false;
    if (!equals(this.ad8_1, tmp0_other_with_cast.ad8_1))
      return false;
    if (!this.bd8_1.equals(tmp0_other_with_cast.bd8_1))
      return false;
    if (!this.cd8_1.equals(tmp0_other_with_cast.cd8_1))
      return false;
    if (!this.dd8_1.equals(tmp0_other_with_cast.dd8_1))
      return false;
    if (!this.ed8_1.equals(tmp0_other_with_cast.ed8_1))
      return false;
    if (!this.fd8_1.equals(tmp0_other_with_cast.fd8_1))
      return false;
    if (!this.gd8_1.equals(tmp0_other_with_cast.gd8_1))
      return false;
    if (!equals(this.hd8_1, tmp0_other_with_cast.hd8_1))
      return false;
    return true;
  }
}
class GradientKind extends Enum {}
class GradientUnits extends Enum {}
class GradientInterpolationMethod extends Enum {}
class Companion_29 {
  constructor() {
    Companion_instance_35 = this;
    this.ocr_1 = listOf([new HorizontalAlign(Companion_getInstance_46().qdl_1), new HorizontalAlign(Companion_getInstance_46().rdl_1), new HorizontalAlign(Companion_getInstance_46().sdl_1), new HorizontalAlign(Companion_getInstance_46().pdl_1)]);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.ocr_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var it = item.vdl_1;
      var tmp$ret$2 = new TextAlignment(it, Companion_getInstance_47().wdl_1);
      destination.d2(tmp$ret$2);
    }
    tmp.pcr_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.ocr_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.n2(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_0 = this_1.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item_0 = _iterator__ex2g4s_0.r1();
      var it_0 = item_0.vdl_1;
      var tmp$ret$5 = new TextAlignment(it_0, Companion_getInstance_47().zdl_1);
      destination_0.d2(tmp$ret$5);
    }
    tmp_0.qcr_1 = destination_0;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = this.ocr_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList.n2(collectionSizeOrDefault(this_2, 10));
    var _iterator__ex2g4s_1 = this_2.p1();
    while (_iterator__ex2g4s_1.q1()) {
      var item_1 = _iterator__ex2g4s_1.r1();
      var it_1 = item_1.vdl_1;
      var tmp$ret$8 = new TextAlignment(it_1, Companion_getInstance_47().xdl_1);
      destination_1.d2(tmp$ret$8);
    }
    tmp_1.rcr_1 = destination_1;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.map' call
    var this_3 = this.ocr_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList.n2(collectionSizeOrDefault(this_3, 10));
    var _iterator__ex2g4s_2 = this_3.p1();
    while (_iterator__ex2g4s_2.q1()) {
      var item_2 = _iterator__ex2g4s_2.r1();
      var it_2 = item_2.vdl_1;
      var tmp$ret$11 = new TextAlignment(it_2, Companion_getInstance_47().ydl_1);
      destination_2.d2(tmp$ret$11);
    }
    tmp_2.scr_1 = destination_2;
    this.tcr_1 = plus(plus(plus(this.pcr_1, this.qcr_1), this.rcr_1), this.scr_1);
    this.ucr_1 = this.pcr_1.u2(0);
    this.vcr_1 = this.pcr_1.u2(1);
    this.wcr_1 = this.pcr_1.u2(2);
    this.xcr_1 = this.pcr_1.u2(3);
    this.ycr_1 = this.qcr_1.u2(0);
    this.zcr_1 = this.qcr_1.u2(1);
    this.acs_1 = this.qcr_1.u2(2);
    this.bcs_1 = this.qcr_1.u2(3);
    this.ccs_1 = this.pcr_1.u2(0);
    this.dcs_1 = this.pcr_1.u2(1);
    this.ecs_1 = this.pcr_1.u2(2);
    this.fcs_1 = this.pcr_1.u2(3);
    this.gcs_1 = this.rcr_1.u2(0);
    this.hcs_1 = this.rcr_1.u2(1);
    this.ics_1 = this.rcr_1.u2(2);
    this.jcs_1 = this.rcr_1.u2(3);
    this.kcs_1 = this.scr_1.u2(0);
    this.lcs_1 = this.scr_1.u2(1);
    this.mcs_1 = this.scr_1.u2(2);
    this.ncs_1 = this.scr_1.u2(3);
  }
  cdm(horizontal, vertical) {
    var tmp;
    if (equals(horizontal, Companion_getInstance_46().qdl_1)) {
      tmp = 0;
    } else if (equals(horizontal, Companion_getInstance_46().rdl_1)) {
      tmp = 1;
    } else if (equals(horizontal, Companion_getInstance_46().sdl_1)) {
      tmp = 2;
    } else if (equals(horizontal, Companion_getInstance_46().pdl_1)) {
      tmp = 3;
    } else {
      return new TextAlignment(horizontal, vertical);
    }
    var horizontalIndex = tmp;
    return equals(vertical, Companion_getInstance_47().wdl_1) ? this.pcr_1.u2(horizontalIndex) : equals(vertical, Companion_getInstance_47().zdl_1) ? this.qcr_1.u2(horizontalIndex) : equals(vertical, Companion_getInstance_47().xdl_1) ? this.rcr_1.u2(horizontalIndex) : equals(vertical, Companion_getInstance_47().ydl_1) ? this.scr_1.u2(horizontalIndex) : new TextAlignment(horizontal, vertical);
  }
}
class TextAlignment {
  constructor(horizontal, vertical) {
    Companion_getInstance_45();
    this.ict_1 = horizontal;
    this.jct_1 = vertical;
    this.kct_1 = Anchor2D.p9g(_HorizontalAlign___get_ratioFake__impl__h46z0d(this.ict_1), _VerticalAlign___get_ratioFake__impl__1h2fwv(this.jct_1));
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.jct_1) + '_' + HorizontalAlign__toString_impl_toflc0(this.ict_1);
  }
  hashCode() {
    var result = HorizontalAlign__hashCode_impl_7x9oj5(this.ict_1);
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.jct_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextAlignment))
      return false;
    var tmp0_other_with_cast = other instanceof TextAlignment ? other : THROW_CCE();
    if (!equals(this.ict_1, tmp0_other_with_cast.ict_1))
      return false;
    if (!equals(this.jct_1, tmp0_other_with_cast.jct_1))
      return false;
    return true;
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_36 = this;
    this.pdl_1 = _HorizontalAlign___init__impl__ad654o(-1.0 / 2048.0);
    this.qdl_1 = _HorizontalAlign___init__impl__ad654o(0.0);
    this.rdl_1 = _HorizontalAlign___init__impl__ad654o(0.5);
    this.sdl_1 = _HorizontalAlign___init__impl__ad654o(1.0);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.tdl_1 = [new HorizontalAlign(this.qdl_1), new HorizontalAlign(this.rdl_1), new HorizontalAlign(this.sdl_1), new HorizontalAlign(this.pdl_1)];
    this.udl_1 = toList_1(this.tdl_1);
  }
}
class HorizontalAlign {
  constructor(ratio) {
    Companion_getInstance_46();
    this.vdl_1 = ratio;
  }
  toString() {
    return HorizontalAlign__toString_impl_toflc0(this.vdl_1);
  }
  hashCode() {
    return HorizontalAlign__hashCode_impl_7x9oj5(this.vdl_1);
  }
  equals(other) {
    return HorizontalAlign__equals_impl_hkfbhv(this.vdl_1, other);
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_37 = this;
    this.wdl_1 = _VerticalAlign___init__impl__f42kfq(0.0);
    this.xdl_1 = _VerticalAlign___init__impl__f42kfq(0.5);
    this.ydl_1 = _VerticalAlign___init__impl__f42kfq(1.0);
    this.zdl_1 = _VerticalAlign___init__impl__f42kfq(Infinity);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.adm_1 = [new VerticalAlign(this.wdl_1), new VerticalAlign(this.xdl_1), new VerticalAlign(this.zdl_1), new VerticalAlign(this.ydl_1)];
    this.bdm_1 = toList_1(this.adm_1);
  }
}
class VerticalAlign {
  constructor(ratio) {
    Companion_getInstance_47();
    this.ddm_1 = ratio;
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.ddm_1);
  }
  hashCode() {
    return VerticalAlign__hashCode_impl_vx8hj7(this.ddm_1);
  }
  equals(other) {
    return VerticalAlign__equals_impl_xp13z(this.ddm_1, other);
  }
}
class TextRenderer {}
function get_version() {
  return 0;
}
class LineInfo {
  constructor(maxTop, minBottom, maxLineHeight) {
    maxTop = maxTop === VOID ? 0.0 : maxTop;
    minBottom = minBottom === VOID ? 0.0 : minBottom;
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    this.fdm_1 = maxTop;
    this.gdm_1 = minBottom;
    this.hdm_1 = maxLineHeight;
  }
  toString() {
    return 'LineInfo(maxTop=' + this.fdm_1 + ', minBottom=' + this.gdm_1 + ', maxLineHeight=' + this.hdm_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.fdm_1);
    result = imul(result, 31) + getNumberHashCode(this.gdm_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.hdm_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineInfo))
      return false;
    var tmp0_other_with_cast = other instanceof LineInfo ? other : THROW_CCE();
    if (!equals(this.fdm_1, tmp0_other_with_cast.fdm_1))
      return false;
    if (!equals(this.gdm_1, tmp0_other_with_cast.gdm_1))
      return false;
    if (!equals(this.hdm_1, tmp0_other_with_cast.hdm_1))
      return false;
    return true;
  }
}
class Entry_0 {
  constructor(tex, x, y, sx, sy, rot) {
    var tmp;
    if (tex === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tex;
    }
    tex = tmp;
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    sx = sx === VOID ? 1.0 : sx;
    sy = sy === VOID ? 1.0 : sy;
    rot = rot === VOID ? get_radians(0) : rot;
    this.idm_1 = tex;
    this.jdm_1 = x;
    this.kdm_1 = y;
    this.ldm_1 = sx;
    this.mdm_1 = sy;
    this.ndm_1 = rot;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    this_0.m1('Entry(');
    this_0.m1("'" + this.idm_1.laj_1 + "', " + numberToInt(this.jdm_1) + ', ' + numberToInt(this.kdm_1) + ', ' + this.idm_1.qaj_1 + ', ' + this.idm_1.raj_1);
    if (!(this.ldm_1 === 1.0)) {
      this_0.m1(', sx=' + get_niceStr_0(this.ldm_1));
    }
    if (!(this.mdm_1 === 1.0)) {
      this_0.m1(', sy=' + get_niceStr_0(this.mdm_1));
    }
    if (!equals(this.ndm_1, get_radians(0))) {
      this_0.m1(', rot=' + get_niceStr_0(_Angle___get_degrees__impl__qg56vw(this.ndm_1)));
    }
    this_0.m1(')');
    return this_0.toString();
  }
  hashCode() {
    var result = this.idm_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.jdm_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.kdm_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ldm_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.mdm_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.ndm_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_0))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_0 ? other : THROW_CCE();
    if (!this.idm_1.equals(tmp0_other_with_cast.idm_1))
      return false;
    if (!equals(this.jdm_1, tmp0_other_with_cast.jdm_1))
      return false;
    if (!equals(this.kdm_1, tmp0_other_with_cast.kdm_1))
      return false;
    if (!equals(this.ldm_1, tmp0_other_with_cast.ldm_1))
      return false;
    if (!equals(this.mdm_1, tmp0_other_with_cast.mdm_1))
      return false;
    if (!equals(this.ndm_1, tmp0_other_with_cast.ndm_1))
      return false;
    return true;
  }
}
class Text2TextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.ydm_1 = Companion_getInstance_45().ucr_1;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.zdm_1 = ArrayList.p2();
    this.adn_1 = doubleArrayListOf(new Float64Array([]));
    this.bdn_1 = doubleArrayListOf(new Float64Array([]));
    this.cdn_1 = doubleArrayListOf(new Float64Array([]));
    this.ddn_1 = doubleArrayListOf(new Float64Array([]));
    this.edn_1 = doubleArrayListOf(new Float64Array([]));
    this.fdn_1 = new DoubleVectorArrayList(4);
    this.gdn_1 = MatrixTransform.y9m();
  }
  hdn() {
    return this.ydm_1.jct_1;
  }
  s2() {
    return this.adn_1.s2();
  }
  idn() {
    var out = arrayListOf([new LineInfo()]);
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var this_0 = this.fdn_1;
    var inductionVariable = 0;
    var last = this_0.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var line = numberToInt(this_0.p9j(n, 0));
        while (out.s2() <= line) {
          out.d2(new LineInfo());
        }
        var lineInfo = out.u2(line);
        var top = this_0.p9j(n, 1);
        var bottom = this_0.p9j(n, 2);
        var lineHeight = this_0.p9j(n, 3);
        var tmp = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a = lineInfo.fdm_1;
        tmp.fdm_1 = Math.max(a, top);
        var tmp_0 = lineInfo;
        // Inline function 'kotlin.math.min' call
        var a_0 = lineInfo.gdm_1;
        tmp_0.gdm_1 = Math.min(a_0, bottom);
        var tmp_1 = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a_1 = lineInfo.hdm_1;
        tmp_1.hdm_1 = Math.max(a_1, lineHeight);
      }
       while (inductionVariable < last);
    return out;
  }
  jdn(n) {
    return n >= this.s2() ? Companion_getInstance_4().a9i_1 : Companion_getInstance_4().u9p(this.adn_1.u2(n), this.bdn_1.u2(n), this.adn_1.u2(n) + this.zdm_1.u2(n).qaj_1 * this.cdn_1.u2(n), this.bdn_1.u2(n) + this.zdm_1.u2(n).raj_1 * this.ddn_1.u2(n));
  }
  faf() {
    if (this.s2() === 0) {
      return Companion_getInstance_4().a9i_1;
    }
    var bb = Companion_getInstance_7().e9i();
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        bb = BoundsBuilder__plus_impl_cz7f7x(bb, this.jdn(n));
      }
       while (inductionVariable < last);
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  kdn(n, out) {
    out.idm_1 = this.zdm_1.u2(n);
    out.jdm_1 = this.adn_1.u2(n);
    out.kdm_1 = this.bdn_1.u2(n);
    out.ldm_1 = this.cdn_1.u2(n);
    out.mdm_1 = this.ddn_1.u2(n);
    var tmp = out;
    Companion_getInstance_8();
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    var ratio = this.edn_1.u2(n);
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = toRatio_0(ratio);
    var tmp$ret$1 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp.ndm_1 = _Angle___init__impl__g23q1m(tmp$ret$1);
    return out;
  }
  ldn() {
    this.fcw(Companion_getInstance_6().g9h_1);
    this.zdm_1.a5();
    this.adn_1.a5();
    this.bdn_1.a5();
    this.cdn_1.a5();
    this.ddn_1.a5();
    this.edn_1.a5();
    this.fdn_1.a5();
    this.dcw(0);
  }
  mcv(reader, codePoint) {
    var tmp = this.ccw();
    var bf = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.io.lang.keep' call
      var tmp0_elvis_lhs = reader == null ? null : reader.zb4_1;
      var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      try {
        tmp$ret$0 = this.gcw(reader, codePoint);
        break $l$block;
      }finally {
        if (reader == null)
          null;
        else {
          reader.zb4_1 = old;
        }
      }
    }
    var m = tmp$ret$0;
    var g = bf.u2(codePoint);
    var x = g.vcj_1;
    var tmp_0 = g.wcj_1;
    var tmp295_subject = this.hdn();
    var y = tmp_0 - (equals(tmp295_subject, Companion_getInstance_47().zdl_1) ? bf.qak() : bf.fck() * _VerticalAlign___get_ratio__impl__b3ilr8(this.hdn()));
    var fontScale = this.scv_1 / bf.eck();
    this.gdn_1 = get_immutable(this.acw()).i9m();
    this.zdm_1.d2(g.ucj_1);
    this.adn_1.la3(this.wb5().r9g_1 + this.acw().m9l(x, y) * fontScale);
    this.bdn_1.la3(this.wb5().s9g_1 + this.acw().p9l(x, y) * fontScale);
    this.cdn_1.la3(this.gdn_1.q9m_1 * fontScale);
    this.ddn_1.la3(this.gdn_1.r9m_1 * fontScale);
    this.edn_1.la3(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4(this.gdn_1.u9m_1)));
    this.fdn_1.na3(this.xcv(), this.pcv_1.pck_1, this.pcv_1.tck_1, this.pcv_1.fck());
    return m;
  }
}
class LineStats {
  constructor(maxLineHeight, maxX, bounds) {
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    maxX = maxX === VOID ? 0.0 : maxX;
    bounds = bounds === VOID ? Companion_getInstance_7().e9i() : bounds;
    this.mct_1 = maxLineHeight;
    this.nct_1 = maxX;
    this.oct_1 = bounds;
  }
  pct(align) {
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, this.nct_1) + BoundsBuilder__xminOr_impl_k3l1m2(this.oct_1, 0.0);
  }
  icw(dx) {
    this.nct_1 = this.nct_1 + dx;
  }
  mdn(fontMetrics) {
    var tmp = this;
    var tmp0 = this.mct_1;
    // Inline function 'kotlin.math.max' call
    var b = fontMetrics.fck();
    tmp.mct_1 = Math.max(tmp0, b);
  }
  ndn() {
  }
  ra8() {
    this.nct_1 = 0.0;
    this.oct_1 = Companion_getInstance_7().z9h_1;
    this.mct_1 = 0.0;
  }
  toString() {
    return 'LineStats(maxLineHeight=' + this.mct_1 + ', maxX=' + this.nct_1 + ', bounds=' + BoundsBuilder__toString_impl_fmvxh7(this.oct_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.mct_1);
    result = imul(result, 31) + getNumberHashCode(this.nct_1) | 0;
    result = imul(result, 31) + BoundsBuilder__hashCode_impl_649zbo(this.oct_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineStats))
      return false;
    var tmp0_other_with_cast = other instanceof LineStats ? other : THROW_CCE();
    if (!equals(this.mct_1, tmp0_other_with_cast.mct_1))
      return false;
    if (!equals(this.nct_1, tmp0_other_with_cast.nct_1))
      return false;
    if (!equals(this.oct_1, tmp0_other_with_cast.oct_1))
      return false;
    return true;
  }
}
class BoundBuilderTextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.cct_1 = Companion_getInstance_7().e9i();
    this.dct_1 = Companion_getInstance_7().e9i();
    this.ect_1 = 0;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.fct_1 = ArrayList.p2();
    this.gct_1 = new LineStats();
  }
  hct() {
    return this.ect_1;
  }
  odn() {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s = this.fct_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp = sum;
      sum = tmp + element.mct_1;
    }
    return sum;
  }
  ycv(align, line) {
    var tmp0_elvis_lhs = getOrNull_1(this.fct_1, line);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return HorizontalAlign__getOffsetX_impl_urzzxf(align, 0.0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var line_0 = tmp;
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, line_0.nct_1);
  }
  lct(align, fontMetrics) {
    return VerticalAlign__getOffsetYRespectBaseline_impl_62po5b(align, fontMetrics, this.odn());
  }
  ra8() {
    super.ra8();
    this.ect_1 = 0;
    this.dct_1 = Companion_getInstance_7().z9h_1;
    this.cct_1 = Companion_getInstance_7().z9h_1;
    this.gct_1.ra8();
    this.fct_1.a5();
  }
  mcv(reader, codePoint) {
    var g = this.gcw(reader, codePoint);
    add_0(this, g.dcl_1);
    this.gct_1.mdn(this.pcv_1);
    return g;
  }
  icw(x) {
    super.icw(x);
    this.gct_1.icw(x);
  }
  jcw(y, end) {
    super.jcw(y, end);
    this.ect_1 = this.ect_1 + 1 | 0;
    this.gct_1.mdn(this.pcv_1);
    this.gct_1.ndn();
    this.fct_1.d2(this.gct_1);
    this.gct_1 = new LineStats();
  }
}
class CreateWStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    this.pdn_1 = $getVersion;
    this.qdn_1 = $handler;
  }
  d87() {
    return this.pdn_1();
  }
  rdn(_this__u8e3s4, text, size, defaultFont) {
    _this__u8e3s4.ra8();
    _this__u8e3s4.ecw(defaultFont, size);
    var reader = new WStringReader(text);
    while (reader.b6y()) {
      var c = _WChar___get_codePoint__impl__c8brwu(reader.ib5());
      var c1 = _WChar___get_codePoint__impl__c8brwu(reader.gb5(1));
      var startPos = reader.zb4_1;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(10);
      if (c === Char__toInt_impl_vasixd(this_0)) {
        _this__u8e3s4.jcw(_this__u8e3s4.fck(), false);
      } else {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'korlibs.io.lang.keep' call
          var tmp0_elvis_lhs = reader == null ? null : reader.zb4_1;
          var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
          try {
            tmp$ret$1 = _this__u8e3s4.gcw(reader, c);
            break $l$block;
          }finally {
            if (reader == null)
              null;
            else {
              reader.zb4_1 = old;
            }
          }
        }
        var g = tmp$ret$1;
        _this__u8e3s4.hcw(Companion_getInstance_5().v9k_1);
        this.qdn_1(_this__u8e3s4, reader, c, g, g.ecl_1 + _this__u8e3s4.hcl(c, c1));
      }
      if (reader.zb4_1 <= startPos) {
        reader.kb5(1);
      }
    }
    _this__u8e3s4.jcw(_this__u8e3s4.fck(), true);
  }
  edm(_this__u8e3s4, text, size, defaultFont) {
    return this.rdn(_this__u8e3s4, text instanceof WString ? text : THROW_CCE(), size, defaultFont);
  }
}
class CreateStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    var tmp = this;
    tmp.sdn_1 = CreateWStringTextRenderer($getVersion, CreateStringTextRenderer$o$wstring$lambda($handler));
  }
  d87() {
    return this.sdn_1.d87();
  }
  tdn(_this__u8e3s4, text, size, defaultFont) {
    // Inline function 'kotlin.apply' call
    this.sdn_1.edm(_this__u8e3s4, Companion_getInstance_11().pb5(text), size, defaultFont);
  }
  edm(_this__u8e3s4, text, size, defaultFont) {
    return this.tdn(_this__u8e3s4, (!(text == null) ? typeof text === 'string' : false) ? text : THROW_CCE(), size, defaultFont);
  }
}
class SegmentHandler {
  constructor() {
    this.udn_1 = intArrayListOf(new Int32Array([]));
    this.vdn_1 = intArrayListOf(new Int32Array([]));
    this.ra8();
  }
  s2() {
    return this.udn_1.s2();
  }
  ra8() {
    this.udn_1.a5();
    this.vdn_1.a5();
  }
  baq(x0, x1) {
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var xmin = this.udn_1.j9u(n);
        var xmax = this.vdn_1.j9u(n);
        if (overlaps(this, xmin, xmax, x0, x1)) {
          // Inline function 'kotlin.math.min' call
          var tmp$ret$0 = Math.min(x0, xmin);
          this.udn_1.s7x(n, tmp$ret$0);
          // Inline function 'kotlin.math.max' call
          var tmp$ret$1 = Math.max(x1, xmax);
          this.vdn_1.s7x(n, tmp$ret$1);
          return Unit_instance;
        }
      }
       while (inductionVariable < last);
    this.udn_1.ga2(x0);
    this.vdn_1.ga2(x1);
  }
}
class ScanlineWriter {
  constructor($outer) {
    this.hdo_1 = $outer;
    this.wdn_1 = get_DEFAULT(Companion_getInstance_48());
    this.xdn_1 = NoneFiller_getInstance();
    this.ydn_1 = -1;
    this.zdn_1 = -1;
    this.ado_1 = new Float32Array(this.s2());
    this.bdo_1 = new Int32Array(this.s2());
    this.cdo_1 = Companion_instance_13.kcj(this.s2());
    this.ddo_1 = Companion_instance_13.kcj(this.s2());
    this.edo_1 = new SegmentHandler();
    this.fdo_1 = 0;
    this.gdo_1 = 1.0;
  }
  s2() {
    return this.hdo_1.kdo_1.sc1_1;
  }
  udo() {
    return this.hdo_1.kdo_1.sc1_1 - 1 | 0;
  }
  ra8() {
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.edo_1;
    var inductionVariable = 0;
    var last = this_0.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0 = this_0.udn_1.j9u(n);
        var xmax = this_0.vdn_1.j9u(n);
        fill_0(this.ado_1, 0.0, tmp0, xmax + 1 | 0);
        fill(this.bdo_1, 0, tmp0, xmax + 1 | 0);
      }
       while (inductionVariable < last);
    this.fdo_1 = 0;
    this.edo_1.ra8();
  }
  vdo(x0, x1, y0) {
    if (this.udo() < 1)
      return Unit_instance;
    var x0_0 = coerceIn(x0, 0, imul(this.udo(), 20));
    var x1_0 = coerceIn(x1, 0, imul(this.udo(), 20));
    var a = x0_0 / 20 | 0;
    var b = x1_0 / 20 | 0;
    var y = y0 / 20 | 0;
    var i0 = coerceIn(a, 0, this.udo());
    var i1 = coerceIn(b, 0, this.udo());
    var i0m = x0_0 % 20 | 0;
    var i1m = x1_0 % 20 | 0;
    if (!(this.zdn_1 === y)) {
      if (y >= 0) {
        this.nd();
      }
      this.zdn_1 = y;
      this.ra8();
    }
    if (!(this.ydn_1 === y0)) {
      this.ydn_1 = y0;
      this.fdo_1 = this.fdo_1 + 1 | 0;
    }
    if (i1 > i0) {
      this.edo_1.baq(i0, i1);
      this.wdo(i0, 1.0 - i0m / 20);
      var inductionVariable = i0 + 1 | 0;
      if (inductionVariable < i1)
        do {
          var x = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.wdo(x, 1.0);
        }
         while (inductionVariable < i1);
      if (!(i1m === 0)) {
        this.wdo(i1, i1m / 20);
      }
    }
  }
  wdo(x, ratio) {
    var mask = 1 << this.fdo_1;
    if ((this.bdo_1[x] & mask) === 0) {
      this.bdo_1[x] = this.bdo_1[x] | mask;
      var _array__4zh2yp = this.ado_1;
      _array__4zh2yp[x] = _array__4zh2yp[x] + ratio;
    }
  }
  nd() {
    var containsUpper = this.hdo_1.kdo_1.tc1_1;
    var containsArg = this.zdn_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      return Unit_instance;
    var galpha = clamp01_0(this.gdo_1);
    var scale_0 = 1.0 / this.fdo_1 * galpha;
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.edo_1;
    var inductionVariable = 0;
    var last = this_0.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0 = this_0.udn_1.j9u(n);
        var xmax = this_0.vdn_1.j9u(n);
        var x = tmp0;
        var count = (xmax - tmp0 | 0) + 1 | 0;
        this.xdn_1.adk(this.ddo_1, 0, tmp0, xmax, this.zdn_1);
        var inductionVariable_0 = tmp0;
        if (inductionVariable_0 <= xmax)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _array__4zh2yp = this.ado_1;
            var _index_0__fvwizt = n_0;
            _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] * scale_0;
          }
           while (!(n_0 === xmax));
        scale(this.ddo_1, tmp0, this.ado_1, tmp0, count);
        var index = this.hdo_1.kdo_1.nc2(0, this.zdn_1) + x | 0;
        if (this.hdo_1.kdo_1.yc1_1) {
          arraycopy(this.hdo_1.kdo_1.ic1_1, index, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.cdo_1), x, count);
        } else {
          premultiply(_RgbaArray___init__impl__oib4y4(this.hdo_1.kdo_1.ic1_1), index, this.cdo_1, x, count);
        }
        this.wdn_1.xdo(this.cdo_1, x, this.ddo_1, x, count);
        if (this.hdo_1.kdo_1.yc1_1) {
          arraycopy(_RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.cdo_1), x, this.hdo_1.kdo_1.ic1_1, index, count);
        } else {
          depremultiply(this.cdo_1, x, _RgbaArray___init__impl__oib4y4(this.hdo_1.kdo_1.ic1_1), index, count);
        }
      }
       while (inductionVariable < last);
  }
}
class Renderer {
  constructor() {
    this.jdp_1 = false;
    this.kdp_1 = 0;
  }
  nd() {
    return Unit_instance;
  }
  mdp() {
    var _unary__edvuaz = this.kdp_1;
    this.kdp_1 = _unary__edvuaz + 1 | 0;
    return _unary__edvuaz;
  }
  ndp() {
    this.kdp_1 = this.kdp_1 - 1 | 0;
    if (this.kdp_1 === 0) {
      this.nd();
    }
  }
  odp(state, fill, winding) {
    var rstate = state;
    if (fill && !this.qdp(state.ucl_1)) {
      rstate = state.g9m();
      rstate.ucl_1 = toBitmapPaint(rstate.ucl_1, state);
    }
    this.idp(rstate, fill, winding);
  }
  pdp(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.odp(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.odp.call(this, state, fill, winding);
    }
    return tmp;
  }
  idp(state, fill, winding) {
    return Unit_instance;
  }
  qdp(_this__u8e3s4) {
    return true;
  }
  rdp(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    if (transform.d8o().equals(MatrixType_IDENTITY_getInstance())) {
      this_0.tas(pos, size);
    } else {
      this_0.bat(transform, Renderer$drawImage$lambda(pos, size));
    }
    this.pdp(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_5().v9k_1, size.r9r(toFloat(image.s2()))).y9l(pos))), true);
  }
  u1o() {
    this.nd();
  }
}
class Bitmap32Context2d extends Renderer {
  constructor(bmp, antialiasing) {
    super();
    this.kdo_1 = bmp;
    this.ldo_1 = antialiasing;
    this.mdo_1 = this.kdo_1.kc1_1.i9r();
    this.ndo_1 = new Rasterizer();
    this.odo_1 = new ColorFiller();
    this.pdo_1 = new GradientFiller();
    this.qdo_1 = new BitmapFiller();
    this.rdo_1 = new ScanlineWriter(this);
    this.sdo_1 = new VectorPath(VOID, VOID, Winding_EVEN_ODD_getInstance());
    this.tdo_1 = new StrokeToFill();
  }
  w9z() {
    return this.kdo_1.sc1_1;
  }
  x9z() {
    return this.kdo_1.tc1_1;
  }
  idp(state, fill, winding) {
    var style = fill ? state.ucl_1 : state.tcl_1;
    var tmp;
    if (style instanceof NonePaint) {
      tmp = NoneFiller_getInstance();
    } else {
      if (style instanceof RGBA) {
        tmp = this.odo_1.ydj(style.sci_1, state);
      } else {
        if (style instanceof GradientPaint) {
          tmp = this.pdo_1.gdk(style, state);
        } else {
          if (style instanceof BitmapPaint) {
            tmp = this.qdo_1.udk(style, state);
          } else {
            // Inline function 'kotlin.TODO' call
            throw NotImplementedError.le();
          }
        }
      }
    }
    var filler = tmp;
    this.rdo_1.wdn_1 = state.bcm_1;
    this.ndo_1.ra8();
    this.ndo_1.ydo_1 = this.jdp_1;
    var doingStroke = !fill;
    var tmp_0;
    if (fill) {
      tmp_0 = state.mcl_1;
    } else {
      this.sdo_1.a5();
      var tmp306_$receiver = state.mcl_1;
      var tmp307_lineWidth = state.ldp();
      var tmp308_joins = state.rcl_1;
      var tmp309_startCap = state.pcl_1;
      var tmp310_endCap = state.qcl_1;
      var tmp311_miterLimit = state.scl_1;
      var tmp312_temp = this.tdo_1;
      var tmp313_outFill = this.sdo_1;
      var tmp314_lineDash = state.ccm_1;
      var tmp315_lineDashOffset = state.dcm_1;
      tmp_0 = strokeToFill(tmp306_$receiver, tmp307_lineWidth, tmp308_joins, tmp309_startCap, tmp310_endCap, tmp311_miterLimit, tmp314_lineDash, tmp315_lineDashOffset, tmp312_temp, tmp313_outFill);
    }
    var fillPath = tmp_0;
    if (!(state.lcl_1 == null)) {
      this.ndo_1.cdp_1.gap_1 = ensureNotNull(state.lcl_1).pah_1;
      // Inline function 'korlibs.math.geom.shape.emitPoints2' call
      var this_0 = ensureNotNull(state.lcl_1);
      var i = Vector2D.y9j();
      var l = Vector2D.y9j();
      if (false) {
        this.ndo_1.cdp_1.f7();
      }
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
      var n = 0;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_1 = this_0.nah_1;
      var n_0 = 0;
      while (n_0 < this_1.s2()) {
        var _unary__edvuaz = n_0;
        n_0 = _unary__edvuaz + 1 | 0;
        switch (this_1.j9u(_unary__edvuaz)) {
          case 0:
            var _unary__edvuaz_0 = n;
            n = _unary__edvuaz_0 + 1 | 0;
            var tmp_1 = this_0.oah_1.u2(_unary__edvuaz_0);
            var _unary__edvuaz_1 = n;
            n = _unary__edvuaz_1 + 1 | 0;
            var it = Vector2D.t9g(tmp_1, this_0.oah_1.u2(_unary__edvuaz_1));
            i = it;
            var x = it.jm();
            var y = it.km();
            this.ndo_1.cdp_1.jaq(x, y, true);
            l = it;
            break;
          case 1:
            var _unary__edvuaz_2 = n;
            n = _unary__edvuaz_2 + 1 | 0;
            var tmp_2 = this_0.oah_1.u2(_unary__edvuaz_2);
            var _unary__edvuaz_3 = n;
            n = _unary__edvuaz_3 + 1 | 0;
            var it_0 = Vector2D.t9g(tmp_2, this_0.oah_1.u2(_unary__edvuaz_3));
            var x_0 = it_0.jm();
            var y_0 = it_0.km();
            this.ndo_1.cdp_1.jaq(x_0, y_0, false);
            l = it_0;
            break;
          case 2:
            var _unary__edvuaz_4 = n;
            n = _unary__edvuaz_4 + 1 | 0;
            var tmp_3 = this_0.oah_1.u2(_unary__edvuaz_4);
            var _unary__edvuaz_5 = n;
            n = _unary__edvuaz_5 + 1 | 0;
            var tmp0 = Vector2D.t9g(tmp_3, this_0.oah_1.u2(_unary__edvuaz_5));
            var _unary__edvuaz_6 = n;
            n = _unary__edvuaz_6 + 1 | 0;
            var tmp_4 = this_0.oah_1.u2(_unary__edvuaz_6);
            var _unary__edvuaz_7 = n;
            n = _unary__edvuaz_7 + 1 | 0;
            var a = Vector2D.t9g(tmp_4, this_0.oah_1.u2(_unary__edvuaz_7));
            var sum = Companion_getInstance_6().z9s(l, tmp0) + Companion_getInstance_6().z9s(tmp0, a);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_0 = numberToInt(sum);
            var rcurveSteps = Math.max(a_0, 20);
            var dt = 1.0 / rcurveSteps;
            var lastPos = {_v: Vector2D.y9j()};
            var prevPos = {_v: Vector2D.y9j()};
            var emittedCount = {_v: 0};
            var tmp0_0 = Companion_getInstance_9().w9f_1;
            Bitmap32Context2d$renderFinal$lambda(lastPos)(Companion_getInstance_1().nae(l, tmp0, a, tmp0_0));
            var nStart = false ? 0 : 1;
            var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
            var inductionVariable = nStart;
            if (inductionVariable <= nEnd)
              do {
                var n_1 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
                Bitmap32Context2d$renderFinal$lambda_0(this, emittedCount, lastPos, prevPos)(Companion_getInstance_1().nae(l, tmp0, a, ratio));
              }
               while (!(n_1 === nEnd));
            l = a;
            break;
          case 3:
            var _unary__edvuaz_8 = n;
            n = _unary__edvuaz_8 + 1 | 0;
            var tmp_5 = this_0.oah_1.u2(_unary__edvuaz_8);
            var _unary__edvuaz_9 = n;
            n = _unary__edvuaz_9 + 1 | 0;
            var tmp0_1 = Vector2D.t9g(tmp_5, this_0.oah_1.u2(_unary__edvuaz_9));
            var _unary__edvuaz_10 = n;
            n = _unary__edvuaz_10 + 1 | 0;
            var tmp_6 = this_0.oah_1.u2(_unary__edvuaz_10);
            var _unary__edvuaz_11 = n;
            n = _unary__edvuaz_11 + 1 | 0;
            var tmp2 = Vector2D.t9g(tmp_6, this_0.oah_1.u2(_unary__edvuaz_11));
            var _unary__edvuaz_12 = n;
            n = _unary__edvuaz_12 + 1 | 0;
            var tmp_7 = this_0.oah_1.u2(_unary__edvuaz_12);
            var _unary__edvuaz_13 = n;
            n = _unary__edvuaz_13 + 1 | 0;
            var a_1 = Vector2D.t9g(tmp_7, this_0.oah_1.u2(_unary__edvuaz_13));
            var sum_0 = Companion_getInstance_6().z9s(l, tmp0_1) + Companion_getInstance_6().z9s(tmp0_1, tmp2) + Companion_getInstance_6().z9s(tmp2, a_1);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_2 = numberToInt(sum_0);
            var rcurveSteps_0 = Math.max(a_2, 20);
            var dt_0 = 1.0 / rcurveSteps_0;
            var lastPos_0 = {_v: Vector2D.y9j()};
            var prevPos_0 = {_v: Vector2D.y9j()};
            var emittedCount_0 = {_v: 0};
            var tmp0_2 = Companion_getInstance_9().w9f_1;
            Bitmap32Context2d$renderFinal$lambda_1(lastPos_0)(Companion_getInstance_1().mae(l, tmp0_1, tmp2, a_1, tmp0_2));
            var nStart_0 = false ? 0 : 1;
            var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
            var inductionVariable_0 = nStart_0;
            if (inductionVariable_0 <= nEnd_0)
              do {
                var n_2 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
                Bitmap32Context2d$renderFinal$lambda_2(this, emittedCount_0, lastPos_0, prevPos_0)(Companion_getInstance_1().mae(l, tmp0_1, tmp2, a_1, ratio_0));
              }
               while (!(n_2 === nEnd_0));
            l = a_1;
            break;
          case 4:
            var destruct = i;
            var x_1 = destruct.jm();
            var y_1 = destruct.km();
            this.ndo_1.cdp_1.jaq(x_1, y_1, false);
            if (true) {
              this.ndo_1.cdp_1.f7();
            }

            break;
        }
      }
      if (false) {
        this.ndo_1.cdp_1.f7();
      }
    }
    var tmp_8 = this.ndo_1.bdp_1;
    tmp_8.gap_1 = winding == null ? ensureNotNull(state.mcl_1).pah_1 : winding;
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i_0 = Vector2D.y9j();
    var l_0 = Vector2D.y9j();
    if (false) {
      this.ndo_1.bdp_1.f7();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n_3 = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = fillPath.nah_1;
    var n_4 = 0;
    while (n_4 < this_2.s2()) {
      var _unary__edvuaz_14 = n_4;
      n_4 = _unary__edvuaz_14 + 1 | 0;
      switch (this_2.j9u(_unary__edvuaz_14)) {
        case 0:
          var _unary__edvuaz_15 = n_3;
          n_3 = _unary__edvuaz_15 + 1 | 0;
          var tmp_9 = fillPath.oah_1.u2(_unary__edvuaz_15);
          var _unary__edvuaz_16 = n_3;
          n_3 = _unary__edvuaz_16 + 1 | 0;
          var it_1 = Vector2D.t9g(tmp_9, fillPath.oah_1.u2(_unary__edvuaz_16));
          i_0 = it_1;
          var x_2 = it_1.jm();
          var y_2 = it_1.km();
          if (doingStroke) {
            if (true) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.ndo_1.bdp_1.jaq(x_2, y_2, true);
          l_0 = it_1;
          break;
        case 1:
          var _unary__edvuaz_17 = n_3;
          n_3 = _unary__edvuaz_17 + 1 | 0;
          var tmp_10 = fillPath.oah_1.u2(_unary__edvuaz_17);
          var _unary__edvuaz_18 = n_3;
          n_3 = _unary__edvuaz_18 + 1 | 0;
          var it_2 = Vector2D.t9g(tmp_10, fillPath.oah_1.u2(_unary__edvuaz_18));
          var x_3 = it_2.jm();
          var y_3 = it_2.km();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.ndo_1.bdp_1.jaq(x_3, y_3, false);
          l_0 = it_2;
          break;
        case 2:
          var _unary__edvuaz_19 = n_3;
          n_3 = _unary__edvuaz_19 + 1 | 0;
          var tmp_11 = fillPath.oah_1.u2(_unary__edvuaz_19);
          var _unary__edvuaz_20 = n_3;
          n_3 = _unary__edvuaz_20 + 1 | 0;
          var tmp0_3 = Vector2D.t9g(tmp_11, fillPath.oah_1.u2(_unary__edvuaz_20));
          var _unary__edvuaz_21 = n_3;
          n_3 = _unary__edvuaz_21 + 1 | 0;
          var tmp_12 = fillPath.oah_1.u2(_unary__edvuaz_21);
          var _unary__edvuaz_22 = n_3;
          n_3 = _unary__edvuaz_22 + 1 | 0;
          var a_3 = Vector2D.t9g(tmp_12, fillPath.oah_1.u2(_unary__edvuaz_22));
          var sum_1 = Companion_getInstance_6().z9s(l_0, tmp0_3) + Companion_getInstance_6().z9s(tmp0_3, a_3);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_4 = numberToInt(sum_1);
          var rcurveSteps_1 = Math.max(a_4, 20);
          var dt_1 = 1.0 / rcurveSteps_1;
          var lastPos_1 = {_v: Vector2D.y9j()};
          var prevPos_1 = {_v: Vector2D.y9j()};
          var emittedCount_1 = {_v: 0};
          var tmp0_4 = Companion_getInstance_9().w9f_1;
          Bitmap32Context2d$renderFinal$lambda_3(lastPos_1)(Companion_getInstance_1().nae(l_0, tmp0_3, a_3, tmp0_4));
          var nStart_1 = false ? 0 : 1;
          var nEnd_1 = true ? rcurveSteps_1 : rcurveSteps_1 - 1 | 0;
          var inductionVariable_1 = nStart_1;
          if (inductionVariable_1 <= nEnd_1)
            do {
              var n_5 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var ratio_1 = _Ratio___init__impl__9mwvn2_0(n_5 * dt_1);
              Bitmap32Context2d$renderFinal$lambda_4(doingStroke, this, emittedCount_1, lastPos_1, prevPos_1, filler, state, winding, fillPath)(Companion_getInstance_1().nae(l_0, tmp0_3, a_3, ratio_1));
            }
             while (!(n_5 === nEnd_1));
          l_0 = a_3;
          break;
        case 3:
          var _unary__edvuaz_23 = n_3;
          n_3 = _unary__edvuaz_23 + 1 | 0;
          var tmp_13 = fillPath.oah_1.u2(_unary__edvuaz_23);
          var _unary__edvuaz_24 = n_3;
          n_3 = _unary__edvuaz_24 + 1 | 0;
          var tmp0_5 = Vector2D.t9g(tmp_13, fillPath.oah_1.u2(_unary__edvuaz_24));
          var _unary__edvuaz_25 = n_3;
          n_3 = _unary__edvuaz_25 + 1 | 0;
          var tmp_14 = fillPath.oah_1.u2(_unary__edvuaz_25);
          var _unary__edvuaz_26 = n_3;
          n_3 = _unary__edvuaz_26 + 1 | 0;
          var tmp2_0 = Vector2D.t9g(tmp_14, fillPath.oah_1.u2(_unary__edvuaz_26));
          var _unary__edvuaz_27 = n_3;
          n_3 = _unary__edvuaz_27 + 1 | 0;
          var tmp_15 = fillPath.oah_1.u2(_unary__edvuaz_27);
          var _unary__edvuaz_28 = n_3;
          n_3 = _unary__edvuaz_28 + 1 | 0;
          var a_5 = Vector2D.t9g(tmp_15, fillPath.oah_1.u2(_unary__edvuaz_28));
          var sum_2 = Companion_getInstance_6().z9s(l_0, tmp0_5) + Companion_getInstance_6().z9s(tmp0_5, tmp2_0) + Companion_getInstance_6().z9s(tmp2_0, a_5);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_6 = numberToInt(sum_2);
          var rcurveSteps_2 = Math.max(a_6, 20);
          var dt_2 = 1.0 / rcurveSteps_2;
          var lastPos_2 = {_v: Vector2D.y9j()};
          var prevPos_2 = {_v: Vector2D.y9j()};
          var emittedCount_2 = {_v: 0};
          var tmp0_6 = Companion_getInstance_9().w9f_1;
          Bitmap32Context2d$renderFinal$lambda_5(lastPos_2)(Companion_getInstance_1().mae(l_0, tmp0_5, tmp2_0, a_5, tmp0_6));
          var nStart_2 = false ? 0 : 1;
          var nEnd_2 = true ? rcurveSteps_2 : rcurveSteps_2 - 1 | 0;
          var inductionVariable_2 = nStart_2;
          if (inductionVariable_2 <= nEnd_2)
            do {
              var n_6 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_6 * dt_2);
              Bitmap32Context2d$renderFinal$lambda_6(doingStroke, this, emittedCount_2, lastPos_2, prevPos_2, filler, state, winding, fillPath)(Companion_getInstance_1().mae(l_0, tmp0_5, tmp2_0, a_5, ratio_2));
            }
             while (!(n_6 === nEnd_2));
          l_0 = a_5;
          break;
        case 4:
          var destruct_0 = i_0;
          var x_4 = destruct_0.jm();
          var y_4 = destruct_0.km();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.ndo_1.bdp_1.jaq(x_4, y_4, false);
          if (true) {
            this.ndo_1.bdp_1.f7();
          }

          break;
      }
    }
    if (false) {
      this.ndo_1.bdp_1.f7();
    }
    renderFinal$flush(this, filler, state, winding, fillPath);
  }
}
class CompositeOperation$Companion$invoke$1 {
  constructor($func) {
    this.sdp_1 = $func;
  }
  xdo(dst, dstN, src, srcN, count) {
    return this.sdp_1(new RgbaPremultipliedArray(dst), dstN, new RgbaPremultipliedArray(src), srcN, count);
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_38 = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_48();
    tmp.tdp_1 = tmp_0.udp(CompositeOperation$Companion$UNIMPLEMENTED$lambda);
  }
  udp(func) {
    return new CompositeOperation$Companion$invoke$1(func);
  }
}
class Companion_33 {
  cat() {
    return CompositeMode_SOURCE_OVER_getInstance();
  }
}
class CompositeMode extends Enum {
  constructor(name, ordinal, op) {
    super(name, ordinal);
    this.xdp_1 = op;
  }
  xdo(dst, dstN, src, srcN, count) {
    this.xdp_1.xdo(dst, dstN, src, srcN, count);
  }
}
class BlendMode extends Enum {}
class State {
  constructor(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    transform = transform === VOID ? Companion_getInstance_5().v9k_1 : transform;
    clip = clip === VOID ? null : clip;
    path = path === VOID ? new VectorPath() : path;
    lineScaleMode = lineScaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : lineScaleMode;
    lineWidth = lineWidth === VOID ? 1.0 : lineWidth;
    startLineCap = startLineCap === VOID ? LineCap_BUTT_getInstance() : startLineCap;
    endLineCap = endLineCap === VOID ? LineCap_BUTT_getInstance() : endLineCap;
    lineJoin = lineJoin === VOID ? LineJoin_MITER_getInstance() : lineJoin;
    miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
    strokeStyle = strokeStyle === VOID ? new RGBA(get_DefaultPaint()) : strokeStyle;
    fillStyle = fillStyle === VOID ? new RGBA(get_DefaultPaint()) : fillStyle;
    fontRegistry = fontRegistry === VOID ? null : fontRegistry;
    font = font === VOID ? null : font;
    fontSize = fontSize === VOID ? 24.0 : fontSize;
    verticalAlign = verticalAlign === VOID ? Companion_getInstance_47().zdl_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? Companion_getInstance_46().qdl_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? CompositeMode_SOURCE_OVER_getInstance() : globalCompositeOperation;
    lineDash = lineDash === VOID ? null : lineDash;
    lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
    this.kcl_1 = transform;
    this.lcl_1 = clip;
    this.mcl_1 = path;
    this.ncl_1 = lineScaleMode;
    this.ocl_1 = lineWidth;
    this.pcl_1 = startLineCap;
    this.qcl_1 = endLineCap;
    this.rcl_1 = lineJoin;
    this.scl_1 = miterLimit;
    this.tcl_1 = strokeStyle;
    this.ucl_1 = fillStyle;
    this.vcl_1 = fontRegistry;
    this.wcl_1 = font;
    this.xcl_1 = fontSize;
    this.ycl_1 = verticalAlign;
    this.zcl_1 = horizontalAlign;
    this.acm_1 = globalAlpha;
    this.bcm_1 = globalCompositeOperation;
    this.ccm_1 = lineDash;
    this.dcm_1 = lineDashOffset;
    var tmp = this;
    tmp.ecm_1 = lazy(Context2d$State$transformTransform$delegate$lambda(this));
  }
  ydp() {
    var tmp0 = this.ecm_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('transformTransform', 1, tmp, Context2d$State$_get_transformTransform_$ref_jajxlc(), null);
    return tmp0.k3();
  }
  ldp() {
    var tmp = this.ocl_1;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = this.ydp().a9n();
    return tmp * Math.abs(this_0);
  }
  jcu(value) {
    this.pcl_1 = value;
    this.qcl_1 = value;
  }
  ccu() {
    return this.pcl_1;
  }
  g9m() {
    var tmp = this.kcl_1;
    var tmp319_safe_receiver = this.lcl_1;
    var tmp_0 = tmp319_safe_receiver == null ? null : tmp319_safe_receiver.g9m();
    var tmp_1 = this.mcl_1.g9m();
    var tmp320_safe_receiver = this.ccm_1;
    return this.zdp(tmp, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp320_safe_receiver == null ? null : tmp320_safe_receiver.g9m());
  }
  adq(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    return new State(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  zdp(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset, $super) {
    transform = transform === VOID ? this.kcl_1 : transform;
    clip = clip === VOID ? this.lcl_1 : clip;
    path = path === VOID ? this.mcl_1 : path;
    lineScaleMode = lineScaleMode === VOID ? this.ncl_1 : lineScaleMode;
    lineWidth = lineWidth === VOID ? this.ocl_1 : lineWidth;
    startLineCap = startLineCap === VOID ? this.pcl_1 : startLineCap;
    endLineCap = endLineCap === VOID ? this.qcl_1 : endLineCap;
    lineJoin = lineJoin === VOID ? this.rcl_1 : lineJoin;
    miterLimit = miterLimit === VOID ? this.scl_1 : miterLimit;
    strokeStyle = strokeStyle === VOID ? this.tcl_1 : strokeStyle;
    fillStyle = fillStyle === VOID ? this.ucl_1 : fillStyle;
    fontRegistry = fontRegistry === VOID ? this.vcl_1 : fontRegistry;
    font = font === VOID ? this.wcl_1 : font;
    fontSize = fontSize === VOID ? this.xcl_1 : fontSize;
    verticalAlign = verticalAlign === VOID ? this.ycl_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? this.zcl_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? this.acm_1 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? this.bcm_1 : globalCompositeOperation;
    lineDash = lineDash === VOID ? this.ccm_1 : lineDash;
    lineDashOffset = lineDashOffset === VOID ? this.dcm_1 : lineDashOffset;
    return $super === VOID ? this.adq(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) : $super.adq.call(this, transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, new VerticalAlign(verticalAlign), new HorizontalAlign(horizontalAlign), globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  toString() {
    return 'State(transform=' + this.kcl_1.toString() + ', clip=' + toString(this.lcl_1) + ', path=' + this.mcl_1.toString() + ', lineScaleMode=' + this.ncl_1.toString() + ', lineWidth=' + this.ocl_1 + ', startLineCap=' + this.pcl_1.toString() + ', endLineCap=' + this.qcl_1.toString() + ', lineJoin=' + this.rcl_1.toString() + ', miterLimit=' + this.scl_1 + ', strokeStyle=' + toString_0(this.tcl_1) + ', fillStyle=' + toString_0(this.ucl_1) + ', fontRegistry=' + toString(this.vcl_1) + ', font=' + toString(this.wcl_1) + ', fontSize=' + this.xcl_1 + ', verticalAlign=' + VerticalAlign__toString_impl_hcpnn2(this.ycl_1) + ', horizontalAlign=' + HorizontalAlign__toString_impl_toflc0(this.zcl_1) + ', globalAlpha=' + this.acm_1 + ', globalCompositeOperation=' + toString_0(this.bcm_1) + ', lineDash=' + toString(this.ccm_1) + ', lineDashOffset=' + this.dcm_1 + ')';
  }
  hashCode() {
    var result = this.kcl_1.hashCode();
    result = imul(result, 31) + (this.lcl_1 == null ? 0 : this.lcl_1.hashCode()) | 0;
    result = imul(result, 31) + this.mcl_1.hashCode() | 0;
    result = imul(result, 31) + this.ncl_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.ocl_1) | 0;
    result = imul(result, 31) + this.pcl_1.hashCode() | 0;
    result = imul(result, 31) + this.qcl_1.hashCode() | 0;
    result = imul(result, 31) + this.rcl_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.scl_1) | 0;
    result = imul(result, 31) + hashCode(this.tcl_1) | 0;
    result = imul(result, 31) + hashCode(this.ucl_1) | 0;
    result = imul(result, 31) + (this.vcl_1 == null ? 0 : hashCode(this.vcl_1)) | 0;
    result = imul(result, 31) + (this.wcl_1 == null ? 0 : hashCode(this.wcl_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.xcl_1) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.ycl_1) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl_7x9oj5(this.zcl_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.acm_1) | 0;
    result = imul(result, 31) + hashCode(this.bcm_1) | 0;
    result = imul(result, 31) + (this.ccm_1 == null ? 0 : hashCode(this.ccm_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.dcm_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof State))
      return false;
    var tmp0_other_with_cast = other instanceof State ? other : THROW_CCE();
    if (!this.kcl_1.equals(tmp0_other_with_cast.kcl_1))
      return false;
    if (!equals(this.lcl_1, tmp0_other_with_cast.lcl_1))
      return false;
    if (!this.mcl_1.equals(tmp0_other_with_cast.mcl_1))
      return false;
    if (!this.ncl_1.equals(tmp0_other_with_cast.ncl_1))
      return false;
    if (!equals(this.ocl_1, tmp0_other_with_cast.ocl_1))
      return false;
    if (!this.pcl_1.equals(tmp0_other_with_cast.pcl_1))
      return false;
    if (!this.qcl_1.equals(tmp0_other_with_cast.qcl_1))
      return false;
    if (!this.rcl_1.equals(tmp0_other_with_cast.rcl_1))
      return false;
    if (!equals(this.scl_1, tmp0_other_with_cast.scl_1))
      return false;
    if (!equals(this.tcl_1, tmp0_other_with_cast.tcl_1))
      return false;
    if (!equals(this.ucl_1, tmp0_other_with_cast.ucl_1))
      return false;
    if (!equals(this.vcl_1, tmp0_other_with_cast.vcl_1))
      return false;
    if (!equals(this.wcl_1, tmp0_other_with_cast.wcl_1))
      return false;
    if (!equals(this.xcl_1, tmp0_other_with_cast.xcl_1))
      return false;
    if (!equals(this.ycl_1, tmp0_other_with_cast.ycl_1))
      return false;
    if (!equals(this.zcl_1, tmp0_other_with_cast.zcl_1))
      return false;
    if (!equals(this.acm_1, tmp0_other_with_cast.acm_1))
      return false;
    if (!equals(this.bcm_1, tmp0_other_with_cast.bcm_1))
      return false;
    if (!equals(this.ccm_1, tmp0_other_with_cast.ccm_1))
      return false;
    if (!equals(this.dcm_1, tmp0_other_with_cast.dcm_1))
      return false;
    return true;
  }
}
class Context2d {
  constructor(renderer, defaultFontRegistry, defaultFont) {
    defaultFontRegistry = defaultFontRegistry === VOID ? null : defaultFontRegistry;
    defaultFont = defaultFont === VOID ? null : defaultFont;
    this.qc9_1 = renderer;
    this.rc9_1 = defaultFontRegistry;
    this.sc9_1 = defaultFont;
    this.tc9_1 = new State(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.rc9_1, this.sc9_1);
    this.uc9_1 = _TGenStack___init__impl__yynjgt();
    this.vc9_1 = Vector2D.y9j();
    this.wc9_1 = Vector2D.y9j();
  }
  bdq() {
    return this.qc9_1.w9z();
  }
  cdq() {
    return this.qc9_1.x9z();
  }
  ddq(state, fill, winding) {
    return this.qc9_1.odp(state, fill, winding);
  }
  edq(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.ddq(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.ddq.call(this, state, fill, winding);
    }
    return tmp;
  }
  fdq(image, pos, size, transform) {
    return this.qc9_1.rdp(image, pos, size, transform);
  }
  gdq() {
    return this.qc9_1.u1o();
  }
  hdq() {
    return this.qc9_1.mdp();
  }
  idq() {
    return this.qc9_1.ndp();
  }
  w9z() {
    return this.bdq();
  }
  x9z() {
    return this.cdq();
  }
  u1o() {
    this.gdq();
  }
  jdq() {
    return this.hdq();
  }
  kdq() {
    return this.idq();
  }
  ldq(value) {
    this.tc9_1.ncl_1 = value;
  }
  icu(value) {
    this.tc9_1.ocl_1 = value;
  }
  bcu() {
    return this.tc9_1.ocl_1;
  }
  jcu(value) {
    this.tc9_1.jcu(value);
  }
  ccu() {
    return this.tc9_1.ccu();
  }
  lcu(value) {
    this.tc9_1.scl_1 = value;
  }
  ecu() {
    return this.tc9_1.scl_1;
  }
  mdq(value) {
    this.tc9_1.pcl_1 = value;
  }
  ndq(value) {
    this.tc9_1.qcl_1 = value;
  }
  kcu(value) {
    this.tc9_1.rcl_1 = value;
  }
  dcu() {
    return this.tc9_1.rcl_1;
  }
  odq(value) {
    this.tc9_1.tcl_1 = value;
  }
  pdq() {
    return this.tc9_1.tcl_1;
  }
  hcm(value) {
    this.tc9_1.ucl_1 = value;
  }
  gcm() {
    return this.tc9_1.ucl_1;
  }
  ccw() {
    return this.tc9_1.wcl_1;
  }
  eck() {
    return this.tc9_1.xcl_1;
  }
  hdn() {
    return this.tc9_1.ycl_1;
  }
  qdq() {
    return this.tc9_1.zcl_1;
  }
  rdq() {
    return Companion_getInstance_45().cdm(this.qdq(), this.hdn());
  }
  mcu(value) {
    this.tc9_1.ccm_1 = value;
  }
  fcu() {
    return this.tc9_1.ccm_1;
  }
  ncu(value) {
    this.tc9_1.dcm_1 = value;
  }
  gcu() {
    return this.tc9_1.dcm_1;
  }
  hcu() {
    TGenStack__push_impl_9yh33t(this.uc9_1, this.tc9_1.g9m());
  }
  pcu() {
    this.tc9_1 = TGenStack__pop_impl_qisxa0(this.uc9_1);
  }
  vdc(sx, sy) {
    this.tc9_1.kcl_1 = this.tc9_1.kcl_1.w9l(sx, sy);
  }
  fcm(sx, sy, $super) {
    sy = sy === VOID ? sx : sy;
    var tmp;
    if ($super === VOID) {
      this.vdc(sx, sy);
      tmp = Unit_instance;
    } else {
      tmp = $super.vdc.call(this, sx, sy);
    }
    return tmp;
  }
  zcv(tx, ty) {
    this.tc9_1.kcl_1 = this.tc9_1.kcl_1.e9m(tx, ty);
  }
  bcw(m) {
    this.tc9_1.kcl_1 = this.tc9_1.kcl_1.f9m(m);
  }
  sdq(_set____db54di) {
    this.vc9_1 = _set____db54di;
  }
  tdq() {
    return this.vc9_1;
  }
  udq(_set____db54di) {
    this.wc9_1 = _set____db54di;
  }
  hah() {
    return this.wc9_1;
  }
  pas() {
    return this.tc9_1.mcl_1.pas();
  }
  f7() {
    this.tc9_1.mcl_1.f7();
    this.udq(this.tdq());
  }
  gah(p) {
    this.tc9_1.mcl_1.gah(trans(this, p));
    this.udq(p);
    this.sdq(p);
  }
  iah(p) {
    this.tc9_1.mcl_1.iah(trans(this, p));
    this.udq(p);
  }
  jah(c, a) {
    this.tc9_1.mcl_1.jah(trans(this, c), trans(this, a));
    this.udq(a);
  }
  lah(c1, c2, a) {
    this.tc9_1.mcl_1.lah(trans(this, c1), trans(this, c2), trans(this, a));
    this.udq(a);
  }
  udc(path) {
    if (this.n1())
      this.tc9_1.mcl_1.pah_1 = path.pah_1;
    write_0(this, path);
  }
  tcw(d) {
    d.scw(this);
  }
  icm(x, y, width, height) {
    this.rct();
    this.uas(x, y, width, height);
    this.xct();
  }
  rct() {
    this.tc9_1.mcl_1 = new VectorPath();
  }
  wct() {
    if (!equals(this.tc9_1.tcl_1, NonePaint_instance)) {
      this.edq(this.tc9_1, false);
    }
  }
  vdq(winding) {
    if (!equals(this.tc9_1.ucl_1, NonePaint_instance)) {
      this.ddq(this.tc9_1, true, winding);
    }
  }
  xct(winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.vdq(winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.vdq.call(this, winding);
    }
    return tmp;
  }
  wdq(paint, winding) {
    if (paint == null)
      return Unit_instance;
    // Inline function 'korlibs.image.vector.Context2d.fillStyle' call
    var oldStyle = this.gcm();
    this.hcm(paint);
    try {
      this.vdq(winding);
    }finally {
      this.hcm(oldStyle);
    }
  }
  acu(paint, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.wdq(paint, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.wdq.call(this, paint, winding);
    }
    return tmp;
  }
  ocu(paint) {
    // Inline function 'korlibs.image.vector.Context2d.strokeStyle' call
    var oldStyle = this.pdq();
    this.odq(paint);
    try {
      this.wct();
    }finally {
      this.odq(oldStyle);
    }
  }
  xdq(path, winding) {
    if (!(path == null)) {
      if (this.tc9_1.lcl_1 == null) {
        this.tc9_1.lcl_1 = new VectorPath();
      }
      ensureNotNull(this.tc9_1.lcl_1).a5();
      ensureNotNull(this.tc9_1.lcl_1).pah_1 = winding;
      ensureNotNull(this.tc9_1.lcl_1).qat(path);
      if (path === this.tc9_1.mcl_1) {
        path.a5();
      }
    } else {
      this.tc9_1.lcl_1 = null;
    }
  }
  ydq(path, winding, $super) {
    path = path === VOID ? this.tc9_1.mcl_1 : path;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.xdq(path, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.xdq.call(this, path, winding);
    }
    return tmp;
  }
  zdq(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) {
    var paint_0 = paint == null ? fill ? this.gcm() : this.pdq() : paint;
    return font == null ? null : drawText(font, this, size, text, paint_0, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  adr(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, $super) {
    pos = pos === VOID ? Companion_getInstance_6().g9h_1 : pos;
    fill = fill === VOID ? true : fill;
    paint = paint === VOID ? null : paint;
    font = font === VOID ? this.ccw() : font;
    size = size === VOID ? this.eck() : size;
    var tmp;
    if (renderer === VOID) {
      var tmp_0 = get_DefaultStringTextRenderer();
      tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
    } else {
      tmp = renderer;
    }
    renderer = tmp;
    align = align === VOID ? this.rdq() : align;
    outMetrics = outMetrics === VOID ? null : outMetrics;
    fillStyle = fillStyle === VOID ? null : fillStyle;
    stroke = stroke === VOID ? null : stroke;
    textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
    return $super === VOID ? this.zdq(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) : $super.zdq.call(this, text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  jcm(image, pos, size) {
    return this.fdq(image, pos, size, this.tc9_1.kcl_1);
  }
  hdi(image, pos, size, $super) {
    size = size === VOID ? toFloat(image.s2()) : size;
    var tmp;
    if ($super === VOID) {
      this.jcm(image, pos, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.jcm.call(this, image, pos, size);
    }
    return tmp;
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_40 = this;
    this.bdr_1 = values_6();
  }
}
class CycleMethod extends Enum {
  hdl() {
    return !this.equals(CycleMethod_NO_CYCLE_getInstance()) && !this.equals(CycleMethod_NO_CYCLE_CLAMP_getInstance());
  }
  ndl(ratio) {
    var tmp;
    switch (this.w1_1) {
      case 0:
        tmp = ratio;
        break;
      case 1:
        tmp = clamp01_0(ratio);
        break;
      case 2:
        // Inline function 'korlibs.math.fract' call

        tmp = ratio - toIntFloor(ratio);
        break;
      case 3:
        var part = umod(ratio, 2.0);
        tmp = part > 1.0 ? 2.0 - part : part;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  cdr(ratio) {
    return this.ndl(ratio);
  }
}
class ColorizedBeziers {
  constructor(beziers) {
    this.ddr_1 = beziers;
    var tmp = this;
    tmp.edr_1 = lazy(ColorizedBeziers$red$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.fdr_1 = lazy(ColorizedBeziers$green$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.gdr_1 = lazy(ColorizedBeziers$blue$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.hdr_1 = lazy(ColorizedBeziers$allProjected$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.idr_1 = lazy(ColorizedBeziers$redProjected$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.jdr_1 = lazy(ColorizedBeziers$greenProjected$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.kdr_1 = lazy(ColorizedBeziers$blueProjected$delegate$lambda(this));
  }
  vdr() {
    var tmp0 = this.edr_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('red', 1, tmp, ColorizedBeziers$_get_red_$ref_xdnpsc(), null);
    return tmp0.k3();
  }
  wdr() {
    var tmp0 = this.fdr_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('green', 1, tmp, ColorizedBeziers$_get_green_$ref_tv17mu(), null);
    return tmp0.k3();
  }
  xdr() {
    var tmp0 = this.gdr_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('blue', 1, tmp, ColorizedBeziers$_get_blue_$ref_5q5gjh(), null);
    return tmp0.k3();
  }
  ldr() {
    var tmp0 = this.hdr_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('allProjected', 1, tmp, ColorizedBeziers$_get_allProjected_$ref_l05e8q(), null);
    return tmp0.k3();
  }
  qdr() {
    var tmp0 = this.idr_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('redProjected', 1, tmp, ColorizedBeziers$_get_redProjected_$ref_613mvq(), null);
    return tmp0.k3();
  }
  rdr() {
    var tmp0 = this.jdr_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('greenProjected', 1, tmp, ColorizedBeziers$_get_greenProjected_$ref_8dwwp4(), null);
    return tmp0.k3();
  }
  sdr() {
    var tmp0 = this.kdr_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('blueProjected', 1, tmp, ColorizedBeziers$_get_blueProjected_$ref_qfjglb(), null);
    return tmp0.k3();
  }
}
class ColoredBezier {
  constructor(bezier, color) {
    this.tdr_1 = bezier;
    this.udr_1 = color;
  }
  toString() {
    return 'ColoredBezier(bezier=' + this.tdr_1.toString() + ', color=' + RGBA__toString_impl_4lw6dp(this.udr_1) + ')';
  }
  hashCode() {
    var result = this.tdr_1.hashCode();
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.udr_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColoredBezier))
      return false;
    var tmp0_other_with_cast = other instanceof ColoredBezier ? other : THROW_CCE();
    if (!this.tdr_1.equals(tmp0_other_with_cast.tdr_1))
      return false;
    if (!(this.udr_1 === tmp0_other_with_cast.udr_1))
      return false;
    return true;
  }
}
class ProjectCurvesLookup {
  constructor(beziers) {
    this.mdr_1 = beziers;
    this.ndr_1 = new ProjectedPoint();
    this.odr_1 = Companion_getInstance_2().y9k();
  }
  pdr(point) {
    return Companion_getInstance_6().z9s(point, this.vaf(point));
  }
  vaf(point) {
    if (this.mdr_1.n1())
      return Vector2D.a9k(0, 0);
    var minDistSq = Infinity;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.mdr_1;
    var n = 0;
    while (n < this_0.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var dist = this_0.u2(_unary__edvuaz).tae().y9i(point);
      if (dist < minDistSq) {
        minDistSq = dist;
      }
    }
    var bminDistSq = Infinity;
    var out = Vector2D.y9j();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.mdr_1;
    var n_0 = 0;
    while (n_0 < this_1.s2()) {
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var tmp0 = this_1.u2(_unary__edvuaz_0);
      $l$block: {
        if (tmp0.tae().x9i(point) > minDistSq) {
          break $l$block;
        }
        tmp0.taf(point, this.ndr_1);
        if (this.ndr_1.jae_1 < bminDistSq) {
          bminDistSq = this.ndr_1.jae_1;
          out = this.ndr_1.hae_1;
        }
      }
    }
    return out;
  }
}
class Shape {}
function getPath(path) {
  return path;
}
function getPath$default(path, $super) {
  path = path === VOID ? new VectorPath() : path;
  return $super === VOID ? this.ydr(path) : getPath(path);
}
function get_bounds() {
  return this.zdr(true);
}
class EmptyShape {
  zdr(includeStrokes) {
    return Companion_getInstance_4().d9i();
  }
  scw(c) {
    return Unit_instance;
  }
}
class CompoundShape {
  constructor(components) {
    this.ads_1 = components;
  }
  zdr(includeStrokes) {
    var bb = Companion_getInstance_7().e9i();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ads_1;
    var n = 0;
    while (n < this_0.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.u2(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, it.zdr(includeStrokes));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  scw(c) {
    $l$block: {
      // Inline function 'korlibs.image.vector.Context2d.buffering' call
      c.jdq();
      try {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var this_0 = this.ads_1;
        var n = 0;
        while (n < this_0.s2()) {
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          this_0.u2(_unary__edvuaz).scw(c);
        }
        break $l$block;
      }finally {
        c.kdq();
      }
    }
    return Unit_instance;
  }
  ydr(path) {
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ads_1;
    var n = 0;
    while (n < this_0.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.u2(_unary__edvuaz).ydr(path);
    }
    return path;
  }
  toString() {
    return 'CompoundShape(\n  ' + joinToString(this.ads_1, ',\n  ') + '\n)';
  }
}
class StyledShape {}
function get_path() {
  return null;
}
function getBounds(includeStrokes) {
  var tmp345_safe_receiver = this.obf();
  var tmp;
  if (tmp345_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = _BoundsBuilder___get_bounds__impl__s1l1gx(plus_1(Companion_getInstance_7().e9i(), tmp345_safe_receiver));
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? Companion_getInstance_4().d9i() : tmp0_elvis_lhs;
}
function getPath_0(path) {
  // Inline function 'kotlin.also' call
  var tmp347_safe_receiver = this.obf();
  if (tmp347_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    path.qat(tmp347_safe_receiver);
  }
  return path;
}
function draw(c) {
  // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
  var t = c.tc9_1.kcl_1;
  try {
    c.rct();
    var tmp348_safe_receiver = this.obf();
    if (tmp348_safe_receiver == null)
      null;
    else {
      draw_0(tmp348_safe_receiver, c);
    }
    if (!(this.mds() == null)) {
      draw_0(ensureNotNull(this.mds()), c);
      c.ydq();
    }
    c.bcw(get_immutable(this.acw()));
    this.ods(c);
  }finally {
    c.tc9_1.kcl_1 = t;
  }
}
function drawInternal(c) {
}
class TextShape {
  cds() {
    var tmp0 = this.bds_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('primitiveShapes', 1, tmp, TextShape$_get_primitiveShapes_$ref_aj2wvd(), null);
    return tmp0.k3();
  }
}
class FillShape {
  constructor(path, clip, paint, transform, globalAlpha) {
    transform = transform === VOID ? Companion_getInstance_5().v9k_1 : transform;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.dds_1 = path;
    this.eds_1 = clip;
    this.fds_1 = paint;
    this.gds_1 = transform;
    this.hds_1 = globalAlpha;
    var tmp = this;
    tmp.ids_1 = lazy(FillShape$pathCurvesList$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.jds_1 = lazy(FillShape$clipCurvesList$delegate$lambda(this));
  }
  obf() {
    return this.dds_1;
  }
  mds() {
    return this.eds_1;
  }
  acw() {
    return this.gds_1;
  }
  kds() {
    var tmp0 = this.ids_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('pathCurvesList', 1, tmp, FillShape$_get_pathCurvesList_$ref_xawj4p(), null);
    return tmp0.k3();
  }
  lds() {
    var tmp0 = this.jds_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('clipCurvesList', 1, tmp, FillShape$_get_clipCurvesList_$ref_3uutse(), null);
    return tmp0.k3();
  }
  nds() {
    return this.kds().s2() === 1 && get_isConvex(first_0(this.kds())) && this.lds() == null;
  }
  ods(c) {
    c.wdq(this.fds_1, this.dds_1.pah_1);
  }
  toString() {
    return 'FillShape(path=' + this.dds_1.toString() + ', clip=' + toString(this.eds_1) + ', paint=' + toString_0(this.fds_1) + ', transform=' + this.gds_1.toString() + ', globalAlpha=' + this.hds_1 + ')';
  }
  hashCode() {
    var result = this.dds_1.hashCode();
    result = imul(result, 31) + (this.eds_1 == null ? 0 : this.eds_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.fds_1) | 0;
    result = imul(result, 31) + this.gds_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.hds_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FillShape))
      return false;
    var tmp0_other_with_cast = other instanceof FillShape ? other : THROW_CCE();
    if (!this.dds_1.equals(tmp0_other_with_cast.dds_1))
      return false;
    if (!equals(this.eds_1, tmp0_other_with_cast.eds_1))
      return false;
    if (!equals(this.fds_1, tmp0_other_with_cast.fds_1))
      return false;
    if (!this.gds_1.equals(tmp0_other_with_cast.gds_1))
      return false;
    if (!equals(this.hds_1, tmp0_other_with_cast.hds_1))
      return false;
    return true;
  }
}
class PolylineShape {
  constructor(path, clip, paint, transform, strokeInfo, globalAlpha) {
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.pds_1 = path;
    this.qds_1 = clip;
    this.rds_1 = paint;
    this.sds_1 = transform;
    this.tds_1 = strokeInfo;
    this.uds_1 = globalAlpha;
    var tmp = this;
    var tmp_0 = KProperty0;
    tmp.vds_1 = getPropertyCallableRef('thickness', 0, tmp_0, StrokeInfo$_get_thickness_$ref_geresy(this.tds_1), null);
    var tmp_1 = this;
    var tmp_2 = KProperty0;
    tmp_1.wds_1 = getPropertyCallableRef('scaleMode', 0, tmp_2, StrokeInfo$_get_scaleMode_$ref_hp7psl(this.tds_1), null);
    var tmp_3 = this;
    var tmp_4 = KProperty0;
    tmp_3.xds_1 = getPropertyCallableRef('startCap', 0, tmp_4, StrokeInfo$_get_startCap_$ref_el6ba0(this.tds_1), null);
    var tmp_5 = this;
    var tmp_6 = KProperty0;
    tmp_5.yds_1 = getPropertyCallableRef('endCap', 0, tmp_6, StrokeInfo$_get_endCap_$ref_wlfq1t(this.tds_1), null);
    var tmp_7 = this;
    var tmp_8 = KProperty0;
    tmp_7.zds_1 = getPropertyCallableRef('join', 0, tmp_8, StrokeInfo$_get_join_$ref_1c260i(this.tds_1), null);
    var tmp_9 = this;
    var tmp_10 = KProperty0;
    tmp_9.adt_1 = getPropertyCallableRef('miterLimit', 0, tmp_10, StrokeInfo$_get_miterLimit_$ref_qyuncy(this.tds_1), null);
    var tmp_11 = this;
    var tmp_12 = KProperty0;
    tmp_11.bdt_1 = getPropertyCallableRef('dash', 0, tmp_12, StrokeInfo$_get_dash_$ref_ajbiai(this.tds_1), null);
    var tmp_13 = this;
    var tmp_14 = KProperty0;
    tmp_13.cdt_1 = getPropertyCallableRef('dashOffset', 0, tmp_14, StrokeInfo$_get_dashOffset_$ref_p72rql(this.tds_1), null);
    var tmp_15 = this;
    tmp_15.ddt_1 = lazy(PolylineShape$fillShape$delegate$lambda(this));
  }
  obf() {
    return this.pds_1;
  }
  mds() {
    return this.qds_1;
  }
  acw() {
    return this.sds_1;
  }
  zdr(includeStrokes) {
    var tmp352_safe_receiver = BoundsBuilder__boundsOrNull_impl_se9lyg(plus_1(Companion_getInstance_7().e9i(), this.pds_1));
    var bounds = tmp352_safe_receiver == null ? null : get_mutable(tmp352_safe_receiver);
    if (includeStrokes) {
      // Inline function 'kotlin.math.max' call
      var a = this.tds_1.pab_1 / 2.0;
      var halfThickness = Math.max(a, 0.0);
      if (bounds == null)
        null;
      else
        bounds.pav(halfThickness, halfThickness);
    }
    var tmp0_elvis_lhs = bounds == null ? null : bounds.x9p();
    return tmp0_elvis_lhs == null ? Companion_getInstance_4().a9i_1 : tmp0_elvis_lhs;
  }
  edt(c) {
    c.ldq(this.tds_1.rab_1);
    c.icu(this.tds_1.pab_1);
    c.mdq(this.tds_1.sab_1);
    c.ndq(this.tds_1.tab_1);
    c.kcu(this.tds_1.uab_1);
    c.lcu(this.tds_1.vab_1);
    c.mcu(this.tds_1.wab_1);
    c.ncu(this.tds_1.xab_1);
  }
  ods(c) {
    this.edt(c);
    c.ocu(this.rds_1);
  }
  toString() {
    return 'PolylineShape(path=' + this.pds_1.toString() + ', clip=' + toString(this.qds_1) + ', paint=' + toString_0(this.rds_1) + ', transform=' + this.sds_1.toString() + ', strokeInfo=' + this.tds_1.toString() + ', globalAlpha=' + this.uds_1 + ')';
  }
  hashCode() {
    var result = this.pds_1.hashCode();
    result = imul(result, 31) + (this.qds_1 == null ? 0 : this.qds_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.rds_1) | 0;
    result = imul(result, 31) + this.sds_1.hashCode() | 0;
    result = imul(result, 31) + this.tds_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.uds_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PolylineShape))
      return false;
    var tmp0_other_with_cast = other instanceof PolylineShape ? other : THROW_CCE();
    if (!this.pds_1.equals(tmp0_other_with_cast.pds_1))
      return false;
    if (!equals(this.qds_1, tmp0_other_with_cast.qds_1))
      return false;
    if (!equals(this.rds_1, tmp0_other_with_cast.rds_1))
      return false;
    if (!this.sds_1.equals(tmp0_other_with_cast.sds_1))
      return false;
    if (!this.tds_1.equals(tmp0_other_with_cast.tds_1))
      return false;
    if (!equals(this.uds_1, tmp0_other_with_cast.uds_1))
      return false;
    return true;
  }
}
class ShapeBuilder extends Context2d {
  constructor(width, height) {
    super(Companion_getInstance_51());
    var tmp = this;
    tmp.ocq_1 = width == null ? 256 : width;
    var tmp_0 = this;
    tmp_0.pcq_1 = height == null ? 256 : height;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.qcq_1 = ArrayList.p2();
  }
  bdq() {
    return this.ocq_1;
  }
  cdq() {
    return this.pcq_1;
  }
  ddq(state, fill, winding) {
    if (state.mcl_1.n1())
      return Unit_instance;
    // Inline function 'kotlin.also' call
    var this_0 = state.mcl_1.g9m();
    var tmp = this_0;
    tmp.pah_1 = winding == null ? this_0.pah_1 : winding;
    var path = this_0;
    var tmp367_safe_receiver = state.lcl_1;
    var tmp368_safe_receiver = tmp367_safe_receiver == null ? null : tmp367_safe_receiver.g9m();
    var tmp_0;
    if (tmp368_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.also' call
      var tmp_1 = tmp368_safe_receiver;
      tmp_1.pah_1 = winding == null ? tmp368_safe_receiver.pah_1 : winding;
      tmp_0 = tmp368_safe_receiver;
    }
    var clip = tmp_0;
    var transform = state.kcl_1;
    if (fill) {
      var tmp0 = this.qcq_1;
      // Inline function 'kotlin.collections.plusAssign' call
      var element = new FillShape(path, clip, state.ucl_1.g9m(), transform, state.acm_1);
      tmp0.d2(element);
    } else {
      var tmp0_0 = this.qcq_1;
      var tmp_2 = state.tcl_1.g9m();
      var tmp369_thickness = state.ocl_1;
      var tmp370_scaleMode = state.ncl_1;
      var tmp371_startCap = state.pcl_1;
      var tmp372_endCap = state.qcl_1;
      var tmp373_join = state.rcl_1;
      var tmp374_dash = state.ccm_1;
      var tmp375_dashOffset = state.dcm_1;
      var tmp376_miterLimit = state.scl_1;
      // Inline function 'kotlin.collections.plusAssign' call
      var element_0 = new PolylineShape(path, clip, tmp_2, transform, new StrokeInfo(tmp369_thickness, true, tmp370_scaleMode, tmp371_startCap, tmp372_endCap, tmp373_join, tmp376_miterLimit, tmp374_dash, tmp375_dashOffset), state.acm_1);
      tmp0_0.d2(element_0);
    }
  }
  fdq(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    this_0.tas(pos, size);
    this.edq(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_5().v9k_1, size.r9r(toFloat(image.s2()))).y9l(pos))), true);
  }
  gdq() {
  }
  hdq() {
    return 0;
  }
  idq() {
  }
  rcq() {
    return this.qcq_1.s2() === 1 ? first_0(this.qcq_1) : new CompoundShape(toList(this.qcq_1));
  }
  scw(c) {
    c.tcw(this.rcq());
  }
}
class SvgPath {
  fdt(path, separator, decimalPlaces) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var parts = ArrayList.p2();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.nah_1;
    var n_0 = 0;
    while (n_0 < this_0.s2()) {
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.j9u(_unary__edvuaz)) {
        case 0:
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.oah_1.u2(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.t9g(tmp, path.oah_1.u2(_unary__edvuaz_1));
          var x = destruct.jm();
          var y = destruct.km();
          // Inline function 'kotlin.collections.plusAssign' call

          var element = 'M' + toSvgPathString$fixX(x, decimalPlaces) + ' ' + toSvgPathString$fixY(y, decimalPlaces);
          parts.d2(element);
          break;
        case 1:
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.oah_1.u2(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.t9g(tmp_0, path.oah_1.u2(_unary__edvuaz_3));
          var x_0 = destruct_0.jm();
          var y_0 = destruct_0.km();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_0 = 'L' + toSvgPathString$fixX(x_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y_0, decimalPlaces);
          parts.d2(element_0);
          break;
        case 2:
          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.oah_1.u2(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var tmp0 = Vector2D.t9g(tmp_1, path.oah_1.u2(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.oah_1.u2(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_1 = Vector2D.t9g(tmp_2, path.oah_1.u2(_unary__edvuaz_7));
          var x1 = tmp0.jm();
          var y1 = tmp0.km();
          var x2 = destruct_1.jm();
          var y2 = destruct_1.km();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_1 = 'Q' + toSvgPathString$fixX(x1, decimalPlaces) + ' ' + toSvgPathString$fixY(y1, decimalPlaces) + ', ' + toSvgPathString$fixX(x2, decimalPlaces) + ' ' + toSvgPathString$fixY(y2, decimalPlaces);
          parts.d2(element_1);
          break;
        case 3:
          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.oah_1.u2(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var tmp0_0 = Vector2D.t9g(tmp_3, path.oah_1.u2(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.oah_1.u2(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var tmp2 = Vector2D.t9g(tmp_4, path.oah_1.u2(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.oah_1.u2(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_2 = Vector2D.t9g(tmp_5, path.oah_1.u2(_unary__edvuaz_13));
          var x1_0 = tmp0_0.jm();
          var y1_0 = tmp0_0.km();
          var x2_0 = tmp2.jm();
          var y2_0 = tmp2.km();
          var x3 = destruct_2.jm();
          var y3 = destruct_2.km();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_2 = 'C' + toSvgPathString$fixX(x1_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y1_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x2_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y2_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x3, decimalPlaces) + ' ' + toSvgPathString$fixY(y3, decimalPlaces);
          parts.d2(element_2);
          break;
        case 4:
          // Inline function 'kotlin.collections.plusAssign' call

          parts.d2('Z');
          break;
      }
    }
    return joinToString(parts, '');
  }
}
class Rasterizer extends RastScale {
  constructor() {
    super();
    this.ydo_1 = false;
    this.zdo_1 = 2;
    this.adp_1 = 1;
    this.bdp_1 = new PolygonScanline();
    this.cdp_1 = new PolygonScanline();
    this.ddp_1 = new IntSegmentSet();
    this.edp_1 = new IntSegmentSet();
    this.fdp_1 = new IntSegmentSet();
    this.gdp_1 = IntArrayList.za1(1024);
  }
  ra8() {
    this.bdp_1.ra8();
    this.cdp_1.ra8();
  }
  gdt(bounds, quality, stats, winding, callback) {
    if (stats == null)
      null;
    else {
      stats.ra8();
    }
    var xmin = this.xap(bounds.v9h());
    var xmax = this.xap(bounds.w9h());
    var tempRect = this.bdp_1.faf();
    var tmp0 = bounds.x9h();
    // Inline function 'kotlin.math.max' call
    var b = tempRect.x9h();
    var tmp$ret$0 = Math.max(tmp0, b);
    var startY = this.xap(tmp$ret$0);
    var tmp0_0 = bounds.y9h();
    // Inline function 'kotlin.math.min' call
    var b_0 = tempRect.y9h();
    var tmp$ret$1 = Math.min(tmp0_0, b_0);
    var endY = this.xap(tmp$ret$1);
    var func = Rasterizer$rasterizeFill$lambda(xmax, xmin, this, callback);
    this.gdp_1.a5();
    var q = quality;
    var yCount = imul(((endY - startY | 0) / this.paq() | 0) + 1 | 0, q);
    var inductionVariable = 0;
    var last = (yCount + q | 0) - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = startY + ((imul(n, this.paq()) / this.adp_1 | 0) / q | 0) | 0;
        this.gdp_1.ga2(y);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.run' call
    var edgesEmitted = 0;
    var edgesChecked = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.gdp_1;
    var n_0 = 0;
    while (n_0 < this_0.s2()) {
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var y_0 = this_0.j9u(_unary__edvuaz);
      this.bdp_1.kaq(y_0, winding, this.ddp_1);
      edgesChecked = edgesChecked + this.bdp_1.vap_1 | 0;
      if (this.cdp_1.o9j()) {
        this.cdp_1.kaq(y_0, this.cdp_1.gap_1, this.edp_1);
        edgesChecked = edgesChecked + this.cdp_1.vap_1 | 0;
        this.fdp_1.nab(this.ddp_1, this.edp_1);
      }
      // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
      var this_1 = this.cdp_1.o9j() ? this.fdp_1 : this.ddp_1;
      var inductionVariable_0 = 0;
      var last_0 = this_1.s2();
      if (inductionVariable_0 < last_0)
        do {
          var n_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          func(this_1.fab_1.j9u(n_1), this_1.gab_1.j9u(n_1), y_0);
          edgesEmitted = edgesEmitted + 1 | 0;
        }
         while (inductionVariable_0 < last_0);
    }
    var tmp;
    if (stats == null) {
      tmp = null;
    } else {
      stats.kdt(edgesChecked, edgesEmitted, yCount);
      tmp = Unit_instance;
    }
  }
  hdp(bounds, quality, stats, winding, callback, $super) {
    quality = quality === VOID ? this.zdo_1 : quality;
    stats = stats === VOID ? null : stats;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.gdt(bounds, quality, stats, winding, callback);
      tmp = Unit_instance;
    } else {
      tmp = $super.gdt.call(this, bounds, quality, stats, winding, callback);
    }
    return tmp;
  }
}
class DummyRenderer extends Renderer {
  constructor(width, height) {
    Companion_getInstance_51();
    super();
    this.ndt_1 = width;
    this.odt_1 = height;
  }
  w9z() {
    return this.ndt_1;
  }
  x9z() {
    return this.odt_1;
  }
}
class Companion_35 extends DummyRenderer {
  constructor() {
    Companion_instance_41 = null;
    super(128, 128);
    Companion_instance_41 = this;
  }
}
class HtmlCanvas {
  ubk(width, height) {
    if (Companion_getInstance_10().gb1()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on Node.JS';
      throw IllegalStateException.o(toString_0(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = document.createElement('canvas');
    out.width = width;
    out.height = height;
    return toLike(out);
  }
}
class HtmlImage {
  kdu(width, height) {
    return HtmlCanvas_instance.ubk(width, height);
  }
  ldu(bmpData, bmpWidth, bmpHeight, canvas) {
    var pixelCount = _RgbaArray___get_size__impl__imxef8(bmpData);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    var idata = ctx.createImageData(bmpWidth, bmpHeight);
    var idataData = idata.data;
    var m = 0;
    var inductionVariable = 0;
    if (inductionVariable < pixelCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl_nzyo1o(bmpData, n);
        var _unary__edvuaz = m;
        m = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz] = _RGBA___get_r__impl__duz7mo(c);
        var _unary__edvuaz_0 = m;
        m = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_0] = _RGBA___get_g__impl__o8pukr(c);
        var _unary__edvuaz_1 = m;
        m = _unary__edvuaz_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_1] = _RGBA___get_b__impl__m6tl80(c);
        var _unary__edvuaz_2 = m;
        m = _unary__edvuaz_2 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_2] = _RGBA___get_a__impl__6msvu7(c);
      }
       while (inductionVariable < pixelCount);
    ctx.putImageData(idata, 0.0, 0.0);
    return canvas;
  }
  mdu(bmp, canvas) {
    return this.ldu(_RgbaArray___init__impl__oib4y4(bmp.tcc().ic1_1), bmp.sc1_1, bmp.tc1_1, canvas);
  }
  pdt(bmp) {
    return this.mdu(bmp, this.kdu(bmp.sc1_1, bmp.tc1_1));
  }
}
class HtmlNativeImage extends NativeImage {
  constructor(texSourceBase, width, height) {
    return new.target.qdu(texSourceBase, width, height);
  }
  static qdu(texSourceBase, width, height) {
    var $this = this.pcf(width, height, texSourceBase, true);
    $this.edu_1 = texSourceBase;
    $this.fdu_1 = $this.edu_1;
    var tmp = $this;
    tmp.gdu_1 = lazy(HtmlNativeImage$lazyCanvasElement$delegate$lambda($this, width, height));
    var tmp_0 = $this;
    tmp_0.hdu_1 = lazy(HtmlNativeImage$ctx$delegate$lambda($this));
    $this.idu_1 = Monotonic_instance.ck();
    return $this;
  }
  h1() {
    return 'HtmlNativeImage';
  }
  static rdu(img) {
    return this.qdu(img, img.width, img.height);
  }
  static jdu(canvas) {
    return this.qdu(canvas, canvas.width, canvas.height);
  }
  odu() {
    var tmp0 = this.gdu_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('lazyCanvasElement', 1, tmp, HtmlNativeImage$_get_lazyCanvasElement_$ref_ucfw2j(), null);
    return tmp0.k3();
  }
  pdu() {
    var tmp0 = this.hdu_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('ctx', 1, tmp, HtmlNativeImage$_get_ctx_$ref_2kgb2(), null);
    return tmp0.k3();
  }
  pc2(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var tmp = this.edu_1;
    if (tmp instanceof HTMLVideoElement) {
      var now = Monotonic_instance.ck();
      var elapsedTime = ValueTimeMark__minus_impl_f87sko(now, this.idu_1);
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$0 = toDuration(16, DurationUnit_MILLISECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(elapsedTime, tmp$ret$0) >= 0) {
        this.idu_1 = now;
        this.pdu().clearRect(0.0, 0.0, width, height);
        this.pdu().drawImage(this.edu_1, 0.0, 0.0);
      }
    }
    var idata = this.pdu().getImageData(x, y, width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(data, 0, out, offset, size);
    if (get_isBigEndian()) {
      bswap32(out, offset, size);
    }
    if (!this.zc1_1) {
      premultiply(_RgbaArray___init__impl__oib4y4(out), offset, _RgbaPremultipliedArray___init__impl__lx83hy(out), offset, imul(width, height));
    }
  }
  rc2(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var idata = this.pdu().createImageData(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(out, offset, data, 0, size);
    if (!this.zc1_1) {
      depremultiply(_RgbaPremultipliedArray___init__impl__lx83hy(data), 0, _RgbaArray___init__impl__oib4y4(data), 0, imul(width, height));
    }
    if (get_isBigEndian()) {
      bswap32(data, 0, size);
    }
    this.pdu().putImageData(idata, x, y);
  }
  oc9(antialiasing) {
    return new Context2d(new CanvasContext2dRenderer(this.odu()));
  }
  sdu(type, quality) {
    return this.odu().toDataURL(type, quality);
  }
  tdu(type, quality, $super) {
    type = type === VOID ? 'image/png' : type;
    quality = quality === VOID ? null : quality;
    return $super === VOID ? this.sdu(type, quality) : $super.sdu.call(this, type, quality);
  }
}
class NonBrowserNativeImageFormatProvider extends BaseNativeImageFormatProvider {
  constructor() {
    NonBrowserNativeImageFormatProvider_instance = null;
    super();
    NonBrowserNativeImageFormatProvider_instance = this;
  }
}
class HtmlNativeImageFormatProvider extends NativeImageFormatProvider {
  constructor() {
    HtmlNativeImageFormatProvider_instance = null;
    super();
    HtmlNativeImageFormatProvider_instance = this;
  }
  *fdh(data, props, $completion) {
    return new NativeImageResult(HtmlNativeImage.jdu(yield* BrowserImage_instance.udu(data, props, $completion)));
  }
  *kdh(vfs, path, props, $completion) {
    var tmp;
    if (vfs instanceof LocalVfs) {
      tmp = HtmlNativeImage.rdu(yield* BrowserImage_instance.vdu(path, props, $completion));
    } else {
      if (vfs instanceof UrlVfs) {
        var jsUrl = vfs.ebi(path);
        tmp = HtmlNativeImage.rdu(yield* BrowserImage_instance.vdu(jsUrl, props, $completion));
      } else {
        tmp = HtmlNativeImage.jdu(yield* BrowserImage_instance.udu(yield* vfs.wi(path).pbh($completion), props, $completion));
      }
    }
    return new NativeImageResult(tmp);
  }
  qcf(width, height, premultiplied) {
    return HtmlNativeImage.jdu(HtmlCanvas_instance.ubk(width, height));
  }
  scf(bmp) {
    return HtmlNativeImage.jdu(HtmlImage_instance.pdt(bmp.ec2()));
  }
}
class BrowserImage {
  *udu(bytes, props, $completion) {
    if (Companion_getInstance_10().gb1()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on NodeJS';
      throw IllegalStateException.o(toString_0(message));
    }
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [bytes];
    // Inline function 'org.w3c.files.BlobPropertyBag' call
    var type = 'image/png';
    var o = {};
    o['type'] = type;
    var tmp$ret$4 = (!(o == null) ? !(o == null) : false) ? o : THROW_CCE();
    var blob = new Blob(tmp, tmp$ret$4);
    var blobURL = URL.createObjectURL(blob);
    try {
      return yield* this.wdu(blobURL, $completion);
    }finally {
      URL.revokeObjectURL(blobURL);
    }
  }
  xdu(img) {
    return this.ndu(img, img.width, img.height);
  }
  ndu(img, width, height) {
    var canvas = HtmlCanvas_instance.ubk(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    ctx.drawImage(img, 0.0, 0.0);
    return canvas;
  }
  *vdu(jsUrl, props, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    return yield () => {
      var uCont = $completion;
      var cancellable = new CancellableContinuationImpl(intercepted(uCont), 1);
      cancellable.u1p();
      if (Companion_getInstance_10().gb1()) {
        // Inline function 'kotlin.error' call
        var message = 'Canvas not available on NodeJS';
        throw IllegalStateException.o(toString_0(message));
      }
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var img = document.createElement('img');
      img.onload = BrowserImage$loadImage$lambda(cancellable, img);
      img.onerror = BrowserImage$loadImage$lambda_0(cancellable, jsUrl);
      img.src = jsUrl;
      return cancellable.v1p();
    };
  }
  ydu(jsUrl, props, $completion, $super) {
    props = props === VOID ? Companion_getInstance_39().acn_1 : props;
    return $super === VOID ? this.vdu(jsUrl, props, $completion) : $super.vdu.call(this, jsUrl, props, $completion);
  }
  *wdu(jsUrl, $completion) {
    return this.xdu(yield* this.ydu(jsUrl, VOID, $completion));
  }
}
class CanvasContext2dRenderer extends Renderer {
  constructor(canvas) {
    super();
    this.bdv_1 = canvas;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.cdv_1 = this.bdv_1.getContext('2d');
    this.ddv_1 = NaN;
    this.edv_1 = null;
  }
  w9z() {
    return this.bdv_1.width;
  }
  x9z() {
    return this.bdv_1.height;
  }
  idv(_this__u8e3s4, paint) {
    var grad = _this__u8e3s4;
    var inductionVariable = 0;
    var last = paint.bd8_1.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var stop = paint.bd8_1.j9u(n);
        var color = paint.cd8_1.j9u(n);
        grad.addColorStop(stop, _RGBA___get_htmlStringSimple__impl__l4nu0u(_RGBA___init__impl__lqpay5(color)));
      }
       while (inductionVariable < last);
    return _this__u8e3s4;
  }
  gdv(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof NonePaint) {
      tmp = 'none';
    } else {
      if (_this__u8e3s4 instanceof RGBA) {
        tmp = _RGBA___get_htmlColor__impl__bzw5k6(_RGBA___get_color__impl__8x3sb3(_this__u8e3s4.sci_1));
      } else {
        if (_this__u8e3s4 instanceof GradientPaint) {
          var tmp_0;
          switch (_this__u8e3s4.ud7_1.w1_1) {
            case 0:
              tmp_0 = this.idv(this.cdv_1.createLinearGradient(_this__u8e3s4.vd7_1, _this__u8e3s4.wd7_1, _this__u8e3s4.yd7_1, _this__u8e3s4.zd7_1), _this__u8e3s4);
              break;
            case 1:
              tmp_0 = this.idv(this.cdv_1.createRadialGradient(_this__u8e3s4.vd7_1, _this__u8e3s4.wd7_1, _this__u8e3s4.xd7_1, _this__u8e3s4.yd7_1, _this__u8e3s4.zd7_1, _this__u8e3s4.ad8_1), _this__u8e3s4);
              break;
            case 2:
              var tmp_1;
              if (!equals(this.cdv_1.createConicGradient, undefined)) {
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$0 = this.cdv_1.createConicGradient(_Angle___get_radians__impl__n00yt5(_this__u8e3s4.hd8_1), _this__u8e3s4.vd7_1, _this__u8e3s4.wd7_1);
                tmp_1 = this.idv(tmp$ret$0, _this__u8e3s4);
              } else {
                tmp_1 = 'fuchsia';
              }

              tmp_0 = tmp_1;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp = tmp_0;
        } else {
          if (_this__u8e3s4 instanceof BitmapPaint) {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$2 = toHtmlNative(_this__u8e3s4.vdk_1).fdu_1;
            tmp = this.cdv_1.createPattern(tmp$ret$2, _this__u8e3s4.edl() && _this__u8e3s4.idl() ? 'repeat' : _this__u8e3s4.edl() ? 'repeat-x' : _this__u8e3s4.idl() ? 'repeat-y' : 'no-repeat');
          } else {
            tmp = 'black';
          }
        }
      }
    }
    return tmp;
  }
  jdv(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.w1_1) {
      case 0:
        tmp = 'clear';
        break;
      case 1:
        tmp = 'copy';
        break;
      case 2:
        tmp = 'source-over';
        break;
      case 3:
        tmp = 'destination-over';
        break;
      case 4:
        tmp = 'source-in';
        break;
      case 5:
        tmp = 'destination-in';
        break;
      case 6:
        tmp = 'source-out';
        break;
      case 7:
        tmp = 'destination-out';
        break;
      case 8:
        tmp = 'source-atop';
        break;
      case 9:
        tmp = 'destination-atop';
        break;
      case 10:
        tmp = 'xor';
        break;
      case 11:
        tmp = 'lighter';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  kdv(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.w1_1) {
      case 0:
        tmp = 'normal';
        break;
      case 1:
        tmp = 'multiply';
        break;
      case 2:
        tmp = 'screen';
        break;
      case 3:
        tmp = 'overlay';
        break;
      case 4:
        tmp = 'darken';
        break;
      case 5:
        tmp = 'lighten';
        break;
      case 6:
        tmp = 'color-dodge';
        break;
      case 7:
        tmp = 'color-burn';
        break;
      case 8:
        tmp = 'hard-light';
        break;
      case 9:
        tmp = 'soft-light';
        break;
      case 10:
        tmp = 'difference';
        break;
      case 11:
        tmp = 'exclusion';
        break;
      case 12:
        tmp = 'hue';
        break;
      case 13:
        tmp = 'saturation';
        break;
      case 14:
        tmp = 'color';
        break;
      case 15:
        tmp = 'luminosity';
        break;
      default:
        // Inline function 'kotlin.text.lowercase' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = _this__u8e3s4.v1_1.toLowerCase();
        break;
    }
    return tmp;
  }
  fdv(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof CompositeMode) {
      tmp = this.jdv(_this__u8e3s4);
    } else {
      if (_this__u8e3s4 instanceof BlendMode) {
        tmp = this.kdv(_this__u8e3s4);
      } else {
        tmp = 'source-over';
      }
    }
    return tmp;
  }
  hdv(_this__u8e3s4, m) {
    _this__u8e3s4.transform(m.a9l_1, m.b9l_1, m.c9l_1, m.d9l_1, m.e9l_1, m.f9l_1);
  }
  rdp(image, pos, size, transform) {
    this.cdv_1.save();
    try {
      // Inline function 'kotlin.run' call
      this.cdv_1.setTransform(transform.a9l_1, transform.b9l_1, transform.c9l_1, transform.d9l_1, transform.e9l_1, transform.f9l_1);
      var tmp = ensureNative(image);
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = (tmp instanceof HtmlNativeImage ? tmp : THROW_CCE()).fdu_1;
      this.cdv_1.drawImage(tmp$ret$2, pos.r9g_1, pos.s9g_1, size.j9i_1, size.k9i_1);
    }finally {
      this.cdv_1.restore();
    }
  }
  ldv(path) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.nah_1;
    var n_0 = 0;
    while (n_0 < this_0.s2()) {
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.j9u(_unary__edvuaz)) {
        case 0:
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.oah_1.u2(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.t9g(tmp, path.oah_1.u2(_unary__edvuaz_1));
          var x = destruct.jm();
          var y = destruct.km();
          this.cdv_1.moveTo(x, y);
          break;
        case 1:
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.oah_1.u2(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.t9g(tmp_0, path.oah_1.u2(_unary__edvuaz_3));
          var x_0 = destruct_0.jm();
          var y_0 = destruct_0.km();
          this.cdv_1.lineTo(x_0, y_0);
          break;
        case 2:
          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.oah_1.u2(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var tmp0 = Vector2D.t9g(tmp_1, path.oah_1.u2(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.oah_1.u2(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_1 = Vector2D.t9g(tmp_2, path.oah_1.u2(_unary__edvuaz_7));
          var cx = tmp0.jm();
          var cy = tmp0.km();
          var ax = destruct_1.jm();
          var ay = destruct_1.km();
          this.cdv_1.quadraticCurveTo(cx, cy, ax, ay);
          break;
        case 3:
          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.oah_1.u2(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var tmp0_0 = Vector2D.t9g(tmp_3, path.oah_1.u2(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.oah_1.u2(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var tmp2 = Vector2D.t9g(tmp_4, path.oah_1.u2(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.oah_1.u2(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_2 = Vector2D.t9g(tmp_5, path.oah_1.u2(_unary__edvuaz_13));
          var cx1 = tmp0_0.jm();
          var cy1 = tmp0_0.km();
          var cx2 = tmp2.jm();
          var cy2 = tmp2.km();
          var ax_0 = destruct_2.jm();
          var ay_0 = destruct_2.km();
          this.cdv_1.bezierCurveTo(cx1, cy1, cx2, cy2, ax_0, ay_0);
          break;
        case 4:
          this.cdv_1.closePath();
          break;
      }
    }
  }
  idp(state, fill, winding) {
    if (state.mcl_1.n1())
      return Unit_instance;
    $l$block: {
      // Inline function 'korlibs.image.format.CanvasContext2dRenderer.keep' call
      this.cdv_1.save();
      try {
        setState(this, state, fill, false);
        var clip = state.lcl_1;
        if (!(clip == null)) {
          this.cdv_1.beginPath();
          this.ldv(clip);
          this.cdv_1.clip(this.mdv(winding == null ? clip.pah_1 : winding));
        }
        this.cdv_1.beginPath();
        this.ldv(state.mcl_1);
        this.hdv(this.cdv_1, state.kcl_1);
        if (fill) {
          transformPaint(this, state.ucl_1);
          this.cdv_1.fill(this.mdv(winding == null ? state.mcl_1.pah_1 : winding));
        } else {
          transformPaint(this, state.tcl_1);
          var lineDash = state.ccm_1;
          if (!(lineDash == null)) {
            this.cdv_1.lineDashOffset = state.dcm_1;
            // Inline function 'korlibs.datastructure.mapDouble' call
            // Inline function 'kotlin.also' call
            var this_0 = DoubleArrayList.ga3();
            var _iterator__ex2g4s = lineDash.p1();
            while (_iterator__ex2g4s.q1()) {
              var v = _iterator__ex2g4s.r1();
              this_0.la3(v);
            }
            // Inline function 'kotlin.collections.toTypedArray' call
            var tmp$ret$6 = copyToArray(this_0);
            this.cdv_1.setLineDash(tmp$ret$6);
          }
          this.cdv_1.stroke();
        }
        break $l$block;
      }finally {
        this.cdv_1.restore();
      }
    }
  }
  mdv(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.w1_1) {
      case 1:
        // Inline function 'org.w3c.dom.NONZERO' call

        // Inline function 'kotlin.js.asDynamic' call

        // Inline function 'kotlin.js.unsafeCast' call

        tmp = 'nonzero';
        break;
      case 0:
        // Inline function 'org.w3c.dom.EVENODD' call

        // Inline function 'kotlin.js.asDynamic' call

        // Inline function 'kotlin.js.unsafeCast' call

        tmp = 'evenodd';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
}
//endregion
function get_isLow(_this__u8e3s4) {
  return _this__u8e3s4.w7g() <= 0.25;
}
var GrowMethod_GROW_IMAGE_instance;
var GrowMethod_NEW_IMAGES_instance;
var GrowMethod_entriesInitialized;
function GrowMethod_initEntries() {
  if (GrowMethod_entriesInitialized)
    return Unit_instance;
  GrowMethod_entriesInitialized = true;
  GrowMethod_GROW_IMAGE_instance = new GrowMethod('GROW_IMAGE', 0);
  GrowMethod_NEW_IMAGES_instance = new GrowMethod('NEW_IMAGES', 1);
}
function reconstructWithSize($this, width, height) {
  var slices = toList($this.sc0_1);
  $this.kc0_1 = Companion_instance_0.aai(width, height);
  $this.qc0_1 = Bitmap32.lc1(width, height, VOID, $this.mc0_1);
  $this.rc0_1.a5();
  $this.rc0_1.d2($this.qc0_1);
  $this.tc0_1.a5();
  $this.sc0_1.a5();
  var _iterator__ex2g4s = slices.p1();
  while (_iterator__ex2g4s.q1()) {
    var entry = _iterator__ex2g4s.r1();
    $this.mc1(entry.ic0_1, entry.jc0_1, entry.ic0_1.laj_1);
  }
}
function growAtlas($this, bmp) {
  switch ($this.oc0_1.w1_1) {
    case 0:
      reconstructWithSize($this, imul($this.w9z(), 2), imul($this.x9z(), 2));
      break;
    case 1:
      if (bmp.qaj_1 > $this.w9z() || bmp.raj_1 > $this.x9z()) {
        // Inline function 'kotlin.error' call
        var message = 'Atlas is too small (' + $this.w9z() + 'x' + $this.x9z() + ') to hold a slice of (' + bmp.qaj_1 + 'x' + bmp.raj_1 + ')';
        throw IllegalStateException.o(toString_0(message));
      }

      $this.kc0_1 = Companion_instance_0.aai($this.w9z(), $this.x9z());
      $this.qc0_1 = Bitmap32.lc1($this.w9z(), $this.x9z(), VOID, $this.mc0_1);
      $this.rc0_1.d2($this.qc0_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function GrowMethod_NEW_IMAGES_getInstance() {
  GrowMethod_initEntries();
  return GrowMethod_NEW_IMAGES_instance;
}
function set_baseMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp0 = baseMipmapLevel$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_baseMipmapLevel_$ref_ckpyc5();
  // Inline function 'korlibs.datastructure.Property.setValue' call
  var property = getPropertyCallableRef('baseMipmapLevel', 1, tmp, tmp_0, _set_baseMipmapLevel_$ref_q0ak7());
  var tmp0_elvis_lhs = tmp0.q9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_baseMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp0 = baseMipmapLevel$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_baseMipmapLevel_$ref_ckpyc5();
  var tmp4 = getPropertyCallableRef('baseMipmapLevel', 1, tmp, tmp_0, _set_baseMipmapLevel_$ref_q0ak7());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var tmp_1 = _this__u8e3s4.p9u();
    var tmp0_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap) : false) ? tmp_1 : null;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp0_elvis_lhs = tmp0.q9u_1;
      tmp_2 = tmp0_safe_receiver.w4(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_2;
    if (res == null) {
      var r = tmp0.r9u_1();
      var tmp_3;
      if (!(r == null)) {
        tmp_3 = true;
      } else {
        var tmp1_elvis_lhs = tmp0.q9u_1;
        tmp_3 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? tmp4.callableName : tmp1_elvis_lhs);
      }
      if (tmp_3) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = tmp0.q9u_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var baseMipmapLevel$delegate;
function set_maxMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp0 = maxMipmapLevel$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_maxMipmapLevel_$ref_6i9ufy();
  // Inline function 'korlibs.datastructure.Property.setValue' call
  var property = getPropertyCallableRef('maxMipmapLevel', 1, tmp, tmp_0, _set_maxMipmapLevel_$ref_rflgoe());
  var tmp0_elvis_lhs = tmp0.q9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_maxMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp0 = maxMipmapLevel$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_maxMipmapLevel_$ref_6i9ufy();
  var tmp4 = getPropertyCallableRef('maxMipmapLevel', 1, tmp, tmp_0, _set_maxMipmapLevel_$ref_rflgoe());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var tmp_1 = _this__u8e3s4.p9u();
    var tmp0_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap) : false) ? tmp_1 : null;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp0_elvis_lhs = tmp0.q9u_1;
      tmp_2 = tmp0_safe_receiver.w4(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_2;
    if (res == null) {
      var r = tmp0.r9u_1();
      var tmp_3;
      if (!(r == null)) {
        tmp_3 = true;
      } else {
        var tmp1_elvis_lhs = tmp0.q9u_1;
        tmp_3 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? tmp4.callableName : tmp1_elvis_lhs);
      }
      if (tmp_3) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = tmp0.q9u_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var maxMipmapLevel$delegate;
function Bitmap$tempInts$delegate$lambda(this$0) {
  return () => new Int32Array(imul(this$0.sc1_1, 2));
}
function Bitmap$_get_tempInts_$ref_piyo2f() {
  return constructCallableReference((p0) => p0.jc2(), 1, 0, 106);
}
function mipmaps(_this__u8e3s4, enable) {
  enable = enable === VOID ? true : enable;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'kotlin.apply' call
  _this__u8e3s4.dc2_1 = enable;
  return _this__u8e3s4;
}
function readPixelsUnsafe(_this__u8e3s4, x, y, width, height) {
  _init_properties_Bitmap_kt__y1ku1b();
  var out = new Int32Array(imul(width, height));
  _this__u8e3s4.pc2(x, y, width, height, out, 0);
  return out;
}
function asumePremultiplied(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  _this__u8e3s4.yc1_1 = true;
  _this__u8e3s4.zc1_1 = true;
  return _this__u8e3s4;
}
function NativeImageContext2d(width, height, antialiased, block) {
  antialiased = antialiased === VOID ? true : antialiased;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'korlibs.image.bitmap.context2d' call
  var this_0 = NativeImage_0(width, height, true);
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = this_0.wc1_1;
  if (false) {
    this_0.fc2();
  }
  var result;
  try {
    var ctx = this_0.oc9(antialiased);
    try {
      block(ctx);
    }finally {
      ctx.u1o();
    }
  }finally {
    result = false ? this_0.hc2(rect) : 0;
  }
  return this_0;
}
function baseMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function _get_baseMipmapLevel_$ref_ckpyc5() {
  return constructCallableReference((p0) => get_baseMipmapLevel(p0), 1, 0, 107);
}
function _set_baseMipmapLevel_$ref_q0ak7() {
  return constructCallableReference((p0, p1) => {
    set_baseMipmapLevel(p0, p1);
    return Unit_instance;
  }, 2, 0, 108);
}
function maxMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function _get_maxMipmapLevel_$ref_6i9ufy() {
  return constructCallableReference((p0) => get_maxMipmapLevel(p0), 1, 0, 109);
}
function _set_maxMipmapLevel_$ref_rflgoe() {
  return constructCallableReference((p0, p1) => {
    set_maxMipmapLevel(p0, p1);
    return Unit_instance;
  }, 2, 0, 110);
}
var properties_initialized_Bitmap_kt_sxrn69;
function _init_properties_Bitmap_kt__y1ku1b() {
  if (!properties_initialized_Bitmap_kt_sxrn69) {
    properties_initialized_Bitmap_kt_sxrn69 = true;
    baseMipmapLevel$delegate = new Property(VOID, baseMipmapLevel$delegate$lambda);
    maxMipmapLevel$delegate = new Property(VOID, maxMipmapLevel$delegate$lambda);
  }
}
var Companion_instance_5;
function Companion_getInstance_15() {
  if (Companion_instance_5 === VOID)
    new Companion();
  return Companion_instance_5;
}
function Bitmap32$iterator$slambda(this$0) {
  return constructCallableReference(function *($this$iterator, $completion) {
    var inductionVariable = 0;
    var last = this$0.g9r();
    var tmp;
    if (inductionVariable < last) {
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        yield* $this$iterator.xm(new RGBA(this$0.dcb(n)), $completion);
      }
       while (inductionVariable < last);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 1);
}
function isFullyTransparent(_this__u8e3s4) {
  var bmp = get_bmp(_this__u8e3s4);
  var data = _RgbaArray___init__impl__oib4y4(get_bmp(_this__u8e3s4).ic1_1);
  var width = _this__u8e3s4.w9h() - _this__u8e3s4.v9h() | 0;
  var inductionVariable = _this__u8e3s4.x9h();
  var last = _this__u8e3s4.y9h();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var index = bmp.nc2(_this__u8e3s4.v9h(), y);
      // Inline function 'kotlin.check' call
      if (!(index >= 0 && index <= (_RgbaArray___get_size__impl__imxef8(data) - width | 0))) {
        var message = 'left=' + _this__u8e3s4.v9h() + ', top=' + _this__u8e3s4.x9h() + ', right=' + _this__u8e3s4.w9h() + ', bottom=' + _this__u8e3s4.y9h();
        throw IllegalStateException.o(toString_0(message));
      }
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < width)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!(_RGBA___get_a__impl__6msvu7(RgbaArray__get_impl_nzyo1o(data, index + n | 0)) === 0))
            return false;
        }
         while (inductionVariable_0 < width);
    }
     while (inductionVariable < last);
  return true;
}
function expandBorder(_this__u8e3s4, area, border) {
  return expandBorder_0(_this__u8e3s4, area.x9h(), area.v9h(), area.y9h(), area.w9h(), border);
}
function expandBorder_0(_this__u8e3s4, areaTop, areaLeft, areaBottom, areaRight, border) {
  var data = _this__u8e3s4.ic1_1;
  var x0Index = _this__u8e3s4.nc2(areaLeft, areaTop);
  var x1Index = _this__u8e3s4.nc2(areaRight - 1 | 0, areaTop);
  var areaWidth = areaRight - areaLeft | 0;
  var areaHeight = areaBottom - areaTop | 0;
  var inductionVariable = 0;
  if (inductionVariable < areaHeight)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var x0Color = data[x0Index];
      var x1Color = data[x1Index];
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < border)
        do {
          var m = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          data[(x0Index - m | 0) - 1 | 0] = x0Color;
          data[(x1Index + m | 0) + 1 | 0] = x1Color;
        }
         while (inductionVariable_0 < border);
      x0Index = x0Index + _this__u8e3s4.sc1_1 | 0;
      x1Index = x1Index + _this__u8e3s4.sc1_1 | 0;
    }
     while (inductionVariable < areaHeight);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 < border)
    do {
      var m_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var x = areaLeft - border | 0;
      var npixels = areaWidth + imul(border, 2) | 0;
      arraycopy(data, _this__u8e3s4.nc2(x, areaTop), data, _this__u8e3s4.nc2(x, (areaTop - m_0 | 0) - 1 | 0), npixels);
      arraycopy(data, _this__u8e3s4.nc2(x, areaBottom - 1 | 0), data, _this__u8e3s4.nc2(x, areaBottom + m_0 | 0), npixels);
    }
     while (inductionVariable_1 < border);
}
var Companion_instance_6;
function Companion_getInstance_16() {
  return Companion_instance_6;
}
var BitmapChannel_RED_instance;
var BitmapChannel_GREEN_instance;
var BitmapChannel_BLUE_instance;
var BitmapChannel_ALPHA_instance;
var Companion_instance_7;
function Companion_getInstance_17() {
  BitmapChannel_initEntries();
  if (Companion_instance_7 === VOID)
    new Companion_1();
  return Companion_instance_7;
}
function values() {
  return [BitmapChannel_RED_getInstance(), BitmapChannel_GREEN_getInstance(), BitmapChannel_BLUE_getInstance(), BitmapChannel_ALPHA_getInstance()];
}
var BitmapChannel_entriesInitialized;
function BitmapChannel_initEntries() {
  if (BitmapChannel_entriesInitialized)
    return Unit_instance;
  BitmapChannel_entriesInitialized = true;
  BitmapChannel_RED_instance = new BitmapChannel('RED', 0, 0);
  BitmapChannel_GREEN_instance = new BitmapChannel('GREEN', 1, 1);
  BitmapChannel_BLUE_instance = new BitmapChannel('BLUE', 2, 2);
  BitmapChannel_ALPHA_instance = new BitmapChannel('ALPHA', 3, 3);
  Companion_getInstance_17();
}
function BitmapChannel_RED_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_RED_instance;
}
function BitmapChannel_GREEN_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_GREEN_instance;
}
function BitmapChannel_BLUE_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_BLUE_instance;
}
function BitmapChannel_ALPHA_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_ALPHA_instance;
}
function slice(_this__u8e3s4, bounds, name, orientation, padding) {
  bounds = bounds === VOID ? RectangleInt.s9q(0, 0, _this__u8e3s4.sc1_1, _this__u8e3s4.tc1_1) : bounds;
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_0().yai_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_3().n9k_1 : padding;
  var left = clamp(bounds.v9h(), 0, _this__u8e3s4.sc1_1);
  var top = clamp(bounds.x9h(), 0, _this__u8e3s4.tc1_1);
  return new RectSlice(_this__u8e3s4, Companion_instance_1.v9p(left, top, clamp(bounds.w9h(), left, _this__u8e3s4.sc1_1), clamp(bounds.y9h(), top, _this__u8e3s4.tc1_1)), orientation, padding, name);
}
function get_bmp(_this__u8e3s4) {
  return get_container(_this__u8e3s4);
}
function extract_0(_this__u8e3s4) {
  var w = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.jaj_1) ? _this__u8e3s4.iaj_1.q9q_1 : _this__u8e3s4.iaj_1.r9q_1;
  var h = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.jaj_1) ? _this__u8e3s4.iaj_1.r9q_1 : _this__u8e3s4.iaj_1.q9q_1;
  var tmp = get_container(_this__u8e3s4).nc9(w + _this__u8e3s4.kaj_1.l9k() | 0, h + _this__u8e3s4.kaj_1.m9k() | 0);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  var raw = extractUntransformed(_this__u8e3s4).mc9(_this__u8e3s4.jaj_1);
  raw.ac9(0, 0, out, _this__u8e3s4.kaj_1.r9k_1, _this__u8e3s4.kaj_1.o9k_1, raw.sc1_1, raw.tc1_1);
  return out;
}
function sliceWithSize(_this__u8e3s4, x, y, width, height, name, orientation, padding) {
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_0().yai_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_3().n9k_1 : padding;
  return slice(_this__u8e3s4, RectangleInt.s9q(x, y, width, height), name, orientation, padding);
}
function get_bounds_0(_this__u8e3s4) {
  return _this__u8e3s4.iaj_1;
}
function get_container(_this__u8e3s4) {
  return _this__u8e3s4.qak();
}
function extractUntransformed(_this__u8e3s4) {
  var tmp = get_container(_this__u8e3s4).nc9(_this__u8e3s4.iaj_1.q9q_1, _this__u8e3s4.iaj_1.r9q_1);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  get_container(_this__u8e3s4).xc8(_this__u8e3s4.iaj_1.o9q_1, _this__u8e3s4.iaj_1.p9q_1, out, 0, 0, _this__u8e3s4.iaj_1.q9q_1, _this__u8e3s4.iaj_1.r9q_1);
  return out;
}
function get_Bitmaps_transparent() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_transparent;
}
var Bitmaps_transparent;
function get_Bitmaps_white() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_white;
}
var Bitmaps_white;
var Bitmaps_instance;
function Bitmaps_getInstance() {
  return Bitmaps_instance;
}
var properties_initialized_Bitmaps_kt_qcuk18;
function _init_properties_Bitmaps_kt__92w93i() {
  if (!properties_initialized_Bitmaps_kt_qcuk18) {
    properties_initialized_Bitmaps_kt_qcuk18 = true;
    Bitmaps_transparent = slice(Companion_getInstance_15().yc9(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().ec3_1)), VOID, 'transparent');
    Bitmaps_white = slice(Companion_getInstance_15().yc9(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().zc2_1)), VOID, 'white');
  }
}
var Companion_instance_8;
function Companion_getInstance_18() {
  return Companion_instance_8;
}
function setFromBitmap$getAlpha(_this__u8e3s4, x, y, min) {
  return _this__u8e3s4.dc9(x, y) ? _RGBA___get_a__impl__6msvu7(_this__u8e3s4.qc2(x, y)) >= min : false;
}
function setFromBitmap$pass(this$0, x, y, dx, dy, d) {
  if (this$0.ucd(x + dx | 0, y + dy | 0) + d < this$0.ucd(x, y)) {
    this$0.qcd(x, y, x + dx | 0, y + dy | 0);
    var tmp0 = x - this$0.rcd(x, y) | 0;
    // Inline function 'kotlin.math.hypot' call
    var y_0 = y - this$0.scd(x, y) | 0;
    var tmp$ret$0 = hypot(tmp0, y_0);
    this$0.tcd(x, y, tmp$ret$0);
  }
}
function distanceMap(_this__u8e3s4, out, thresold) {
  out = out === VOID ? new DistanceBitmap(_this__u8e3s4.sc1_1, _this__u8e3s4.tc1_1) : out;
  thresold = thresold === VOID ? 0.5 : thresold;
  // Inline function 'kotlin.also' call
  out.wcd(_this__u8e3s4, thresold);
  return out;
}
function index4($this, x, y) {
  return imul($this.nc2(x, y), 4);
}
function NativeImage_0(width, height, premultiplied) {
  premultiplied = premultiplied === VOID ? null : premultiplied;
  return get_nativeImageFormatProvider().qcf(width, height, premultiplied);
}
function NativeImageOrBitmap32(width, height, native, premultiplied) {
  native = native === VOID ? true : native;
  premultiplied = premultiplied === VOID ? null : premultiplied;
  var tmp;
  if (native) {
    tmp = NativeImage_0(width, height, premultiplied);
  } else {
    tmp = Bitmap32.lc1(width, height, VOID, premultiplied == null ? true : premultiplied);
  }
  return tmp;
}
function ensureNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof NativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = get_nativeImageFormatProvider().scf(_this__u8e3s4);
  }
  return tmp;
}
var Companion_instance_9;
function Companion_getInstance_19() {
  if (Companion_instance_9 === VOID)
    Companion_3.gcg();
  return Companion_instance_9;
}
function applyEffect(_this__u8e3s4, effect) {
  var safeBorder = get_safeBorder(effect);
  var out = Companion_getInstance_15().zc9(_this__u8e3s4.sc1_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.tc1_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.yc1_1);
  out.rcb(_this__u8e3s4, safeBorder, safeBorder);
  applyEffectInline(out, effect);
  return out;
}
function get_safeBorder(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 == null ? null : _this__u8e3s4.gch();
  return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
}
function applyEffectInline(_this__u8e3s4, effect) {
  if (effect == null)
    return Unit_instance;
  if (!(effect.zcg_1 === 0)) {
    blurInplace(_this__u8e3s4, effect.zcg_1);
  }
  if (!(effect.cch_1 === 0) || !(effect.ach_1 === 0) || !(effect.bch_1 === 0)) {
    dropShadowInplace(_this__u8e3s4, effect.ach_1, effect.bch_1, effect.cch_1, effect.dch_1);
  }
  if (!(effect.ech_1 === 0)) {
    borderInline(_this__u8e3s4, effect.ech_1, effect.fch_1);
  }
}
function blurInplace(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.sc1_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.tc1_1 / 2 | 0) - 1 | 0);
  var t1 = Bitmap8.rcc(_this__u8e3s4.sc1_1, _this__u8e3s4.tc1_1);
  var t2 = Bitmap8.rcc(_this__u8e3s4.sc1_1, _this__u8e3s4.tc1_1);
  var inductionVariable = 0;
  if (inductionVariable < 4)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var channel = Companion_getInstance_17().u2(n);
      _this__u8e3s4.vcb(channel, t1);
      arraycopy_0(t1.x8s(), 0, t2.x8s(), 0, t2.g9r());
      gaussBlur(t1.x8s(), t2.x8s(), _this__u8e3s4.sc1_1, _this__u8e3s4.tc1_1, r_0);
      _this__u8e3s4.ucb(channel, t2);
    }
     while (inductionVariable < 4);
}
function gaussBlur(scl, tcl, w, h, r) {
  var a = 0;
  var b = 0;
  var c = 0;
  // Inline function 'korlibs.image.bitmap.effect.boxesForGaussN3' call
  var n = 3;
  // Inline function 'kotlin.math.sqrt' call
  var x = 12.0 * r * r / n + 1;
  var wIdeal = Math.sqrt(x);
  var wl = toIntFloor_0(wIdeal);
  if ((wl % 2 | 0) === 0) {
    wl = wl - 1 | 0;
  }
  var wu = wl + 2 | 0;
  var mIdeal = (12.0 * r * r - imul(imul(n, wl), wl) - imul(imul(4, n), wl) - imul(3, n)) / (imul(-4, wl) - 4 | 0);
  var m = round(mIdeal);
  var tmp0 = 0 < m ? wl : wu;
  var tmp2 = 1 < m ? wl : wu;
  var v2 = 2 < m ? wl : wu;
  a = tmp0;
  b = tmp2;
  c = v2;
  boxBlur(scl, tcl, w, h, (a - 1 | 0) / 2 | 0);
  boxBlur(tcl, scl, w, h, (b - 1 | 0) / 2 | 0);
  boxBlur(scl, tcl, w, h, (c - 1 | 0) / 2 | 0);
}
function boxBlur(scl, tcl, w, h, r) {
  arraycopy_0(scl, 0, tcl, 0, scl.length);
  boxBlurH(tcl, scl, w, h, r);
  boxBlurT(scl, tcl, w, h, r);
}
function boxBlurH(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < h)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = imul(i, w);
      var li = ti;
      var ri = ti + r | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, (ti + w | 0) - 1 | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + j | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var tmp = v;
          var _unary__edvuaz = ri;
          ri = _unary__edvuaz + 1 | 0;
          v = tmp + (getU8(scl, _unary__edvuaz) - fv | 0) | 0;
          var _unary__edvuaz_0 = ti;
          ti = _unary__edvuaz_0 + 1 | 0;
          tcl[_unary__edvuaz_0] = toByte(v / arr | 0);
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = w - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var tmp_0 = v;
          var _unary__edvuaz_1 = ri;
          ri = _unary__edvuaz_1 + 1 | 0;
          var tmp_1 = getU8(scl, _unary__edvuaz_1);
          var _unary__edvuaz_2 = li;
          li = _unary__edvuaz_2 + 1 | 0;
          v = tmp_0 + (tmp_1 - getU8(scl, _unary__edvuaz_2) | 0) | 0;
          var _unary__edvuaz_3 = ti;
          ti = _unary__edvuaz_3 + 1 | 0;
          tcl[_unary__edvuaz_3] = toByte(v / arr | 0);
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = w - r | 0;
      if (inductionVariable_3 < w)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var tmp_2 = v;
          var _unary__edvuaz_4 = li;
          li = _unary__edvuaz_4 + 1 | 0;
          v = tmp_2 + (lv - getU8(scl, _unary__edvuaz_4) | 0) | 0;
          var _unary__edvuaz_5 = ti;
          ti = _unary__edvuaz_5 + 1 | 0;
          tcl[_unary__edvuaz_5] = toByte(v / arr | 0);
        }
         while (inductionVariable_3 < w);
    }
     while (inductionVariable < h);
}
function boxBlurT(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < w)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = i;
      var li = ti;
      var ri = ti + imul(r, w) | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, ti + imul(w, h - 1 | 0) | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + imul(j, w) | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          v = v + (getU8(scl, ri) - fv | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = h - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          v = v + (getU8(scl, ri) - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = h - r | 0;
      if (inductionVariable_3 < h)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          v = v + (lv - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_3 < h);
    }
     while (inductionVariable < w);
}
function blur(_this__u8e3s4, r) {
  var out = Bitmap8.rcc(_this__u8e3s4.sc1_1 + imul(r, 2) | 0, _this__u8e3s4.tc1_1 + imul(r, 2) | 0);
  Companion_instance_6.ycc(_this__u8e3s4, 0, 0, out, r, r, _this__u8e3s4.sc1_1, _this__u8e3s4.tc1_1);
  blurInplace_0(out, r);
  return out;
}
function blurInplace_0(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.sc1_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.tc1_1 / 2 | 0) - 1 | 0);
  var t2 = Bitmap8.rcc(_this__u8e3s4.sc1_1, _this__u8e3s4.tc1_1);
  arraycopy_0(_this__u8e3s4.x8s(), 0, t2.x8s(), 0, _this__u8e3s4.g9r());
  gaussBlur(t2.x8s(), _this__u8e3s4.x8s(), _this__u8e3s4.sc1_1, _this__u8e3s4.tc1_1, r_0);
}
function borderInline(_this__u8e3s4, r, color) {
  color = color === VOID ? Colors_getInstance().ac3_1 : color;
  var out = _this__u8e3s4;
  var distance = distanceMap(out);
  var inductionVariable = 0;
  var last = out.tc1_1;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = out.sc1_1;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dist = distance.ucd(x, y);
          if (dist < (r + 1 | 0)) {
            var alpha = dist >= r ? 1.0 - dist % 1.0 : 1.0;
            var rcolor = alpha === 1.0 ? color : RGBA__withAf_impl_dpdu32(color, _RGBA___get_af__impl__vu36qv(color) * alpha);
            out.gcb(x, y, Companion_getInstance_21().hch(rcolor, out.hcb(x, y)));
          }
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
}
function dropShadowInplace(_this__u8e3s4, x, y, r, color) {
  color = color === VOID ? Colors_getInstance().ac3_1 : color;
  // Inline function 'kotlin.apply' call
  var copy = _this__u8e3s4.g9m();
  var pcolor = _RGBA___get_premultiplied__impl__3bulqc(color);
  // Inline function 'kotlin.also' call
  var this_0 = blur(_this__u8e3s4.wcb(BitmapChannel_ALPHA_getInstance()), r);
  this_0.yc1_1 = true;
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaArray__set_impl_epw2wg(this_0.wca_1, n, Companion_getInstance_21().ich(imul(_RGBAPremultiplied___get_r__impl__m8nz5i(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_g__impl__fv131x(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_b__impl__dt4tp6(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_a__impl__f0hnd1(pcolor), n) / 255 | 0));
    }
     while (inductionVariable < 256);
  var shadow = this_0.ec2();
  _this__u8e3s4.pcb(Colors_getInstance().ec3_1);
  _this__u8e3s4.scb(shadow, x - r | 0, y - r | 0);
  _this__u8e3s4.scb(copy, 0, 0);
  return _this__u8e3s4;
}
var NewSDF_instance;
function NewSDF_getInstance() {
  return NewSDF_instance;
}
function decode(_this__u8e3s4, data, dataOffset, out, outOffset, size, littleEndian) {
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  switch (_this__u8e3s4.sch()) {
    case 16:
      var tmp_0;
      if (littleEndian) {
        tmp_0 = getU16LE$ref();
      } else {
        tmp_0 = getU16BE$ref();
      }

      tmp = tmp_0;
      break;
    case 24:
      var tmp_1;
      if (littleEndian) {
        tmp_1 = getU24LE$ref();
      } else {
        tmp_1 = getU24BE$ref();
      }

      tmp = tmp_1;
      break;
    case 32:
      var tmp_2;
      if (littleEndian) {
        tmp_2 = getS32LE$ref();
      } else {
        tmp_2 = getS32BE$ref();
      }

      tmp = tmp_2;
      break;
    default:
      throw IllegalArgumentException.h2('Unsupported bpp ' + _this__u8e3s4.sch());
  }
  var readFunc = tmp;
  // Inline function 'korlibs.image.color.decodeInternal' call
  var io = dataOffset;
  var oo = outOffset;
  var bytesPerPixel = get_bytesPerPixel(_this__u8e3s4);
  var outdata = out;
  var Bpp = numberToInt(bytesPerPixel);
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = readFunc(data, io);
      io = io + Bpp | 0;
      var _unary__edvuaz = oo;
      oo = _unary__edvuaz + 1 | 0;
      RgbaArray__set_impl_epw2wg(outdata, _unary__edvuaz, Companion_getInstance_21().ich(_this__u8e3s4.tch(c), _this__u8e3s4.uch(c), _this__u8e3s4.vch(c), _this__u8e3s4.wch(c)));
    }
     while (inductionVariable < size);
}
function get_bytesPerPixel(_this__u8e3s4) {
  return _this__u8e3s4.sch() / 8;
}
function getU16LE$ref() {
  return constructCallableReference((p0, p1) => getU16LE(p0, p1), 2, 0, 111, 'getU16LE');
}
function getU16BE$ref() {
  return constructCallableReference((p0, p1) => getU16BE(p0, p1), 2, 0, 112, 'getU16BE');
}
function getU24LE$ref() {
  return constructCallableReference((p0, p1) => getU24LE(p0, p1), 2, 0, 113, 'getU24LE');
}
function getU24BE$ref() {
  return constructCallableReference((p0, p1) => getU24BE(p0, p1), 2, 0, 114, 'getU24BE');
}
function getS32LE$ref() {
  return constructCallableReference((p0, p1) => getS32LE(p0, p1), 2, 0, 115, 'getS32LE');
}
function getS32BE$ref() {
  return constructCallableReference((p0, p1) => getS32BE(p0, p1), 2, 0, 116, 'getS32BE');
}
var Colors_instance;
function Colors_getInstance() {
  if (Colors_instance === VOID)
    new Colors();
  return Colors_instance;
}
var Companion_instance_10;
function Companion_getInstance_20() {
  if (Companion_instance_10 === VOID)
    new Companion_4();
  return Companion_instance_10;
}
function blendComponent($this, c1, c2, factor) {
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = c1 * (1.0 - Ratio__toFloat_impl_1ftup5(factor)) + c2 * Ratio__toFloat_impl_1ftup5(factor);
  return roundToInt(this_0) & 255;
}
function _RGBA___init__impl__lqpay5(value) {
  return value;
}
function _RGBA___get_value__impl__hhco8v($this) {
  return $this;
}
function RGBA__clone_impl_w007z0($this) {
  return new RGBA($this);
}
function _RGBA___get_color__impl__8x3sb3($this) {
  return $this;
}
function _RGBA___get_r__impl__duz7mo($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 0 | 0) & 255;
}
function _RGBA___get_g__impl__o8pukr($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 8 | 0) & 255;
}
function _RGBA___get_b__impl__m6tl80($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 16 | 0) & 255;
}
function _RGBA___get_a__impl__6msvu7($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 24 | 0) & 255;
}
function _RGBA___get_rf__impl__kvz75k($this) {
  return _RGBA___get_r__impl__duz7mo($this) / 255.0;
}
function _RGBA___get_gf__impl__5gcu1f($this) {
  return _RGBA___get_g__impl__o8pukr($this) / 255.0;
}
function _RGBA___get_bf__impl__1xz5yg($this) {
  return _RGBA___get_b__impl__m6tl80($this) / 255.0;
}
function _RGBA___get_af__impl__vu36qv($this) {
  return _RGBA___get_a__impl__6msvu7($this) / 255.0;
}
function _RGBA___get_rgb__impl__tijaqt($this) {
  return _RGBA___get_value__impl__hhco8v($this) & 16777215;
}
function RGBA__withA_impl_vogscm($this, v) {
  return _RGBA___init__impl__lqpay5(_RGBA___get_value__impl__hhco8v($this) & 16777215 | clampUByte(v) << 24);
}
function RGBA__withAd_impl_cralao($this, v) {
  return RGBA__withA_impl_vogscm($this, d2i(v));
}
function RGBA__withAf_impl_dpdu32($this, v) {
  return RGBA__withA_impl_vogscm($this, f2i(v));
}
function RGBA__concatAd_impl_gwhfm($this, v) {
  return RGBA__withA_impl_vogscm($this, roundToInt(_RGBA___get_a__impl__6msvu7($this) * v));
}
function _RGBA___get_hexString__impl__kocngm($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.ad(9);
  this_0.o1(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  appendHexByte(this_0, _RGBA___get_a__impl__6msvu7($this));
  return this_0.toString();
}
function _RGBA___get_hexStringNoAlpha__impl__j315et($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.ad(7);
  this_0.o1(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  return this_0.toString();
}
function _RGBA___get_htmlColor__impl__bzw5k6($this) {
  return 'rgba(' + _RGBA___get_r__impl__duz7mo($this) + ', ' + _RGBA___get_g__impl__o8pukr($this) + ', ' + _RGBA___get_b__impl__m6tl80($this) + ', ' + get_niceStr(_RGBA___get_af__impl__vu36qv($this)) + ')';
}
function _RGBA___get_htmlStringSimple__impl__l4nu0u($this) {
  return _RGBA___get_hexStringNoAlpha__impl__j315et($this);
}
function RGBA__toString_impl_4lw6dp($this) {
  return _RGBA___get_hexString__impl__kocngm($this);
}
function RGBA__compareTo_impl_lrfjc1($this, other) {
  return compareTo(_RGBA___get_value__impl__hhco8v($this), _RGBA___get_value__impl__hhco8v(other));
}
function RGBA__compareTo_impl_lrfjc1_0($this, other) {
  return RGBA__compareTo_impl_lrfjc1($this.sci_1, other instanceof RGBA ? other.sci_1 : THROW_CCE());
}
function RGBA__interpolateWith_impl_mw7p5y($this, ratio, other) {
  return Companion_getInstance_21().yci($this, other, ratio);
}
function RGBA__interpolateWith_impl_mw7p5y_0($this, ratio, other) {
  return new RGBA(RGBA__interpolateWith_impl_mw7p5y($this.sci_1, ratio, other instanceof RGBA ? other.sci_1 : THROW_CCE()));
}
function RGBA__premultipliedValue_impl_oja55q($this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc($this)) : _RGBA___get_value__impl__hhco8v($this);
}
function _RGBA___get_premultiplied__impl__3bulqc($this) {
  return _RGBA___get_premultipliedFast__impl__qiau4g($this);
}
function _RGBA___get_premultipliedFast__impl__qiau4g($this) {
  var A = _RGBA___get_a__impl__6msvu7($this) + 1 | 0;
  if (A >= 255)
    return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this));
  if (A <= 1)
    return _RGBAPremultiplied___init__impl__uos02x(0);
  var RB = (imul(_RGBA___get_value__impl__hhco8v($this) & 16711935, A) >>> 8 | 0) & 16711935;
  var G = (imul(_RGBA___get_value__impl__hhco8v($this) & 65280, A) >>> 8 | 0) & 65280;
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this) & -16777216 | RB | G);
}
var Companion_instance_11;
function Companion_getInstance_21() {
  if (Companion_instance_11 === VOID)
    new Companion_5();
  return Companion_instance_11;
}
function RGBA__hashCode_impl_h59qf6($this) {
  return $this;
}
function RGBA__equals_impl_4vjmca($this, other) {
  if (!(other instanceof RGBA))
    return false;
  if (!($this === (other instanceof RGBA ? other.sci_1 : THROW_CCE())))
    return false;
  return true;
}
function _RGBAPremultiplied___init__impl__uos02x(value) {
  return value;
}
function _RGBAPremultiplied___get_value__impl__bqfhud($this) {
  return $this;
}
function _RGBAPremultiplied___init__impl__uos02x_0(r, g, b, a) {
  return _RGBAPremultiplied___init__impl__uos02x(packIntClamped(r, g, b, a));
}
function _RGBAPremultiplied___get_r__impl__m8nz5i($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 0 | 0) & 255;
}
function _RGBAPremultiplied___get_g__impl__fv131x($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 8 | 0) & 255;
}
function _RGBAPremultiplied___get_b__impl__dt4tp6($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 16 | 0) & 255;
}
function _RGBAPremultiplied___get_a__impl__f0hnd1($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0) & 255;
}
function _RGBAPremultiplied___get_rf__impl__pt0c4y($this) {
  return _RGBAPremultiplied___get_r__impl__m8nz5i($this) / 255.0;
}
function _RGBAPremultiplied___get_gf__impl__ivron7($this) {
  return _RGBAPremultiplied___get_g__impl__fv131x($this) / 255.0;
}
function _RGBAPremultiplied___get_bf__impl__qa3on2($this) {
  return _RGBAPremultiplied___get_b__impl__dt4tp6($this) / 255.0;
}
function _RGBAPremultiplied___get_af__impl__euwcjn($this) {
  return _RGBAPremultiplied___get_a__impl__f0hnd1($this) / 255.0;
}
function _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv($this) {
  var alpha = _RGBAPremultiplied___get_a__impl__f0hnd1($this);
  var tmp;
  if (alpha === 0) {
    tmp = Colors_getInstance().ec3_1;
  } else {
    var ialpha = 255.0 / alpha;
    var tmp_0 = Companion_getInstance_21();
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = _RGBAPremultiplied___get_r__impl__m8nz5i($this) * ialpha;
    var tmp_1 = roundToInt(this_0);
    // Inline function 'kotlin.math.roundToInt' call
    var this_1 = _RGBAPremultiplied___get_g__impl__fv131x($this) * ialpha;
    var tmp_2 = roundToInt(this_1);
    // Inline function 'kotlin.math.roundToInt' call
    var this_2 = _RGBAPremultiplied___get_b__impl__dt4tp6($this) * ialpha;
    var tmp$ret$2 = roundToInt(this_2);
    tmp = tmp_0.ich(tmp_1, tmp_2, tmp$ret$2, alpha);
  }
  return tmp;
}
function RGBAPremultiplied__scaled256_impl_hjm9ii($this, s) {
  var rb = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 16711935, s) >>> 8 | 0) & 16711935;
  var g = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 65280, s) >>> 8 | 0) & 65280;
  var a = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0, s) >>> 8 | 0) << 24;
  return _RGBAPremultiplied___init__impl__uos02x(rb | g | a);
}
function RGBAPremultiplied__scaled_impl_qz7lg1($this, alpha) {
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = clamp01_0(alpha) * 256;
  var tmp$ret$0 = roundToInt(this_0);
  return RGBAPremultiplied__scaled256_impl_hjm9ii($this, tmp$ret$0);
}
var Companion_instance_12;
function Companion_getInstance_22() {
  return Companion_instance_12;
}
function _RgbaPremultipliedArray___init__impl__lx83hy(ints) {
  return ints;
}
function _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this) {
  return $this;
}
var Companion_instance_13;
function Companion_getInstance_23() {
  return Companion_instance_13;
}
function _RgbaPremultipliedArray___get_size__impl__6lte0e($this) {
  return _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this).length;
}
function RgbaPremultipliedArray__get_impl_1u69ta($this, index) {
  return _RGBAPremultiplied___init__impl__uos02x(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index]);
}
function RgbaPremultipliedArray__set_impl_7fwbby($this, index, color) {
  _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index] = _RGBAPremultiplied___get_value__impl__bqfhud(color);
}
function RgbaPremultipliedArray__fill_impl_sem38t($this, value, start, end) {
  return fill(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this), _RGBAPremultiplied___get_value__impl__bqfhud(value), start, end);
}
function RgbaPremultipliedArray__toString_impl_seal6e($this) {
  return 'RgbaPremultipliedArray(' + _RgbaPremultipliedArray___get_size__impl__6lte0e($this) + ')';
}
function RgbaPremultipliedArray__hashCode_impl_kvnjzv($this) {
  return hashCode($this);
}
function RgbaPremultipliedArray__equals_impl_vav5d5($this, other) {
  if (!(other instanceof RgbaPremultipliedArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaPremultipliedArray ? other.lcj_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _RgbaArray___init__impl__oib4y4(ints) {
  return ints;
}
function _RgbaArray___get_ints__impl__u2kps1($this) {
  return $this;
}
var Companion_instance_14;
function Companion_getInstance_24() {
  return Companion_instance_14;
}
function RgbaArray__subList_impl_rbyi98($this, fromIndex, toIndex) {
  return new GenericSubList(new RgbaArray($this), fromIndex, toIndex);
}
function RgbaArray__contains_impl_ofn00n($this, element) {
  return contains(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
}
function RgbaArray__contains_impl_ofn00n_0($this, element) {
  if (!(element instanceof RGBA))
    return false;
  return RgbaArray__contains_impl_ofn00n($this.mcj_1, element instanceof RGBA ? element.sci_1 : THROW_CCE());
}
function RgbaArray__containsAll_impl_l6gz5c($this, elements) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(elements, Collection)) {
      tmp = elements.n1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = elements.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var it = element.sci_1;
      if (!RgbaArray__contains_impl_ofn00n($this, it)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function RgbaArray__containsAll_impl_l6gz5c_0($this, elements) {
  return RgbaArray__containsAll_impl_l6gz5c($this.mcj_1, elements);
}
function RgbaArray__indexOf_impl_d6b5pl($this, element) {
  return indexOf(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
}
function RgbaArray__indexOf_impl_d6b5pl_0($this, element) {
  if (!(element instanceof RGBA))
    return -1;
  return RgbaArray__indexOf_impl_d6b5pl($this.mcj_1, element instanceof RGBA ? element.sci_1 : THROW_CCE());
}
function RgbaArray__isEmpty_impl_nch3ip($this) {
  // Inline function 'kotlin.collections.isEmpty' call
  return _RgbaArray___get_ints__impl__u2kps1($this).length === 0;
}
function RgbaArray__iterator_impl_5wfwsm($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0_0($this, index) {
  return new GenericListIterator(new RgbaArray($this), index);
}
function _RgbaArray___get_size__impl__imxef8($this) {
  return _RgbaArray___get_ints__impl__u2kps1($this).length;
}
function RgbaArray__get_impl_nzyo1o($this, index) {
  return _RGBA___init__impl__lqpay5(_RgbaArray___get_ints__impl__u2kps1($this)[index]);
}
function RgbaArray__get_impl_nzyo1o_0($this, index) {
  return new RGBA(RgbaArray__get_impl_nzyo1o($this.mcj_1, index));
}
function RgbaArray__set_impl_epw2wg($this, index, color) {
  _RgbaArray___get_ints__impl__u2kps1($this)[index] = _RGBA___get_value__impl__hhco8v(color);
}
function RgbaArray__toString_impl_vgvk04($this) {
  return 'RgbaArray(' + _RgbaArray___get_size__impl__imxef8($this) + ')';
}
function RgbaArray__hashCode_impl_ht2l65($this) {
  return hashCode($this);
}
function RgbaArray__equals_impl_6qvuf($this, other) {
  if (!(other instanceof RgbaArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaArray ? other.mcj_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function asNonPremultiplied(_this__u8e3s4) {
  return _RGBA___init__impl__lqpay5(_RGBAPremultiplied___get_value__impl__bqfhud(_this__u8e3s4));
}
function asPremultiplied(_this__u8e3s4) {
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v(_this__u8e3s4));
}
function mix(_this__u8e3s4, src) {
  var dst = _this__u8e3s4;
  var srcAf = _RGBAPremultiplied___get_af__impl__euwcjn(src);
  var oneMSrcAf = 1.0 - srcAf;
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = _RGBAPremultiplied___get_a__impl__f0hnd1(src) + _RGBAPremultiplied___get_a__impl__f0hnd1(dst) * oneMSrcAf;
  var outA = roundToInt(this_0);
  // Inline function 'kotlin.math.roundToInt' call
  var this_1 = _RGBAPremultiplied___get_r__impl__m8nz5i(src) + _RGBAPremultiplied___get_r__impl__m8nz5i(dst) * oneMSrcAf;
  var outR = roundToInt(this_1);
  // Inline function 'kotlin.math.roundToInt' call
  var this_2 = _RGBAPremultiplied___get_g__impl__fv131x(src) + _RGBAPremultiplied___get_g__impl__fv131x(dst) * oneMSrcAf;
  var outG = roundToInt(this_2);
  // Inline function 'kotlin.math.roundToInt' call
  var this_3 = _RGBAPremultiplied___get_b__impl__dt4tp6(src) + _RGBAPremultiplied___get_b__impl__dt4tp6(dst) * oneMSrcAf;
  var outB = roundToInt(this_3);
  return _RGBAPremultiplied___init__impl__uos02x_0(outR, outG, outB, outA);
}
function scale(color, colorOffset, alpha, alphaOffset, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var a = clamp01_0(alpha[alphaOffset + n | 0]);
      if (a === 1.0)
        continue $l$loop;
      RgbaPremultipliedArray__set_impl_7fwbby(color, colorOffset + n | 0, RGBAPremultiplied__scaled_impl_qz7lg1(RgbaPremultipliedArray__get_impl_1u69ta(color, colorOffset + n | 0), a));
    }
     while (inductionVariable < count);
}
function premultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaPremultipliedArray__set_impl_7fwbby(dst, dstN + n | 0, _RGBA___get_premultiplied__impl__3bulqc(RgbaArray__get_impl_nzyo1o(src, srcN + n | 0)));
    }
     while (inductionVariable < count);
}
function depremultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = RgbaPremultipliedArray__get_impl_1u69ta(src, srcN + n | 0);
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
      RgbaArray__set_impl_epw2wg(dst, tmp, tmp$ret$0);
    }
     while (inductionVariable < count);
}
function mix_0(dst, dstX, src, srcX, count) {
  return mix_1(dst, dstX, dst, dstX, src, srcX, count);
}
function mix_1(tgt, tgtX, dst, dstX, src, srcX, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var srcC = RgbaPremultipliedArray__get_impl_1u69ta(src, srcX + n | 0);
      RgbaPremultipliedArray__set_impl_7fwbby(tgt, tgtX + n | 0, _RGBAPremultiplied___get_a__impl__f0hnd1(srcC) === 255 ? srcC : Companion_instance_12.jcj(RgbaPremultipliedArray__get_impl_1u69ta(dst, dstX + n | 0), srcC));
    }
     while (inductionVariable < count);
}
function _RGBAf___init__impl__idjpgn(data) {
  return data;
}
function _RGBAf___get_data__impl__yt2t4($this) {
  return $this;
}
function _RGBAf___init__impl__idjpgn_0(r, g, b, a) {
  r = r === VOID ? 1.0 : r;
  g = g === VOID ? 1.0 : g;
  b = b === VOID ? 1.0 : b;
  a = a === VOID ? 1.0 : a;
  // Inline function 'kotlin.floatArrayOf' call
  var tmp$ret$0 = new Float32Array([r, g, b, a]);
  return _RGBAf___init__impl__idjpgn(tmp$ret$0);
}
function _RGBAf___set_r__impl__pz5j5e($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[0] = v;
}
function _RGBAf___get_r__impl__jfq8gq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[0];
}
function _RGBAf___set_g__impl__c4jj21($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[1] = v;
}
function _RGBAf___get_g__impl__dhoraz($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[1];
}
function _RGBAf___set_b__impl__a2n9pa($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[2] = v;
}
function _RGBAf___get_b__impl__fjl0nq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[2];
}
function _RGBAf___set_a__impl__iqz7cx($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[3] = v;
}
function _RGBAf___get_a__impl__qnwk97($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[3];
}
var Companion_instance_15;
function Companion_getInstance_25() {
  return Companion_instance_15;
}
function BitmapFont$Glyph$bmp$delegate$lambda(this$0) {
  return () => extract_0(this$0.ucj_1).ec2();
}
function BitmapFont$Glyph$_get_bmp_$ref_4xexcz() {
  return constructCallableReference((p0) => p0.ack(), 1, 0, 117);
}
var Companion_instance_16;
function Companion_getInstance_26() {
  return Companion_instance_16;
}
function BitmapFontImpl$naturalFontMetrics$delegate$lambda(this$0) {
  return () => {
    var ascent = this$0.pcm_1;
    var baseline = 0.0;
    var tmp = -this$0.ucm_1;
    var tmp_0 = -this$0.ucm_1;
    // Inline function 'kotlin.run' call
    var width = 0.0;
    var _iterator__ex2g4s = this$0.qcm_1.y4().p1();
    while (_iterator__ex2g4s.q1()) {
      var glyph = _iterator__ex2g4s.r1();
      if (!(glyph == null)) {
        var tmp0 = width;
        // Inline function 'kotlin.math.max' call
        var b = glyph.ucj_1.qaj_1;
        width = Math.max(tmp0, b);
      }
    }
    var tmp$ret$0 = width;
    return new FontMetrics(this$0.ncm_1, ascent, ascent, baseline, tmp, tmp_0, 0.0, tmp$ret$0);
  };
}
function BitmapFontImpl$_get_naturalFontMetrics_$ref_dn6csr() {
  return constructCallableReference((p0) => p0.lck(), 1, 0, 118);
}
function BitmapFontImpl$anyGlyph$delegate$lambda(this$0) {
  return () => {
    var tmp0_elvis_lhs = this$0.qcm_1.u2(this$0.qcm_1.x4().p1().r1());
    return tmp0_elvis_lhs == null ? this$0.zcm() : tmp0_elvis_lhs;
  };
}
function BitmapFontImpl$_get_anyGlyph_$ref_qec2o0() {
  return constructCallableReference((p0) => p0.kck(), 1, 0, 119);
}
function BitmapFontImpl$invalidGlyph$delegate$lambda(this$0) {
  return () => {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.ncm_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function BitmapFontImpl$_get_invalidGlyph_$ref_bkheff() {
  return constructCallableReference((p0) => p0.zcm(), 1, 0, 120);
}
function *readBitmapFont(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().acn_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  var fntFile = _this__u8e3s4;
  // Inline function 'kotlin.text.trim' call
  var this_0 = yield* fntFile.tbh(VOID, $completion);
  var content = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  // Inline function 'kotlin.collections.hashMapOf' call
  var textures = HashMap.s9();
  var tmp;
  if (startsWith_0(content, _Char___init__impl__6a9atx(60))) {
    tmp = yield* readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion);
  } else if (startsWith_0(content, _Char___init__impl__6a9atx(123))) {
    tmp = yield* readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion);
  } else if (startsWith(content, 'info')) {
    tmp = yield* readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion);
  } else {
    // Inline function 'kotlin.TODO' call
    var reason = 'Unsupported font type starting with ' + substr_0(content, 0, 16);
    throw NotImplementedError.le('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function *readBitmapFontXml(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().acn_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var xml = Xml(content);
  var tmp60_safe_receiver = firstOrNull(xml.wi('info'));
  var tmp0_elvis_lhs = tmp60_safe_receiver == null ? null : tmp60_safe_receiver.gbq('size');
  var fontSize = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
  var tmp61_safe_receiver = firstOrNull(xml.wi('common'));
  var tmp1_elvis_lhs = tmp61_safe_receiver == null ? null : tmp61_safe_receiver.gbq('lineHeight');
  var lineHeight = tmp1_elvis_lhs == null ? 16.0 : tmp1_elvis_lhs;
  var tmp62_safe_receiver = firstOrNull(xml.wi('common'));
  var tmp2_elvis_lhs = tmp62_safe_receiver == null ? null : tmp62_safe_receiver.gbq('base');
  var base = tmp2_elvis_lhs == null ? 16.0 : tmp2_elvis_lhs;
  var tmp63_safe_receiver = firstOrNull(xml.wi('distanceField'));
  var distanceField = tmp63_safe_receiver == null ? null : tmp63_safe_receiver.hbq('fieldType');
  var _iterator__ex2g4s = get(xml.wi('pages'), 'page').p1();
  while (_iterator__ex2g4s.q1()) {
    var page = _iterator__ex2g4s.r1();
    var id = page.dbq('id');
    var file = page.fbq('file');
    var texFile = fntFile.x1m().wi(file);
    var tex = slice(mipmaps(yield* readBitmap(texFile, props, $completion), mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.b5(id, tex);
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get(xml.wi('chars'), 'char');
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s_0 = this_0.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var item = _iterator__ex2g4s_0.r1();
    var page_0 = item.dbq('page');
    var tmp0_elvis_lhs_0 = textures.w4(page_0);
    var texture = tmp0_elvis_lhs_0 == null ? first(textures.y4()) : tmp0_elvis_lhs_0;
    var tmp = item.dbq('id');
    var tmp_0;
    if (atlas == null) {
      tmp_0 = null;
    } else {
      var tmp_1 = texture.yak(item.dbq('x'), item.dbq('y'), item.dbq('width'), item.dbq('height'));
      tmp_0 = atlas.ic2(tmp_1 instanceof RectSlice ? tmp_1 : THROW_CCE(), Unit_instance);
    }
    var tmp65_safe_receiver = tmp_0;
    var tmp1_elvis_lhs_0 = tmp65_safe_receiver == null ? null : tmp65_safe_receiver.ic0_1;
    var tmp$ret$3 = new Glyph(fontSize, tmp, tmp1_elvis_lhs_0 == null ? texture.yak(item.dbq('x'), item.dbq('y'), item.dbq('width'), item.dbq('height')) : tmp1_elvis_lhs_0, item.dbq('xoffset'), item.dbq('yoffset'), item.dbq('xadvance'));
    destination.d2(tmp$ret$3);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_1 = get(xml.wi('kernings'), 'kerning');
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.n2(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_1 = this_1.p1();
  while (_iterator__ex2g4s_1.q1()) {
    var item_0 = _iterator__ex2g4s_1.r1();
    var tmp$ret$6 = new Kerning(item_0.dbq('first'), item_0.dbq('second'), item_0.dbq('amount'));
    destination_0.d2(tmp$ret$6);
  }
  var kernings = destination_0;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.n2(collectionSizeOrDefault(glyphs, 10));
  var _iterator__ex2g4s_2 = glyphs.p1();
  while (_iterator__ex2g4s_2.q1()) {
    var item_1 = _iterator__ex2g4s_2.r1();
    var tmp$ret$9 = to(item_1.tcj_1, item_1);
    destination_1.d2(tmp$ret$9);
  }
  var tmp8 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.n2(collectionSizeOrDefault(kernings, 10));
  var _iterator__ex2g4s_3 = kernings.p1();
  while (_iterator__ex2g4s_3.q1()) {
    var item_2 = _iterator__ex2g4s_3.r1();
    var tmp$ret$12 = to(Companion_instance_15.rcj(item_2.bck_1, item_2.cck_1), item_2);
    destination_2.d2(tmp$ret$12);
  }
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), tmp8, kernings_0, name, distanceField);
}
function *readBitmapFontJson(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().acn_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var json = get_dyn(Companion_getInstance_12().gx(content));
  var fontSize = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'info'), 'size'), 16.0);
  var lineHeight = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'lineHeight'), 16.0);
  var base = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'base'), 16.0);
  var distanceField = Dyn__toStringOrNull_impl_7e6cgy(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'distanceField'), 'fieldType'));
  // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
  var this_0 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'pages'));
  var n = 0;
  while (n < this_0.s2()) {
    var tmp0 = n;
    var page = this_0.u2(n).qbq_1;
    var file = Dyn__toString_impl_9l0v3s(page);
    var texFile = fntFile.x1m().wi(file);
    var tex = slice(mipmaps(yield* readBitmap(texFile, props, $completion), mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.b5(tmp0, tex);
    n = n + 1 | 0;
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'chars'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var it = item.qbq_1;
    var page_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'page'));
    var tmp0_elvis_lhs = textures.w4(page_0);
    var texture = tmp0_elvis_lhs == null ? first(textures.y4()) : tmp0_elvis_lhs;
    var tmp = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'id'));
    var tmp_0;
    if (atlas == null) {
      tmp_0 = null;
    } else {
      var tmp_1 = texture.yak(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height')));
      tmp_0 = atlas.ic2(tmp_1 instanceof RectSlice ? tmp_1 : THROW_CCE(), Unit_instance);
    }
    var tmp43_safe_receiver = tmp_0;
    var tmp1_elvis_lhs = tmp43_safe_receiver == null ? null : tmp43_safe_receiver.ic0_1;
    var tmp$ret$5 = new Glyph(fontSize, tmp, tmp1_elvis_lhs == null ? texture.yak(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height'))) : tmp1_elvis_lhs, _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'yoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xadvance')));
    destination.d2(tmp$ret$5);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_2 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'kernings'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.n2(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s_0 = this_2.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var item_0 = _iterator__ex2g4s_0.r1();
    var it_0 = item_0.qbq_1;
    var tmp$ret$8 = new Kerning(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'first')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'second')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'amount')));
    destination_0.d2(tmp$ret$8);
  }
  var kernings = destination_0;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.n2(collectionSizeOrDefault(glyphs, 10));
  var _iterator__ex2g4s_1 = glyphs.p1();
  while (_iterator__ex2g4s_1.q1()) {
    var item_1 = _iterator__ex2g4s_1.r1();
    var tmp$ret$11 = to(item_1.tcj_1, item_1);
    destination_1.d2(tmp$ret$11);
  }
  var tmp8 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.n2(collectionSizeOrDefault(kernings, 10));
  var _iterator__ex2g4s_2 = kernings.p1();
  while (_iterator__ex2g4s_2.q1()) {
    var item_2 = _iterator__ex2g4s_2.r1();
    var tmp$ret$14 = to(Companion_instance_15.rcj(item_2.bck_1, item_2.cck_1), item_2);
    destination_2.d2(tmp$ret$14);
  }
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), tmp8, kernings_0, name, distanceField);
}
function *readBitmapFontTxt(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().acn_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  // Inline function 'kotlin.collections.arrayListOf' call
  var kernings = ArrayList.p2();
  // Inline function 'kotlin.collections.arrayListOf' call
  var glyphs = ArrayList.p2();
  var lineHeight = 16.0;
  var fontSize = 16.0;
  var base = null;
  var _iterator__ex2g4s = lines(content).p1();
  while (_iterator__ex2g4s.q1()) {
    var rline = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.text.trim' call
    var line = toString_0(trim(isCharSequence(rline) ? rline : THROW_CCE()));
    var map = LinkedHashMap.m7();
    var _iterator__ex2g4s_0 = split_0(line, charArrayOf([_Char___init__impl__6a9atx(32)])).p1();
    while (_iterator__ex2g4s_0.q1()) {
      var part = _iterator__ex2g4s_0.r1();
      var _destruct__k2r9zo = plus(split_0(part, charArrayOf([_Char___init__impl__6a9atx(61)])), listOf(['', '']));
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.u2(0);
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.u2(1);
      // Inline function 'kotlin.collections.set' call
      map.b5(key, value);
    }
    if (startsWith(line, 'info')) {
      var tmp44_safe_receiver = map.w4('size');
      var tmp0_elvis_lhs = tmp44_safe_receiver == null ? null : toDouble(tmp44_safe_receiver);
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
      fontSize = Math.abs(this_0);
    } else if (startsWith(line, 'page')) {
      var tmp45_safe_receiver = map.w4('id');
      var tmp1_elvis_lhs = tmp45_safe_receiver == null ? null : toInt_0(tmp45_safe_receiver);
      var id = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var tmp46_safe_receiver = map.w4('file');
      var tmp2_elvis_lhs = tmp46_safe_receiver == null ? null : unquote(tmp46_safe_receiver);
      var tmp;
      if (tmp2_elvis_lhs == null) {
        // Inline function 'kotlin.error' call
        var message = 'page without file';
        throw IllegalStateException.o(toString_0(message));
      } else {
        tmp = tmp2_elvis_lhs;
      }
      var file = tmp;
      // Inline function 'kotlin.collections.set' call
      var value_0 = slice(mipmaps(yield* readBitmap(fntFile.x1m().wi(file), props, $completion), mipmaps_0));
      textures.b5(id, value_0);
    } else if (startsWith(line, 'common ')) {
      var tmp47_safe_receiver = map.w4('lineHeight');
      var tmp3_elvis_lhs = tmp47_safe_receiver == null ? null : toDoubleOrNull(tmp47_safe_receiver);
      lineHeight = tmp3_elvis_lhs == null ? 16.0 : tmp3_elvis_lhs;
      var tmp48_safe_receiver = map.w4('base');
      base = tmp48_safe_receiver == null ? null : toDoubleOrNull(tmp48_safe_receiver);
    } else if (startsWith(line, 'char ')) {
      var tmp49_safe_receiver = map.w4('page');
      var tmp4_elvis_lhs = tmp49_safe_receiver == null ? null : toIntOrNull(tmp49_safe_receiver);
      var page = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
      var tmp5_elvis_lhs = textures.w4(page);
      var texture = tmp5_elvis_lhs == null ? first(textures.y4()) : tmp5_elvis_lhs;
      var dmap = get_dyn(map);
      var id_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'id'));
      var tmp52_fontSize = fontSize;
      var tmp53_xoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xoffset'));
      var tmp54_yoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'yoffset'));
      var tmp55_xadvance = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xadvance'));
      var tmp_0;
      if (atlas == null) {
        tmp_0 = null;
      } else {
        var tmp_1 = texture.yak(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0)));
        tmp_0 = atlas.ic2(tmp_1 instanceof RectSlice ? tmp_1 : THROW_CCE(), Unit_instance);
      }
      var tmp51_safe_receiver = tmp_0;
      var tmp6_elvis_lhs = tmp51_safe_receiver == null ? null : tmp51_safe_receiver.ic0_1;
      var tmp56_texture = tmp6_elvis_lhs == null ? texture.yak(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0))) : tmp6_elvis_lhs;
      // Inline function 'kotlin.collections.plusAssign' call
      var element = new Glyph(tmp52_fontSize, id_0, tmp56_texture, tmp53_xoffset, tmp54_yoffset, tmp55_xadvance);
      glyphs.d2(element);
    } else if (startsWith(line, 'kerning ')) {
      var tmp57_safe_receiver = map.w4('first');
      var tmp7_elvis_lhs = tmp57_safe_receiver == null ? null : toIntOrNull(tmp57_safe_receiver);
      var tmp_2 = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      var tmp58_safe_receiver = map.w4('second');
      var tmp8_elvis_lhs = tmp58_safe_receiver == null ? null : toIntOrNull(tmp58_safe_receiver);
      var tmp_3 = tmp8_elvis_lhs == null ? 0 : tmp8_elvis_lhs;
      var tmp59_safe_receiver = map.w4('amount');
      var tmp9_elvis_lhs = tmp59_safe_receiver == null ? null : toIntOrNull(tmp59_safe_receiver);
      // Inline function 'kotlin.collections.plusAssign' call
      var element_0 = new Kerning(tmp_2, tmp_3, tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs);
      kernings.d2(element_0);
    }
  }
  var tmp2 = fontSize;
  var tmp4 = lineHeight;
  var tmp10_elvis_lhs = base;
  var tmp6 = tmp10_elvis_lhs == null ? lineHeight : tmp10_elvis_lhs;
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(glyphs, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.cd(capacity);
  var _iterator__ex2g4s_1 = glyphs.p1();
  while (_iterator__ex2g4s_1.q1()) {
    var element_1 = _iterator__ex2g4s_1.r1();
    var tmp$ret$13 = element_1.tcj_1;
    destination.b5(tmp$ret$13, element_1);
  }
  var tmp8 = toIntMap(destination);
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var kernings_0 = associateByInt(kernings, readBitmapFontTxt$lambda);
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(tmp2), numberToDouble(tmp4), numberToDouble(tmp6), tmp8, kernings_0, name, null);
}
function readBitmapFontTxt$lambda(_unused_var__etf5q3, it) {
  return Companion_instance_15.rcj(it.bck_1, it.cck_1);
}
var Companion_instance_17;
function Companion_getInstance_27() {
  if (Companion_instance_17 === VOID)
    new Companion_11();
  return Companion_instance_17;
}
var DefaultTtfFontOrNull;
function get_DefaultTtfFont() {
  if (DefaultTtfFontOrNull == null) {
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.time.measureTimedValue' call
    var mark = Monotonic_instance.ck();
    var result = TtfFont.acq(DefaultTtfFontBytes(), 'Default Font');
    var res = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
    DefaultTtfFontOrNull = res.lw_1;
  }
  return ensureNotNull(DefaultTtfFontOrNull);
}
function get_DefaultTtfFontAsBitmap() {
  return get_lazyBitmapSDF(get_DefaultTtfFont());
}
function DefaultTtfFontBytes() {
  return uncompress(fromBase64('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'), Companion_getInstance_13());
}
function renderGlyphToBitmap(_this__u8e3s4, size, codePoint, paint, fill, effect, border, nativeRendering, reader) {
  paint = paint === VOID ? new RGBA(get_DefaultPaint()) : paint;
  fill = fill === VOID ? true : fill;
  effect = effect === VOID ? null : effect;
  border = border === VOID ? 1 : border;
  nativeRendering = nativeRendering === VOID ? true : nativeRendering;
  reader = reader === VOID ? null : reader;
  var font = _this__u8e3s4;
  var fmetrics = _this__u8e3s4.yck(size);
  var gmetrics = _this__u8e3s4.gcl(size, codePoint, VOID, reader);
  var gx = -gmetrics.v9h();
  var gy = gmetrics.x9z() + gmetrics.x9h();
  var border2 = imul(border, 2);
  var iwidth = toIntCeil_0(gmetrics.w9z()) + border2 | 0;
  var iheight = toIntCeil_0(gmetrics.x9z()) + border2 | 0;
  var image = nativeRendering ? NativeImage_0(iwidth, iheight) : Bitmap32.lc1(iwidth, iheight, VOID, true);
  // Inline function 'korlibs.image.bitmap.context2d' call
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = image.wc1_1;
  if (true) {
    image.fc2();
  }
  var result;
  try {
    var ctx = image.oc9(true);
    try {
      renderGlyphToBitmap$renderGlyph(ctx, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
    }finally {
      ctx.u1o();
    }
  }finally {
    result = true ? image.hc2(rect) : 0;
  }
  var imageOut = applyEffect(image.pc9(), effect);
  var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.t9g(gx + border, gy + border), gmetrics, fmetrics, Companion_getInstance_5().v9k_1, 0, 0);
  var tmp = new TextMetrics();
  var tmp_0 = listOf_0(glyph);
  var tmp_1 = listOf_0(listOf_0(glyph));
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_0 = new ShapeBuilder(iwidth, iheight);
  renderGlyphToBitmap$renderGlyph(this_0, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
  var tmp$ret$4 = this_0.rcq();
  return new TextToBitmapResult(imageOut, fmetrics, tmp, tmp_0, tmp_1, tmp$ret$4);
}
function PlacedGlyphMetrics$boundsPath$delegate$lambda(this$0) {
  return () => {
    // Inline function 'korlibs.math.geom.shape.buildVectorPath' call
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    this_0.qah_1 = false;
    this_0.uas(this$0.ucq_1.v9h(), -this$0.vcq_1.qck_1, this$0.ucq_1.ecl_1, this$0.vcq_1.fck());
    return applyTransform(this_0, Companion_getInstance_5().y9k().y9l(this$0.tcq_1).f9m(this$0.wcq_1));
  };
}
function PlacedGlyphMetrics$_get_boundsPath_$ref_h88zv4() {
  return constructCallableReference((p0) => p0.dcr(), 1, 0, 121);
}
function PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this$0) {
  return () => {
    var curves = getCurves(this$0.dcr());
    var tmp;
    if (!(curves.aad_1.s2() === 4)) {
      println('curves=' + curves.aad_1.s2());
      tmp = Unit_instance;
    }
    return curves;
  };
}
function PlacedGlyphMetrics$_get_boundsPathCurves_$ref_1r7ydw() {
  return constructCallableReference((p0) => p0.ecr(), 1, 0, 122);
}
function PlacedGlyphMetrics$caretStart$delegate$lambda(this$0) {
  return () => {
    // Inline function 'korlibs.math.geom.Line2D.flipped' call
    var this_0 = this$0.ecr().aad_1.u2(3).mag();
    var tmp$ret$0 = Line2D.w9j(this_0.v9j_1, this_0.u9j_1);
    return toBezier(tmp$ret$0);
  };
}
function PlacedGlyphMetrics$_get_caretStart_$ref_1l9c45() {
  return constructCallableReference((p0) => p0.fcr(), 1, 0, 123);
}
function PlacedGlyphMetrics$caretEnd$delegate$lambda(this$0) {
  return () => this$0.ecr().aad_1.u2(1);
}
function PlacedGlyphMetrics$_get_caretEnd_$ref_fj1a4y() {
  return constructCallableReference((p0) => p0.gcr(), 1, 0, 124);
}
function getTextBoundsWithGlyphs(_this__u8e3s4, size, text, renderer, align) {
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_45().ycr_1 : align;
  var font = _this__u8e3s4;
  // Inline function 'kotlin.also' call
  var this_0 = new TextMetricsResult();
  var tmp74_pos = Companion_getInstance_6().g9h_1;
  drawText(font, null, size, text, null, tmp74_pos, false, renderer, align, this_0);
  return this_0;
}
function getTextBounds(_this__u8e3s4, size, text, out, renderer, align) {
  out = out === VOID ? new TextMetrics() : out;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_45().ucr_1 : align;
  var actions = new BoundBuilderTextRendererActions();
  invoke(renderer, actions, text, size, _this__u8e3s4);
  _this__u8e3s4.nck(size, out.qcs_1);
  out.rcs_1 = actions.hct();
  var bb = Companion_getInstance_7().e9i();
  var dy = 0.0;
  var lineBounds = FastArrayList.f9v();
  var offsetY = actions.lct(align.jct_1, out.qcs_1);
  var _iterator__ex2g4s = actions.fct_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var line = _iterator__ex2g4s.r1();
    var offsetX = line.pct(align.ict_1);
    var rect = new Rectangle(-offsetX, +offsetY + dy - out.qct(), line.nct_1, line.mct_1);
    bb = BoundsBuilder__plus_impl_cz7f7x(bb, rect);
    lineBounds.d2(rect);
    dy = dy + line.mct_1;
  }
  out.pcs_1 = lineBounds;
  out.ocs_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  return out;
}
function drawText(_this__u8e3s4, ctx, size, text, paint, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, placed) {
  pos = pos === VOID ? Companion_getInstance_6().g9h_1 : pos;
  fill = fill === VOID ? true : fill;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_45().ycr_1 : align;
  outMetrics = outMetrics === VOID ? null : outMetrics;
  fillStyle = fillStyle === VOID ? null : fillStyle;
  stroke = stroke === VOID ? null : stroke;
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  placed = placed === VOID ? null : placed;
  var glyphs = !(outMetrics == null) ? new MultiplePlacedGlyphMetrics() : null;
  var fnt = _this__u8e3s4;
  var doRender = drawText$lambda(fillStyle, stroke, ctx, fill);
  var actions = new drawText$actions$1(renderer, text, size, fnt, align, pos, ctx, paint, textRangeStart, textRangeEnd, doRender, glyphs, placed);
  if (ctx == null)
    null;
  else {
    ctx.rct();
  }
  invoke(renderer, actions, text, size, _this__u8e3s4);
  doRender();
  if (!(outMetrics == null)) {
    ensureNotNull(glyphs);
    outMetrics.mcr_1 = glyphs.sct_1;
    outMetrics.ncr_1 = glyphs.tct_1;
    var fmetrics = _this__u8e3s4.yck(size);
    outMetrics.kcr_1 = fmetrics;
    var metrics = outMetrics.lcr_1;
    metrics.qcs_1.uct(fmetrics);
    metrics.rcs_1 = glyphs.tct_1.s2();
    var tmp_1 = metrics;
    // Inline function 'kotlin.collections.map' call
    var this_0 = glyphs.tct_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var bb = Companion_getInstance_7().e9i();
      var _iterator__ex2g4s_0 = item.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var g = _iterator__ex2g4s_0.r1();
        bb = plus_1(bb, g.dcr());
      }
      var tmp$ret$2 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
      destination.d2(tmp$ret$2);
    }
    tmp_1.pcs_1 = destination;
    metrics.ocs_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(BoundsBuilder__plus_impl_cz7f7x_0(Companion_getInstance_7().e9i(), metrics.pcs_1));
  }
  return outMetrics;
}
function renderGlyphToBitmap$renderGlyph(_this__u8e3s4, $paint, font, $size, $codePoint, gx, $border, gy, gmetrics, $fill) {
  _this__u8e3s4.hcm($paint);
  font.kcm(_this__u8e3s4, $size, $codePoint, Vector2D.t9g(gx + $border, gy + $border), true, gmetrics);
  if ($fill) {
    _this__u8e3s4.xct();
  } else {
    _this__u8e3s4.wct();
  }
}
function drawText$lambda($fillStyle, $stroke, $ctx, $fill) {
  return () => {
    if (!($fillStyle == null) || !($stroke == null)) {
      var tmp67_safe_receiver = $ctx;
      if (tmp67_safe_receiver == null)
        null;
      else {
        var tmp2 = $fillStyle;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var stroke = $stroke;
        var tmp4 = stroke == null ? null : stroke.yct_1;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var strokeInfo = stroke == null ? null : stroke.zct_1;
        if (!(tmp2 == null)) {
          tmp67_safe_receiver.acu(tmp2);
        }
        if (!(tmp4 == null)) {
          if (!(strokeInfo == null)) {
            $l$block: {
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              if (tmp4 == null || strokeInfo == null) {
                break $l$block;
              }
              var tmp4_0 = strokeInfo.pab_1;
              var tmp6 = strokeInfo.sab_1;
              var tmp8 = strokeInfo.uab_1;
              var tmp10 = strokeInfo.vab_1;
              var tmp12 = strokeInfo.wab_1;
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              var lineDashOffset = strokeInfo.xab_1;
              if (false) {
                tmp67_safe_receiver.rct();
              }
              // Inline function 'korlibs.image.vector.Context2d.keep' call
              tmp67_safe_receiver.hcu();
              try {
                tmp67_safe_receiver.icu(numberToDouble(tmp4_0));
                tmp67_safe_receiver.jcu(tmp6);
                tmp67_safe_receiver.kcu(tmp8);
                tmp67_safe_receiver.lcu(numberToDouble(tmp10));
                tmp67_safe_receiver.mcu(tmp12);
                tmp67_safe_receiver.ncu(numberToDouble(lineDashOffset));
                tmp67_safe_receiver.ocu(tmp4);
              }finally {
                tmp67_safe_receiver.pcu();
              }
            }
          } else {
            // Inline function 'korlibs.image.vector.Context2d.stroke' call
            var lineWidth = tmp67_safe_receiver.bcu();
            var lineCap = tmp67_safe_receiver.ccu();
            var lineJoin = tmp67_safe_receiver.dcu();
            var miterLimit = tmp67_safe_receiver.ecu();
            var lineDash = tmp67_safe_receiver.fcu();
            var lineDashOffset_0 = tmp67_safe_receiver.gcu();
            if (false) {
              tmp67_safe_receiver.rct();
            }
            // Inline function 'korlibs.image.vector.Context2d.keep' call
            tmp67_safe_receiver.hcu();
            try {
              tmp67_safe_receiver.icu(numberToDouble(lineWidth));
              tmp67_safe_receiver.jcu(lineCap);
              tmp67_safe_receiver.kcu(lineJoin);
              tmp67_safe_receiver.lcu(numberToDouble(miterLimit));
              tmp67_safe_receiver.mcu(lineDash);
              tmp67_safe_receiver.ncu(numberToDouble(lineDashOffset_0));
              tmp67_safe_receiver.ocu(tmp4);
            }finally {
              tmp67_safe_receiver.pcu();
            }
          }
        }
      }
    } else {
      if ($fill) {
        var tmp68_safe_receiver = $ctx;
        if (tmp68_safe_receiver == null)
          null;
        else {
          tmp68_safe_receiver.xct();
        }
      } else {
        var tmp69_safe_receiver = $ctx;
        if (tmp69_safe_receiver == null)
          null;
        else {
          tmp69_safe_receiver.wct();
        }
      }
    }
    var tmp70_safe_receiver = $ctx;
    if (tmp70_safe_receiver == null)
      null;
    else {
      tmp70_safe_receiver.rct();
    }
    return Unit_instance;
  };
}
function *readFont(_this__u8e3s4, preload, props, mipmaps, $completion) {
  preload = preload === VOID ? false : preload;
  props = props === VOID ? Companion_getInstance_39().acn_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  var header = yield* _this__u8e3s4.obh(until(0, 16), $completion);
  switch (getS32BE(header, 0)) {
    case 1953784678:
    case 1330926671:
    case 65536:
      return yield* readTtfFont(_this__u8e3s4, VOID, VOID, $completion);
    default:
      return yield* readBitmapFont(_this__u8e3s4, props, mipmaps, VOID, $completion);
  }
}
var SystemFontRegistryOrNull;
var lazyBitmap$delegate;
function get_lazyBitmapSDF(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp0 = lazyBitmapSDF$delegate;
  var tmp = KProperty1;
  var tmp4 = getPropertyCallableRef('lazyBitmapSDF', 1, tmp, _get_lazyBitmapSDF_$ref_puibqq(), null);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var tmp0_elvis_lhs = tmp0.s9u_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = tmp0.t9u_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = tmp0.s9u_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var lazyBitmapSDF$delegate;
var Companion_instance_18;
function Companion_getInstance_28() {
  if (Companion_instance_18 === VOID)
    new Companion_12();
  return Companion_instance_18;
}
function LazyBitmapFont$anyGlyph$delegate$lambda(this$0) {
  return () => {
    var tmp0_elvis_lhs = this$0.dcx_1.u2(this$0.dcx_1.x4().p1().r1());
    return tmp0_elvis_lhs == null ? this$0.zcm() : tmp0_elvis_lhs;
  };
}
function LazyBitmapFont$_get_anyGlyph_$ref_5keg5w() {
  return constructCallableReference((p0) => p0.kck(), 1, 0, 125);
}
function LazyBitmapFont$invalidGlyph$delegate$lambda(this$0) {
  return () => {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.xcw_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function LazyBitmapFont$_get_invalidGlyph_$ref_m7c1op() {
  return constructCallableReference((p0) => p0.zcm(), 1, 0, 126);
}
function LazyBitmapFont$naturalFontMetrics$delegate$lambda(this$0) {
  return () => {
    var descent = this$0.acx_1.sck_1 - this$0.acx_1.uck_1;
    var tmp78_size = this$0.acx_1.ock_1;
    var tmp79_top = this$0.acx_1.pck_1;
    var tmp80_ascent = this$0.acx_1.qck_1;
    var tmp81_baseline = this$0.acx_1.rck_1;
    var tmp82_maxWidth = this$0.acx_1.vck_1;
    return new FontMetrics(tmp78_size, tmp79_top, tmp80_ascent, tmp81_baseline, descent, descent, 0.0, tmp82_maxWidth, 0.0);
  };
}
function LazyBitmapFont$_get_naturalFontMetrics_$ref_dzk74v() {
  return constructCallableReference((p0) => p0.lck(), 1, 0, 127);
}
function toLazyBitmapFont(_this__u8e3s4, fontSize, distanceField) {
  distanceField = distanceField === VOID ? null : distanceField;
  _init_properties_LazyBitmapFont_kt__76ptri();
  return new LazyBitmapFont(_this__u8e3s4, fontSize, distanceField);
}
function lazyBitmap$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, null);
}
function lazyBitmapSDF$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, 'sdf');
}
function _get_lazyBitmapSDF_$ref_puibqq() {
  return constructCallableReference((p0) => get_lazyBitmapSDF(p0), 1, 0, 128);
}
var properties_initialized_LazyBitmapFont_kt_c74u44;
function _init_properties_LazyBitmapFont_kt__76ptri() {
  if (!properties_initialized_LazyBitmapFont_kt_c74u44) {
    properties_initialized_LazyBitmapFont_kt_c74u44 = true;
    lazyBitmap$delegate = new PropertyThis(VOID, lazyBitmap$delegate$lambda);
    lazyBitmapSDF$delegate = new PropertyThis(VOID, lazyBitmapSDF$delegate$lambda);
  }
}
var Op_version_instance;
var Op_Copyright_instance;
var Op_Notice_instance;
var Op_isFixedPitch_instance;
var Op_FullName_instance;
var Op_ItalicAngle_instance;
var Op_FamilyName_instance;
var Op_UnderlinePosition_instance;
var Op_Weight_instance;
var Op_UnderlineThickness_instance;
var Op_FontBBox_instance;
var Op_PaintType_instance;
var Op_BlueValues_instance;
var Op_CharstringType_instance;
var Op_OtherBlues_instance;
var Op_FontMatrix_instance;
var Op_FamilyBlues_instance;
var Op_StrokeWidth_instance;
var Op_FamilyOtherBlues_instance;
var Op_BlueScale_instance;
var Op_StdHW_instance;
var Op_BlueShift_instance;
var Op_StdVW_instance;
var Op_BlueFuzz_instance;
var Op_StemSnapH_instance;
var Op_UniqueID_instance;
var Op_StemSnapV_instance;
var Op_XUID_instance;
var Op_ForceBold_instance;
var Op_charset_instance;
var Op_Encoding_instance;
var Op_CharStrings_instance;
var Op_LanguageGroup_instance;
var Op_Private_instance;
var Op_ExpansionFactor_instance;
var Op_Subrs_instance;
var Op_initialRandomSeed_instance;
var Op_defaultWidthX_instance;
var Op_SyntheicBase_instance;
var Op_nominalWidthX_instance;
var Op_PostScript_instance;
var Op_vsindex_instance;
var Op_BaseFontName_instance;
var Op_blend_instance;
var Op_BaseFontBlend_instance;
var Op_vstore_instance;
var Op_maxstack_instance;
var Op_ROS_instance;
var Op_CIDFontVersion_instance;
var Op_CIDFontRevision_instance;
var Op_CIDFontType_instance;
var Op_CIDCount_instance;
var Op_UIDBase_instance;
var Op_FDArray_instance;
var Op_FDSelect_instance;
var Op_FontName_instance;
var Companion_instance_19;
function Companion_getInstance_29() {
  Op_initEntries();
  if (Companion_instance_19 === VOID)
    new Companion_13();
  return Companion_instance_19;
}
function values_0() {
  return [Op_version_getInstance(), Op_Copyright_getInstance(), Op_Notice_getInstance(), Op_isFixedPitch_getInstance(), Op_FullName_getInstance(), Op_ItalicAngle_getInstance(), Op_FamilyName_getInstance(), Op_UnderlinePosition_getInstance(), Op_Weight_getInstance(), Op_UnderlineThickness_getInstance(), Op_FontBBox_getInstance(), Op_PaintType_getInstance(), Op_BlueValues_getInstance(), Op_CharstringType_getInstance(), Op_OtherBlues_getInstance(), Op_FontMatrix_getInstance(), Op_FamilyBlues_getInstance(), Op_StrokeWidth_getInstance(), Op_FamilyOtherBlues_getInstance(), Op_BlueScale_getInstance(), Op_StdHW_getInstance(), Op_BlueShift_getInstance(), Op_StdVW_getInstance(), Op_BlueFuzz_getInstance(), Op_StemSnapH_getInstance(), Op_UniqueID_getInstance(), Op_StemSnapV_getInstance(), Op_XUID_getInstance(), Op_ForceBold_getInstance(), Op_charset_getInstance(), Op_Encoding_getInstance(), Op_CharStrings_getInstance(), Op_LanguageGroup_getInstance(), Op_Private_getInstance(), Op_ExpansionFactor_getInstance(), Op_Subrs_getInstance(), Op_initialRandomSeed_getInstance(), Op_defaultWidthX_getInstance(), Op_SyntheicBase_getInstance(), Op_nominalWidthX_getInstance(), Op_PostScript_getInstance(), Op_vsindex_getInstance(), Op_BaseFontName_getInstance(), Op_blend_getInstance(), Op_BaseFontBlend_getInstance(), Op_vstore_getInstance(), Op_maxstack_getInstance(), Op_ROS_getInstance(), Op_CIDFontVersion_getInstance(), Op_CIDFontRevision_getInstance(), Op_CIDFontType_getInstance(), Op_CIDCount_getInstance(), Op_UIDBase_getInstance(), Op_FDArray_getInstance(), Op_FDSelect_getInstance(), Op_FontName_getInstance()];
}
var Op_entriesInitialized;
function Op_initEntries() {
  if (Op_entriesInitialized)
    return Unit_instance;
  Op_entriesInitialized = true;
  Op_version_instance = new Op('version', 0, 0);
  Op_Copyright_instance = new Op('Copyright', 1, 3072);
  Op_Notice_instance = new Op('Notice', 2, 1);
  Op_isFixedPitch_instance = new Op('isFixedPitch', 3, 3073);
  Op_FullName_instance = new Op('FullName', 4, 2);
  Op_ItalicAngle_instance = new Op('ItalicAngle', 5, 3074);
  Op_FamilyName_instance = new Op('FamilyName', 6, 3);
  Op_UnderlinePosition_instance = new Op('UnderlinePosition', 7, 3075);
  Op_Weight_instance = new Op('Weight', 8, 4);
  Op_UnderlineThickness_instance = new Op('UnderlineThickness', 9, 3076);
  Op_FontBBox_instance = new Op('FontBBox', 10, 5);
  Op_PaintType_instance = new Op('PaintType', 11, 3077);
  Op_BlueValues_instance = new Op('BlueValues', 12, 6);
  Op_CharstringType_instance = new Op('CharstringType', 13, 3078);
  Op_OtherBlues_instance = new Op('OtherBlues', 14, 7);
  Op_FontMatrix_instance = new Op('FontMatrix', 15, 3079);
  Op_FamilyBlues_instance = new Op('FamilyBlues', 16, 8);
  Op_StrokeWidth_instance = new Op('StrokeWidth', 17, 3080);
  Op_FamilyOtherBlues_instance = new Op('FamilyOtherBlues', 18, 9);
  Op_BlueScale_instance = new Op('BlueScale', 19, 3081);
  Op_StdHW_instance = new Op('StdHW', 20, 10);
  Op_BlueShift_instance = new Op('BlueShift', 21, 3082);
  Op_StdVW_instance = new Op('StdVW', 22, 11);
  Op_BlueFuzz_instance = new Op('BlueFuzz', 23, 3083);
  Op_StemSnapH_instance = new Op('StemSnapH', 24, 3084);
  Op_UniqueID_instance = new Op('UniqueID', 25, 13);
  Op_StemSnapV_instance = new Op('StemSnapV', 26, 3085);
  Op_XUID_instance = new Op('XUID', 27, 14);
  Op_ForceBold_instance = new Op('ForceBold', 28, 3086);
  Op_charset_instance = new Op('charset', 29, 15);
  Op_Encoding_instance = new Op('Encoding', 30, 16);
  Op_CharStrings_instance = new Op('CharStrings', 31, 17);
  Op_LanguageGroup_instance = new Op('LanguageGroup', 32, 3089);
  Op_Private_instance = new Op('Private', 33, 18);
  Op_ExpansionFactor_instance = new Op('ExpansionFactor', 34, 3090);
  Op_Subrs_instance = new Op('Subrs', 35, 19);
  Op_initialRandomSeed_instance = new Op('initialRandomSeed', 36, 3091);
  Op_defaultWidthX_instance = new Op('defaultWidthX', 37, 20);
  Op_SyntheicBase_instance = new Op('SyntheicBase', 38, 3092);
  Op_nominalWidthX_instance = new Op('nominalWidthX', 39, 21);
  Op_PostScript_instance = new Op('PostScript', 40, 3093);
  Op_vsindex_instance = new Op('vsindex', 41, 22);
  Op_BaseFontName_instance = new Op('BaseFontName', 42, 3094);
  Op_blend_instance = new Op('blend', 43, 23);
  Op_BaseFontBlend_instance = new Op('BaseFontBlend', 44, 3095);
  Op_vstore_instance = new Op('vstore', 45, 24);
  Op_maxstack_instance = new Op('maxstack', 46, 25);
  Op_ROS_instance = new Op('ROS', 47, 3102);
  Op_CIDFontVersion_instance = new Op('CIDFontVersion', 48, 3103);
  Op_CIDFontRevision_instance = new Op('CIDFontRevision', 49, 3104);
  Op_CIDFontType_instance = new Op('CIDFontType', 50, 3105);
  Op_CIDCount_instance = new Op('CIDCount', 51, 3106);
  Op_UIDBase_instance = new Op('UIDBase', 52, 3107);
  Op_FDArray_instance = new Op('FDArray', 53, 3108);
  Op_FDSelect_instance = new Op('FDSelect', 54, 3109);
  Op_FontName_instance = new Op('FontName', 55, 3110);
  Companion_getInstance_29();
}
function Op_version_getInstance() {
  Op_initEntries();
  return Op_version_instance;
}
function Op_Copyright_getInstance() {
  Op_initEntries();
  return Op_Copyright_instance;
}
function Op_Notice_getInstance() {
  Op_initEntries();
  return Op_Notice_instance;
}
function Op_isFixedPitch_getInstance() {
  Op_initEntries();
  return Op_isFixedPitch_instance;
}
function Op_FullName_getInstance() {
  Op_initEntries();
  return Op_FullName_instance;
}
function Op_ItalicAngle_getInstance() {
  Op_initEntries();
  return Op_ItalicAngle_instance;
}
function Op_FamilyName_getInstance() {
  Op_initEntries();
  return Op_FamilyName_instance;
}
function Op_UnderlinePosition_getInstance() {
  Op_initEntries();
  return Op_UnderlinePosition_instance;
}
function Op_Weight_getInstance() {
  Op_initEntries();
  return Op_Weight_instance;
}
function Op_UnderlineThickness_getInstance() {
  Op_initEntries();
  return Op_UnderlineThickness_instance;
}
function Op_FontBBox_getInstance() {
  Op_initEntries();
  return Op_FontBBox_instance;
}
function Op_PaintType_getInstance() {
  Op_initEntries();
  return Op_PaintType_instance;
}
function Op_BlueValues_getInstance() {
  Op_initEntries();
  return Op_BlueValues_instance;
}
function Op_CharstringType_getInstance() {
  Op_initEntries();
  return Op_CharstringType_instance;
}
function Op_OtherBlues_getInstance() {
  Op_initEntries();
  return Op_OtherBlues_instance;
}
function Op_FontMatrix_getInstance() {
  Op_initEntries();
  return Op_FontMatrix_instance;
}
function Op_FamilyBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyBlues_instance;
}
function Op_StrokeWidth_getInstance() {
  Op_initEntries();
  return Op_StrokeWidth_instance;
}
function Op_FamilyOtherBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyOtherBlues_instance;
}
function Op_BlueScale_getInstance() {
  Op_initEntries();
  return Op_BlueScale_instance;
}
function Op_StdHW_getInstance() {
  Op_initEntries();
  return Op_StdHW_instance;
}
function Op_BlueShift_getInstance() {
  Op_initEntries();
  return Op_BlueShift_instance;
}
function Op_StdVW_getInstance() {
  Op_initEntries();
  return Op_StdVW_instance;
}
function Op_BlueFuzz_getInstance() {
  Op_initEntries();
  return Op_BlueFuzz_instance;
}
function Op_StemSnapH_getInstance() {
  Op_initEntries();
  return Op_StemSnapH_instance;
}
function Op_UniqueID_getInstance() {
  Op_initEntries();
  return Op_UniqueID_instance;
}
function Op_StemSnapV_getInstance() {
  Op_initEntries();
  return Op_StemSnapV_instance;
}
function Op_XUID_getInstance() {
  Op_initEntries();
  return Op_XUID_instance;
}
function Op_ForceBold_getInstance() {
  Op_initEntries();
  return Op_ForceBold_instance;
}
function Op_charset_getInstance() {
  Op_initEntries();
  return Op_charset_instance;
}
function Op_Encoding_getInstance() {
  Op_initEntries();
  return Op_Encoding_instance;
}
function Op_CharStrings_getInstance() {
  Op_initEntries();
  return Op_CharStrings_instance;
}
function Op_LanguageGroup_getInstance() {
  Op_initEntries();
  return Op_LanguageGroup_instance;
}
function Op_Private_getInstance() {
  Op_initEntries();
  return Op_Private_instance;
}
function Op_ExpansionFactor_getInstance() {
  Op_initEntries();
  return Op_ExpansionFactor_instance;
}
function Op_Subrs_getInstance() {
  Op_initEntries();
  return Op_Subrs_instance;
}
function Op_initialRandomSeed_getInstance() {
  Op_initEntries();
  return Op_initialRandomSeed_instance;
}
function Op_defaultWidthX_getInstance() {
  Op_initEntries();
  return Op_defaultWidthX_instance;
}
function Op_SyntheicBase_getInstance() {
  Op_initEntries();
  return Op_SyntheicBase_instance;
}
function Op_nominalWidthX_getInstance() {
  Op_initEntries();
  return Op_nominalWidthX_instance;
}
function Op_PostScript_getInstance() {
  Op_initEntries();
  return Op_PostScript_instance;
}
function Op_vsindex_getInstance() {
  Op_initEntries();
  return Op_vsindex_instance;
}
function Op_BaseFontName_getInstance() {
  Op_initEntries();
  return Op_BaseFontName_instance;
}
function Op_blend_getInstance() {
  Op_initEntries();
  return Op_blend_instance;
}
function Op_BaseFontBlend_getInstance() {
  Op_initEntries();
  return Op_BaseFontBlend_instance;
}
function Op_vstore_getInstance() {
  Op_initEntries();
  return Op_vstore_instance;
}
function Op_maxstack_getInstance() {
  Op_initEntries();
  return Op_maxstack_instance;
}
function Op_ROS_getInstance() {
  Op_initEntries();
  return Op_ROS_instance;
}
function Op_CIDFontVersion_getInstance() {
  Op_initEntries();
  return Op_CIDFontVersion_instance;
}
function Op_CIDFontRevision_getInstance() {
  Op_initEntries();
  return Op_CIDFontRevision_instance;
}
function Op_CIDFontType_getInstance() {
  Op_initEntries();
  return Op_CIDFontType_instance;
}
function Op_CIDCount_getInstance() {
  Op_initEntries();
  return Op_CIDCount_instance;
}
function Op_UIDBase_getInstance() {
  Op_initEntries();
  return Op_UIDBase_instance;
}
function Op_FDArray_getInstance() {
  Op_initEntries();
  return Op_FDArray_instance;
}
function Op_FDSelect_getInstance() {
  Op_initEntries();
  return Op_FDSelect_instance;
}
function Op_FontName_getInstance() {
  Op_initEntries();
  return Op_FontName_instance;
}
var Op_hstem_instance;
var Op_vstem_instance;
var Op_and_instance;
var Op_vmoveto_instance;
var Op_or_instance;
var Op_rlineto_instance;
var Op_not_instance;
var Op_hlineto_instance;
var Op_vlineto_instance;
var Op_rrcurveto_instance;
var Op_abs_instance;
var Op_callsubr_instance;
var Op_add_instance;
var Op_return_instance;
var Op_sub_instance;
var Op_div_instance;
var Op_endchar_instance;
var Op_neg_instance;
var Op_cff2vsidx_instance;
var Op_eq_instance;
var Op_cff2blend_instance;
var Op_hstemhm_instance;
var Op_drop_instance;
var Op_hintmask_instance;
var Op_cntrmask_instance;
var Op_put_instance;
var Op_rmoveto_instance;
var Op_get_instance;
var Op_hmoveto_instance;
var Op_ifelse_instance;
var Op_vstemhm_instance;
var Op_random_instance;
var Op_rcurveline_instance;
var Op_mul_instance;
var Op_rlinecurve_instance;
var Op_vvcurveto_instance;
var Op_sqrt_instance;
var Op_hhcurveto_instance;
var Op_dup_instance;
var Op_exch_instance;
var Op_callgsubr_instance;
var Op_index_instance;
var Op_vhcurveto_instance;
var Op_roll_instance;
var Op_hvcurveto_instance;
var Op_hflex_instance;
var Op_flex_instance;
var Op_hflex1_instance;
var Op_flex1_instance;
var Companion_instance_20;
function Companion_getInstance_30() {
  Op_initEntries_0();
  if (Companion_instance_20 === VOID)
    new Companion_14();
  return Companion_instance_20;
}
function values_1() {
  return [Op_hstem_getInstance(), Op_vstem_getInstance(), Op_and_getInstance(), Op_vmoveto_getInstance(), Op_or_getInstance(), Op_rlineto_getInstance(), Op_not_getInstance(), Op_hlineto_getInstance(), Op_vlineto_getInstance(), Op_rrcurveto_getInstance(), Op_abs_getInstance(), Op_callsubr_getInstance(), Op_add_getInstance(), Op_return_getInstance(), Op_sub_getInstance(), Op_div_getInstance(), Op_endchar_getInstance(), Op_neg_getInstance(), Op_cff2vsidx_getInstance(), Op_eq_getInstance(), Op_cff2blend_getInstance(), Op_hstemhm_getInstance(), Op_drop_getInstance(), Op_hintmask_getInstance(), Op_cntrmask_getInstance(), Op_put_getInstance(), Op_rmoveto_getInstance(), Op_get_getInstance(), Op_hmoveto_getInstance(), Op_ifelse_getInstance(), Op_vstemhm_getInstance(), Op_random_getInstance(), Op_rcurveline_getInstance(), Op_mul_getInstance(), Op_rlinecurve_getInstance(), Op_vvcurveto_getInstance(), Op_sqrt_getInstance(), Op_hhcurveto_getInstance(), Op_dup_getInstance(), Op_exch_getInstance(), Op_callgsubr_getInstance(), Op_index_getInstance(), Op_vhcurveto_getInstance(), Op_roll_getInstance(), Op_hvcurveto_getInstance(), Op_hflex_getInstance(), Op_flex_getInstance(), Op_hflex1_getInstance(), Op_flex1_getInstance()];
}
var Op_entriesInitialized_0;
function Op_initEntries_0() {
  if (Op_entriesInitialized_0)
    return Unit_instance;
  Op_entriesInitialized_0 = true;
  Op_hstem_instance = new Op_0('hstem', 0, 1);
  Op_vstem_instance = new Op_0('vstem', 1, 3);
  Op_and_instance = new Op_0('and', 2, 3075);
  Op_vmoveto_instance = new Op_0('vmoveto', 3, 4);
  Op_or_instance = new Op_0('or', 4, 3076);
  Op_rlineto_instance = new Op_0('rlineto', 5, 5);
  Op_not_instance = new Op_0('not', 6, 3077);
  Op_hlineto_instance = new Op_0('hlineto', 7, 6);
  Op_vlineto_instance = new Op_0('vlineto', 8, 7);
  Op_rrcurveto_instance = new Op_0('rrcurveto', 9, 8);
  Op_abs_instance = new Op_0('abs', 10, 3081);
  Op_callsubr_instance = new Op_0('callsubr', 11, 10);
  Op_add_instance = new Op_0('add', 12, 3082);
  Op_return_instance = new Op_0('return', 13, 11);
  Op_sub_instance = new Op_0('sub', 14, 3083);
  Op_div_instance = new Op_0('div', 15, 3084);
  Op_endchar_instance = new Op_0('endchar', 16, 14);
  Op_neg_instance = new Op_0('neg', 17, 3086);
  Op_cff2vsidx_instance = new Op_0('cff2vsidx', 18, 15);
  Op_eq_instance = new Op_0('eq', 19, 3087);
  Op_cff2blend_instance = new Op_0('cff2blend', 20, 16);
  Op_hstemhm_instance = new Op_0('hstemhm', 21, 18);
  Op_drop_instance = new Op_0('drop', 22, 3090);
  Op_hintmask_instance = new Op_0('hintmask', 23, 19);
  Op_cntrmask_instance = new Op_0('cntrmask', 24, 20);
  Op_put_instance = new Op_0('put', 25, 3092);
  Op_rmoveto_instance = new Op_0('rmoveto', 26, 21);
  Op_get_instance = new Op_0('get', 27, 3093);
  Op_hmoveto_instance = new Op_0('hmoveto', 28, 22);
  Op_ifelse_instance = new Op_0('ifelse', 29, 3094);
  Op_vstemhm_instance = new Op_0('vstemhm', 30, 23);
  Op_random_instance = new Op_0('random', 31, 3095);
  Op_rcurveline_instance = new Op_0('rcurveline', 32, 24);
  Op_mul_instance = new Op_0('mul', 33, 3096);
  Op_rlinecurve_instance = new Op_0('rlinecurve', 34, 25);
  Op_vvcurveto_instance = new Op_0('vvcurveto', 35, 26);
  Op_sqrt_instance = new Op_0('sqrt', 36, 3098);
  Op_hhcurveto_instance = new Op_0('hhcurveto', 37, 27);
  Op_dup_instance = new Op_0('dup', 38, 3099);
  Op_exch_instance = new Op_0('exch', 39, 3100);
  Op_callgsubr_instance = new Op_0('callgsubr', 40, 29);
  Op_index_instance = new Op_0('index', 41, 3101);
  Op_vhcurveto_instance = new Op_0('vhcurveto', 42, 30);
  Op_roll_instance = new Op_0('roll', 43, 3102);
  Op_hvcurveto_instance = new Op_0('hvcurveto', 44, 31);
  Op_hflex_instance = new Op_0('hflex', 45, 3106);
  Op_flex_instance = new Op_0('flex', 46, 3107);
  Op_hflex1_instance = new Op_0('hflex1', 47, 3108);
  Op_flex1_instance = new Op_0('flex1', 48, 3109);
  Companion_getInstance_30();
}
function computeSubrBias($this, count) {
  return count < 1240 ? 107 : count < 33900 ? 1131 : 32768;
}
function Op_hstem_getInstance() {
  Op_initEntries_0();
  return Op_hstem_instance;
}
function Op_vstem_getInstance() {
  Op_initEntries_0();
  return Op_vstem_instance;
}
function Op_and_getInstance() {
  Op_initEntries_0();
  return Op_and_instance;
}
function Op_vmoveto_getInstance() {
  Op_initEntries_0();
  return Op_vmoveto_instance;
}
function Op_or_getInstance() {
  Op_initEntries_0();
  return Op_or_instance;
}
function Op_rlineto_getInstance() {
  Op_initEntries_0();
  return Op_rlineto_instance;
}
function Op_not_getInstance() {
  Op_initEntries_0();
  return Op_not_instance;
}
function Op_hlineto_getInstance() {
  Op_initEntries_0();
  return Op_hlineto_instance;
}
function Op_vlineto_getInstance() {
  Op_initEntries_0();
  return Op_vlineto_instance;
}
function Op_rrcurveto_getInstance() {
  Op_initEntries_0();
  return Op_rrcurveto_instance;
}
function Op_abs_getInstance() {
  Op_initEntries_0();
  return Op_abs_instance;
}
function Op_callsubr_getInstance() {
  Op_initEntries_0();
  return Op_callsubr_instance;
}
function Op_add_getInstance() {
  Op_initEntries_0();
  return Op_add_instance;
}
function Op_return_getInstance() {
  Op_initEntries_0();
  return Op_return_instance;
}
function Op_sub_getInstance() {
  Op_initEntries_0();
  return Op_sub_instance;
}
function Op_div_getInstance() {
  Op_initEntries_0();
  return Op_div_instance;
}
function Op_endchar_getInstance() {
  Op_initEntries_0();
  return Op_endchar_instance;
}
function Op_neg_getInstance() {
  Op_initEntries_0();
  return Op_neg_instance;
}
function Op_cff2vsidx_getInstance() {
  Op_initEntries_0();
  return Op_cff2vsidx_instance;
}
function Op_eq_getInstance() {
  Op_initEntries_0();
  return Op_eq_instance;
}
function Op_cff2blend_getInstance() {
  Op_initEntries_0();
  return Op_cff2blend_instance;
}
function Op_hstemhm_getInstance() {
  Op_initEntries_0();
  return Op_hstemhm_instance;
}
function Op_drop_getInstance() {
  Op_initEntries_0();
  return Op_drop_instance;
}
function Op_hintmask_getInstance() {
  Op_initEntries_0();
  return Op_hintmask_instance;
}
function Op_cntrmask_getInstance() {
  Op_initEntries_0();
  return Op_cntrmask_instance;
}
function Op_put_getInstance() {
  Op_initEntries_0();
  return Op_put_instance;
}
function Op_rmoveto_getInstance() {
  Op_initEntries_0();
  return Op_rmoveto_instance;
}
function Op_get_getInstance() {
  Op_initEntries_0();
  return Op_get_instance;
}
function Op_hmoveto_getInstance() {
  Op_initEntries_0();
  return Op_hmoveto_instance;
}
function Op_ifelse_getInstance() {
  Op_initEntries_0();
  return Op_ifelse_instance;
}
function Op_vstemhm_getInstance() {
  Op_initEntries_0();
  return Op_vstemhm_instance;
}
function Op_random_getInstance() {
  Op_initEntries_0();
  return Op_random_instance;
}
function Op_rcurveline_getInstance() {
  Op_initEntries_0();
  return Op_rcurveline_instance;
}
function Op_mul_getInstance() {
  Op_initEntries_0();
  return Op_mul_instance;
}
function Op_rlinecurve_getInstance() {
  Op_initEntries_0();
  return Op_rlinecurve_instance;
}
function Op_vvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vvcurveto_instance;
}
function Op_sqrt_getInstance() {
  Op_initEntries_0();
  return Op_sqrt_instance;
}
function Op_hhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hhcurveto_instance;
}
function Op_dup_getInstance() {
  Op_initEntries_0();
  return Op_dup_instance;
}
function Op_exch_getInstance() {
  Op_initEntries_0();
  return Op_exch_instance;
}
function Op_callgsubr_getInstance() {
  Op_initEntries_0();
  return Op_callgsubr_instance;
}
function Op_index_getInstance() {
  Op_initEntries_0();
  return Op_index_instance;
}
function Op_vhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vhcurveto_instance;
}
function Op_roll_getInstance() {
  Op_initEntries_0();
  return Op_roll_instance;
}
function Op_hvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hvcurveto_instance;
}
function Op_hflex_getInstance() {
  Op_initEntries_0();
  return Op_hflex_instance;
}
function Op_flex_getInstance() {
  Op_initEntries_0();
  return Op_flex_instance;
}
function Op_hflex1_getInstance() {
  Op_initEntries_0();
  return Op_hflex1_instance;
}
function Op_flex1_getInstance() {
  Op_initEntries_0();
  return Op_flex1_instance;
}
var CFF_instance;
function CFF_getInstance() {
  return CFF_instance;
}
var CharStringType2_instance;
function CharStringType2_getInstance() {
  return CharStringType2_instance;
}
var TtfCIDFont_instance;
function TtfCIDFont_getInstance() {
  if (TtfCIDFont_instance === VOID)
    new TtfCIDFont();
  return TtfCIDFont_instance;
}
var Companion_instance_21;
function Companion_getInstance_31() {
  if (Companion_instance_21 === VOID)
    new Companion_15();
  return Companion_instance_21;
}
function *readTtfFont(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
  onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
  enableLigatures = enableLigatures === VOID ? true : enableLigatures;
  return TtfFont.acq(yield* _this__u8e3s4.pbh($completion), get_baseName(_this__u8e3s4), onlyReadMetadata, enableLigatures);
}
function _get_ss__ndcawb($this) {
  var tmp0 = $this.ad5_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ss', 1, tmp, BaseTtfFont$Table$_get_ss_$ref_yydhzk(), null);
  return tmp0.k3();
}
function BaseTtfFont$Table$ss$delegate$lambda(this$0) {
  return () => ensureNotNull(this$0.zd4_1)();
}
function BaseTtfFont$Table$_get_ss_$ref_yydhzk() {
  return constructCallableReference((p0) => _get_ss__ndcawb(p0), 1, 0, 129);
}
function BaseTtfFont$Companion$readHeaderTables$lambda($$this$run, $table) {
  return () => $$this$run.zb6($table.xd4_1, $table.yd4_1);
}
var NameId_COPYRIGHT_instance;
var NameId_NAME_instance;
var NameId_STYLE_instance;
var NameId_UNAME_instance;
var NameId_COMPLETE_NAME_instance;
var NameId_RELEASE_VERSION_instance;
var NameId_POSTSCRIPT_NAME_instance;
var NameId_TRADEMARK_instance;
var NameId_MANUFACTURER_instance;
var NameId_DESIGNER_instance;
var NameId_DESCRIPTION_instance;
var NameId_URL_VENDOR_instance;
var NameId_URL_DESIGNER_instance;
var NameId_LICENSE_DESCRIPTION_instance;
var NameId_LICENSE_URL_instance;
var NameId_RESERVED_15_instance;
var NameId_PREFERRED_FAMILY_instance;
var NameId_PREFERRED_SUBFAMILY_instance;
var NameId_COMPATIBLE_FULL_instance;
var NameId_SAMPLE_TEXT_instance;
var NameId_POSTSCRIPT_CID_instance;
var NameId_WWS_FAMILY_NAME_instance;
var NameId_WWS_SUBFAMILY_NAME_instance;
var NameId_LIGHT_BACKGROUND_instance;
var NameId_DARK_BACKGROUND_instance;
var NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
var Companion_instance_22;
function Companion_getInstance_32() {
  return Companion_instance_22;
}
function values_2() {
  return [NameId_COPYRIGHT_getInstance(), NameId_NAME_getInstance(), NameId_STYLE_getInstance(), NameId_UNAME_getInstance(), NameId_COMPLETE_NAME_getInstance(), NameId_RELEASE_VERSION_getInstance(), NameId_POSTSCRIPT_NAME_getInstance(), NameId_TRADEMARK_getInstance(), NameId_MANUFACTURER_getInstance(), NameId_DESIGNER_getInstance(), NameId_DESCRIPTION_getInstance(), NameId_URL_VENDOR_getInstance(), NameId_URL_DESIGNER_getInstance(), NameId_LICENSE_DESCRIPTION_getInstance(), NameId_LICENSE_URL_getInstance(), NameId_RESERVED_15_getInstance(), NameId_PREFERRED_FAMILY_getInstance(), NameId_PREFERRED_SUBFAMILY_getInstance(), NameId_COMPATIBLE_FULL_getInstance(), NameId_SAMPLE_TEXT_getInstance(), NameId_POSTSCRIPT_CID_getInstance(), NameId_WWS_FAMILY_NAME_getInstance(), NameId_WWS_SUBFAMILY_NAME_getInstance(), NameId_LIGHT_BACKGROUND_getInstance(), NameId_DARK_BACKGROUND_getInstance(), NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance()];
}
var NameId_entriesInitialized;
function NameId_initEntries() {
  if (NameId_entriesInitialized)
    return Unit_instance;
  NameId_entriesInitialized = true;
  NameId_COPYRIGHT_instance = new NameId('COPYRIGHT', 0, 0);
  NameId_NAME_instance = new NameId('NAME', 1, 1);
  NameId_STYLE_instance = new NameId('STYLE', 2, 2);
  NameId_UNAME_instance = new NameId('UNAME', 3, 3);
  NameId_COMPLETE_NAME_instance = new NameId('COMPLETE_NAME', 4, 4);
  NameId_RELEASE_VERSION_instance = new NameId('RELEASE_VERSION', 5, 5);
  NameId_POSTSCRIPT_NAME_instance = new NameId('POSTSCRIPT_NAME', 6, 6);
  NameId_TRADEMARK_instance = new NameId('TRADEMARK', 7, 7);
  NameId_MANUFACTURER_instance = new NameId('MANUFACTURER', 8, 8);
  NameId_DESIGNER_instance = new NameId('DESIGNER', 9, 9);
  NameId_DESCRIPTION_instance = new NameId('DESCRIPTION', 10, 10);
  NameId_URL_VENDOR_instance = new NameId('URL_VENDOR', 11, 11);
  NameId_URL_DESIGNER_instance = new NameId('URL_DESIGNER', 12, 12);
  NameId_LICENSE_DESCRIPTION_instance = new NameId('LICENSE_DESCRIPTION', 13, 13);
  NameId_LICENSE_URL_instance = new NameId('LICENSE_URL', 14, 14);
  NameId_RESERVED_15_instance = new NameId('RESERVED_15', 15, 15);
  NameId_PREFERRED_FAMILY_instance = new NameId('PREFERRED_FAMILY', 16, 16);
  NameId_PREFERRED_SUBFAMILY_instance = new NameId('PREFERRED_SUBFAMILY', 17, 17);
  NameId_COMPATIBLE_FULL_instance = new NameId('COMPATIBLE_FULL', 18, 18);
  NameId_SAMPLE_TEXT_instance = new NameId('SAMPLE_TEXT', 19, 19);
  NameId_POSTSCRIPT_CID_instance = new NameId('POSTSCRIPT_CID', 20, 20);
  NameId_WWS_FAMILY_NAME_instance = new NameId('WWS_FAMILY_NAME', 21, 21);
  NameId_WWS_SUBFAMILY_NAME_instance = new NameId('WWS_SUBFAMILY_NAME', 22, 22);
  NameId_LIGHT_BACKGROUND_instance = new NameId('LIGHT_BACKGROUND', 23, 23);
  NameId_DARK_BACKGROUND_instance = new NameId('DARK_BACKGROUND', 24, 23);
  NameId_VARIATION_POSTSCRIPT_PREFIX_instance = new NameId('VARIATION_POSTSCRIPT_PREFIX', 25, 25);
}
var Colrv1Paint_PaintColrLayers_instance;
var Colrv1Paint_PaintSolid_instance;
var Colrv1Paint_PaintVarSolid_instance;
var Colrv1Paint_PaintLinearGradient_instance;
var Colrv1Paint_PaintVarLinearGradient_instance;
var Colrv1Paint_PaintRadialGradient_instance;
var Colrv1Paint_PaintVarRadialGradient_instance;
var Colrv1Paint_PaintSweepGradient_instance;
var Colrv1Paint_PaintVarSweepGradient_instance;
var Colrv1Paint_PaintGlyph_instance;
var Colrv1Paint_PaintColrGlyph_instance;
var Colrv1Paint_PaintTransform_instance;
var Colrv1Paint_PaintVarTransform_instance;
var Colrv1Paint_PaintTranslate_instance;
var Colrv1Paint_PaintVarTranslate_instance;
var Colrv1Paint_PaintScale_instance;
var Colrv1Paint_PaintVarScale_instance;
var Colrv1Paint_PaintScaleAroundCenter_instance;
var Colrv1Paint_PaintVarScaleAroundCenter_instance;
var Colrv1Paint_PaintScaleUniform_instance;
var Colrv1Paint_PaintVarScaleUniform_instance;
var Colrv1Paint_PaintScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintRotate_instance;
var Colrv1Paint_PaintVarRotate_instance;
var Colrv1Paint_PaintRotateAroundCenter_instance;
var Colrv1Paint_PaintVarRotateAroundCenter_instance;
var Colrv1Paint_PaintSkew_instance;
var Colrv1Paint_PaintVarSkew_instance;
var Colrv1Paint_PaintSkewAroundCenter_instance;
var Colrv1Paint_PaintVarSkewAroundCenter_instance;
var Colrv1Paint_PaintComposite_instance;
var Companion_instance_23;
function Companion_getInstance_33() {
  Colrv1Paint_initEntries();
  if (Companion_instance_23 === VOID)
    new Companion_17();
  return Companion_instance_23;
}
function values_3() {
  return [Colrv1Paint_PaintColrLayers_getInstance(), Colrv1Paint_PaintSolid_getInstance(), Colrv1Paint_PaintVarSolid_getInstance(), Colrv1Paint_PaintLinearGradient_getInstance(), Colrv1Paint_PaintVarLinearGradient_getInstance(), Colrv1Paint_PaintRadialGradient_getInstance(), Colrv1Paint_PaintVarRadialGradient_getInstance(), Colrv1Paint_PaintSweepGradient_getInstance(), Colrv1Paint_PaintVarSweepGradient_getInstance(), Colrv1Paint_PaintGlyph_getInstance(), Colrv1Paint_PaintColrGlyph_getInstance(), Colrv1Paint_PaintTransform_getInstance(), Colrv1Paint_PaintVarTransform_getInstance(), Colrv1Paint_PaintTranslate_getInstance(), Colrv1Paint_PaintVarTranslate_getInstance(), Colrv1Paint_PaintScale_getInstance(), Colrv1Paint_PaintVarScale_getInstance(), Colrv1Paint_PaintScaleAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleAroundCenter_getInstance(), Colrv1Paint_PaintScaleUniform_getInstance(), Colrv1Paint_PaintVarScaleUniform_getInstance(), Colrv1Paint_PaintScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintRotate_getInstance(), Colrv1Paint_PaintVarRotate_getInstance(), Colrv1Paint_PaintRotateAroundCenter_getInstance(), Colrv1Paint_PaintVarRotateAroundCenter_getInstance(), Colrv1Paint_PaintSkew_getInstance(), Colrv1Paint_PaintVarSkew_getInstance(), Colrv1Paint_PaintSkewAroundCenter_getInstance(), Colrv1Paint_PaintVarSkewAroundCenter_getInstance(), Colrv1Paint_PaintComposite_getInstance()];
}
var Colrv1Paint_entriesInitialized;
function Colrv1Paint_initEntries() {
  if (Colrv1Paint_entriesInitialized)
    return Unit_instance;
  Colrv1Paint_entriesInitialized = true;
  Colrv1Paint_PaintColrLayers_instance = new Colrv1Paint('PaintColrLayers', 0);
  Colrv1Paint_PaintSolid_instance = new Colrv1Paint('PaintSolid', 1);
  Colrv1Paint_PaintVarSolid_instance = new Colrv1Paint('PaintVarSolid', 2);
  Colrv1Paint_PaintLinearGradient_instance = new Colrv1Paint('PaintLinearGradient', 3);
  Colrv1Paint_PaintVarLinearGradient_instance = new Colrv1Paint('PaintVarLinearGradient', 4);
  Colrv1Paint_PaintRadialGradient_instance = new Colrv1Paint('PaintRadialGradient', 5);
  Colrv1Paint_PaintVarRadialGradient_instance = new Colrv1Paint('PaintVarRadialGradient', 6);
  Colrv1Paint_PaintSweepGradient_instance = new Colrv1Paint('PaintSweepGradient', 7);
  Colrv1Paint_PaintVarSweepGradient_instance = new Colrv1Paint('PaintVarSweepGradient', 8);
  Colrv1Paint_PaintGlyph_instance = new Colrv1Paint('PaintGlyph', 9);
  Colrv1Paint_PaintColrGlyph_instance = new Colrv1Paint('PaintColrGlyph', 10);
  Colrv1Paint_PaintTransform_instance = new Colrv1Paint('PaintTransform', 11);
  Colrv1Paint_PaintVarTransform_instance = new Colrv1Paint('PaintVarTransform', 12);
  Colrv1Paint_PaintTranslate_instance = new Colrv1Paint('PaintTranslate', 13);
  Colrv1Paint_PaintVarTranslate_instance = new Colrv1Paint('PaintVarTranslate', 14);
  Colrv1Paint_PaintScale_instance = new Colrv1Paint('PaintScale', 15);
  Colrv1Paint_PaintVarScale_instance = new Colrv1Paint('PaintVarScale', 16);
  Colrv1Paint_PaintScaleAroundCenter_instance = new Colrv1Paint('PaintScaleAroundCenter', 17);
  Colrv1Paint_PaintVarScaleAroundCenter_instance = new Colrv1Paint('PaintVarScaleAroundCenter', 18);
  Colrv1Paint_PaintScaleUniform_instance = new Colrv1Paint('PaintScaleUniform', 19);
  Colrv1Paint_PaintVarScaleUniform_instance = new Colrv1Paint('PaintVarScaleUniform', 20);
  Colrv1Paint_PaintScaleUniformAroundCenter_instance = new Colrv1Paint('PaintScaleUniformAroundCenter', 21);
  Colrv1Paint_PaintVarScaleUniformAroundCenter_instance = new Colrv1Paint('PaintVarScaleUniformAroundCenter', 22);
  Colrv1Paint_PaintRotate_instance = new Colrv1Paint('PaintRotate', 23);
  Colrv1Paint_PaintVarRotate_instance = new Colrv1Paint('PaintVarRotate', 24);
  Colrv1Paint_PaintRotateAroundCenter_instance = new Colrv1Paint('PaintRotateAroundCenter', 25);
  Colrv1Paint_PaintVarRotateAroundCenter_instance = new Colrv1Paint('PaintVarRotateAroundCenter', 26);
  Colrv1Paint_PaintSkew_instance = new Colrv1Paint('PaintSkew', 27);
  Colrv1Paint_PaintVarSkew_instance = new Colrv1Paint('PaintVarSkew', 28);
  Colrv1Paint_PaintSkewAroundCenter_instance = new Colrv1Paint('PaintSkewAroundCenter', 29);
  Colrv1Paint_PaintVarSkewAroundCenter_instance = new Colrv1Paint('PaintVarSkewAroundCenter', 30);
  Colrv1Paint_PaintComposite_instance = new Colrv1Paint('PaintComposite', 31);
  Companion_getInstance_33();
}
var Companion_instance_24;
function Companion_getInstance_34() {
  return Companion_instance_24;
}
function NameId_COPYRIGHT_getInstance() {
  NameId_initEntries();
  return NameId_COPYRIGHT_instance;
}
function NameId_NAME_getInstance() {
  NameId_initEntries();
  return NameId_NAME_instance;
}
function NameId_STYLE_getInstance() {
  NameId_initEntries();
  return NameId_STYLE_instance;
}
function NameId_UNAME_getInstance() {
  NameId_initEntries();
  return NameId_UNAME_instance;
}
function NameId_COMPLETE_NAME_getInstance() {
  NameId_initEntries();
  return NameId_COMPLETE_NAME_instance;
}
function NameId_RELEASE_VERSION_getInstance() {
  NameId_initEntries();
  return NameId_RELEASE_VERSION_instance;
}
function NameId_POSTSCRIPT_NAME_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_NAME_instance;
}
function NameId_TRADEMARK_getInstance() {
  NameId_initEntries();
  return NameId_TRADEMARK_instance;
}
function NameId_MANUFACTURER_getInstance() {
  NameId_initEntries();
  return NameId_MANUFACTURER_instance;
}
function NameId_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_DESIGNER_instance;
}
function NameId_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_DESCRIPTION_instance;
}
function NameId_URL_VENDOR_getInstance() {
  NameId_initEntries();
  return NameId_URL_VENDOR_instance;
}
function NameId_URL_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_URL_DESIGNER_instance;
}
function NameId_LICENSE_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_DESCRIPTION_instance;
}
function NameId_LICENSE_URL_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_URL_instance;
}
function NameId_RESERVED_15_getInstance() {
  NameId_initEntries();
  return NameId_RESERVED_15_instance;
}
function NameId_PREFERRED_FAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_FAMILY_instance;
}
function NameId_PREFERRED_SUBFAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_SUBFAMILY_instance;
}
function NameId_COMPATIBLE_FULL_getInstance() {
  NameId_initEntries();
  return NameId_COMPATIBLE_FULL_instance;
}
function NameId_SAMPLE_TEXT_getInstance() {
  NameId_initEntries();
  return NameId_SAMPLE_TEXT_instance;
}
function NameId_POSTSCRIPT_CID_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_CID_instance;
}
function NameId_WWS_FAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_FAMILY_NAME_instance;
}
function NameId_WWS_SUBFAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_SUBFAMILY_NAME_instance;
}
function NameId_LIGHT_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_LIGHT_BACKGROUND_instance;
}
function NameId_DARK_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_DARK_BACKGROUND_instance;
}
function NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance() {
  NameId_initEntries();
  return NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
}
function Colrv1Paint_PaintColrLayers_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrLayers_instance;
}
function Colrv1Paint_PaintSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSolid_instance;
}
function Colrv1Paint_PaintVarSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSolid_instance;
}
function Colrv1Paint_PaintLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintLinearGradient_instance;
}
function Colrv1Paint_PaintVarLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarLinearGradient_instance;
}
function Colrv1Paint_PaintRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRadialGradient_instance;
}
function Colrv1Paint_PaintVarRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRadialGradient_instance;
}
function Colrv1Paint_PaintSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSweepGradient_instance;
}
function Colrv1Paint_PaintVarSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSweepGradient_instance;
}
function Colrv1Paint_PaintGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintGlyph_instance;
}
function Colrv1Paint_PaintColrGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrGlyph_instance;
}
function Colrv1Paint_PaintTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTransform_instance;
}
function Colrv1Paint_PaintVarTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTransform_instance;
}
function Colrv1Paint_PaintTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTranslate_instance;
}
function Colrv1Paint_PaintVarTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTranslate_instance;
}
function Colrv1Paint_PaintScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScale_instance;
}
function Colrv1Paint_PaintVarScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScale_instance;
}
function Colrv1Paint_PaintScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleAroundCenter_instance;
}
function Colrv1Paint_PaintScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniform_instance;
}
function Colrv1Paint_PaintVarScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniform_instance;
}
function Colrv1Paint_PaintScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotate_instance;
}
function Colrv1Paint_PaintVarRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotate_instance;
}
function Colrv1Paint_PaintRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotateAroundCenter_instance;
}
function Colrv1Paint_PaintVarRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotateAroundCenter_instance;
}
function Colrv1Paint_PaintSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkew_instance;
}
function Colrv1Paint_PaintVarSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkew_instance;
}
function Colrv1Paint_PaintSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkewAroundCenter_instance;
}
function Colrv1Paint_PaintVarSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkewAroundCenter_instance;
}
function Colrv1Paint_PaintComposite_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintComposite_instance;
}
var Companion_instance_25;
function Companion_getInstance_35() {
  return Companion_instance_25;
}
function _FWord___init__impl__2rjyqf(data) {
  return data;
}
function _FWord___get_data__impl__9ys4ze($this) {
  return $this;
}
function FWord__toDouble_impl_53j5qp($this) {
  return _FWord___get_data__impl__9ys4ze($this);
}
var DataFormat_UBYTE_instance;
var DataFormat_STRING_instance;
var DataFormat_USHORT_instance;
var DataFormat_ULONG_instance;
var DataFormat_URATIO_instance;
var DataFormat_SBYTE_instance;
var DataFormat_UNDEFINED_instance;
var DataFormat_SSHORT_instance;
var DataFormat_SLONG_instance;
var DataFormat_SRATIO_instance;
var DataFormat_SFLOAT_instance;
var DataFormat_DFLOAT_instance;
var DataFormat_UNKNOWN_instance;
var Companion_instance_26;
function Companion_getInstance_36() {
  DataFormat_initEntries();
  if (Companion_instance_26 === VOID)
    new Companion_20();
  return Companion_instance_26;
}
function values_4() {
  return [DataFormat_UBYTE_getInstance(), DataFormat_STRING_getInstance(), DataFormat_USHORT_getInstance(), DataFormat_ULONG_getInstance(), DataFormat_URATIO_getInstance(), DataFormat_SBYTE_getInstance(), DataFormat_UNDEFINED_getInstance(), DataFormat_SSHORT_getInstance(), DataFormat_SLONG_getInstance(), DataFormat_SRATIO_getInstance(), DataFormat_SFLOAT_getInstance(), DataFormat_DFLOAT_getInstance(), DataFormat_UNKNOWN_getInstance()];
}
function EXIF$DataFormat$lambda(it) {
  return it;
}
function EXIF$DataFormat$lambda_0(it) {
  return 4;
}
function EXIF$DataFormat$lambda_1(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_2(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_3(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_4(it) {
  return it;
}
function EXIF$DataFormat$lambda_5(it) {
  return it;
}
function EXIF$DataFormat$lambda_6(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_7(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_8(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_9(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_10(it) {
  return imul(it, 8);
}
function EXIF$DataFormat$lambda_11(it) {
  return 0;
}
var DataFormat_entriesInitialized;
function DataFormat_initEntries() {
  if (DataFormat_entriesInitialized)
    return Unit_instance;
  DataFormat_entriesInitialized = true;
  DataFormat_UBYTE_instance = new DataFormat('UBYTE', 0, 1, EXIF$DataFormat$lambda);
  DataFormat_STRING_instance = new DataFormat('STRING', 1, 2, EXIF$DataFormat$lambda_0);
  DataFormat_USHORT_instance = new DataFormat('USHORT', 2, 3, EXIF$DataFormat$lambda_1);
  DataFormat_ULONG_instance = new DataFormat('ULONG', 3, 4, EXIF$DataFormat$lambda_2);
  DataFormat_URATIO_instance = new DataFormat('URATIO', 4, 5, EXIF$DataFormat$lambda_3);
  DataFormat_SBYTE_instance = new DataFormat('SBYTE', 5, 6, EXIF$DataFormat$lambda_4);
  DataFormat_UNDEFINED_instance = new DataFormat('UNDEFINED', 6, 7, EXIF$DataFormat$lambda_5);
  DataFormat_SSHORT_instance = new DataFormat('SSHORT', 7, 8, EXIF$DataFormat$lambda_6);
  DataFormat_SLONG_instance = new DataFormat('SLONG', 8, 9, EXIF$DataFormat$lambda_7);
  DataFormat_SRATIO_instance = new DataFormat('SRATIO', 9, 10, EXIF$DataFormat$lambda_8);
  DataFormat_SFLOAT_instance = new DataFormat('SFLOAT', 10, 11, EXIF$DataFormat$lambda_9);
  DataFormat_DFLOAT_instance = new DataFormat('DFLOAT', 11, 12, EXIF$DataFormat$lambda_10);
  DataFormat_UNKNOWN_instance = new DataFormat('UNKNOWN', 12, -1, EXIF$DataFormat$lambda_11);
  Companion_getInstance_36();
}
function readExifBase$readUShort(data, endian, index) {
  return getU16(data, imul(index, 2), endian.mb0());
}
function readExifBase$readInt(data, endian, index) {
  return getS32(data, imul(index, 4), endian.mb0());
}
function DataFormat_UBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UBYTE_instance;
}
function DataFormat_STRING_getInstance() {
  DataFormat_initEntries();
  return DataFormat_STRING_instance;
}
function DataFormat_USHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_USHORT_instance;
}
function DataFormat_ULONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_ULONG_instance;
}
function DataFormat_URATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_URATIO_instance;
}
function DataFormat_SBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SBYTE_instance;
}
function DataFormat_UNDEFINED_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNDEFINED_instance;
}
function DataFormat_SSHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SSHORT_instance;
}
function DataFormat_SLONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SLONG_instance;
}
function DataFormat_SRATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SRATIO_instance;
}
function DataFormat_SFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SFLOAT_instance;
}
function DataFormat_DFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_DFLOAT_instance;
}
function DataFormat_UNKNOWN_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNKNOWN_instance;
}
var EXIF_instance;
function EXIF_getInstance() {
  if (EXIF_instance === VOID)
    new EXIF();
  return EXIF_instance;
}
var Direction_ONCE_FORWARD_instance;
var Direction_ONCE_REVERSE_instance;
var Direction_FORWARD_instance;
var Direction_REVERSE_instance;
var Direction_PING_PONG_instance;
var Direction_entriesInitialized;
function Direction_initEntries() {
  if (Direction_entriesInitialized)
    return Unit_instance;
  Direction_entriesInitialized = true;
  Direction_ONCE_FORWARD_instance = new Direction('ONCE_FORWARD', 0);
  Direction_ONCE_REVERSE_instance = new Direction('ONCE_REVERSE', 1);
  Direction_FORWARD_instance = new Direction('FORWARD', 2);
  Direction_REVERSE_instance = new Direction('REVERSE', 3);
  Direction_PING_PONG_instance = new Direction('PING_PONG', 4);
}
function ImageAnimation$_init_$lambda_bxp50i(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.fdd_1;
  var tmp$ret$2 = b.fdd_1;
  return compareValues(tmp, tmp$ret$2);
}
function Direction_FORWARD_getInstance() {
  Direction_initEntries();
  return Direction_FORWARD_instance;
}
var Companion_instance_27;
function Companion_getInstance_37() {
  return Companion_instance_27;
}
function ImageData$framesSortedByPriority$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp;
  if (b.hde()) {
    tmp = 2147483647;
  } else {
    tmp = imul(imul(b.gde().sc1_1, b.gde().tc1_1), imul(b.gde().uc1_1, b.gde().uc1_1));
  }
  var tmp_0 = tmp;
  var tmp_1;
  if (a.hde()) {
    tmp_1 = 2147483647;
  } else {
    tmp_1 = imul(imul(a.gde().sc1_1, a.gde().tc1_1), imul(a.gde().uc1_1, a.gde().uc1_1));
  }
  var tmp$ret$2 = tmp_1;
  return compareValues(tmp_0, tmp$ret$2);
}
var Companion_instance_28;
function Companion_getInstance_38() {
  return Companion_instance_28;
}
function ImageDataContainer$imageDatasByName$delegate$lambda(this$0) {
  return () => {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this$0.wde_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cd(capacity);
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp$ret$2 = element.pde_1;
      destination.b5(tmp$ret$2, element);
    }
    return destination;
  };
}
function ImageDataContainer$_get_imageDatasByName_$ref_lvn64y() {
  return constructCallableReference((p0) => p0.zde(), 1, 0, 130);
}
function ImageDataContainer$default$delegate$lambda(this$0) {
  return () => {
    var tmp0_elvis_lhs = this$0.zde().w4(null);
    return tmp0_elvis_lhs == null ? first_0(this$0.wde_1) : tmp0_elvis_lhs;
  };
}
function ImageDataContainer$_get_default_$ref_ugc3m1() {
  return constructCallableReference((p0) => p0.adf(), 1, 0, 131);
}
var tilesetBorder$delegate;
function ImageFormat$decodingProps$delegate$lambda(this$0) {
  return () => toProps(this$0);
}
function ImageFormat$_get_decodingProps_$ref_aisyt3() {
  return constructCallableReference((p0) => p0.bdf(), 1, 0, 132);
}
var Companion_instance_29;
function Companion_getInstance_39() {
  if (Companion_instance_29 === VOID)
    new Companion_23();
  return Companion_instance_29;
}
function toProps(_this__u8e3s4, props) {
  props = props === VOID ? Companion_getInstance_39().acn_1 : props;
  _init_properties_ImageFormat_kt__44biio();
  return props.fdg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _this__u8e3s4);
}
function tilesetBorder$delegate$lambda() {
  _init_properties_ImageFormat_kt__44biio();
  return 1;
}
var properties_initialized_ImageFormat_kt_anr6ua;
function _init_properties_ImageFormat_kt__44biio() {
  if (!properties_initialized_ImageFormat_kt_anr6ua) {
    properties_initialized_ImageFormat_kt_anr6ua = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = tilesetBorder$delegate$lambda;
    tilesetBorder$delegate = new Property(null, default_0);
  }
}
function ImageFormats$_get__formats_$ref_elynds() {
  return constructCallableReference((p0) => p0.ldg(), 1, 0, 133);
}
function ImageFormats$_set__formats_$ref_u5pdxw() {
  return constructCallableReference((p0, p1) => {
    p0.mdg(p1);
    return Unit_instance;
  }, 2, 0, 134);
}
function listFormats(_this__u8e3s4) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = _this__u8e3s4.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var list = listFormats_0(element);
    addAll(destination, list);
  }
  return toMutableSet(destination);
}
function listFormats_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ImageFormats) {
    tmp = _this__u8e3s4.pdg();
  } else {
    tmp = setOf_0(_this__u8e3s4);
  }
  return tmp;
}
var Companion_instance_30;
function Companion_getInstance_40() {
  return Companion_instance_30;
}
var Type_NORMAL_instance;
var Type_GROUP_instance;
var Type_TILEMAP_instance;
var Companion_instance_31;
function Companion_getInstance_41() {
  Type_initEntries();
  if (Companion_instance_31 === VOID)
    new Companion_25();
  return Companion_instance_31;
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_NORMAL_instance = new Type('NORMAL', 0);
  Type_GROUP_instance = new Type('GROUP', 1);
  Type_TILEMAP_instance = new Type('TILEMAP', 2);
  Companion_getInstance_41();
}
function Type_NORMAL_getInstance() {
  Type_initEntries();
  return Type_NORMAL_instance;
}
function Type_GROUP_getInstance() {
  Type_initEntries();
  return Type_GROUP_instance;
}
function Type_TILEMAP_getInstance() {
  Type_initEntries();
  return Type_TILEMAP_instance;
}
function set_orientation(_this__u8e3s4, _set____db54di) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var tmp0 = orientation$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_orientation_$ref_6edfbk();
  var tmp4 = getPropertyCallableRef('orientation', 1, tmp, tmp_0, _set_orientation_$ref_gi3mu4());
  var tmp_1 = _set____db54di;
  // Inline function 'korlibs.datastructure.Property.setValue' call
  var value = tmp_1 == null ? null : new SliceOrientation(tmp_1);
  var tmp0_elvis_lhs = tmp0.q9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_orientation(_this__u8e3s4) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var tmp0 = orientation$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_orientation_$ref_6edfbk();
  var tmp4 = getPropertyCallableRef('orientation', 1, tmp, tmp_0, _set_orientation_$ref_gi3mu4());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var tmp_1 = _this__u8e3s4.p9u();
    var tmp0_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap) : false) ? tmp_1 : null;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp0_elvis_lhs = tmp0.q9u_1;
      tmp_2 = tmp0_safe_receiver.w4(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_2;
    if (res == null) {
      var r = tmp0.r9u_1();
      var tmp_3;
      if (!(r == null)) {
        tmp_3 = true;
      } else {
        var tmp1_elvis_lhs = tmp0.q9u_1;
        tmp_3 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? tmp4.callableName : tmp1_elvis_lhs);
      }
      if (tmp_3) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = tmp0.q9u_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      }
      var tmp_4 = r;
      tmp$ret$0 = tmp_4 == null ? null : tmp_4.eam_1;
      break $l$block;
    }
    var tmp_5 = res;
    tmp$ret$0 = tmp_5 == null ? null : tmp_5.eam_1;
  }
  return tmp$ret$0;
}
var orientation$delegate;
function orientation$delegate$lambda() {
  _init_properties_ImageOrientation_kt__rodtsl();
  return null;
}
function _get_orientation_$ref_6edfbk() {
  return constructCallableReference((p0) => {
    var tmp = get_orientation(p0);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, 1, 0, 135);
}
function _set_orientation_$ref_gi3mu4() {
  return constructCallableReference((p0, p1) => {
    var tmp = p1;
    set_orientation(p0, tmp == null ? null : tmp.eam_1);
    return Unit_instance;
  }, 2, 0, 136);
}
var properties_initialized_ImageOrientation_kt_37wzbr;
function _init_properties_ImageOrientation_kt__rodtsl() {
  if (!properties_initialized_ImageOrientation_kt_37wzbr) {
    properties_initialized_ImageOrientation_kt_37wzbr = true;
    orientation$delegate = new Property(VOID, orientation$delegate$lambda);
  }
}
function get_imageLoadingLogger() {
  _init_properties_KorioExt_kt__tiega5();
  return imageLoadingLogger;
}
var imageLoadingLogger;
function *readBitmapSlice(_this__u8e3s4, name, atlas, props, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  props = props === VOID ? Companion_getInstance_39().acn_1 : props;
  return yield* readBitmapSlice_0(_this__u8e3s4, props, name, atlas, $completion);
}
function *readBitmap(_this__u8e3s4, props, $completion) {
  props = props === VOID ? Companion_getInstance_39().acn_1 : props;
  return yield* _readBitmap(_this__u8e3s4, VOID, props.bdf(), $completion);
}
function *readBitmap_0(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  return yield* _readBitmap(VOID, yield* readAll(_this__u8e3s4, $completion), props.bdf(), $completion);
}
function *readBitmapSlice_0(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  var result = yield* /*#__NOINLINE__*/readBitmap(_this__u8e3s4, bprops, $completion);
  return !(atlas == null) ? atlas.pc1(result.pc9(), Unit_instance, name).ic0_1 : slice(result, VOID, name);
}
function *_readBitmap(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_39().acn_1 : props;
  var prop = !(file == null) ? props.cdg(file) : props;
  var rformats = !prop.ydf_1 ? listOf_0(prop.zdf_1) : prop.zdf_1 == null ? listOf_0(null) : prop.xdf_1 ? listOf([prop.zdf_1, null]) : listOf([null, prop.zdf_1]);
  var lastError = null;
  var _iterator__ex2g4s = rformats.p1();
  while (_iterator__ex2g4s.q1()) {
    var format = _iterator__ex2g4s.r1();
    try {
      var rformat = format == null ? get_nativeImageFormatProvider() : format;
      var tmp;
      if (!(bytes == null)) {
        tmp = yield* rformat.odf(bytes, prop, $completion);
      } else if (!(file == null)) {
        tmp = yield* rformat.pdf(file, prop, $completion);
      } else {
        // Inline function 'kotlin.TODO' call
        throw NotImplementedError.le();
      }
      var bmp = tmp;
      // Inline function 'kotlin.also' call
      if (prop.udf_1) {
        asumePremultiplied(bmp);
      }
      return bmp;
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        lastError = e;
        if (e instanceof CancellationException)
          throw e;
        else {
          var tmp_0;
          if (e instanceof FileNotFoundException) {
            tmp_0 = true;
          } else {
            tmp_0 = e instanceof ImageDecoderNotFoundException;
          }
          if (!tmp_0) {
            // Inline function 'korlibs.logger.Logger.info' call
            var tmp0 = get_imageLoadingLogger();
            // Inline function 'korlibs.logger.Logger.log' call
            var level = Level_INFO_getInstance();
            if (tmp0.obj(level)) {
              tmp0.pbj(level, e);
            }
          }
        }
      } else {
        throw $p;
      }
    }
  }
  throw ensureNotNull(lastError);
}
var properties_initialized_KorioExt_kt_kjvlu9;
function _init_properties_KorioExt_kt__tiega5() {
  if (!properties_initialized_KorioExt_kt_kjvlu9) {
    properties_initialized_KorioExt_kt_kjvlu9 = true;
    imageLoadingLogger = Companion_getInstance_14().pb5('ImageLoading');
  }
}
function toBitmap(_this__u8e3s4) {
  return Bitmap32.lc1(_this__u8e3s4.kbk_1, _this__u8e3s4.lbk_1, _this__u8e3s4.mbk_1, _this__u8e3s4.nbk_1);
}
function toBitmap_0(_this__u8e3s4) {
  return toBitmap(_this__u8e3s4.pbk());
}
var Colorspace_GRAYSCALE_instance;
var Colorspace_RGB_instance;
var Colorspace_INDEXED_instance;
var Colorspace_GRAYSCALE_ALPHA_instance;
var Colorspace_RGBA_instance;
var Companion_instance_32;
function Companion_getInstance_42() {
  Colorspace_initEntries();
  if (Companion_instance_32 === VOID)
    new Companion_26();
  return Companion_instance_32;
}
function values_5() {
  return [Colorspace_GRAYSCALE_getInstance(), Colorspace_RGB_getInstance(), Colorspace_INDEXED_getInstance(), Colorspace_GRAYSCALE_ALPHA_getInstance(), Colorspace_RGBA_getInstance()];
}
var Colorspace_entriesInitialized;
function Colorspace_initEntries() {
  if (Colorspace_entriesInitialized)
    return Unit_instance;
  Colorspace_entriesInitialized = true;
  Colorspace_GRAYSCALE_instance = new Colorspace('GRAYSCALE', 0, 0, 1);
  Colorspace_RGB_instance = new Colorspace('RGB', 1, 2, 3);
  Colorspace_INDEXED_instance = new Colorspace('INDEXED', 2, 3, 1);
  Colorspace_GRAYSCALE_ALPHA_instance = new Colorspace('GRAYSCALE_ALPHA', 3, 4, 2);
  Colorspace_RGBA_instance = new Colorspace('RGBA', 4, 6, 4);
  Companion_getInstance_42();
}
function readCommon($this, s, readHeader, info) {
  info = info === VOID ? new ImageInfo() : info;
  var magic = readS32BE(s);
  if (!(magic === -1991225785))
    throw IllegalArgumentException.h2('Invalid PNG file magic: ' + get_hex(magic) + '!=' + get_hex(-1991225785));
  readS32BE(s);
  var pheader = {_v: null};
  var pngdata = ByteArrayBuilder.taz();
  var rgbPalette = _UByteArrayInt___init__impl__xif7bu_0(768);
  var tmp = 0;
  var tmp_0 = new Int8Array(256);
  while (tmp < 256) {
    tmp_0[tmp] = -1;
    tmp = tmp + 1 | 0;
  }
  var aPalette = _UByteArrayInt___init__impl__xif7bu(tmp_0);
  var paletteCount = {_v: 0};
  while (!get_eof(s) && readCommon$readChunk(s, pheader, info, paletteCount, rgbPalette, aPalette, readHeader, pngdata)) {
  }
  if (readHeader)
    return pheader._v;
  var tmp0_elvis_lhs = pheader._v;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException.h2('PNG without header!');
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var header = tmp_1;
  var width = header.ydi_1;
  var height = header.zdi_1;
  var outputSizeHint = imul(imul(1 + width | 0, height), header.fdj_1);
  var databb = uncompress(pngdata.xaz(), Companion_getInstance_13());
  var databbp = 0;
  var context = new DecodingContext(header);
  var bpp = context.hdj_1.fdj_1;
  var row32 = context.kdj_1;
  var tmp_2;
  if (header.fdj_1 === 1) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, paletteCount._v);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.n3_1;
    var last = this_0.o3_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = item;
        var tmp$ret$3 = _RGBA___get_value__impl__hhco8v(Companion_getInstance_21().ich(UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 0 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 1 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 2 | 0), UByteArrayInt__get_impl_px6q8a(aPalette, it)));
        destination.d2(tmp$ret$3);
      }
       while (!(item === last));
    tmp_2 = Bitmap8.rcc(width, height, VOID, _RgbaArray___init__impl__oib4y4(toIntArray(destination)));
  } else {
    tmp_2 = Bitmap32.lc1(width, height, VOID, false);
  }
  var bmp = tmp_2;
  var bmp8 = bmp instanceof Bitmap8 ? bmp : null;
  var bmp32 = bmp instanceof Bitmap32 ? bmp : null;
  var passes = header.edj_1 === 1 ? $this.qdj_1 : $this.rdj_1;
  var _iterator__ex2g4s = passes.p1();
  while (_iterator__ex2g4s.q1()) {
    var pass = _iterator__ex2g4s.r1();
    var progression = step(until(pass.rdi_1, height), pass.tdi_1);
    var inductionVariable_0 = progression.n3_1;
    var last_0 = progression.o3_1;
    var step_0 = progression.p3_1;
    if (step_0 > 0 && inductionVariable_0 <= last_0 || (step_0 < 0 && last_0 <= inductionVariable_0))
      do {
        var row = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + step_0 | 0;
        var col = pass.sdi_1;
        var colIncrement = pass.udi_1;
        var pixelsInThisRow = width >>> pass.xdi_1 | 0;
        var bytesInThisRow = imul(imul(pixelsInThisRow, header.fdj_1), header.adj_1) / 8 | 0;
        var _unary__edvuaz = databbp;
        databbp = _unary__edvuaz + 1 | 0;
        var filter = databb[_unary__edvuaz] & 255;
        var currentRow = context.jdj_1;
        var lastRow = context.idj_1;
        arraycopy_0(databb, databbp, asByteArray(currentRow), 0, bytesInThisRow);
        databbp = databbp + bytesInThisRow | 0;
        if (!(bmp8 == null)) {
          $this.tdj(filter, lastRow, currentRow, header.fdj_1);
          switch (header.adj_1) {
            case 1:
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < width)
                do {
                  var n = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  var tmp2 = col + n | 0;
                  var tmp4 = row;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var color = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n / 8 | 0, 0), 7 - imul(n % 8 | 0, 1) | 0, 1);
                  bmp.wc2(tmp2, tmp4, color);
                }
                 while (inductionVariable_1 < width);
              break;
            case 2:
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < width)
                do {
                  var n_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  var tmp2_0 = col + n_0 | 0;
                  var tmp4_0 = row;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var color_0 = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n_0 / 4 | 0, 0), 6 - imul(n_0 % 4 | 0, 2) | 0, 2);
                  bmp.wc2(tmp2_0, tmp4_0, color_0);
                }
                 while (inductionVariable_2 < width);
              break;
            case 4:
              var inductionVariable_3 = 0;
              if (inductionVariable_3 < width)
                do {
                  var n_1 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  var tmp2_1 = col + n_1 | 0;
                  var tmp4_1 = row;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var color_1 = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n_1 / 2 | 0, 0), 4 - imul(n_1 % 2 | 0, 4) | 0, 4);
                  bmp.wc2(tmp2_1, tmp4_1, color_1);
                }
                 while (inductionVariable_3 < width);
              break;
            case 8:
              bmp8.gcd(col, row, asByteArray(currentRow), width, colIncrement);
              break;
            default:
              // Inline function 'kotlin.error' call

              var message = 'Unsupported header.bitsPerChannel=' + header.adj_1;
              throw IllegalStateException.o(toString_0(message));
          }
        } else if (!(bmp32 == null)) {
          if (header.adj_1 === 8) {
            $this.sdj(filter, lastRow, currentRow, bpp, bytesInThisRow);
            switch (bpp) {
              case 3:
                decode(Companion_getInstance_20(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              case 4:
                decode(Companion_getInstance_21(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              default:
                // Inline function 'kotlin.TODO' call

                var reason = 'Bytes: ' + bpp;
                throw NotImplementedError.le('An operation is not implemented: ' + reason);
            }
            bmp32.xcc(col, row, row32, width, colIncrement);
          } else {
            // Inline function 'kotlin.error' call
            var message_0 = 'Unsupported header.bitsPerChannel=' + header.adj_1;
            throw IllegalStateException.o(toString_0(message_0));
          }
        }
        context.udj();
      }
       while (!(row === last_0));
  }
  return bmp;
}
function PNG$readCommon$readChunk$slambda($data, $info) {
  return constructCallableReference(function *($completion) {
    return yield* EXIF_getInstance().ddd(openAsync(readAll_0($data)), $info, VOID, $completion);
  }, 0);
}
function readCommon$readChunk(_this__u8e3s4, pheader, $info, paletteCount, rgbPalette, aPalette, $readHeader, pngdata) {
  if (get_eof(_this__u8e3s4))
    return false;
  var length = readS32BE(_this__u8e3s4);
  var type = readStringz_0(_this__u8e3s4, 4);
  var data = readStream(_this__u8e3s4, fromInt(length));
  var crc = readS32BE(_this__u8e3s4);
  switch (type) {
    case 'IHDR':
      // Inline function 'kotlin.run' call

      var tmp = readS32BE(data);
      var tmp_0 = readS32BE(data);
      var tmp_1 = readU8(data);
      var tmp0_elvis_lhs = Companion_getInstance_42().qdi_1.w4(readU8(data));
      // Inline function 'kotlin.also' call

      var this_0 = new Header(tmp, tmp_0, tmp_1, tmp0_elvis_lhs == null ? Colorspace_RGBA_getInstance() : tmp0_elvis_lhs, readU8(data), readU8(data), readU8(data));
      $info.idf_1 = this_0.ydi_1;
      $info.jdf_1 = this_0.zdi_1;
      $info.kdf_1 = imul(this_0.adj_1, this_0.bdj_1.pdi_1);
      pheader._v = this_0;
      break;
    case 'PLTE':
      var tmp0 = paletteCount._v;
      // Inline function 'kotlin.math.max' call

      var b = convertToInt(data.a()) / 3 | 0;
      paletteCount._v = Math.max(tmp0, b);
      data.ob3(asByteArray(rgbPalette), 0, convertToInt(data.a()));
      break;
    case 'tRNS':
      var tmp0_0 = paletteCount._v;
      // Inline function 'kotlin.math.max' call

      var b_0 = convertToInt(data.a());
      paletteCount._v = Math.max(tmp0_0, b_0);
      data.ob3(asByteArray(aPalette), 0, convertToInt(data.a()));
      break;
    case 'IDAT':
      if ($readHeader) {
        return false;
      }

      pngdata.vaz(readAll_0(data));
      break;
    case 'eXIf':
      runBlockingNoSuspensions(PNG$readCommon$readChunk$slambda(data, $info));
      break;
    case 'IEND':
      return false;
  }
  return true;
}
function Colorspace_GRAYSCALE_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_instance;
}
function Colorspace_RGB_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGB_instance;
}
function Colorspace_INDEXED_getInstance() {
  Colorspace_initEntries();
  return Colorspace_INDEXED_instance;
}
function Colorspace_GRAYSCALE_ALPHA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_ALPHA_instance;
}
function Colorspace_RGBA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGBA_instance;
}
var PNG_instance;
function PNG_getInstance() {
  if (PNG_instance === VOID)
    PNG.vdj();
  return PNG_instance;
}
function get_RegisteredImageFormats() {
  _init_properties_RegisteredImageFormats_kt__dq34zn();
  return RegisteredImageFormats;
}
var RegisteredImageFormats;
var properties_initialized_RegisteredImageFormats_kt_ribwxx;
function _init_properties_RegisteredImageFormats_kt__dq34zn() {
  if (!properties_initialized_RegisteredImageFormats_kt_ribwxx) {
    properties_initialized_RegisteredImageFormats_kt_ribwxx = true;
    RegisteredImageFormats = ImageFormatsMutable.wdg([PNG_getInstance()]);
  }
}
var WEBP_WASM_BASE64_ZLIB;
function sumPacked4MulR(a, b, mul) {
  var dstRB = imul(b & 16711935, mul) >>> 8 | 0;
  var dstGA = imul((b >>> 8 | 0) & 16711935, mul) >>> 8 | 0;
  var r = ((a >>> 0 | 0) & 255) + ((dstRB >>> 0 | 0) & 255) | 0;
  var g = ((a >>> 8 | 0) & 255) + ((dstGA >>> 0 | 0) & 255) | 0;
  var b_0 = ((a >>> 16 | 0) & 255) + ((dstRB >>> 16 | 0) & 255) | 0;
  var a_0 = ((a >>> 24 | 0) & 255) + ((dstGA >>> 16 | 0) & 255) | 0;
  return packIntClamped(r, g, b_0, a_0);
}
function d2i(v) {
  return toIntRound(clamp01(v) * 255);
}
function f2i(v) {
  return toIntRound_0(clamp01_0(v) * 255);
}
function packIntUnchecked(r, g, b, a) {
  return (r & 255) << 0 | (g & 255) << 8 | (b & 255) << 16 | (a & 255) << 24;
}
function packIntClamped(r, g, b, a) {
  return clampUByte(r) | clampUByte(g) << 8 | clampUByte(b) << 16 | clampUByte(a) << 24;
}
var Companion_instance_33;
function Companion_getInstance_43() {
  return Companion_instance_33;
}
function _get_fill__d6ivc8($this) {
  var tmp = $this.fdk_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('fill');
  }
}
function color($this, ratio) {
  return RgbaPremultipliedArray__get_impl_1u69ta($this.edk_1, numberToInt(clamp01_0(ratio) * 255));
}
function _set_texture__qu271y($this, value) {
  $this.qdk_1 = value;
  $this.mdk_1 = $this.qdk_1.sc1_1;
  $this.ndk_1 = $this.qdk_1.tc1_1;
  $this.odk_1 = 1.0 / $this.mdk_1;
  $this.pdk_1 = 1.0 / $this.ndk_1;
}
var NoneFiller_instance;
function NoneFiller_getInstance() {
  if (NoneFiller_instance === VOID)
    new NoneFiller();
  return NoneFiller_instance;
}
function toFiller(_this__u8e3s4, state) {
  var tmp;
  if (_this__u8e3s4 instanceof NonePaint) {
    tmp = NoneFiller_getInstance();
  } else {
    if (_this__u8e3s4 instanceof RGBA) {
      // Inline function 'kotlin.also' call
      var this_0 = new ColorFiller();
      this_0.ydj(_this__u8e3s4.sci_1, state);
      tmp = this_0;
    } else {
      if (_this__u8e3s4 instanceof GradientPaint) {
        // Inline function 'kotlin.also' call
        var this_1 = new GradientFiller();
        this_1.gdk(_this__u8e3s4, state);
        tmp = this_1;
      } else {
        if (_this__u8e3s4 instanceof BitmapPaint) {
          // Inline function 'kotlin.also' call
          var this_2 = new BitmapFiller();
          this_2.udk(_this__u8e3s4, state);
          tmp = this_2;
        } else {
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.le();
        }
      }
    }
  }
  return tmp;
}
var NonePaint_instance;
function NonePaint_getInstance() {
  return NonePaint_instance;
}
function colorInt($this, $receiver, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc($receiver)) : _RGBA___get_value__impl__hhco8v($receiver);
}
function _fillColors($this, out, stops, colors, premultiplied) {
  var numberOfStops = stops.s2();
  var NCOLORS = out.length;
  switch (numberOfStops) {
    case 0:
    case 1:
      var color = numberOfStops === 0 ? Colors_getInstance().bc5_1 : _RGBA___init__impl__lqpay5(colors.vl());
      var pcolor = colorInt($this, color, premultiplied);
      var inductionVariable = 0;
      if (inductionVariable < NCOLORS)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          out[n] = pcolor;
        }
         while (inductionVariable < NCOLORS);
      break;
    default:
      var inductionVariable_0 = 0;
      var last = _fillColors$stopN(stops, NCOLORS, 0);
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          out[n_0] = colorInt($this, _RGBA___init__impl__lqpay5(colors.vl()), premultiplied);
        }
         while (inductionVariable_0 < last);
      var inductionVariable_1 = 0;
      var last_0 = numberOfStops - 1 | 0;
      if (inductionVariable_1 < last_0)
        do {
          var n_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var stop0 = _fillColors$stopN(stops, NCOLORS, n_1 + 0 | 0);
          var stop1 = _fillColors$stopN(stops, NCOLORS, n_1 + 1 | 0);
          var color0 = _RGBA___init__impl__lqpay5(colors.j9u(n_1 + 0 | 0));
          var color1 = _RGBA___init__impl__lqpay5(colors.j9u(n_1 + 1 | 0));
          var inductionVariable_2 = stop0;
          if (inductionVariable_2 < stop1)
            do {
              var s = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio = _Ratio___init__impl__9mwvn2(s - stop0 | 0, stop1 - stop0 | 0);
              out[s] = colorInt($this, Companion_getInstance_21().yci(color0, color1, ratio), premultiplied);
            }
             while (inductionVariable_2 < stop1);
        }
         while (inductionVariable_1 < last_0);
      var inductionVariable_3 = _fillColors$stopN(stops, NCOLORS, numberOfStops - 1 | 0);
      if (inductionVariable_3 < NCOLORS)
        do {
          var n_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          out[n_2] = colorInt($this, _RGBA___init__impl__lqpay5(colors.oa2()), premultiplied);
        }
         while (inductionVariable_3 < NCOLORS);
      break;
  }
}
function _fillColors$stopN($stops, NCOLORS, n) {
  return numberToInt($stops.u2(n) * NCOLORS);
}
var Companion_instance_34;
function Companion_getInstance_44() {
  return Companion_instance_34;
}
function colorsToString($this, colors) {
  return '[' + joinToString(new RgbaArray(colors), ', ', VOID, VOID, VOID, VOID, GradientPaint$colorsToString$lambda) + ']';
}
function colorsToString_0($this, colors) {
  return colorsToString($this, _RgbaArray___init__impl__oib4y4(colors.sa2()));
}
function GradientPaint$colorsToString$lambda(it) {
  return _RGBA___get_hexString__impl__kocngm(it.sci_1);
}
var GradientKind_LINEAR_instance;
var GradientKind_RADIAL_instance;
var GradientKind_SWEEP_instance;
var GradientKind_entriesInitialized;
function GradientKind_initEntries() {
  if (GradientKind_entriesInitialized)
    return Unit_instance;
  GradientKind_entriesInitialized = true;
  GradientKind_LINEAR_instance = new GradientKind('LINEAR', 0);
  GradientKind_RADIAL_instance = new GradientKind('RADIAL', 1);
  GradientKind_SWEEP_instance = new GradientKind('SWEEP', 2);
}
function get_DefaultPaint() {
  return Colors_getInstance().ac3_1;
}
var GradientUnits_USER_SPACE_ON_USE_instance;
var GradientUnits_OBJECT_BOUNDING_BOX_instance;
var GradientUnits_entriesInitialized;
function GradientUnits_initEntries() {
  if (GradientUnits_entriesInitialized)
    return Unit_instance;
  GradientUnits_entriesInitialized = true;
  GradientUnits_USER_SPACE_ON_USE_instance = new GradientUnits('USER_SPACE_ON_USE', 0);
  GradientUnits_OBJECT_BOUNDING_BOX_instance = new GradientUnits('OBJECT_BOUNDING_BOX', 1);
}
var GradientInterpolationMethod_LINEAR_instance;
var GradientInterpolationMethod_NORMAL_instance;
var GradientInterpolationMethod_entriesInitialized;
function GradientInterpolationMethod_initEntries() {
  if (GradientInterpolationMethod_entriesInitialized)
    return Unit_instance;
  GradientInterpolationMethod_entriesInitialized = true;
  GradientInterpolationMethod_LINEAR_instance = new GradientInterpolationMethod('LINEAR', 0);
  GradientInterpolationMethod_NORMAL_instance = new GradientInterpolationMethod('NORMAL', 1);
}
function GradientKind_LINEAR_getInstance() {
  GradientKind_initEntries();
  return GradientKind_LINEAR_instance;
}
function GradientKind_RADIAL_getInstance() {
  GradientKind_initEntries();
  return GradientKind_RADIAL_instance;
}
function GradientUnits_OBJECT_BOUNDING_BOX_getInstance() {
  GradientUnits_initEntries();
  return GradientUnits_OBJECT_BOUNDING_BOX_instance;
}
function GradientInterpolationMethod_NORMAL_getInstance() {
  GradientInterpolationMethod_initEntries();
  return GradientInterpolationMethod_NORMAL_instance;
}
var Companion_instance_35;
function Companion_getInstance_45() {
  if (Companion_instance_35 === VOID)
    new Companion_29();
  return Companion_instance_35;
}
function _HorizontalAlign___init__impl__ad654o(ratio) {
  return ratio;
}
function _HorizontalAlign___get_ratio__impl__x9wlea($this) {
  return $this;
}
function _HorizontalAlign___get_ratioFake__impl__h46z0d($this) {
  return equals($this, Companion_getInstance_46().pdl_1) ? 0.0 : _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
var Companion_instance_36;
function Companion_getInstance_46() {
  if (Companion_instance_36 === VOID)
    new Companion_30();
  return Companion_instance_36;
}
function HorizontalAlign__getOffsetX_impl_urzzxf($this, width) {
  return equals($this, Companion_getInstance_46().pdl_1) ? 0.0 : width * _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
function HorizontalAlign__toString_impl_toflc0($this) {
  return equals($this, Companion_getInstance_46().qdl_1) ? 'LEFT' : equals($this, Companion_getInstance_46().rdl_1) ? 'CENTER' : equals($this, Companion_getInstance_46().sdl_1) ? 'RIGHT' : equals($this, Companion_getInstance_46().pdl_1) ? 'JUSTIFY' : 'HorizontalAlign(' + _HorizontalAlign___get_ratio__impl__x9wlea($this) + ')';
}
function HorizontalAlign__hashCode_impl_7x9oj5($this) {
  return getNumberHashCode($this);
}
function HorizontalAlign__equals_impl_hkfbhv($this, other) {
  if (!(other instanceof HorizontalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof HorizontalAlign ? other.vdl_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _VerticalAlign___init__impl__f42kfq(ratio) {
  return ratio;
}
function _VerticalAlign___get_ratio__impl__b3ilr8($this) {
  return $this;
}
function _VerticalAlign___get_ratioFake__impl__1h2fwv($this) {
  return equals($this, Companion_getInstance_47().zdl_1) ? 1.0 : _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
var Companion_instance_37;
function Companion_getInstance_47() {
  if (Companion_instance_37 === VOID)
    new Companion_31();
  return Companion_instance_37;
}
function VerticalAlign__getOffsetY_impl_iso0y6($this, height, baseline) {
  return equals($this, Companion_getInstance_47().zdl_1) ? baseline : -height * _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
function VerticalAlign__getOffsetYRespectBaseline_impl_62po5b($this, font, totalHeight) {
  return equals($this, Companion_getInstance_47().zdl_1) ? 0.0 : interpolate_0(toRatio_0(_VerticalAlign___get_ratio__impl__b3ilr8($this)), font.pck_1, font.pck_1 - totalHeight);
}
function VerticalAlign__toString_impl_hcpnn2($this) {
  return equals($this, Companion_getInstance_47().wdl_1) ? 'TOP' : equals($this, Companion_getInstance_47().xdl_1) ? 'MIDDLE' : equals($this, Companion_getInstance_47().ydl_1) ? 'BOTTOM' : equals($this, Companion_getInstance_47().zdl_1) ? 'BASELINE' : 'VerticalAlign(' + _VerticalAlign___get_ratio__impl__b3ilr8($this) + ')';
}
function VerticalAlign__hashCode_impl_vx8hj7($this) {
  return getNumberHashCode($this);
}
function VerticalAlign__equals_impl_xp13z($this, other) {
  if (!(other instanceof VerticalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof VerticalAlign ? other.ddm_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var DefaultWStringTextRenderer;
function get_DefaultStringTextRenderer() {
  _init_properties_TextRenderer_kt__4uayeo();
  return DefaultStringTextRenderer;
}
var DefaultStringTextRenderer;
function invoke(_this__u8e3s4, actions, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  // Inline function 'kotlin.apply' call
  _this__u8e3s4.edm(actions, text, size, defaultFont);
}
function add($this, x, y) {
  var rx = $this.wb5().r9g_1 + $this.acw().m9l(x, y);
  var ry = $this.wb5().s9g_1 + $this.acw().p9l(x, y);
  $this.dct_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.dct_1, Vector2D.t9g(rx, ry));
  if ($this.ect_1 === 0) {
    $this.cct_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.cct_1, Vector2D.t9g(rx, ry));
  }
  var _receiver__tnumb7 = $this.gct_1;
  _receiver__tnumb7.oct_1 = BoundsBuilder__plus_impl_cz7f7x_1(_receiver__tnumb7.oct_1, Vector2D.t9g(rx, ry));
}
function add_0($this, rect) {
  var fx = rect.v9h();
  var fy = rect.x9h();
  var w = rect.q9h_1;
  var h = rect.r9h_1;
  add($this, fx, fy);
  add($this, fx + w, fy);
  add($this, fx + w, fy + h);
  add($this, fx, fy + h);
}
function measure(_this__u8e3s4, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  var actions = new BoundBuilderTextRendererActions();
  invoke(_this__u8e3s4, actions, text, size, defaultFont);
  return actions;
}
function CreateWStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateWStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateWStringTextRenderer$2(getVersion, handler);
}
function CreateStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateStringTextRenderer$2(getVersion, handler);
}
function DefaultWStringTextRenderer$lambda($this$CreateWStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateWStringTextRenderer.mcv(text, c);
  $this$CreateWStringTextRenderer.icw(advance);
  return Unit_instance;
}
function DefaultStringTextRenderer$lambda($this$CreateStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateStringTextRenderer.mcv(text, c);
  $this$CreateStringTextRenderer.icw(advance);
  return Unit_instance;
}
function CreateWStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$o$wstring$lambda($handler) {
  return ($this$CreateWStringTextRenderer, text, c, g, advance) => {
    $handler($this$CreateWStringTextRenderer, text, c, g, advance);
    return Unit_instance;
  };
}
var properties_initialized_TextRenderer_kt_lfmsb6;
function _init_properties_TextRenderer_kt__4uayeo() {
  if (!properties_initialized_TextRenderer_kt_lfmsb6) {
    properties_initialized_TextRenderer_kt_lfmsb6 = true;
    DefaultWStringTextRenderer = CreateWStringTextRenderer(VOID, DefaultWStringTextRenderer$lambda);
    DefaultStringTextRenderer = CreateStringTextRenderer(VOID, DefaultStringTextRenderer$lambda);
  }
}
function overlaps($this, a0, a1, b0, b1) {
  // Inline function 'kotlin.math.min' call
  var min = Math.min(a0, a0);
  // Inline function 'kotlin.math.max' call
  var max = Math.max(a1, a1);
  // Inline function 'kotlin.math.max' call
  var maxMinor = Math.max(a0, b0);
  // Inline function 'kotlin.math.min' call
  var minMajor = Math.min(a1, b1);
  return (min <= maxMinor ? maxMinor <= max : false) || (min <= minMajor ? minMajor <= max : false);
}
function Bitmap32Context2d$renderFinal$flush$lambda(this$0) {
  return (x0, x1, y) => {
    this$0.rdo_1.vdo(x0, x1, y);
    return Unit_instance;
  };
}
function renderFinal$flush(this$0, filler, $state, $winding, fillPath) {
  if (this$0.ndo_1.bdp_1.o9j()) {
    this$0.ndo_1.zdo_1 = this$0.ldo_1 ? 4 : 1;
    this$0.rdo_1.xdn_1 = filler;
    this$0.rdo_1.gdo_1 = $state.acm_1;
    this$0.rdo_1.ra8();
    var tmp = $winding == null ? fillPath.pah_1 : $winding;
    this$0.ndo_1.hdp(this$0.mdo_1, VOID, VOID, tmp, Bitmap32Context2d$renderFinal$flush$lambda(this$0));
    this$0.rdo_1.nd();
    this$0.ndo_1.bdp_1.ra8();
  }
}
function Bitmap32Context2d$renderFinal$lambda($lastPos) {
  return (it) => {
    $lastPos._v = it;
    return Unit_instance;
  };
}
function Bitmap32Context2d$renderFinal$lambda_0(this$0, $emittedCount, $lastPos, $prevPos) {
  return (it) => {
    var x = it.jm();
    var y = it.km();
    this$0.ndo_1.cdp_1.jaq(x, y, false);
    var _unary__edvuaz = $emittedCount._v;
    $emittedCount._v = _unary__edvuaz + 1 | 0;
    $lastPos._v = $prevPos._v;
    $prevPos._v = it;
    return Unit_instance;
  };
}
function Bitmap32Context2d$renderFinal$lambda_1($lastPos) {
  return (it) => {
    $lastPos._v = it;
    return Unit_instance;
  };
}
function Bitmap32Context2d$renderFinal$lambda_2(this$0, $emittedCount, $lastPos, $prevPos) {
  return (it) => {
    var x = it.jm();
    var y = it.km();
    this$0.ndo_1.cdp_1.jaq(x, y, false);
    var _unary__edvuaz = $emittedCount._v;
    $emittedCount._v = _unary__edvuaz + 1 | 0;
    $lastPos._v = $prevPos._v;
    $prevPos._v = it;
    return Unit_instance;
  };
}
function Bitmap32Context2d$renderFinal$lambda_3($lastPos) {
  return (it) => {
    $lastPos._v = it;
    return Unit_instance;
  };
}
function Bitmap32Context2d$renderFinal$lambda_4($doingStroke, this$0, $emittedCount, $lastPos, $prevPos, $filler, $state, $winding, $fillPath) {
  return (it) => {
    var x = it.jm();
    var y = it.km();
    if ($doingStroke) {
      if (false) {
        renderFinal$flush(this$0, $filler, $state, $winding, $fillPath);
      }
    }
    this$0.ndo_1.bdp_1.jaq(x, y, false);
    var _unary__edvuaz = $emittedCount._v;
    $emittedCount._v = _unary__edvuaz + 1 | 0;
    $lastPos._v = $prevPos._v;
    $prevPos._v = it;
    return Unit_instance;
  };
}
function Bitmap32Context2d$renderFinal$lambda_5($lastPos) {
  return (it) => {
    $lastPos._v = it;
    return Unit_instance;
  };
}
function Bitmap32Context2d$renderFinal$lambda_6($doingStroke, this$0, $emittedCount, $lastPos, $prevPos, $filler, $state, $winding, $fillPath) {
  return (it) => {
    var x = it.jm();
    var y = it.km();
    if ($doingStroke) {
      if (false) {
        renderFinal$flush(this$0, $filler, $state, $winding, $fillPath);
      }
    }
    this$0.ndo_1.bdp_1.jaq(x, y, false);
    var _unary__edvuaz = $emittedCount._v;
    $emittedCount._v = _unary__edvuaz + 1 | 0;
    $lastPos._v = $prevPos._v;
    $prevPos._v = it;
    return Unit_instance;
  };
}
function CompositeOperation$Companion$UNIMPLEMENTED$lambda(dst, dstN, src, srcN, count) {
  mix_0(dst.lcj_1, dstN, src.lcj_1, srcN, count);
  return Unit_instance;
}
var Companion_instance_38;
function Companion_getInstance_48() {
  if (Companion_instance_38 === VOID)
    new Companion_32();
  return Companion_instance_38;
}
var CompositeMode_CLEAR_instance;
var CompositeMode_COPY_instance;
var CompositeMode_SOURCE_OVER_instance;
var CompositeMode_DESTINATION_OVER_instance;
var CompositeMode_SOURCE_IN_instance;
var CompositeMode_DESTINATION_IN_instance;
var CompositeMode_SOURCE_OUT_instance;
var CompositeMode_DESTINATION_OUT_instance;
var CompositeMode_SOURCE_ATOP_instance;
var CompositeMode_DESTINATION_ATOP_instance;
var CompositeMode_XOR_instance;
var CompositeMode_LIGHTER_instance;
var Companion_instance_39;
function Companion_getInstance_49() {
  return Companion_instance_39;
}
function CompositeMode$lambda(dst, dstN, src, srcN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var d = RgbaPremultipliedArray__get_impl_1u69ta(dst.lcj_1, dstN + n | 0);
      var s = RgbaPremultipliedArray__get_impl_1u69ta(src.lcj_1, srcN + n | 0);
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(d);
      RgbaPremultipliedArray__set_impl_7fwbby(dst.lcj_1, tmp, _RGBA___get_premultiplied__impl__3bulqc(RGBA__withA_impl_vogscm(tmp$ret$0, clampUByte(_RGBAPremultiplied___get_a__impl__f0hnd1(d) - _RGBAPremultiplied___get_a__impl__f0hnd1(s) | 0))));
    }
     while (inductionVariable < count);
  return Unit_instance;
}
function CompositeMode$lambda_0(dst, dstN, src, srcN, count) {
  mix_1(dst.lcj_1, dstN, dst.lcj_1, dstN, src.lcj_1, srcN, count);
  return Unit_instance;
}
function CompositeMode$lambda_1(dst, dstN, src, srcN, count) {
  mix_1(dst.lcj_1, dstN, src.lcj_1, srcN, dst.lcj_1, dstN, count);
  return Unit_instance;
}
var CompositeMode_entriesInitialized;
function CompositeMode_initEntries() {
  if (CompositeMode_entriesInitialized)
    return Unit_instance;
  CompositeMode_entriesInitialized = true;
  var tmp = Companion_getInstance_48();
  CompositeMode_CLEAR_instance = new CompositeMode('CLEAR', 0, tmp.udp(CompositeMode$lambda));
  CompositeMode_COPY_instance = new CompositeMode('COPY', 1, Companion_getInstance_48().tdp_1);
  var tmp_0 = Companion_getInstance_48();
  CompositeMode_SOURCE_OVER_instance = new CompositeMode('SOURCE_OVER', 2, tmp_0.udp(CompositeMode$lambda_0));
  var tmp_1 = Companion_getInstance_48();
  CompositeMode_DESTINATION_OVER_instance = new CompositeMode('DESTINATION_OVER', 3, tmp_1.udp(CompositeMode$lambda_1));
  CompositeMode_SOURCE_IN_instance = new CompositeMode('SOURCE_IN', 4, Companion_getInstance_48().tdp_1);
  CompositeMode_DESTINATION_IN_instance = new CompositeMode('DESTINATION_IN', 5, Companion_getInstance_48().tdp_1);
  CompositeMode_SOURCE_OUT_instance = new CompositeMode('SOURCE_OUT', 6, Companion_getInstance_48().tdp_1);
  CompositeMode_DESTINATION_OUT_instance = new CompositeMode('DESTINATION_OUT', 7, Companion_getInstance_48().tdp_1);
  CompositeMode_SOURCE_ATOP_instance = new CompositeMode('SOURCE_ATOP', 8, Companion_getInstance_48().tdp_1);
  CompositeMode_DESTINATION_ATOP_instance = new CompositeMode('DESTINATION_ATOP', 9, Companion_getInstance_48().tdp_1);
  CompositeMode_XOR_instance = new CompositeMode('XOR', 10, Companion_getInstance_48().tdp_1);
  CompositeMode_LIGHTER_instance = new CompositeMode('LIGHTER', 11, Companion_getInstance_48().tdp_1);
}
function get_DEFAULT(_this__u8e3s4) {
  return Companion_instance_39.cat();
}
function CompositeMode_SOURCE_OVER_getInstance() {
  CompositeMode_initEntries();
  return CompositeMode_SOURCE_OVER_instance;
}
function Context2d$State$transformTransform$delegate$lambda(this$0) {
  return () => this$0.kcl_1.i9m();
}
function Context2d$State$_get_transformTransform_$ref_jajxlc() {
  return constructCallableReference((p0) => p0.ydp(), 1, 0, 137);
}
function trans($this, p) {
  var tmp0 = $this.tc9_1.kcl_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (tmp0.t9h()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.t9g(tmp0.m9l(p.r9g_1, p.s9g_1), tmp0.p9l(p.r9g_1, p.s9g_1));
  }
  return tmp$ret$0;
}
function write_0(_this__u8e3s4, path) {
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = path.nah_1;
  var n_0 = 0;
  while (n_0 < this_0.s2()) {
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.j9u(_unary__edvuaz)) {
      case 0:
        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = path.oah_1.u2(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.t9g(tmp, path.oah_1.u2(_unary__edvuaz_1));
        _this__u8e3s4.gah(it);
        break;
      case 1:
        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = path.oah_1.u2(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.t9g(tmp_0, path.oah_1.u2(_unary__edvuaz_3));
        _this__u8e3s4.iah(it_0);
        break;
      case 2:
        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = path.oah_1.u2(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var tmp0 = Vector2D.t9g(tmp_1, path.oah_1.u2(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = path.oah_1.u2(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.t9g(tmp_2, path.oah_1.u2(_unary__edvuaz_7));
        _this__u8e3s4.jah(tmp0, a);
        break;
      case 3:
        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = path.oah_1.u2(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var tmp0_0 = Vector2D.t9g(tmp_3, path.oah_1.u2(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = path.oah_1.u2(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var tmp2 = Vector2D.t9g(tmp_4, path.oah_1.u2(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = path.oah_1.u2(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_0 = Vector2D.t9g(tmp_5, path.oah_1.u2(_unary__edvuaz_13));
        _this__u8e3s4.lah(tmp0_0, tmp2, a_0);
        break;
      case 4:
        _this__u8e3s4.f7();
        break;
    }
  }
}
function toBitmapPaint(_this__u8e3s4, state) {
  var filler = toFiller(_this__u8e3s4, state);
  var bb = Companion_getInstance_7().e9i();
  bb = BoundsBuilder__plus_impl_cz7f7x(bb, state.mcl_1.faf());
  var tmp = bb;
  var tmp333_safe_receiver = state.lcl_1;
  bb = BoundsBuilder__plus_impl_cz7f7x(tmp, tmp333_safe_receiver == null ? null : tmp333_safe_receiver.faf());
  var bounds = _BoundsBuilder___get_bounds__impl__s1l1gx(bb).v9q(state.kcl_1);
  // Inline function 'kotlin.also' call
  var this_0 = Bitmap32.lc1(toIntCeil_0(bounds.q9h_1), toIntCeil_0(bounds.r9h_1), VOID, true);
  filler.cdk(this_0);
  var bmp = this_0;
  return new BitmapPaint(bmp, Companion_getInstance_5().y9k().a9m(-bounds.v9h(), -bounds.x9h()));
}
var CycleMethod_NO_CYCLE_instance;
var CycleMethod_NO_CYCLE_CLAMP_instance;
var CycleMethod_REPEAT_instance;
var CycleMethod_REFLECT_instance;
var Companion_instance_40;
function Companion_getInstance_50() {
  CycleMethod_initEntries();
  if (Companion_instance_40 === VOID)
    new Companion_34();
  return Companion_instance_40;
}
function values_6() {
  return [CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_CLAMP_getInstance(), CycleMethod_REPEAT_getInstance(), CycleMethod_REFLECT_getInstance()];
}
var CycleMethod_entriesInitialized;
function CycleMethod_initEntries() {
  if (CycleMethod_entriesInitialized)
    return Unit_instance;
  CycleMethod_entriesInitialized = true;
  CycleMethod_NO_CYCLE_instance = new CycleMethod('NO_CYCLE', 0);
  CycleMethod_NO_CYCLE_CLAMP_instance = new CycleMethod('NO_CYCLE_CLAMP', 1);
  CycleMethod_REPEAT_instance = new CycleMethod('REPEAT', 2);
  CycleMethod_REFLECT_instance = new CycleMethod('REFLECT', 3);
  Companion_getInstance_50();
}
function _CycleMethodPair___init__impl__y6jlco(data) {
  return data;
}
function _CycleMethodPair___get_data__impl__r5ik0n($this) {
  return $this;
}
function _CycleMethodPair___init__impl__y6jlco_0(x, y) {
  return _CycleMethodPair___init__impl__y6jlco(insert8(insert8(0, x.w1_1, 0), y.w1_1, 8));
}
function _CycleMethodPair___get_x__impl__dgz5uj($this) {
  var tmp = Companion_getInstance_50().bdr_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 0 | 0) & 255];
}
function _CycleMethodPair___get_y__impl__fcnb7o($this) {
  var tmp = Companion_getInstance_50().bdr_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 8 | 0) & 255];
}
function CycleMethodPair__apply_impl_g3sekg($this, ratio) {
  return Vector2D.t9g(_CycleMethodPair___get_x__impl__dgz5uj($this).cdr(ratio.r9g_1), _CycleMethodPair___get_y__impl__fcnb7o($this).cdr(ratio.s9g_1));
}
function CycleMethod_NO_CYCLE_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_instance;
}
function CycleMethod_NO_CYCLE_CLAMP_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_CLAMP_instance;
}
function CycleMethod_REPEAT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REPEAT_instance;
}
function CycleMethod_REFLECT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REFLECT_instance;
}
function draw_0(_this__u8e3s4, c) {
  c.udc(_this__u8e3s4);
}
function draw_1(_this__u8e3s4, path) {
  _this__u8e3s4.udc(path);
}
function msdfBmp(_this__u8e3s4, width, height) {
  var msdf_0 = msdf(_this__u8e3s4, width, height);
  // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
  // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
  var width_0 = msdf_0.sc1_1 - 0 | 0;
  var inductionVariable = 0;
  var last = 0 + (msdf_0.tc1_1 - 0 | 0) | 0;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var n = msdf_0.nc2(0, 0 + y | 0);
      var inductionVariable_0 = 0;
      var last_0 = 0 + width_0 | 0;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          n = n + 1 | 0;
          var value = msdf_0.nce(x, y);
          var tmp = 0 === 3 ? -100.0 : value;
          var value_0 = msdf_0.oce(x, y);
          var tmp_0 = 1 === 3 ? -100.0 : value_0;
          var value_1 = msdf_0.pce(x, y);
          var tmp_1 = 2 === 3 ? -100.0 : value_1;
          var value_2 = msdf_0.qce(x, y);
          var tmp$ret$6 = 3 === 3 ? -100.0 : value_2;
          msdf_0.rce(x, y, tmp, tmp_0, tmp_1, tmp$ret$6);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  msdf_0.yce(-1.0);
  msdf_0.acf(-1.0, +1.0);
  msdf_0.xce();
  var msdfBitmap = msdf_0.ec2();
  return msdfBitmap;
}
function sdfBmp(_this__u8e3s4, width, height) {
  var tmp = NewSDF_instance;
  var newImage = tmp.qch(NativeImageContext2d(width, height, VOID, sdfBmp$lambda(_this__u8e3s4)).ec2(), VOID, 0);
  return newImage.jch_1.pc9();
}
function msdf(_this__u8e3s4, width, height) {
  return msdf_0(_this__u8e3s4, FloatBitmap32.lce(width, height));
}
function msdf_0(_this__u8e3s4, data) {
  var path = _this__u8e3s4;
  var curvesList = toCurvesList(path);
  var p = Vector2D.y9j();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(curvesList, 10));
  var _iterator__ex2g4s = curvesList.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$2 = colorize(item.aad_1, item.bad_1);
    destination.d2(tmp$ret$2);
  }
  var colorizedCurves = destination;
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = colorizedCurves.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element = _iterator__ex2g4s_0.r1();
    var list = element.ddr_1;
    addAll(destination_0, list);
  }
  var allColorizedCurves = new ColorizedBeziers(destination_0);
  var inductionVariable = 0;
  var last = data.tc1_1;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = data.sc1_1;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          p = Vector2D.t9g(x + 0.5, y + 0.5);
          var inside = path.oat(p);
          var allDist = allColorizedCurves.ldr().pdr(p);
          var redDist = allColorizedCurves.qdr().pdr(p);
          var greenDist = allColorizedCurves.rdr().pdr(p);
          var blueDist = allColorizedCurves.sdr().pdr(p);
          var minR = redDist;
          var minG = greenDist;
          var minB = blueDist;
          var minA = allDist;
          if (inside) {
            minR = -minR;
            minG = -minG;
            minB = -minB;
            minA = -minA;
          }
          data.rce(x, y, minR, minG, minB, minA);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return data;
}
function ColorizedBeziers$red$delegate$lambda(this$0) {
  return () => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this$0.ddr_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (!(_RGBA___get_r__impl__duz7mo(element.udr_1) === 0)) {
        destination.d2(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$_get_red_$ref_xdnpsc() {
  return constructCallableReference((p0) => p0.vdr(), 1, 0, 138);
}
function ColorizedBeziers$green$delegate$lambda(this$0) {
  return () => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this$0.ddr_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (!(_RGBA___get_g__impl__o8pukr(element.udr_1) === 0)) {
        destination.d2(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$_get_green_$ref_tv17mu() {
  return constructCallableReference((p0) => p0.wdr(), 1, 0, 139);
}
function ColorizedBeziers$blue$delegate$lambda(this$0) {
  return () => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this$0.ddr_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (!(_RGBA___get_b__impl__m6tl80(element.udr_1) === 0)) {
        destination.d2(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$_get_blue_$ref_5q5gjh() {
  return constructCallableReference((p0) => p0.xdr(), 1, 0, 140);
}
function ColorizedBeziers$allProjected$delegate$lambda(this$0) {
  return () => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.ddr_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = item.tdr_1;
      destination.d2(tmp$ret$2);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$_get_allProjected_$ref_l05e8q() {
  return constructCallableReference((p0) => p0.ldr(), 1, 0, 141);
}
function ColorizedBeziers$redProjected$delegate$lambda(this$0) {
  return () => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.vdr();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = item.tdr_1;
      destination.d2(tmp$ret$2);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$_get_redProjected_$ref_613mvq() {
  return constructCallableReference((p0) => p0.qdr(), 1, 0, 142);
}
function ColorizedBeziers$greenProjected$delegate$lambda(this$0) {
  return () => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.wdr();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = item.tdr_1;
      destination.d2(tmp$ret$2);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$_get_greenProjected_$ref_8dwwp4() {
  return constructCallableReference((p0) => p0.rdr(), 1, 0, 143);
}
function ColorizedBeziers$blueProjected$delegate$lambda(this$0) {
  return () => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.xdr();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = item.tdr_1;
      destination.d2(tmp$ret$2);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$_get_blueProjected_$ref_qfjglb() {
  return constructCallableReference((p0) => p0.sdr(), 1, 0, 144);
}
function colorize(_this__u8e3s4, closed) {
  closed = closed === VOID ? true : closed;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(_this__u8e3s4, 10));
  var index = 0;
  var _iterator__ex2g4s = _this__u8e3s4.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var color = msdfColor(index_0, _this__u8e3s4.s2(), closed);
    var tmp$ret$2 = new ColoredBezier(item, color);
    destination.d2(tmp$ret$2);
  }
  return new ColorizedBeziers(destination);
}
function msdfColor(index, size, closed) {
  if (size === 1)
    return Colors_getInstance().zc2_1;
  if (index === 0)
    return Colors_getInstance().bc5_1;
  return ((index - 1 | 0) % 2 | 0) === 0 ? Colors_getInstance().pc8_1 : Colors_getInstance().zc3_1;
}
function sdfBmp$lambda($this_sdfBmp) {
  return ($this$NativeImageContext2d) => {
    // Inline function 'korlibs.image.vector.Context2d.fill' call
    var paint = new RGBA(Colors_getInstance().zc2_1);
    if (true) {
      $this$NativeImageContext2d.rct();
    }
    write($this$NativeImageContext2d, $this_sdfBmp);
    $this$NativeImageContext2d.wdq(paint, null);
    return Unit_instance;
  };
}
var EmptyShape_instance;
function EmptyShape_getInstance() {
  return EmptyShape_instance;
}
function TextShape$_get_primitiveShapes_$ref_aj2wvd() {
  return constructCallableReference((p0) => p0.cds(), 1, 0, 145);
}
function FillShape$pathCurvesList$delegate$lambda(this$0) {
  return () => toCurvesList(this$0.dds_1);
}
function FillShape$_get_pathCurvesList_$ref_xawj4p() {
  return constructCallableReference((p0) => p0.kds(), 1, 0, 146);
}
function FillShape$clipCurvesList$delegate$lambda(this$0) {
  return () => {
    var tmp351_safe_receiver = this$0.eds_1;
    return tmp351_safe_receiver == null ? null : toCurvesList(tmp351_safe_receiver);
  };
}
function FillShape$_get_clipCurvesList_$ref_3uutse() {
  return constructCallableReference((p0) => p0.lds(), 1, 0, 147);
}
function StrokeInfo$_get_thickness_$ref_geresy(p0) {
  return constructCallableReference(() => p0.pab_1, 0, 0, 148, VOID, [p0]);
}
function StrokeInfo$_get_scaleMode_$ref_hp7psl(p0) {
  return constructCallableReference(() => p0.rab_1, 0, 0, 149, VOID, [p0]);
}
function StrokeInfo$_get_startCap_$ref_el6ba0(p0) {
  return constructCallableReference(() => p0.sab_1, 0, 0, 150, VOID, [p0]);
}
function StrokeInfo$_get_endCap_$ref_wlfq1t(p0) {
  return constructCallableReference(() => p0.tab_1, 0, 0, 151, VOID, [p0]);
}
function StrokeInfo$_get_join_$ref_1c260i(p0) {
  return constructCallableReference(() => p0.uab_1, 0, 0, 152, VOID, [p0]);
}
function StrokeInfo$_get_miterLimit_$ref_qyuncy(p0) {
  return constructCallableReference(() => p0.vab_1, 0, 0, 153, VOID, [p0]);
}
function StrokeInfo$_get_dash_$ref_ajbiai(p0) {
  return constructCallableReference(() => p0.wab_1, 0, 0, 154, VOID, [p0]);
}
function StrokeInfo$_get_dashOffset_$ref_p72rql(p0) {
  return constructCallableReference(() => p0.xab_1, 0, 0, 155, VOID, [p0]);
}
function PolylineShape$fillShape$delegate$lambda(this$0) {
  return () => new FillShape(strokeToFill_0(this$0.pds_1, this$0.tds_1), this$0.qds_1, this$0.rds_1, this$0.sds_1, this$0.uds_1);
}
function toContext2dCommands(_this__u8e3s4, prefix, suffix, decimalPlaces) {
  prefix = prefix === VOID ? 'ctx.' : prefix;
  suffix = suffix === VOID ? ';' : suffix;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList.p2();
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_1 = _this__u8e3s4.nah_1;
  var n_0 = 0;
  while (n_0 < this_1.s2()) {
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_1.j9u(_unary__edvuaz)) {
      case 0:
        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.oah_1.u2(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var destruct = Vector2D.t9g(tmp, _this__u8e3s4.oah_1.u2(_unary__edvuaz_1));
        var x = destruct.jm();
        var y = destruct.km();
        this_0.d2('moveTo(' + toContext2dCommands$round(x, decimalPlaces) + ', ' + toContext2dCommands$round(y, decimalPlaces) + ')');
        break;
      case 1:
        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var destruct_0 = Vector2D.t9g(tmp_0, _this__u8e3s4.oah_1.u2(_unary__edvuaz_3));
        var x_0 = destruct_0.jm();
        var y_0 = destruct_0.km();
        this_0.d2('lineTo(' + toContext2dCommands$round(x_0, decimalPlaces) + ', ' + toContext2dCommands$round(y_0, decimalPlaces) + ')');
        break;
      case 2:
        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var tmp0 = Vector2D.t9g(tmp_1, _this__u8e3s4.oah_1.u2(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var destruct_1 = Vector2D.t9g(tmp_2, _this__u8e3s4.oah_1.u2(_unary__edvuaz_7));
        var cx = tmp0.jm();
        var cy = tmp0.km();
        var ax = destruct_1.jm();
        var ay = destruct_1.km();
        this_0.d2('quadTo(' + toContext2dCommands$round(cx, decimalPlaces) + ', ' + toContext2dCommands$round(cy, decimalPlaces) + ', ' + toContext2dCommands$round(ax, decimalPlaces) + ', ' + toContext2dCommands$round(ay, decimalPlaces) + ')');
        break;
      case 3:
        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var tmp0_0 = Vector2D.t9g(tmp_3, _this__u8e3s4.oah_1.u2(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var tmp2 = Vector2D.t9g(tmp_4, _this__u8e3s4.oah_1.u2(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var destruct_2 = Vector2D.t9g(tmp_5, _this__u8e3s4.oah_1.u2(_unary__edvuaz_13));
        var cx1 = tmp0_0.jm();
        var cy1 = tmp0_0.km();
        var cx2 = tmp2.jm();
        var cy2 = tmp2.km();
        var ax_0 = destruct_2.jm();
        var ay_0 = destruct_2.km();
        this_0.d2('cubicTo(' + toContext2dCommands$round(cx1, decimalPlaces) + ', ' + toContext2dCommands$round(cy1, decimalPlaces) + ', ' + toContext2dCommands$round(cx2, decimalPlaces) + ', ' + toContext2dCommands$round(cy2, decimalPlaces) + ', ' + toContext2dCommands$round(ax_0, decimalPlaces) + ', ' + toContext2dCommands$round(ay_0, decimalPlaces) + ')');
        break;
      case 4:
        this_0.d2('close()');
        break;
    }
  }
  // Inline function 'kotlin.collections.map' call
  var this_2 = this_0.g9();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s = this_2.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$14 = prefix + item + suffix;
    destination.d2(tmp$ret$14);
  }
  return destination;
}
function toSvgPathString(_this__u8e3s4, separator, decimalPlaces) {
  separator = separator === VOID ? ' ' : separator;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  return SvgPath_instance.fdt(_this__u8e3s4, separator, decimalPlaces);
}
function toContext2dCommands$round(_this__u8e3s4, $decimalPlaces) {
  return niceStr(_this__u8e3s4, $decimalPlaces);
}
function toSvgPathString$fixX(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
function toSvgPathString$fixY(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
var SvgPath_instance;
function SvgPath_getInstance() {
  return SvgPath_instance;
}
function Rasterizer$rasterizeFill$lambda($xmax, $xmin, this$0, $callback) {
  return (a, b, y) => {
    var tmp;
    if (a <= $xmax && b >= $xmin) {
      var a0 = coerceIn(a, $xmin, $xmax);
      var b0 = coerceIn(b, $xmin, $xmax);
      if (this$0.ydo_1) {
        println('RASTER(' + a0 + ', ' + b0 + ', ' + y + ')');
      }
      tmp = $callback(a0, b0, y);
    } else {
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function Renderer$drawImage$lambda($pos, $size) {
  return ($this$transformed) => {
    $this$transformed.tas($pos, $size);
    return Unit_instance;
  };
}
var Companion_instance_41;
function Companion_getInstance_51() {
  if (Companion_instance_41 === VOID)
    new Companion_35();
  return Companion_instance_41;
}
var HtmlCanvas_instance;
function HtmlCanvas_getInstance() {
  return HtmlCanvas_instance;
}
function toLike(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4;
}
function toHtmlNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof HtmlNativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = HtmlNativeImage.jdu(HtmlImage_instance.pdt(_this__u8e3s4.ec2()));
  }
  return tmp;
}
var HtmlImage_instance;
function HtmlImage_getInstance() {
  return HtmlImage_instance;
}
function get_nativeImageFormatProvider() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return nativeImageFormatProvider;
}
var nativeImageFormatProvider;
function get_isLittleEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return isLittleEndian;
}
var isLittleEndian;
function HtmlNativeImage$lazyCanvasElement$delegate$lambda(this$0, $width, $height) {
  return () => {
    var tmp;
    // Inline function 'kotlin.js.asDynamic' call
    if (this$0.fdu_1.src !== undefined) {
      var tmp_0 = BrowserImage_instance;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = this$0.fdu_1;
      tmp = tmp_0.ndu(tmp$ret$1, $width, $height);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this$0.fdu_1;
    }
    // Inline function 'kotlin.also' call
    var this_0 = tmp;
    this$0.fdu_1 = this_0;
    return this_0;
  };
}
function HtmlNativeImage$_get_lazyCanvasElement_$ref_ucfw2j() {
  return constructCallableReference((p0) => p0.odu(), 1, 0, 156);
}
function HtmlNativeImage$ctx$delegate$lambda(this$0) {
  return () => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this$0.odu().getContext('2d');
  };
}
function HtmlNativeImage$_get_ctx_$ref_2kgb2() {
  return constructCallableReference((p0) => p0.pdu(), 1, 0, 157);
}
var NonBrowserNativeImageFormatProvider_instance;
function NonBrowserNativeImageFormatProvider_getInstance() {
  if (NonBrowserNativeImageFormatProvider_instance === VOID)
    new NonBrowserNativeImageFormatProvider();
  return NonBrowserNativeImageFormatProvider_instance;
}
var HtmlNativeImageFormatProvider_instance;
function HtmlNativeImageFormatProvider_getInstance() {
  if (HtmlNativeImageFormatProvider_instance === VOID)
    new HtmlNativeImageFormatProvider();
  return HtmlNativeImageFormatProvider_instance;
}
function BrowserImage$loadImage$lambda($c, $img) {
  return (it) => {
    var tmp0 = $c;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var value = $img;
    var tmp$ret$3 = _Result___init__impl__xyqfz8(value);
    tmp0.qd(tmp$ret$3);
    return Unit_instance;
  };
}
function BrowserImage$loadImage$lambda_0($c, $jsUrl) {
  return (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1, _unused_var__etf5q3_2, _unused_var__etf5q3_3) => {
    var tmp0 = $c;
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = RuntimeException.xb('error loading image ' + $jsUrl);
    var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
    tmp0.qd(tmp$ret$1);
    return Unit_instance;
  };
}
var BrowserImage_instance;
function BrowserImage_getInstance() {
  return BrowserImage_instance;
}
function get_isBigEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return !get_isLittleEndian();
}
function bswap32(v, offset, size) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  var inductionVariable = offset;
  var last = offset + size | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      v[n] = bswap32_0(v[n]);
    }
     while (inductionVariable < last);
}
function setFont($this, font, fontSize) {
  var tmp;
  if ((font == null ? null : font.h1()) == $this.edv_1) {
    tmp = fontSize === $this.ddv_1;
  } else {
    tmp = false;
  }
  if (tmp)
    return Unit_instance;
  var tmp_0 = $this;
  tmp_0.edv_1 = font == null ? null : font.h1();
  $this.ddv_1 = fontSize;
  var tmp0_elvis_lhs = font == null ? null : font.h1();
  $this.cdv_1.font = '' + fontSize + "px '" + (tmp0_elvis_lhs == null ? 'default' : tmp0_elvis_lhs) + "'";
}
function setState($this, state, fill, doSetFont) {
  $this.cdv_1.globalAlpha = state.acm_1;
  $this.cdv_1.globalCompositeOperation = $this.fdv(state.bcm_1);
  if (doSetFont) {
    setFont($this, state.wcl_1, state.xcl_1);
  }
  if (fill) {
    $this.cdv_1.fillStyle = $this.gdv(state.ucl_1);
  } else {
    $this.cdv_1.lineWidth = state.ocl_1;
    var tmp;
    switch (state.rcl_1.w1_1) {
      case 0:
        // Inline function 'org.w3c.dom.BEVEL' call

        // Inline function 'kotlin.js.asDynamic' call

        // Inline function 'kotlin.js.unsafeCast' call

        tmp = 'bevel';
        break;
      case 2:
        // Inline function 'org.w3c.dom.MITER' call

        // Inline function 'kotlin.js.asDynamic' call

        // Inline function 'kotlin.js.unsafeCast' call

        tmp = 'miter';
        break;
      case 1:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.asDynamic' call

        // Inline function 'kotlin.js.unsafeCast' call

        tmp = 'round';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.cdv_1.lineJoin = tmp;
    var tmp_0;
    switch (state.ccu().w1_1) {
      case 0:
        // Inline function 'org.w3c.dom.BUTT' call

        // Inline function 'kotlin.js.asDynamic' call

        // Inline function 'kotlin.js.unsafeCast' call

        tmp_0 = 'butt';
        break;
      case 2:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.asDynamic' call

        // Inline function 'kotlin.js.unsafeCast' call

        tmp_0 = 'round';
        break;
      case 1:
        // Inline function 'org.w3c.dom.SQUARE' call

        // Inline function 'kotlin.js.asDynamic' call

        // Inline function 'kotlin.js.unsafeCast' call

        tmp_0 = 'square';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.cdv_1.lineCap = tmp_0;
    $this.cdv_1.strokeStyle = $this.gdv(state.tcl_1);
  }
}
function transformPaint($this, paint) {
  if (isInterface(paint, TransformedPaint)) {
    $this.hdv($this.cdv_1, paint.acw());
  }
}
function bswap32_0(v) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return (v >>> 24 | 0 | v << 24 | (v & 65280) << 8 | (v >>> 8 | 0)) & 65280;
}
var properties_initialized_NativeImageFormatProviderJs_kt_7b9n17;
function _init_properties_NativeImageFormatProviderJs_kt__3qg4wz() {
  if (!properties_initialized_NativeImageFormatProviderJs_kt_7b9n17) {
    properties_initialized_NativeImageFormatProviderJs_kt_7b9n17 = true;
    nativeImageFormatProvider = Companion_getInstance_10().hb1() ? NonBrowserNativeImageFormatProvider_getInstance() : Companion_getInstance_10().gb1() ? NonBrowserNativeImageFormatProvider_getInstance() : HtmlNativeImageFormatProvider_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [1];
    // Inline function 'org.khronos.webgl.get' call
    // Inline function 'kotlin.js.asDynamic' call
    isLittleEndian = (new Uint8Array((new Int32Array(tmp$ret$0)).buffer))[0] === 1;
  }
}
//region block: post-declaration
initMetadataForClass(GrowMethod, 'GrowMethod');
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(MutableAtlas, 'MutableAtlas', MutableAtlas.oc1);
initMetadataForClass(Bitmap, 'Bitmap');
initMetadataForCompanion(Companion, VOID, VOID, [2, 3]);
initMetadataForClass(Bitmap32, 'Bitmap32', VOID, VOID, [Iterable]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(BitmapIndexed, 'BitmapIndexed');
initMetadataForClass(Bitmap8, 'Bitmap8');
initMetadataForCompanion(Companion_1);
initMetadataForClass(BitmapChannel, 'BitmapChannel');
initMetadataForObject(Bitmaps, 'Bitmaps');
initMetadataForCompanion(Companion_2);
initMetadataForClass(DistanceBitmap, 'DistanceBitmap');
initMetadataForClass(FloatBitmap32, 'FloatBitmap32');
initMetadataForClass(MultiBitmap, 'MultiBitmap');
initMetadataForClass(NativeImage, 'NativeImage', VOID, VOID, [NativeImageRef]);
initMetadataForInterface(ForcedTexId, 'ForcedTexId');
initMetadataForClass(NullBitmap, 'NullBitmap');
initMetadataForCompanion(Companion_3);
initMetadataForClass(Palette, 'Palette');
initMetadataForClass(BitmapEffect, 'BitmapEffect', BitmapEffect);
initMetadataForClass(Result, 'Result');
initMetadataForObject(NewSDF, 'NewSDF');
initMetadataForClass(ColorFormat32, 'ColorFormat32');
initMetadataForClass(ColorFormat24, 'ColorFormat24');
initMetadataForClass(ColorTransformMul, 'ColorTransformMul', ColorTransformMul);
initMetadataForObject(Colors, 'Colors');
initMetadataForClass(RGB, 'RGB');
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(RGBA, 'RGBA', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_6);
initMetadataForCompanion(Companion_7);
initMetadataForClass(RgbaPremultipliedArray, 'RgbaPremultipliedArray');
initMetadataForCompanion(Companion_8);
initMetadataForClass(RgbaArray, 'RgbaArray', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_9);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Kerning, 'Kerning');
initMetadataForClass(Glyph, 'Glyph');
initMetadataForInterface(Font, 'Font', VOID, VOID, VOID, [0]);
initMetadataForInterface(BitmapFont, 'BitmapFont', VOID, VOID, [Font], [0]);
protoOf(BitmapFontImpl).jck = get_baseBmp;
protoOf(BitmapFontImpl).nck = getFontMetrics;
protoOf(BitmapFontImpl).yck = getFontMetrics$default;
protoOf(BitmapFontImpl).zck = getGlyphMetrics;
protoOf(BitmapFontImpl).gcl = getGlyphMetrics$default;
protoOf(BitmapFontImpl).lcm = getKerning;
protoOf(BitmapFontImpl).icl = getTextScale;
protoOf(BitmapFontImpl).u2 = get_0;
protoOf(BitmapFontImpl).jcl = renderGlyph;
protoOf(BitmapFontImpl).kcm = renderGlyph$default;
initMetadataForClass(BitmapFontImpl, 'BitmapFontImpl', VOID, VOID, [BitmapFont], [0]);
initMetadataForCompanion(Companion_11);
initMetadataForClass(CharacterSet, 'CharacterSet');
initMetadataForClass(TextToBitmapResult, 'TextToBitmapResult');
initMetadataForClass(PlacedGlyphMetrics, 'PlacedGlyphMetrics');
initMetadataForClass(TextMetricsResult, 'TextMetricsResult', TextMetricsResult);
initMetadataForClass(MultiplePlacedGlyphMetrics, 'MultiplePlacedGlyphMetrics', MultiplePlacedGlyphMetrics);
initMetadataForInterface(ITextRendererActions, 'ITextRendererActions');
protoOf(TextRendererActions).ra8 = reset;
protoOf(TextRendererActions).icw = advance;
protoOf(TextRendererActions).jcw = newLine;
initMetadataForClass(TextRendererActions, 'TextRendererActions', VOID, VOID, [ITextRendererActions]);
initMetadataForClass(drawText$actions$1);
initMetadataForClass(GlyphPath, 'GlyphPath', GlyphPath);
initMetadataForCompanion(Companion_12);
protoOf(LazyBitmapFont).jck = get_baseBmp;
protoOf(LazyBitmapFont).nck = getFontMetrics;
protoOf(LazyBitmapFont).yck = getFontMetrics$default;
protoOf(LazyBitmapFont).zck = getGlyphMetrics;
protoOf(LazyBitmapFont).gcl = getGlyphMetrics$default;
protoOf(LazyBitmapFont).lcm = getKerning;
protoOf(LazyBitmapFont).icl = getTextScale;
protoOf(LazyBitmapFont).q9v = getOrNull_2;
protoOf(LazyBitmapFont).u2 = get_0;
protoOf(LazyBitmapFont).jcl = renderGlyph;
protoOf(LazyBitmapFont).kcm = renderGlyph$default;
initMetadataForClass(LazyBitmapFont, 'LazyBitmapFont', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(FontMetrics, 'FontMetrics', FontMetrics);
initMetadataForClass(GlyphMetrics, 'GlyphMetrics', GlyphMetrics);
initMetadataForClass(TextMetrics, 'TextMetrics', TextMetrics);
initMetadataForCompanion(Companion_13);
initMetadataForClass(GlyphPath_0, 'GlyphPath');
initMetadataForClass(CFFResult, 'CFFResult');
initMetadataForClass(DataIndex, 'DataIndex', DataIndex.bcz, VOID, [Iterable]);
initMetadataForClass(Op, 'Op');
initMetadataForCompanion(Companion_14);
initMetadataForClass(EvalContext, 'EvalContext', EvalContext);
initMetadataForClass(Op_0, 'Op');
initMetadataForObject(CFF, 'CFF');
initMetadataForObject(CharStringType2, 'CharStringType2');
initMetadataForObject(TtfCIDFont, 'TtfCIDFont');
initMetadataForCompanion(Companion_15, VOID, VOID, [1]);
initMetadataForInterface(VectorFont, 'VectorFont', VOID, VOID, [Font], [0]);
protoOf(BaseTtfFont).yck = getFontMetrics$default;
protoOf(BaseTtfFont).gcl = getGlyphMetrics$default;
protoOf(BaseTtfFont).xd2 = getGlyphPath$default;
protoOf(BaseTtfFont).jcl = renderGlyph_0;
protoOf(BaseTtfFont).kcm = renderGlyph$default;
protoOf(BaseTtfFont).q9v = getOrNull_2;
initMetadataForClass(BaseTtfFont, 'BaseTtfFont', VOID, VOID, [VectorFont], [0]);
initMetadataForClass(TtfFont, 'TtfFont', VOID, VOID, VOID, [0]);
initMetadataForCompanion(Companion_16);
initMetadataForCompanion(Companion_17);
initMetadataForClass(NamesInfo, 'NamesInfo', NamesInfo);
initMetadataForClass(SubstitutionInfo, 'SubstitutionInfo');
initMetadataForClass(Table, 'Table');
initMetadataForClass(HorMetric, 'HorMetric');
initMetadataForCompanion(Companion_18);
initMetadataForClass(NameId, 'NameId');
initMetadataForClass(ColorBitmapInfo, 'ColorBitmapInfo', ColorBitmapInfo);
initMetadataForClass(SbitLineMetrics, 'SbitLineMetrics', SbitLineMetrics);
initMetadataForClass(BitmapGlyphInfo, 'BitmapGlyphInfo');
initMetadataForClass(ColorLine, 'ColorLine');
initMetadataForClass(ColorStop, 'ColorStop');
initMetadataForClass(Colrv1Paint, 'Colrv1Paint');
initMetadataForClass(COLRv1, 'COLRv1', COLRv1);
initMetadataForClass(Contour, 'Contour', Contour);
initMetadataForClass(GlyphReference, 'GlyphReference');
initMetadataForClass(ColrLayerInfo, 'ColrLayerInfo');
initMetadataForInterface(ColrGlyphInfo, 'ColrGlyphInfo');
protoOf(ColrGlyphInfoV1).dda = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV1, 'ColrGlyphInfoV1', VOID, VOID, [ColrGlyphInfo]);
protoOf(ColrGlyphInfoV0).dda = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV0, 'ColrGlyphInfoV0', VOID, VOID, [ColrGlyphInfo]);
protoOf(GlyphGraphicsPath).xas = arc$default;
initMetadataForClass(GlyphGraphicsPath, 'GlyphGraphicsPath', VOID, VOID, [VectorBuilder]);
initMetadataForClass(Glyph_0, 'Glyph');
initMetadataForClass(CompositeGlyph, 'CompositeGlyph');
initMetadataForClass(CFFGlyph, 'CFFGlyph');
initMetadataForClass(SimpleGlyph, 'SimpleGlyph');
initMetadataForClass(BaseTtfFont$readCblc$Subtable, 'Subtable');
initMetadataForClass(BaseTtfFont$readSbix$StrikeInfo, 'StrikeInfo');
initMetadataForClass(BaseTtfFont$readCoverage$RangeInfo, 'RangeInfo');
initMetadataForClass(BaseTtfFont$readCmap$EncodingRecord, 'EncodingRecord');
initMetadataForCompanion(Companion_19);
initMetadataForCompanion(Companion_20);
initMetadataForClass(DataFormat, 'DataFormat');
initMetadataForObject(EXIF, 'EXIF', VOID, VOID, VOID, [3]);
initMetadataForClass(Direction, 'Direction');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ImageAnimation, 'ImageAnimation');
initMetadataForCompanion(Companion_21);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ImageData, 'ImageData');
initMetadataForCompanion(Companion_22);
initMetadataForClass(ImageDataContainer, 'ImageDataContainer');
initMetadataForClass(ImageFormat, 'ImageFormat', VOID, VOID, VOID, [2, 1]);
initMetadataForCompanion(Companion_23);
initMetadataForClass(ImageDecodingProps, 'ImageDecodingProps', ImageDecodingProps);
initMetadataForClass(ImageDecoderNotFoundException, 'ImageDecoderNotFoundException');
initMetadataForClass(ImageFormats, 'ImageFormats', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageFormatsMutable, 'ImageFormatsMutable', ImageFormatsMutable.vdg, VOID, VOID, [2, 1]);
initMetadataForCompanion(Companion_24);
initMetadataForClass(ImageFrame, 'ImageFrame');
initMetadataForClass(ImageFrameLayer, 'ImageFrameLayer');
initMetadataForClass(ImageInfo, 'ImageInfo', ImageInfo);
initMetadataForCompanion(Companion_25);
initMetadataForClass(Type, 'Type');
initMetadataForClass(ImageLayer, 'ImageLayer');
initMetadataForClass(NativeImageFormatProvider, 'NativeImageFormatProvider', NativeImageFormatProvider, VOID, VOID, [1, 2, 3]);
initMetadataForClass(NativeImageResult, 'NativeImageResult');
initMetadataForClass(BitmapNativeImage, 'BitmapNativeImage');
initMetadataForClass(BaseNativeImageFormatProvider, 'BaseNativeImageFormatProvider', BaseNativeImageFormatProvider, VOID, VOID, [1, 2, 3]);
initMetadataForCompanion(Companion_26);
initMetadataForClass(InterlacedPass, 'InterlacedPass');
initMetadataForClass(Colorspace, 'Colorspace');
initMetadataForClass(Header, 'Header');
initMetadataForClass(DecodingContext, 'DecodingContext');
initMetadataForObject(PNG, 'PNG', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(BaseFiller, 'BaseFiller');
initMetadataForClass(ColorFiller, 'ColorFiller', ColorFiller);
initMetadataForCompanion(Companion_27);
initMetadataForClass(GradientFiller, 'GradientFiller', GradientFiller);
initMetadataForClass(BitmapFiller, 'BitmapFiller', BitmapFiller);
initMetadataForObject(NoneFiller, 'NoneFiller');
initMetadataForObject(NonePaint, 'NonePaint');
initMetadataForInterface(TransformedPaint, 'TransformedPaint');
initMetadataForClass(BitmapPaint, 'BitmapPaint', VOID, VOID, [TransformedPaint]);
initMetadataForCompanion(Companion_28);
initMetadataForClass(GradientPaint, 'GradientPaint', VOID, VOID, [TransformedPaint]);
initMetadataForClass(GradientKind, 'GradientKind');
initMetadataForClass(GradientUnits, 'GradientUnits');
initMetadataForClass(GradientInterpolationMethod, 'GradientInterpolationMethod');
initMetadataForCompanion(Companion_29);
initMetadataForClass(TextAlignment, 'TextAlignment');
initMetadataForCompanion(Companion_30);
initMetadataForClass(HorizontalAlign, 'HorizontalAlign');
initMetadataForCompanion(Companion_31);
initMetadataForClass(VerticalAlign, 'VerticalAlign');
initMetadataForInterface(TextRenderer, 'TextRenderer');
initMetadataForClass(LineInfo, 'LineInfo', LineInfo);
initMetadataForClass(Entry_0, 'Entry', Entry_0);
initMetadataForClass(Text2TextRendererActions, 'Text2TextRendererActions', Text2TextRendererActions);
initMetadataForClass(LineStats, 'LineStats', LineStats);
initMetadataForClass(BoundBuilderTextRendererActions, 'BoundBuilderTextRendererActions', BoundBuilderTextRendererActions);
initMetadataForClass(CreateWStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForClass(CreateStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForClass(SegmentHandler, 'SegmentHandler', SegmentHandler);
initMetadataForClass(ScanlineWriter, 'ScanlineWriter');
initMetadataForClass(Renderer, 'Renderer');
initMetadataForClass(Bitmap32Context2d, 'Bitmap32Context2d');
initMetadataForClass(CompositeOperation$Companion$invoke$1);
initMetadataForCompanion(Companion_32);
initMetadataForCompanion(Companion_33);
initMetadataForClass(CompositeMode, 'CompositeMode');
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(State, 'State', State);
protoOf(Context2d).qas = line;
protoOf(Context2d).ras = arcTo;
protoOf(Context2d).n1 = isEmpty;
protoOf(Context2d).sas = rect;
protoOf(Context2d).tas = rect_0;
protoOf(Context2d).uas = rect_1;
protoOf(Context2d).vas = roundRect;
protoOf(Context2d).was = arc;
protoOf(Context2d).xas = arc$default;
protoOf(Context2d).oab = circle;
protoOf(Context2d).yas = rMoveTo;
protoOf(Context2d).zas = rLineTo;
protoOf(Context2d).v9q = transformed;
initMetadataForClass(Context2d, 'Context2d', VOID, VOID, [VectorBuilder]);
initMetadataForCompanion(Companion_34);
initMetadataForClass(CycleMethod, 'CycleMethod');
initMetadataForClass(ColorizedBeziers, 'ColorizedBeziers');
initMetadataForClass(ColoredBezier, 'ColoredBezier');
initMetadataForClass(ProjectCurvesLookup, 'ProjectCurvesLookup');
initMetadataForInterface(Shape, 'Shape');
protoOf(EmptyShape).ydr = getPath;
protoOf(EmptyShape).lcx = getPath$default;
protoOf(EmptyShape).mda = get_bounds;
initMetadataForObject(EmptyShape, 'EmptyShape', VOID, VOID, [Shape]);
protoOf(CompoundShape).lcx = getPath$default;
protoOf(CompoundShape).mda = get_bounds;
initMetadataForClass(CompoundShape, 'CompoundShape', VOID, VOID, [Shape]);
initMetadataForInterface(StyledShape, 'StyledShape', VOID, VOID, [Shape]);
initMetadataForClass(TextShape, 'TextShape', VOID, VOID, [StyledShape]);
protoOf(FillShape).zdr = getBounds;
protoOf(FillShape).ydr = getPath_0;
protoOf(FillShape).lcx = getPath$default;
protoOf(FillShape).scw = draw;
protoOf(FillShape).mda = get_bounds;
initMetadataForClass(FillShape, 'FillShape', VOID, VOID, [StyledShape]);
protoOf(PolylineShape).ydr = getPath_0;
protoOf(PolylineShape).lcx = getPath$default;
protoOf(PolylineShape).scw = draw;
protoOf(PolylineShape).mda = get_bounds;
initMetadataForClass(PolylineShape, 'PolylineShape', VOID, VOID, [StyledShape]);
initMetadataForClass(ShapeBuilder, 'ShapeBuilder');
initMetadataForObject(SvgPath, 'SvgPath');
initMetadataForClass(Rasterizer, 'Rasterizer', Rasterizer);
initMetadataForClass(DummyRenderer, 'DummyRenderer');
initMetadataForCompanion(Companion_35);
initMetadataForObject(HtmlCanvas, 'HtmlCanvas');
initMetadataForObject(HtmlImage, 'HtmlImage');
initMetadataForClass(HtmlNativeImage, 'HtmlNativeImage');
initMetadataForObject(NonBrowserNativeImageFormatProvider, 'NonBrowserNativeImageFormatProvider', VOID, VOID, VOID, [1, 2, 3]);
initMetadataForObject(HtmlNativeImageFormatProvider, 'HtmlNativeImageFormatProvider', VOID, VOID, VOID, [2, 3, 1]);
initMetadataForObject(BrowserImage, 'BrowserImage', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(CanvasContext2dRenderer, 'CanvasContext2dRenderer');
//endregion
//region block: init
Companion_instance_6 = new Companion_0();
Bitmaps_instance = new Bitmaps();
Companion_instance_8 = new Companion_2();
NewSDF_instance = new NewSDF();
Companion_instance_12 = new Companion_6();
Companion_instance_13 = new Companion_7();
Companion_instance_14 = new Companion_8();
Companion_instance_15 = new Companion_9();
Companion_instance_16 = new Companion_10();
DefaultTtfFontOrNull = null;
SystemFontRegistryOrNull = null;
CFF_instance = new CFF();
CharStringType2_instance = new CharStringType2();
Companion_instance_22 = new Companion_16();
Companion_instance_24 = new Companion_18();
Companion_instance_25 = new Companion_19();
Companion_instance_27 = new Companion_21();
Companion_instance_28 = new Companion_22();
Companion_instance_30 = new Companion_24();
WEBP_WASM_BASE64_ZLIB = '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';
Companion_instance_33 = new Companion_27();
NonePaint_instance = new NonePaint();
Companion_instance_34 = new Companion_28();
Companion_instance_39 = new Companion_33();
EmptyShape_instance = new EmptyShape();
SvgPath_instance = new SvgPath();
HtmlCanvas_instance = new HtmlCanvas();
HtmlImage_instance = new HtmlImage();
BrowserImage_instance = new BrowserImage();
//endregion
//region block: exports
export {
  _RGBA___get_a__impl__6msvu7 as _RGBA___get_a__impl__6msvu71iz31ltxv1lni,
  _RGBA___get_af__impl__vu36qv as _RGBA___get_af__impl__vu36qv2yz7cenba06b7,
  _RGBA___get_b__impl__m6tl80 as _RGBA___get_b__impl__m6tl8019te0bj9gepls,
  _RGBA___get_bf__impl__1xz5yg as _RGBA___get_bf__impl__1xz5ygo6edauwytiyj,
  _RGBA___get_g__impl__o8pukr as _RGBA___get_g__impl__o8pukr2r7akkj4liw5z,
  _RGBA___get_gf__impl__5gcu1f as _RGBA___get_gf__impl__5gcu1f1yixpj8zlhxfr,
  RGBA__hashCode_impl_h59qf6 as RGBA__hashCode_impl_h59qf61f7mvf3brfggb,
  _RGBA___get_hexString__impl__kocngm as _RGBA___get_hexString__impl__kocngmsbr7v8rutwo8,
  _RGBA___get_premultiplied__impl__3bulqc as _RGBA___get_premultiplied__impl__3bulqc1wh24booo6c8s,
  _RGBA___get_r__impl__duz7mo as _RGBA___get_r__impl__duz7mo1syen2f503lbi,
  _RGBA___get_rf__impl__kvz75k as _RGBA___get_rf__impl__kvz75k3ulh4acu9ex4c,
  _RGBA___get_rgb__impl__tijaqt as _RGBA___get_rgb__impl__tijaqt35gwtq7wukg16,
  RGBA__toString_impl_4lw6dp as RGBA__toString_impl_4lw6dphy5yaenoheku,
  _RGBA___get_value__impl__hhco8v as _RGBA___get_value__impl__hhco8v1qo6hdnmg6vpg,
  RGBA__withAd_impl_cralao as RGBA__withAd_impl_cralao3tppw6lob1jl8,
  RGBA__withA_impl_vogscm as RGBA__withA_impl_vogscm35996kpuzu85s,
  _RGBAPremultiplied___get_af__impl__euwcjn as _RGBAPremultiplied___get_af__impl__euwcjnisi9w6didku3,
  _RGBAPremultiplied___get_bf__impl__qa3on2 as _RGBAPremultiplied___get_bf__impl__qa3on2147hgy4bstouc,
  _RGBAPremultiplied___get_gf__impl__ivron7 as _RGBAPremultiplied___get_gf__impl__ivron73pq6ucw516uw5,
  _RGBAPremultiplied___get_rf__impl__pt0c4y as _RGBAPremultiplied___get_rf__impl__pt0c4y37rs1zhk1filf,
  _RgbaArray___init__impl__oib4y4 as _RgbaArray___init__impl__oib4y43p8q13pykzb2a,
  _RgbaPremultipliedArray___init__impl__lx83hy as _RgbaPremultipliedArray___init__impl__lx83hy1hj7ki2yedww7,
  HorizontalAlign__getOffsetX_impl_urzzxf as HorizontalAlign__getOffsetX_impl_urzzxf1p1rgxoikghn1,
  _HorizontalAlign___get_ratio__impl__x9wlea as _HorizontalAlign___get_ratio__impl__x9wlea3hl94vdjlkzri,
  VerticalAlign__getOffsetY_impl_iso0y6 as VerticalAlign__getOffsetY_impl_iso0y61qg0x863lloin,
  _VerticalAlign___get_ratioFake__impl__1h2fwv as _VerticalAlign___get_ratioFake__impl__1h2fwv35o79qpxi74bi,
  Companion_getInstance_15 as Companion_getInstance16xj8a4brdtzi,
  Bitmaps_instance as Bitmaps_instance7rskgm1vqxdg,
  Colors_getInstance as Colors_getInstance3pptco3oesytn,
  Companion_getInstance_21 as Companion_getInstance3k5cs6pucdtn7,
  Companion_instance_16 as Companion_instance32vng4qkr3hdi,
  Companion_instance_15 as Companion_instance3mv764rpympbk,
  Companion_getInstance_27 as Companion_getInstance19jbnxyfpggdq,
  Companion_getInstance_45 as Companion_getInstance1hhdzhwpqlcg8,
  Companion_getInstance_47 as Companion_getInstance7ct8khg4zvht,
  EmptyShape_instance as EmptyShape_instance3meesyokr70ly,
  readFont as readFont9m5jston0h5k,
  readBitmapSlice as readBitmapSlice88s6ccedkid9,
  readBitmap_0 as readBitmapo6nrz66d4x8p,
  readBitmap as readBitmap1mzeobqc4iv0x,
  MutableAtlas as MutableAtlas41tbjanvwcb0,
  BitmapEffect as BitmapEffect3nrrxebx6tit3,
  Bitmap32 as Bitmap321klycakvwgb5w,
  Bitmap8 as Bitmap82ekc5d8xpcfp2,
  get_Bitmaps_transparent as get_Bitmaps_transparent3nm2857y3u3hn,
  get_Bitmaps_white as get_Bitmaps_white37u58wbn8ngk2,
  FloatBitmap32 as FloatBitmap321fufbxi3ys0iu,
  ForcedTexId as ForcedTexId3ivekmtdm8t3u,
  MultiBitmap as MultiBitmapk0zsv2zy1mpk,
  NativeImageOrBitmap32 as NativeImageOrBitmap3211fg7set8uiki,
  NativeImage as NativeImagebqxh3nwkmck,
  NullBitmap as NullBitmap15b22oyta4usb,
  get_baseMipmapLevel as get_baseMipmapLevel1ty2cgb5p9xw4,
  get_bmp as get_bmpevghw2zw2fa7,
  extract_0 as extractrn4rijx1x4kx,
  get_maxMipmapLevel as get_maxMipmapLevel13juf70j6ney9,
  mipmaps as mipmaps15hw75h1oqdr8,
  slice as slice2pfxfvku0ybgy,
  ColorTransformMul as ColorTransformMul2rawiv5hyxh9p,
  RGBA as RGBA34obx2i62wcl3,
  Glyph as Glyphdz1l7rusab9h,
  BitmapFontImpl as BitmapFontImpljoxrxbqjo5ee,
  BitmapFont as BitmapFont35unsvaxq1brd,
  get_DefaultTtfFont as get_DefaultTtfFontddovg6zy24ck,
  get_DefaultTtfFontAsBitmap as get_DefaultTtfFontAsBitmap1hzwi8e4truhb,
  FontMetrics as FontMetrics1b1o1zbrk6cew,
  Font as Font2bg7nte760csr,
  TextMetricsResult as TextMetricsResult1qr6b0fc6i56z,
  TextMetrics as TextMetrics1vfyzci74zdhy,
  getTextBoundsWithGlyphs as getTextBoundsWithGlyphsa2ggkffutq4d,
  getTextBounds as getTextBoundsio1pfpt2q8ze,
  renderGlyphToBitmap as renderGlyphToBitmap31bj0136i501b,
  HtmlNativeImage as HtmlNativeImagenz79853f60h,
  ImageDecodingProps as ImageDecodingProps12g4gdsvb3zm5,
  get_RegisteredImageFormats as get_RegisteredImageFormats243xf60qkmjxj,
  toHtmlNative as toHtmlNative1zcg9na83p2te,
  BitmapPaint as BitmapPaintgyia0tdij0bl,
  GradientPaint as GradientPaint1uc4xuo0s2w8w,
  NonePaint as NonePaint2h93brzruznft,
  get_DefaultStringTextRenderer as get_DefaultStringTextRendererdyzggul2pyry,
  Entry_0 as Entry3jfmfe0iy8gwc,
  LineInfo as LineInfo27uw564y6w2d2,
  Text2TextRendererActions as Text2TextRendererActions1307nbc4pqqhs,
  invoke as invoke2ot88cm6qcfmr,
  CompoundShape as CompoundShape2jsp34o6wp7wp,
  FillShape as FillShape13c5zk3dmjgcf,
  PolylineShape as PolylineShape2w5p5crr94b97,
  ShapeBuilder as ShapeBuilderk05da5wk16e9,
  TextShape as TextShape3u9vrw15swk1x,
  get_isLow as get_isLow1k7uocm2ojjr8,
};
//endregion
